<template>
  <div ref="container" style="z-index: 1">
    <block v-if="loading"></block>
    <!-- <v-card class="white box">
      <v-row class="d-flex justify-center">
        <v-col v-if="workingIn == ''" cols="12" md="4" style="text-align: center;">
          <v-alert  class="btndisable" style="padding: 4px !important;"> nueva factura</v-alert>
        </v-col>
        <v-col v-else cols="12" md="4" style="text-align: center;">
          <v-alert  class="btndisable" style="padding: 4px !important;">{{workingIn}}</v-alert>
        </v-col>
        <v-col cols="12" md="4" style="padding-bottom: 13px !important;" class="fast-ease-in-transitioned-element" >
          <date-picker 
            label="Fecha"
            @dateSelected="(param) => (form.invoicedate = param)"
            dense
            class="fast-ease-in-transitioned-element"
          >
          </date-picker>
        </v-col>
      </v-row>
      
    </v-card> -->
    <div>
      <v-row id="toshowdiv" v-show="togglehide">
        <v-col cols="12">
          <v-card class="mb-4 pa-1" rounded="lg" color="white">
            <div class="comment rounded-lg white--text py-2 px-1 mb-2">
              <v-row dense align="center">
                <v-col cols="12" md="10" sm="9">
                  <div class="text-subtitle-1 flex-grow-1 text-center">
                    <template v-if="workingIn === ''">AGREGANDO NUEVO DTE: {{ retornarDTEname }}</template>
                    <template v-else>
                      <pre style="font-family: inherit">{{ workingIn }}</pre>
                    </template>
                  </div>
                </v-col>
                <v-col cols="12" md="2" sm="3" class="text-sm-right">
                  <v-btn @click="togglehide = !togglehide" small :block="$vuetify.breakpoint.xs" color="primary"
                    class="text-subtitle-1">{{ togglehide ? 'Ampliar' : 'Minimizar' }}</v-btn>
                </v-col>
              </v-row>
            </div>
            <v-card-text class="pa-1">
              <v-row class="d-flex flex-column flex-sm-row justify-space-between align-center gap-4 my-2 px-6" style="
                    font-weight: bold !important;
                    color: black !important;
                    font-size: 11pt !important;
                  ">
                <v-btn class="btn-save" @click="showCustomer = !showCustomer"><v-icon>mdi-file-account</v-icon></v-btn>
                <div>
                  {{ form?.legalname ?? 'Aun sin seleccionar un cliente' }}
                </div>
                <div>
                  {{ form.invoicedate }}
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- INICIO PRIMER CARD POS-->
      <v-card rounded="lg" color="white" class="mb-4 pa-1" v-show="!togglehide">
        <div class="comment rounded-lg white--text py-2 px-1 mb-2">
          <v-row dense align="center">
            <v-col cols="12" md="10" sm="9">
              <div class="text-subtitle-1 flex-grow-1 text-center">
                <template v-if="workingIn === ''">AGREGANDO NUEVO DTE: {{ retornarDTEname }}</template>
                <template v-else>
                  <pre style="font-family: inherit">{{ workingIn }}</pre>
                </template>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="3" class="text-sm-right">
              <v-btn @click="togglehide = !togglehide" small :block="$vuetify.breakpoint.xs" color="primary"
                class="text-subtitle-1">{{ togglehide ? 'Ampliar' : 'Minimizar' }}</v-btn>
            </v-col>
          </v-row>
        </div>
        <v-card-text>
          <v-form ref="posForm">
            <v-row dense>
              <!--v-col cols="12" lg="2" md="5" sm="3">
                <CustomAutoComplete
                  key="idCustomer"
                  v-if="customersList.length > 0"
                  :label="'ID'"
                  v-model="form.idcustomer"
                  :search="{ ...search, filteredFrom: 2 }"
                  :items="customersList"
                  :item-text="'ID_Customer'"
                  :filter-endpoint="$API.customers.filterCustomers"
                  :item-value="'ID_Customer'"
                  @select="
                    (e) => {
                      form.idcustomer = e;
                      customerSelectOnchange(e);
                    }
                  "
                  @updateItems="updateCustomersLIst"
                />
              </v-col-->
              <v-col cols="12" lg="6" md="12" sm="12">
                <div 
                  class="form-group"
                >
                  <v-btn 
                    style="vertical-align: top; margin-right: 5px;"
                    @click="showCustomer = !showCustomer" color="primary">
                    <v-icon >mdi-file-account</v-icon>
                  </v-btn>
                  <v-btn 
                    style="vertical-align: top; margin-right: 5px;"
                    v-if="showAccountStatement"
                    @click="getReportAccountStatement()" color="primary">
                    <v-icon >mdi-account-cash-outline</v-icon>
                  </v-btn>
                  <CustomAutoComplete
                    :style="{width: `calc(100% - ${showAccountStatement ? '140px':'70px'})`}"
                    style="display: inline-block; vertical-align: top;"
                    key="Customer"
                    v-if="customersList.length > 0"
                    :label="'Cliente'"
                    v-model="form.idcustomer"
                    :search="{ ...search, filteredFrom: 2 }"
                    :min-search-length="3"
                    :limit="50"
                    :items="customersList"
                    :item-text="'itemText'"
                    :filter-endpoint="$API.customers.filterCustomers"
                    :item-value="'ID_Customer'"
                    @select="
                      (e) => {
                        form.idcustomer = e;
                        customerSelectOnchange(e);
                        updateTempInvoiceField();
                      }
                    "
                    @updateItems="updateCustomersLIst"
                  />
                </div>
              </v-col>

              <!-- listado de botones -->
              <v-col cols="12" md="12" lg="6" sm="12" class="mb-4">
                <div
                  class="d-flex flex-wrap align-center justify-lg-end justify-center"
                  style="gap: 8px;"
                >
                  <v-btn
                    color="primary"
                    class="text-uppercase"
                    @click.prevent="searchCustomerDialog = true"
                  >
                    BUSCAR CLIENTE
                  </v-btn>

                  <v-btn
                    @click.prevent="searchSeveralCustomer(); updateTempInvoiceField()"
                    color="primary"
                  >
                    CLIENTE VARIOS
                  </v-btn>

                  <v-btn
                    v-if="posrestaurant"
                    color="primary"
                    class="text-uppercase"
                    @click.prevent="showSearchCustomerTableDialog = true"
                  >
                    MESAS
                  </v-btn>

                  <v-btn
                    v-if="
                      form.invoicetype != 'DNC' && form.invoicetype != 'DND' && form.invoicetype != 'DNR'
                      && TipoPlan != 'Ecoanual CONAMYPE'
                      && !isCreditPaymentRestricted
                    "
                    color="primary"
                    @click="showDialogAdvancePayments = !showDialogAdvancePayments"
                  >
                    ANTICIPOS
                  </v-btn>

                  <v-btn
                    color="primary"
                    class="text-uppercase"
                    @click="showDialogSaleThirdParty = true"
                    v-if="TipoPlan != 'Ecoanual CONAMYPE'"
                  >
                    V. TERCEROS
                  </v-btn>

                </div>
              </v-col>
              <v-col cols="12" class="mb-3" v-if="isCustomerSelected && validateform">
                <h3>Faltan datos por rellenar para el cliente</h3>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6">
                <date-picker
                  label="Fecha"
                  v-model="form.invoicedate"
                  @dateSelected="(param) =>{ 
                    form.invoicedate = param;
                    updateTempInvoiceField()
                  }"
                  dense
                  >
                  <!--:disbaled="isCarsem ? true : false"-->
                </date-picker>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="false">
                <v-text-field
                  outlined
                  dense
                  class="text-input-red"
                  style="font-weight: bold"
                  v-model="form.legalidinvoice"
                  @input="(value) => updateTempInvoiceField()"
                  label="Correlativo fiscal"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6">
                <v-select
                  outlined
                  dense
                  attach
                  v-model="form.invoicetype"
                  :disabled="contingency != null && ['RECHAZADO', 'CONTINGENCIA'].includes(header?.FeMhEstado)"
                  @change="(value) => {
                    getInvoiceId().subscribe();
                    updateTempInvoiceField();
                    setEnableQuantitiesVal();
                  }"
                  :items="filterType"
                  item-text="name"
                  item-value="key"
                  :label="$t('vwinvoices_cinvoicetype')"
                  class="fast-ease-in-transitioned-element"
                >
                </v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.isquote == 0 && pospayments == 0">
                <v-select
                  outlined
                  dense
                  v-model="form.invoicepaymenttype"
                  @change="(value) => {
                    updateTempInvoiceField()
                  }"
                  attach
                  :items="visiblePaymentTypes"
                  item-text="Valores"
                  item-value="Valores"
                  label="Método de pago"
                  :disabled="isCreditPaymentRestricted"
                  class="fast-ease-in-transitioned-element"
                  :rules="required"
                >
                </v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6"
              v-if="
                form.invoicepaymenttype != 'Billetes y monedas' &&
                pospayments == 0 &&
                form.invoicepaymenttype != undefined &&
                form.invoicepaymenttype != '' &&
                form.invoicetype != 'DND' &&
                form.invoicetype != 'DNC'"
              >
                <v-text-field
                  outlined
                  dense
                  v-model="form.invoicereference"
                  @input="(value) => {
                    updateTempInvoiceField()
                  }"
                  label="N. Referencia"
                >
                </v-text-field>
              </v-col>
              <v-col id="parent" cols="12" lg="3" md="4" sm="6" v-if="form.isquote == 0">
                <v-select
                  outlined
                  dense
                  attach
                  v-model="form.invoicestatusdescription"
                  :items="checkCountryInvoiceStatuses"
                  label="Estado de la factura"
                  :rules="required"
                  @change="(value) => {
                    updateTempInvoiceField()
                  }"
                >
                  </v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="ndornc == null && (form.invoicetype == 'DNC' || form.invoicetype == 'DND')">
                <v-text-field
                  outlined
                  dense
                  attach
                  v-model="form.nccodigorelacionado"
                  label="Doc. relacionado fisico"
                  :rules="required"
                >
                  </v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="ndornc == null && (form.invoicetype == 'DNC' || form.invoicetype == 'DND')">
                <date-picker
                  label="Fecha doc. relacionado"
                  v-model="form.ncfecharelacionado"
                  @dateSelected="(param) => (form.ncfecharelacionado = param)"
                  dense
                  class="fast-ease-in-transitioned-element"
                >
                </date-picker>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicestatusdescription == 'Crédito'">
                <v-select
                  outlined
                  dense
                  v-model="form.invoicecreditday"
                  attach
                  :items="creditDays"
                  label="Días de crédito"
                  :readonly="readOnlyCreditDays()"
                  @input="(value) => {
                    updateTempInvoiceField()
                  }"
                  :rules="required"
                >
                </v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="legalidInvoiceCondition() && false">
                <template v-if="form.invoicetype == 'CCF'">
                  <v-text-field
                    outlined
                    dense
                    class="text-input-red fast-ease-in-transitioned-element"
                    style="font-weight: bold"
                    v-model="form.legalidinvoice"
                    label="Correlativo fiscal"
                    disabled
                    :rules="required"
                  ></v-text-field>
                </template>
                <template v-else>
                  <v-text-field
                    outlined
                    dense
                    class="text-input-red fast-ease-in-transitioned-element"
                    style="font-weight: bold"
                    v-model="form.legalidinvoice"
                    label="Correlativo fiscal"
                    disabled
                  ></v-text-field>
                </template>
              </v-col>
              <v-col  cols="12" lg="3" md="8" sm="12" v-show="mostrarOcultarVendedor()">
                <div
                  class="form-group"
                >
                  <v-btn
                    style="vertical-align: top; margin-right: 5px;"
                    v-if="sellersList.length > 0"
                    color="primary"
                    @click="searchSellerDialog = !searchSellerDialog"
                  >
                    <v-icon v-if="sellersList.length > 0">mdi-magnify</v-icon>
                  </v-btn>
                  
                  <CustomAutoComplete
                    style="display: inline-block; width: calc(100% - 70px); vertical-align: top;"
                    v-if="sellersList.length > 0"
                    :label="`Vendedor${
                      POSRequiredIdSeller === 1 ? '*' : ''
                    } `"
                    v-model="form.ID_Seller"
                    :search="{ ...search }"
                    :items="sellersList"
                    :item-text="'FullName'"
                    :filter-endpoint="$API.sellers.getAllSellersFiltered"
                    :item-value="'ID_Seller'"
                    @select="
                      (e) => {
                        form.ID_Seller = e;
                        updateTempInvoiceField()
                      }
                    "
                    @updateItems="updateSellersList"
                    :required="POSRequiredIdSeller === 1"
                  />
                </div>
              </v-col>
              <v-col  cols="12" lg="3" md="8" sm="12" v-show="mostrarOcultarTecnicos()">
                <div
                  class="form-group"
                >
                  <v-btn
                    style="vertical-align: top; margin-right: 5px;"
                    v-if="technicalList.length > 0"
                    color="primary"
                    @click="searchTechnicalDialog = !searchTechnicalDialog"
                  >
                    <v-icon v-if="technicalList.length > 0">mdi-magnify</v-icon>
                  </v-btn>
                  
                  <CustomAutoComplete
                    style="display: inline-block; width: calc(100% - 70px); vertical-align: top;"
                    v-if="technicalList.length > 0"
                    :label="`Técnico${
                      POSRequiredIdSeller === 1 ? '*' : ''
                    } `"
                    v-model="form.ID_Technical"
                    :search="{ ...search }"
                    :items="technicalList"
                    :item-text="'FullName'"
                    :filter-endpoint="$API.sellers.getAllTechnicalFiltered"
                    :item-value="'ID_Seller'"
                    @select="
                      (e) => {
                        form.ID_Technical = e;
                        updateTempInvoiceField()
                      }
                    "
                    @updateItems="updateTechnicalList"
                    :required="POSRequiredIdSeller === 1"
                  />
                </div>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="EnableZoneConfiguration">
                <v-select
                  :items="ZoneConfiguration"
                  v-model="form.zoneclient"
                  label="Zona del cliente: "
                  outlined
                  attach
                  dense
                  @change="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "
                  ></v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'CDD'">
              <v-select
                  outlined
                  dense
                  v-model="form.codasociado"
                  attach
                  :items="codigosAsociados"
                  item-value="id"
                  item-text="valor"
                  label="Código de documento asociado"
                  class="fast-ease-in-transitioned-element"
                  :rules="required"
                  @change="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  ">
                </v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX'">
                <v-select
                  outlined
                  dense
                  v-model="form.codasociado"
                  attach
                  :items="codigosAsociadosEx"
                  item-value="id"
                  item-text="valor"
                  label="Código de documento asociado"
                  class="fast-ease-in-transitioned-element"
                  @change="updateTempInvoiceField()">
                </v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'CDD' || form.invoicetype == 'FEX'">
                <v-text-field v-model="form.docasociado" dense outlined label="Documento asociado *" :rules="required"
                  @input="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'CDD' || form.invoicetype == 'FEX'">
                <v-text-field v-model="form.detalleasociado" dense outlined label="Detalle de documento asociado *"
                  :rules="required" @input="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && form.codasociado == 4">
                <v-select
                  outlined
                  dense
                  v-model="form.modotransp"
                  attach
                  :items="modoTransporte"
                  item-value="id"
                  item-text="valor"
                  label="Modo de transporte"
                  class="fast-ease-in-transitioned-element"
                  @input="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "
                >
                </v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && form.codasociado == 4">
                <v-text-field
                  v-model="form.numconductor"
                  dense
                  outlined
                  label="N. identificación de conductor"
                  @input="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && form.codasociado == 4">
                <v-text-field
                  v-model="form.nombreconductor"
                  dense
                  outlined
                  label="Nombre del conductor"
                  @input="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && form.codasociado == 4">
                <v-text-field
                  v-model="form.placatrans"
                  dense
                  outlined
                  label="Placa del transporte"
                  @input="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX'">
                <v-text-field
                  v-model="form.seguro"
                  type="number"
                  dense
                  outlined
                  label="Seguro"
                  @input="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX'">
                <v-text-field
                  v-model="form.flete"
                  type="number"
                  dense
                  outlined
                  label="Flete"
                  @input="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX'">
                <v-select
                  outlined
                  dense
                  v-model="form.fexzona"
                  attach
                  :items="zonasExportacion"
                  :rules="required"
                  item-value="id"
                  item-text="valor"
                  label="Zona de Exportación *"
                  class="fast-ease-in-transitioned-element"
                  @input="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "
                >
                </v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'DNR'">
                <v-select
                  outlined
                  dense
                  v-model="form.bientitulo"
                  attach
                  :items="bienTitulo"
                  item-value="id"
                  item-text="value"
                  label="Bienes Remitidos a Títulos de"
                  class="fast-ease-in-transitioned-element"
                  :rules="required"
                >
                </v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'">
                <v-text-field
                  v-model="form.portofdeparture"
                  dense
                  outlined
                  label="PORT OF DEPARTURE / PUERTO DE SALIDA:"
                  @input="
                    (e) => {
                      updateTempInvoiceField()
                    }
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'">
                <v-text-field
                  v-model="form.shipmentno"
                  dense
                  outlined
                  label="SHIPMENT No / EMBARQUE No:"
                  @input="(value) => updateTempInvoiceField()"
                ></v-text-field>
              </v-col>
              <v-col v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'" cols="12" lg="3" md="4" sm="6">
                <v-text-field
                  v-model="form.containerno"
                  dense
                  outlined
                  @input="(value) => updateTempInvoiceField()"
                  label="CONTAINER No / CONTENEDOR No:"
                ></v-text-field>
              </v-col>
              <v-col v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'" cols="12" lg="3" md="4" sm="6">
                <v-text-field
                  v-model="form.blno"
                  dense
                  outlined
                  label="B/L No:"
                  @input="(value) => updateTempInvoiceField()"
                ></v-text-field>
              </v-col>
              <v-col v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'" cols="12" lg="3" md="4" sm="6">
                <v-text-field
                  v-model="form.vesselvoyage"
                  dense
                  outlined
                  label="VESSEL & VOYAGE / BARCO Y VIAJE:"
                  @input="(value) => updateTempInvoiceField()"
                ></v-text-field>
              </v-col>
              <v-col v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'" cols="12" lg="3" md="4" sm="6">
                <v-text-field
                  v-model="form.usadfa"
                  dense
                  outlined
                  label="USA FDA:"
                  @input="(value) => updateTempInvoiceField()"
                ></v-text-field>
              </v-col>
              <v-col v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'" cols="12" lg="3" md="4" sm="6">
                <v-text-field
                  v-model="form.termsofpayment"
                  dense
                  outlined
                  label="TERMS OF PAYMENT / TERMINO DE PAGO:"
                  @input="(value) => updateTempInvoiceField()"
                ></v-text-field>
              </v-col>
              <v-col v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'" cols="12" lg="3" md="4" sm="6">
                <v-select
                  outlined
                  dense
                  v-model="form.codincoterms"
                  attach
                  :items="incoterms"
                  item-value="id"
                  item-text="valor"
                  label="INCOTERMS:"
                  class="fast-ease-in-transitioned-element"
                  @change="(value) => updateTempInvoiceField()"
                >
                </v-select>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" class="mb-4" v-if="form.ventaterceronit && form.ventaterceronombre">
                <v-card>
                  <v-card-title>Venta a Terceros</v-card-title>
                  <v-card-text style="color: black !important;">
                    <b>NIT: </b>{{form.ventaterceronit}} 
                    <br/>
                    <b>Nombre, denomincación o razón social: </b>{{form.ventaterceronombre}}
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-row dense class="align-center">
                  <v-col cols="12" sm="4" class="py-0">
                    <v-btn
                      :class="`${showBgcolorNotes} mt-3 text-subtitle-1`"
                      @click="showComment = !showComment"
                      color="comment"
                    >
                      Responsable Emisor/Receptor del DTE
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="4" class="py-0">
                    <v-btn
                      :class="`${showBgcolorNotes} mt-3 text-subtitle-1`"
                      @click="showInvoiceComments = !showInvoiceComments"
                      color="comment"
                    >
                      Comentarios
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="4" class="py-0">
                    <v-btn
                      :class="`${showBgcolorNotes} mt-3 text-subtitle-1`"
                      @click="openApendiceDialog"
                      color="comment"
                    >
                      Apéndices
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>  
      </v-card>
      <!-- FIN PRIMER CARD POS-->

      <!-- INICIO DIALOGO COMENTARIO DE FACTURA -->
      <v-dialog v-model="showComment" max-width="1000">
        <v-card>
          <v-card-title class="text-h5"
            >Responsable Emisor/Receptor del DTE</v-card-title
          >
          <v-card-text>
            <v-alert type="info" outlined dense class="mb-4">
              Use esta opción cuando la factura deba incluir los datos del
              responsable que emite y recibe el DTE, tal como lo solicita el
              Ministerio de Hacienda en los casos en que se requieren estos
              datos adicionales.
            </v-alert>
            <v-row class="mt-1">
              <v-col cols="12" md="12">
                <v-checkbox
                  hide-details
                  v-model="form.showresponsabilitiesininvoice"
                  :true-value="1"
                  :false-value="0"
                  label="Enviar informacion de responsables emisor / receptor (obligatorio a partir de $25,000.00)"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row class="mt-1" v-if="form.showresponsabilitiesininvoice">
              <v-col cols="12" class="my-2"><b>Emisor</b></v-col>
              <v-col cols="12">
                <v-select
                  outlined
                  dense
                  attach
                  v-model="responsableDteUserId"
                  :items="dteUsers"
                  item-text="label"
                  item-value="value"
                  label="Nombre del responsable que genera el DTE"
                  @change="handleDteResponsibleChange"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.extensiondocuentrega"
                  label="Documento de identificación de quien genera el DTE"
                  :rules="responsibleDataRequired ? required : []"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.extensiontelefonoentrega"
                  label="Teléfono del responsable que genera el DTE"
                  :rules="responsibleDataRequired ? required : []"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="my-2"><b>Receptor</b></v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  v-model="form.extensionnombrecibe"
                  label="Nombre del responsable por parte del receptor"
                  :rules="responsibleDataRequired ? required : []"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.extensiondocurecibe"
                  label="Documento de identificación del responsable por parte del receptor"
                  :rules="responsibleDataRequired ? required : []"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.extensiontelefonorecibe"
                  label="Teléfono del responsable por parte del receptor"
                  :rules="responsibleDataRequired ? required : []"
                ></v-text-field>
              </v-col>
              
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-right">
              <v-btn
                @click="showComment = !showComment"
                class="btndisable"
              >
                Continuar
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- FIN DIALOGO COMENTARIO FACTURA -->

      <!-- INICIO DIALOGO COMENTARIOS DE FACTURA -->
      <v-dialog v-model="showInvoiceComments" max-width="1000">
        <v-card>
          <v-card-title class="text-h5">Comentarios</v-card-title>
          <v-card-text>
            <v-row class="mt-1">
              <v-col cols="12">
                <v-radio-group
                  v-if="form.isquote == 1"
                  v-model="form.rulestoshowcomments"
                  class="mb-4"
                >
                  <v-radio
                    label="Incluir comentario en comprobantes y cotización"
                    :value="0"
                  ></v-radio>
                  <v-radio
                    label="Incluir comentario solo en comprobantes"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Incluir comentario solo en cotización"
                    :value="2"
                  ></v-radio>
                </v-radio-group>
                <quill-editor
                  :options="quillOptions"
                  class="mt-5"
                  @change="onEditorChange($event)"
                  v-model="form.invoiceinternalnote"
                ></quill-editor>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-right">
              <v-btn
                @click="showInvoiceComments = !showInvoiceComments"
                class="btndisable"
              >
                Continuar
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- FIN DIALOGO COMENTARIOS DE FACTURA -->

      <!-- INICIO DIALOGO APENDICE FACTURA -->
      <v-dialog v-model="showApendice" max-width="1100" scrollable>
        <v-card>
          <v-card-title class="text-h5">Apéndices</v-card-title>
          <v-card-text>
            <v-alert type="info" outlined dense class="mb-4">
              Use este espacio cuando necesite agregar información
              complementaria a la factura, como referencias, observaciones o
              datos adicionales que el Ministerio de Hacienda permita incluir
              como apéndice.
            </v-alert>
            <v-form ref="apendiceForm">
              <v-row class="mt-1">
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn
                    color="primary"
                    class="text-uppercase"
                    small
                    :disabled="apendiceRows.length >= 10"
                    @click.prevent="addApendiceRow"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="12">
                  <DxDataGrid
                    :data-source="apendiceRows"
                    :show-borders="true"
                    :column-auto-width="true"
                    :key-expr="'_rowId'"
                    :scrolling="{ useNative: true }"
                  >
                    <DxColumn cell-template="deleteApendice" caption="" :width="70" />
                    <DxColumn cell-template="campoApendice" caption="Campo" :width="220" />
                    <DxColumn cell-template="etiquetaApendice" caption="Etiqueta" :min-width="260" />
                    <DxColumn cell-template="valorApendice" caption="Valor" :min-width="260" />

                    <template #deleteApendice="{ data }">
                      <a
                        href="#"
                        class="mx-1"
                        @click.prevent.stop="removeApendiceRow(data.data)"
                      >
                        <v-icon color="error">mdi-delete</v-icon>
                      </a>
                    </template>

                    <template #campoApendice="{ data }">
                      <v-combobox
                        v-model="data.data.campo"
                        :items="apendiceCampoOptions"
                        item-text="text"
                        item-value="value"
                        dense
                        outlined
                        hide-details="auto"
                        class="fast-ease-in-transitioned-element"
                        :rules="apendiceFieldRules.campo"
                        @input="onApendiceCampoChange(data.data, $event)"
                      ></v-combobox>
                    </template>

                    <template #etiquetaApendice="{ data }">
                      <v-text-field
                        v-model="data.data.etiqueta"
                        dense
                        outlined
                        hide-details="auto"
                        :rules="apendiceFieldRules.etiqueta"
                        @input="syncApendiceFormValue"
                      ></v-text-field>
                    </template>

                    <template #valorApendice="{ data }">
                      <v-text-field
                        v-model="data.data.valor"
                        dense
                        outlined
                        hide-details="auto"
                        :rules="apendiceFieldRules.valor"
                        @input="syncApendiceFormValue"
                      ></v-text-field>
                    </template>
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-right">
              <v-btn
                @click="closeApendiceDialog"
                class="btndisable"
              >
                Continuar
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- FIN DIALOGO APENDICE FACTURA -->

    <!-- INICIO DIALOGO INFORMACIÓN DEL CLIENTE -->
    <v-dialog v-model="showCustomer" scrollable max-width="1280">
      <v-card style="overflow: auto; max-height: 95vh;">
        <v-card-title
          style="display: flex; justify-content: space-between"
        >
          <div class="text-h5">Información del cliente</div>
          <v-checkbox
            v-model="newCostumer"
            :disabled="isCustomerSelected"
            label="Nuevo cliente"
          ></v-checkbox>
        </v-card-title>
        <v-card-text>
          <new-customer-screen
            v-if="newCostumer"
            :initial-invoice-type="form.invoicetype"
            @cancel="newCostumer = false"
            @error="showAlert('warning', 'Advertencia', $event)"
            @submit="handleNewCustomerSubmit"
          />
          
          <form v-else v-show="showCustomer">
            
            <!--div
              class="mt-2 mb-5"
              style="width: 100%"
              v-if="isCustomerSelected"
            >
              <h4>
                <b>{{ $t("vwinvoices_cidclient") }}</b>
                {{ form.idcustomer }}
                <b>{{ form.isa_business ? "Negocio: " : "Cliente: " }}</b>
                {{
                  this.form.isa_business
                    ? form.businessname
                    : form.firstname + " " + form.lastname
                }}
              </h4>
            </div-->
            <v-row v-if="showAccountStatement" class="mt-1 mb-5">
              <v-col cols="12">
                <b>Información crediticia</b>
              </v-col>
              <v-col cols="3">
                Saldo actual:
                <b>
                  ${{ (customerCreditInformation?.TotalDebt || 0).toFixed(2) }}
                </b>
              </v-col>
              <v-col cols="3">
                Estado del crédito:
                <b>
                  {{ customerSelectedData?.CreditStatus }}
                </b>
              </v-col>
              <v-col cols="3">
                Período del crédito:
                <b>
                  {{ customerSelectedData?.CreditPeriod }}
                  {{ customerSelectedData?.CreditPeriod > 1 ? 'días' : 'día' }}
                </b>
              </v-col>
              <v-col cols="3">
                Monto límite:
                <b>
                  ${{ customerSelectedData?.LimitCredit }}
                </b>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col cols="12" md="6">
                <v-text-field
                  v-if="
                    form.invoicetype == 'FCF' ||
                    form.invoicetype == 'CCF'
                  "
                  outlined
                  dense
                  v-model="form.legalname"
                  :label="$t('vwinvoices_clegalname')"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.legalname"
                  :label="$t('vwinvoices_clegalname')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.legaladdress"
                  :label="$t('vwinvoices_clegaladdress')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="['452476470895e11843a44d7053b6521e'].includes(keyMaster)">
                <v-text-field
                  outlined
                  dense
                  v-model="form.legaladdress2"
                  label="Dirección Complementaria"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" v-if="!form.isa_business">
                <v-text-field
                  v-if="
                    form.invoicetype == 'CCF' ||
                    (form.invoicetype == 'FCF' &&
                      sumObject.total > 25000.0)
                  "
                  outlined
                  dense
                  v-model="form.dui"
                  label="Documento identidad"
                  @input="getDuiMask"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.dui"
                  label="Documento identidad"
                  @input="getDuiMask"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" v-if="form.isa_business">
                <v-text-field
                  v-if="
                    form.invoicetype == 'FCF' &&
                    sumObject.total > 25000.0
                  "
                  outlined
                  dense
                  v-model="form.dui"
                  label="Documento identidad"
                  @input="getDuiMask"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.dui"
                  label="Documento identidad"
                  @input="getDuiMask"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" v-if="!form.isa_business">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.phonenumber"
                  label="Número de télefono:"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.phonenumber"
                  label="Número de télefono:"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" v-if="form.isa_business">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.businesscontactphone"
                  label="Número de télefono:"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.businesscontactphone"
                  label="Número de télefono:"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" v-if="!form.isa_business">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.email"
                  label="Correo eléctronico: "
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.email"
                  label="Correo eléctronico: "
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" v-if="form.isa_business">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.businesscontactemail"
                  label="Correo eléctronico: "
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.businesscontactemail"
                  label="Correo eléctronico: "
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.legalnit"
                  :label="$t('vwinvoices_clegalnit')"
                  @keyup="getNITMask"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.legalnit"
                  :label="$t('vwinvoices_clegalnit')"
                  @keyup="getNITMask"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.legalnrc"
                  :label="$t('vwinvoices_clegalnrc')"
                  @input="getNRCMask"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.legalnrc"
                  :label="$t('vwinvoices_clegalnrc')"
                  @input="getNRCMask"
                ></v-text-field>
              </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete
                    outlined
                    dense
                    v-model="form.legalentity"
                    attach
                  :items="businessEntityOptions"
                    :label="$t('vwinvoices_clegalentity')"
                  ></v-autocomplete>
                </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  label="Actividad economica:*"
                  :items="activities"
                  @change="changueValueactivity"
                  attach
                  v-model="form.codactividad"
                  item-text="Valores"
                  item-value="Codigo"
                  :rules="required"
                ></v-autocomplete>
                <v-autocomplete
                  v-else
                  outlined
                  dense
                  label="Actividad economica:*"
                  :items="activities"
                  @change="changueValueactivity"
                  attach
                  v-model="form.codactividad"
                  item-text="Valores"
                  item-value="Codigo"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="3">
                <v-select
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  :items="taxpayersize"
                  item-value="key"
                  attach
                  item-text="value"
                  v-model="form.legaltaxpayersize"
                  :label="$t('vwinvoices_clegaltaxpayersize')"
                  :rules="required"
                >
                </v-select>
                <v-select
                  v-else
                  outlined
                  dense
                  :items="taxpayersize"
                  item-value="key"
                  attach
                  item-text="value"
                  v-model="form.legaltaxpayersize"
                  :label="$t('vwinvoices_clegaltaxpayersize')"
                >
                </v-select>
              </v-col>
              <!--  <v-col cols="12" md="5">
                <v-text-field outlined dense 
                  v-model="form.legalsector"
                  :label="$t('vwinvoices_clegalsector')"
                ></v-text-field>
              </v-col> -->
              <v-col style="display: none" cols="12" md="4">
                <v-text-field
                  outlined
                  dense
                  v-model="form.information"
                  :label="$t('vwinvoices_clegalinformation')"
                ></v-text-field>
              </v-col>            
              
              <v-col class="align-self-center" cols="12" md="3">
                <v-checkbox
                  :value="form.legalisnontaxable"
                  v-model="form.legalisnontaxable"
                  :label="$t('vwinvoices_cclientisnontaxable')"
                ></v-checkbox>
              </v-col>

              <v-col cols="12">
                <v-combobox
                  v-model="BccEmails"
                  :items="BccEmails"
                  multiple
                  chips
                  outlined
                  attach
                  label="Enviar facturas a (como copias)"
                  clearable
                  @blur="validateEmails"
                ></v-combobox>
              </v-col>
              <!-- <v-col class="align-self-center" cols="12" md="3">
                <v-checkbox
                  :value="form.legalisexempt"
                  v-model="form.legalisexempt"
                  label="Cliente exento"
                ></v-checkbox>
              </v-col> -->
              <!--<v-col cols="12" lg="4">
                                  <v-select outlined dense  :items="['Foo', 'Bar', 'Fizz', 'Buzz']" label="Payment Type" attach> 
                                      <template v-slot:item="{ item, attrs, on }">
                                          <v-list-item v-bind="attrs" v-on="on">
                                              <v-list-item-title :id="attrs['aria-labelledby']" v-text="item"
                                              ></v-list-item-title>
                                          </v-list-item>
                                      </template>
                                  </v-select>
                              </v-col>-->
              <v-col cols="12" mb="12" class="mb-4"
                ><v-btn
                  class="btndisable float-right"
                  @click="
                    newCostumer ? addNewCustomer() : '';
                    showCustomer = !showCustomer;
                  "
                  >Continuar</v-btn
                ></v-col
              >
              <!--v-col cols="12" lg="4" class="align-self-center mb-4" v-if="!isCustomerSelected">
                                  <v-btn color="primary" class="text-uppercase" @click.prevent="addNewClient">
                                      {{$t('vwinvoices_csaveasnewclient')}}
                                  </v-btn>
                              </v-col-->
            </v-row>
          </form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- FIN DIALOGO INFORMACIÓN CLIENTE -->

    <!-- SEGUNDO CARD POST -->
      <v-row
        id="tohidediv"
        v-show="!togglehide"
        style="margin-top: -10px !important"
      >
        <!--<v-col cols="12">
          <div class="white pa-4 border-5 box">
            <div style="width: 100%; margin: 0;" class="tabs" @click="showProductsAndServices = !showProductsAndServices">
                  <v-icon v-if="showProductsAndServices" color="white" left>
                    mdi-minus
                  </v-icon>
                  <v-icon v-else color="white" left> mdi-plus </v-icon>
                  Ver productos y servicios disponibles
            </div-->

        <div>
          <v-dialog
            v-model="showProductsAndServices"
            scrollable
            max-width="1300"
            @keydown.enter="handleEnterKey"
            @keydown.down="handleKeyDown"
            tabindex="0"
          >
            <v-card>
              <v-card-title class="text-h5">
                Productos y servicios disponibles
              </v-card-title>
              <v-card-text>
                <div v-if="showProductsAndServices">
                  <v-row class="d-flex align-center mt-4" v-if="!showExtraInfoBatch">
                    <v-col cols="auto">
                      <v-radio-group
                        v-model="displayInvoice"
                        row
                        class="mr-2"
                      >
                        <v-radio
                          label="Productos"
                          value="products"
                        />
                        <v-radio
                          label="Servicios"
                          value="services"
                        />
                      </v-radio-group>
                    </v-col>
                    <v-col cols="auto">
                      <v-checkbox
                      outlined
                      dense
                      v-model="filterProducts.showZeroQuantities"
                      :value="1"
                      label="Mostrar productos sin existencias"
                      style="margin-top: -4px;"
                      />
                    </v-col>
                    <v-col cols="auto">
                      <v-checkbox
                      outlined
                      dense
                      v-model="minProductView"
                      :value="true"
                      label="Vista minimizada"
                      style="margin-top: -4px;" v-if="displayInvoice == 'products'"
                      />
                    </v-col>
                    <v-col cols="12" class="mt-2 text-right">
                      Escriba un nombre o codigo, presione enter o el boton buscar para obtener resultados.
                    </v-col>
                  </v-row>
                  <h3 v-if="showExtraInfoBatch">Este producto tiene varios lotes en inventario. Por favor, selecciona el lote que deseas descargar.</h3>
                  <template v-if="displayInvoice === 'products'">
                    <div>
                      <v-btn
                        class="btnclean"
                        style="margin-bottom: 10px; display: none"
                        dark
                        @click.prevent="showFilter = true"
                        >{{ $t("vwinvoices_cfilter") }}</v-btn
                      >
                      <v-bottom-sheet v-model="showFilter" inset>
                        <v-sheet class="text-center">
                          <v-btn
                            class="mt-6"
                            text
                            color="error"
                            @click="showFilter = !showFilter"
                          >
                            close
                          </v-btn>
                          <div class="my-3 pa-4">
                            <v-select
                              outlined
                              dense
                              hide-details
                              :items="priceList"
                              attach
                              class="mb-2"
                              v-model="filterProducts.pricelist"
                              item-text="id"
                              item-value="id"
                              :label="$t('vwinvoices_cpricelist')"
                            ></v-select>
                            <v-select
                              outlined
                              dense
                              hide-details
                              attach
                              :items="types"
                              class="mb-2"
                              v-model="filterProducts.type"
                              :label="$t('vwinvoices_citemstype')"
                            >
                            </v-select>
                            <v-select
                              outlined
                              dense
                              hide-details
                              attach
                              :items="warehouse"
                              item-text="Warehouse"
                              item-value="ID_Warehouse"
                              class="mb-2"
                              v-model="filterProducts.warehouse"
                              :label="$t('vwinvoices_cwarehouse')"
                            >
                            </v-select>
                            <v-select
                              outlined
                              dense
                              hide-details
                              attach
                              :items="provider"
                              item-text="ProviderName"
                              item-value="ID_Provider"
                              class="mb-2"
                              v-model="filterProducts.provider"
                              label="Proveedor"
                            >
                            </v-select>
                          </div>
                        </v-sheet>
                      </v-bottom-sheet>
                    </div>
                    <GeneralFilter
                      ref="generalFilter"
                      :breakline="true" 
                      :filterEndpoint="
                        $API.products.getProductsToBillForInvoiceFiltered
                      "
                      :search="filterProducts"
                      @emptyFilter="getProductsOnFilter"
                      @filtered="productsFilterHandler"
                      col-md-search="12"
                    >
                      <template #options>
                        <div class="product-filter-inline-selects product-filter-inline-selects--grid">
                          <div class="row mb-3">
                            <div class="col-12 col-md-4">
                              <v-select
                                class="w-full"
                                outlined
                                dense
                                hide-details
                                clearable
                                attach
                                :items="sortedFamilies"
                                item-text="name"
                                item-value="value"
                                v-model="filterProducts.family"
                                label="Familia"
                                @change="handleFamilyChange"
                              />
                            </div>
                            <div class="col-12 col-md-4">
                              <v-select
                                class="w-full"
                                outlined
                                dense
                                hide-details
                                clearable
                                attach
                                :items="filteredCategories"
                                item-text="name"
                                item-value="value"
                                v-model="filterProducts.category"
                                label="Categoría"
                                :disabled="!filterProducts.family"
                                @change="handleCategoryChange"
                              />
                            </div>
                            <div class="col-12 col-md-4">
                              <v-select
                                class="w-full"
                                outlined
                                dense
                                hide-details
                                clearable
                                attach
                                :items="filteredSubcategories"
                                item-text="name"
                                item-value="value"
                                v-model="filterProducts.subcategory"
                                label="Subcategoría"
                                :disabled="!filterProducts.category"
                                @change="applyProductsClassificationFilter"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                      <DxDataGrid
                        ref="dxDataGridInstance"
                        style="max-height: 250px"
                        class="isScrolledByGeneralFilter"
                        :data-source="productsToBill"
                        key-expr="ID_Item"
                        :keyboard-navigation="{
                          enabled: true,
                          enterKeyAction: 'moveFocus',
                          enterKeyDirection: 'column',
                        }"
                        :allow-column-resizing="true"
                        column-resizing-mode="widget"
                        :column-auto-width="true"
                        :paging="{ enabled: false }"
                      >
                        <DxScrolling row-rendering-mode="virtual" />
                        <!--DxPaging :page-size="5" /-->
                        <DxColumn
                          :width="45"
                          cell-template="show-template"
                          caption=""
                        ></DxColumn>
                        <DxColumn
                          :width="150"
                          data-field="ID_Item"
                          caption="ID"
                          v-if="!minProductView"
                        ></DxColumn>
                        <DxColumn
                          :width="100"
                          data-field="BarCode"
                          caption="Código alterno"
                        ></DxColumn>
                        <DxColumn
                          data-field="ItemName"
                          caption="Producto"
                          v-if="!minProductView"
                        ></DxColumn>
                        <DxColumn
                          data-field="ItemComercialName"
                          caption="Nombre comercial"
                          v-if="!minProductView"
                        ></DxColumn>
                         <DxColumn
                          :width="260"
                          cell-template="commercialNameTemplate"
                          caption="Nombre comercial"
                          v-if="minProductView"
                        ></DxColumn>
                        <template #commercialNameTemplate="{ data }">
                          <div class="text-wrap">
                            {{ data.data.ItemComercialName }}
                          </div>
                        </template>
                        <DxColumn
                          :width="130"
                          data-field="PriceListName"
                          caption="PriceListName"
                          v-if="!minProductView"
                        ></DxColumn>
                        <DxColumn
                          :width="90"
                          data-field="ExpirationDate"
                          caption="Vencimiento"
                          v-if="minProductView"
                        />
                        <DxColumn
                          :width="90"
                          data-field="ID_ItemBatch"
                          caption="Lote"
                          v-if="minProductView"
                        />
                        <DxColumn
                          :width="130"
                          data-field="PriceListName"
                          caption="PriceListName"
                          v-if="minProductView"
                        ></DxColumn>
                        <!-- <DxColumn :width="120" data-field="ItemNewPrice" caption="Precio"></DxColumn> -->
                        <DxColumn
                          :width="120"
                          cell-template="itemPriceFormatted"
                          caption="Precio"
                        ></DxColumn>
                        <DxColumn
                          :width="60"
                          data-field="ItemCurrentQuantity"
                          caption="Existencias"
                        ></DxColumn>
                        <DxColumn
                          :width="130"
                          data-field="ID_ItemBatch"
                          caption="Lote"
                          v-if="!minProductView"
                        ></DxColumn>
                        <DxColumn
                          :width="130"
                          data-field="ExpirationDate"
                          caption="Vencimiento"
                          v-if="!minProductView"
                        ></DxColumn>
                        <DxColumn
                          :width="130"
                          data-field="NameWarehouse"
                          caption="Warehouse"
                        ></DxColumn>
                        <DxColumn
                          :width="130"
                          data-field="NameFamily"
                          caption="Familia"
                        ></DxColumn>
                        <DxColumn
                          :width="130"
                          data-field="NameCategory"
                          caption="Categoría"
                        ></DxColumn>
                        <DxColumn
                          :width="130"
                          data-field="NameSubCategory"
                          caption="Subcategoría"
                        ></DxColumn>
                        <template #show-template="{ data }">
                          <a
                            ref="plusIcon"
                            href="#"
                            class="mx-1"
                            tabindex="0"
                            @click.prevent.stop="
                              triggerAddItemEvent(data.data, 1)
                            "
                            @keyup.space.prevent="handleSpace(data.data)"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </a>
                        </template>
                        <template #itemPriceFormatted="{ data }">
                          {{ Currency
                          }}{{ numberWithCommas(data.data.ItemNewPrice) }}
                        </template>
                      </DxDataGrid>
                    </GeneralFilter>
                  </template>
                  <template v-else-if="displayInvoice === 'services'">
                    <GeneralFilter
                      ref="dxDataGridInstance"
                      :filterEndpoint="
                        $API.services.getAllServicesWithPriceListFiltered
                      "
                      :search="filterServices"
                      @emptyFilter="getServicesOnFilter"
                      @filtered="servicesFilterHandler"
                      :col-md-search="12"
                    >
                      <template #options>
                        <div class="product-filter-inline-selects product-filter-inline-selects--grid">
                          <div class="row mb-2">
                            <div class="col-12 col-md-4">
                              <v-select
                                class="w-full"
                                outlined
                                dense
                                hide-details
                                clearable
                                attach
                                :items="sortedFamilies"
                                item-text="name"
                                item-value="value"
                                v-model="filterServices.family"
                                label="Familia"
                                @change="handleServiceFamilyChange"
                              >
                              </v-select>
                            </div>
                            <div class="col-12 col-md-4">
                              <v-select
                                class="w-full"
                                outlined
                                dense
                                hide-details
                                clearable
                                attach
                                :items="filteredServiceCategories"
                                item-text="name"
                                item-value="value"
                                v-model="filterServices.category"
                                label="Categoría"
                                :disabled="!filterServices.family"
                                @change="handleServiceCategoryChange"
                              >
                              </v-select>
                            </div>
                            <div class="col-12 col-md-4">
                              <v-select
                                class="w-full"
                                outlined
                                dense
                                hide-details
                                clearable
                                attach
                                :items="filteredServiceSubcategories"
                                item-text="name"
                                item-value="value"
                                v-model="filterServices.subcategory"
                                label="Subcategoría"
                                :disabled="!filterServices.category"
                                @change="applyServicesClassificationFilter"
                              >
                              </v-select>
                            </div>
                          </div>
                        </div>
                      </template>
                      <DxDataGrid
                        class="isScrolledByGeneralFilter"
                        style="max-height: 250px"
                        :data-source="servicesToBill"
                        key-expr="CodeService"
                        :allow-column-resizing="true"
                        column-resizing-mode="widget"
                        :column-auto-width="true"
                        :paging="{ enabled: false }"
                      >
                        <DxScrolling row-rendering-mode="virtual" />
                        <!--DxPaging :page-size="5" /-->
                        <DxColumn
                          :width="45"
                          cell-template="show-template"
                          caption=""
                        ></DxColumn>
                        <template #show-template="{ data }">
                          <a
                            ref="plusIconService"
                            href="#"
                            class="mx-1"
                            @click.prevent.stop="
                              triggerAddItemEvent(data.data, 2)
                            "
                            @keyup.space.prevent="handleSpaceService(data.data)"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </a>
                        </template>
                        <DxColumn
                          :width="150"
                          data-field="CodeService"
                          caption="ID"
                        ></DxColumn>
                        <DxColumn
                          data-field="AlterCode"
                          header-cell-template="headerAlterCode"
                        ></DxColumn>
                        <template #headerAlterCode="{}">
                          <div>Código<br />alterno</div>
                        </template>
                        <DxColumn
                          data-field="NameService"
                          header-cell-template="headerNameService"
                        ></DxColumn>
                        <template #headerNameService="{}">
                          <div>Nombre de<br />servicio</div>
                        </template>
                        <DxColumn
                          data-field="Name"
                          header-cell-template="headerNameLab"
                        ></DxColumn>
                        <template #headerNameLab="{}">
                          <div>Nombre a<br />facturar</div>
                        </template>
                        <DxColumn
                          :width="130"
                          data-field="TypeService"
                          header-cell-template="headerTypeservice"
                        >
                          <DxLookup
                            :data-source="typeService"
                            display-expr="Name"
                            value-expr="ID"
                          />
                        </DxColumn>
                        <template #headerTypeservice="{}">
                          <div>Tipo de<br />servicio</div>
                        </template>
                        <DxColumn
                          :width="130"
                          data-field="PriceListName"
                          caption="PriceListName"
                        ></DxColumn>
                        <!-- <DxColumn :width="120" data-field="ItemNewPrice" caption="Precio"></DxColumn> -->
                        <DxColumn
                          :width="120"
                          cell-template="itemPriceFormatted"
                          caption="Precio"
                        ></DxColumn>
                        <DxColumn
                          :width="120"
                          data-field="NameFamily"
                          caption="Familia"
                        ></DxColumn>
                        <DxColumn
                          :width="120"
                          data-field="NameCategory"
                          caption="Categoría"
                        ></DxColumn>
                        <DxColumn
                          :width="120"
                          data-field="NameSubcategory"
                          caption="Subcategoría"
                        ></DxColumn>
                        <template #itemPriceFormatted="{ data }">
                          {{ Currency
                          }}{{ numberWithCommas(data.data.ItemNewPrice) }}
                        </template>
                      </DxDataGrid>
                    </GeneralFilter>
                  </template>
                </div>
              </v-card-text>
              <v-col class="text-right">
                <v-btn
                  @click="showProductsAndServices = !showProductsAndServices"
                  class="btndisable"
                >
                  Continuar
                </v-btn>
              </v-col>
            </v-card>
          </v-dialog>
        </div>

        <QuantityDialog
          v-if="currentItemToAdd"
          :show="showQuantityDialog"
          :itemToReturn="currentItemToAdd"
          :notQuantity="notQuantity"
          @cancel="clearQuantityInputValues"
          @submit="submitQuantityInput"
        />
        <!--</div>
        </v-col-->
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="white pa-4 border-5 box">
            <v-row class="d-flex justify-center">
              <p>
                <b>{{ $t("vwinvoices_ccurrentinvoiceitems") }}</b>
              </p>
            </v-row>
            <v-row class="mt-2">
              <v-col
                cols="12"
                :md="posrestaurant ? 1 : 2"
                class="d-flex justify-center"
                style="padding-bottom: 13px !important"
              >
                <v-btn class="btn-save ml-3" @click="loadpriceProducts()"
                  ><v-icon>mdi-magnify</v-icon></v-btn
                >
              </v-col>
              <v-col
                v-if="posrestaurant"
                cols="12"
                md="1"
                class="d-flex justify-center"
              >
                <!-- <v-btn class="btn-save ml-3" @click="loadpriceProducts()"><v-icon>mdi-notebook</v-icon></v-btn> -->
                <!-- <v-btn class="btn-save ml-3" @click="loadpriceProducts()"><v-icon>mdi-table-chair</v-icon></v-btn> -->
                <v-btn class="btn-save ml-3" @click="openClasificationSelector"
                  ><v-icon>mdi-food</v-icon></v-btn
                >
                <!-- <v-btn class="btn-save ml-3" @click="loadpriceProducts()"><v-icon>mdi-notebook-check-outline</v-icon></v-btn> -->
                <!-- <v-btn class="btn-save ml-3" @click="loadpriceProducts()"><v-icon>mdi-coffee-to-go</v-icon></v-btn> -->
              </v-col>
              <v-col cols="12" md="3">
                <!-- <v-text-field outlined dense v-model="selectedBarCode" item-text="BarCode"
                  @keyup.enter="addBarCode()" item-value="ID_Item" label="Ingrese código de barras / alternos"
                  :readonly="checkWarehandPl" attach></v-text-field> -->
                <v-text-field
                  outlined
                  dense
                  v-model="selectedBarCode"
                  item-text="BarCode"
                  @keyup.enter="addBarCode()"
                  item-value="ID_Item"
                  label="Ingrese código de barras / alternos"
                  attach
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" v-if="false">
                <!--   <v-text-field outlined dense 
                  id="input_productcode"
                  v-model="productcode"
                  @keyup.enter="addProductAndService()"
                  label="Ingrese código de producto"
                  dense
                ></v-text-field> -->
                <!-- <v-autocomplete outlined dense v-model="productcode" :items="allproducts" item-text="ID"
                  @change="addselector()" item-value="prod" label="Código de producto o servicio"
                  :readonly="checkWarehandPl" attach></v-autocomplete> -->
                <CustomAutoComplete
                  :filter-endpoint="$API.products.getAllWithServicesFiltered"
                  v-if="assignedList.prod || assignedList.serv"
                  v-model="productcode"
                  :search="{ ...search }"
                  :items="ProductServList ? ProductServList : allproductbyName"
                  :item-text="'val'"
                  :isProd="true"
                  @select="
                    (e) => {
                      productcode = e;
                      addselector(e);
                    }
                  "
                  :item-value="'val'"
                  label="Código de producto o servicio"
                  :emitComplete="true"
                  @updateItems="updateServProList"
                >
                </CustomAutoComplete>
              </v-col>

              <v-col cols="12" md="7">
                <!--   <v-text-field outlined dense 
                  id="input_productcode"
                  v-model="productcode"
                  @keyup.enter="addProductAndService()"
                  label="Ingrese código de producto"
                  dense
                ></v-text-field> -->
                <!-- <v-autocomplete outlined dense v-model="productcode" :items="allproductbyName" item-text="ID"
                  @change="addselector()" item-value="prod" label="Nombre de producto o servicio" attach
                  :readonly="checkWarehandPl"></v-autocomplete> -->
                <CustomAutoCompleteObject
                  :key="`product-selector-${productAutocompleteKey}`"
                  :filter-endpoint="$API.products.getAllWithServicesFiltered"
                  v-if="assignedList.prod || assignedList.serv"
                  v-model="productcode"
                  :search="{ ...search }"
                  :items="[
                    ...(ProductServList ?? allproductbyName ?? []),
                  ]"
                  :item-text="'ID'"
                  :isProd="true"
                  :item-value="getProductSelectorValue"
                  @selection="handleProductSelection"
                  :label="!isCustomerSelected? 'Es requerido seleccionar un cliente': 'Nombre de producto o servicio'"
                  :emitComplete="true"
                  @updateItems="updateServProList"
                  empty-search="No se encontraron coincidencias o el producto no tiene existencias"
                >
                  <template v-slot:item="{ item }">
                    <div class="autocomplete-product-option">
                      <div class="autocomplete-product-option__header">
                        <v-list-item-title class="autocomplete-product-option__title">
                          <strong>{{ item.ID }}</strong>
                        </v-list-item-title>

                        <v-chip
                          x-small
                          label
                          :color="item.prod && item?.prod?.type === 'product' ? 'indigo lighten-5' : 'blue-grey lighten-5'"
                          :text-color="item.prod && item?.prod?.type === 'product' ? 'indigo darken-3' : 'blue-grey darken-2'"
                          class="autocomplete-product-option__type"
                        >
                          {{ item.prod && item?.prod?.type === 'product' ? 'Producto' : 'Servicio' }}
                        </v-chip>
                      </div>

                      <v-list-item-subtitle v-if="item.prod && item?.prod?.type === 'product'" class="autocomplete-product-option__meta">
                        <div class="autocomplete-product-option__chips">
                          <v-chip
                            small
                            label
                            color="primary"
                            text-color="white"
                            class="mr-1 mb-1"
                            v-if="item?.prod?.PriceListName"
                          >
                            <small class="me-2">Lista de precio</small>
                            <b>{{ item?.prod?.PriceListName }}</b>
                          </v-chip>
                          <v-chip
                            small
                            label
                            color="primary"
                            text-color="white"
                            class="mr-1 mb-1"
                          >
                            <small class="me-2">Precio</small>
                            <b>${{ (item?.prod?.ItemOriginalPrice)?.toFixed(2) }}</b>
                          </v-chip>
                          <v-chip
                            small
                            label
                            color="primary"
                            text-color="white"
                            class="mr-1 mb-1"
                          >
                            <small class="me-2">Existencia</small>
                            <b>{{ item.prod.ItemCurrentQuantity }}</b>
                          </v-chip>
                          <v-chip
                            small
                            label
                            color="teal darken-1"
                            text-color="white"
                            class="mr-1 mb-1"
                            v-if="item.prod.ID_ItemBatch && item.prod.ID_ItemBatch?.length > 0"
                          >
                            <small class="me-2">Lote</small>
                            <b>{{ item.prod.ID_ItemBatch }}</b>
                          </v-chip>

                          <v-chip
                            small
                            label
                            color="teal darken-1"
                            text-color="white"
                            class="mr-1 mb-1"
                            v-if="item.prod.ExpirationDate && item.prod.ExpirationDate?.length > 0"
                          >
                            <small class="me-2">Exp</small>
                            <b>{{
                              item.prod.ExpirationDate
                            }}</b>
                          </v-chip>
                        </div>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.prod && item?.prod?.type === 'service'" class="autocomplete-product-option__meta">
                        <v-chip
                          small
                          label
                          color="primary"
                          text-color="white"
                          class="mr-1 mb-1"
                        >
                          <small class="me-2">Precio</small>
                          <b>${{ (item?.prod?.ItemOriginalPrice ?? item?.prod?.Price)?.toFixed(2) }}</b>
                        </v-chip>
                      </v-list-item-subtitle>
                    </div>
                  </template>
                </CustomAutoCompleteObject>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  outlined
                  dense
                  attach
                  v-model="warehouseSelected"
                  :items="warehouses"
                  item-text="Warehouse"
                  item-value="ID_Warehouse"
                  label="Almacen"
                  @change="reactiveMainProductsFilter"
                  :readonly="!$store.getters['rolesUser/getCustomRole'](240)"
                  :disabled="(this.billposwith1warehouse == 1 && this.productsToShow.length > 0)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  outlined
                  dense
                  attach
                  v-model="PriceListSelected"
                  @change="getPriceListSelected()"
                  :items="priceListData"
                  item-text="id"
                  item-value="id"
                  label="Lista de precios"
                  :readonly="!$store.getters['rolesUser/getCustomRole'](239)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  outlined
                  dense
                  v-model="allowRepetitionOfArticles"
                  label="Permitir repetición de articulos"
                />
              </v-col>
              <v-col cols="12" md="2" v-if="!ishosting">
                <v-checkbox
                  outlined
                  dense
                  v-model="noaddivainpos"
                  label="Agregar precios sin IVA para Crédito Fiscales"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-if="ishosting"
                  outlined
                  dense
                  v-model="addimpturismo"
                  label="Incluir impuesto al turismo en precios unitarios"
                />
              </v-col>
            </v-row>
            <br />
            <v-row style="overflow-x: scroll" class="mb-3 pt-1">
              <v-col
                cols="12"
                md="2"
              >
                <v-btn
                  color="btn-save"
                  class="mb-2"
                  @click="openGlobalDiscountModal()"
                  v-if="!invoiceAutoSave"
                  :disabled="!isCustomerSelected"
                >
                  Aplicar descuentos
                </v-btn>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn 
                  class="primary mb-3"
                  @click="extendedViewTable = !extendedViewTable"
                >
                  Vista {{ !extendedViewTable ? 'extendida' : 'mínima' }}
                </v-btn>
              </v-col>
               <v-col cols="0" md="4">
                <!--Agregar aqui nuevos componentes para mantener la alineacion-->
               </v-col>
              <v-col cols="12" md="4" class="mt-4" v-if="['FCF', 'CCF'].includes(form.invoicetype) && posrestaurant">
                <v-row justify="end" class="text-right bg-primary">
                  <v-col cols="7">
                    <v-checkbox v-model="activarPropinas" class="propina-check" label="Activar Propinas"></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      outlined
                      dense
                      label="% propina"
                      v-model="porcentajePropinas"
                      min="0"
                      max="100"
                      type="number"
                      :disabled="!activarPropinas"
                      class="propina-input"
                    ></v-text-field>
                  </v-col>
                </v-row> 
              </v-col>
              <v-col cols="12">
                <DxDataGrid
                  class="isScrolledByGeneralFilter"
                  :data-source="
                    productsFiltered === false
                      ? productsToShow
                      : productsToShowFiltered
                  "
                  :allow-column-resizing="false"
                  column-resizing-mode="widget"
                  :column-auto-width="true"
                  :word-wrap-enabled="true"
                  :disabled="isProductsGridDisabled"
                  @editor-preparing="onProductsGridEditorPreparing"
                >
                  <DxEditing
                    :allow-updating="true"
                    :select-text-on-edit-start="true"
                    start-edit-action="click"
                    mode="cell"
                  />
                  <DxColumn
                    data-field="ID_Item"
                    :allow-editing="false"
                    caption="ID"
                    :width="120"
                  ></DxColumn>
                  <DxColumn
                    v-if="posshowprincipalbarcode == 1"
                    data-field="BarCode"
                    :allow-editing="false"
                    caption="Código alterno principal"
                  ></DxColumn>
                  <DxColumn
                    cell-template="Item-name"
                    :allow-editing="allowEditName"
                    :allow-updating="allowEditName"
                    data-type="text"
                    caption="Nombre de Producto/Servicio"
                    :min-width="300"
                  >
                  </DxColumn>
                  <DxColumn
                    v-if="showformairlinetickets"
                    cell-template="EsBoleto"
                    caption="Inf. Boleto"
                  ></DxColumn>
                  <template #EsBoleto="{data}">
                    <div>
                      <button
                        type="checkbox"
                        :disabled="allowQtyEditWhenForceBlocking"
                        @click="
                          showFormAirplaneTicket = true;
                          airplaneTicketObject = data.data;
                        "
                      >
                        <v-icon
                          :color="comprobateFormAirplaneTicket(data.data)
                              ? 'warning'
                              : 'primary'
                          "
                          >mdi-eye</v-icon
                        >
                      </button>
                    </div>
                  </template>
                  <DxColumn
                    data-field="qty"
                    caption="Cantidad"
                    data-type="number"
                    :width="100"
                  >
                    <DxFormat typed="fixedPoint" :precision="0" />
                    <DxRequiredRule
                      message="La cantidad del producto a facturar es requerida"
                    />
                    <DxPatternRule
                      :pattern="itemQtyPattern"
                      message="La cantidad del producto solo puede contener numeros enteros mayores a 0"
                    />
                    <!-- <DxAsyncRule 
                      :validation-callback="itemsQtyOnlyDigits"
                      message="La cantidad del producto solo puede contener numeros enteros mayores a 0"
                    /> -->
                    <DxAsyncRule
                      :validation-callback="handleStockAndQty"
                      message="La cantidad del producto no puede exceder el stock actual"
                    />
                  </DxColumn>
                  <DxColumn cell-template="itemPrice" caption="Pre./U" :width="100"></DxColumn>
                  <!--DxColumn data-field="ItemNewPrice" caption="Pre./U" width="10%" :allow-editing="false"></DxColumn-->
                  <DxColumn cell-template="Discount" caption="Descuento" :width="100">
                  </DxColumn>
                  <DxColumn v-if="extendedViewTable" cell-template="NonTaxable" caption="Exento">
                  </DxColumn>
                  <DxColumn v-if="extendedViewTable" cell-template="NonSuj" caption="No Sujeto">
                  </DxColumn>
                  <DxColumn v-if="extendedViewTable" cell-template="NoGravadas" caption="No Gravadas">
                  </DxColumn>
                  <DxColumn
                    v-if="extendedViewTable"
                    cell-template="IsHidrocarburo"
                    caption="Hidrocarburo"
                  ></DxColumn>
                  <DxColumn
                    v-if="extendedViewTable"
                    cell-template="TurismoPorAlojamiento"
                    caption="Imp. Alojamiento"
                  ></DxColumn>
                  <DxColumn
                    cell-template="totalItemPrice"
                    caption="Total"
                    :width="150"
                  ></DxColumn>
                  <!--DxColumn :calculate-cell-value="calculateCellValue" caption="Total" width="10%"></DxColumn-->
                  <DxColumn cell-template="show-template" caption="" :width="40"></DxColumn>
                  <DxColumn data-field="ItemCurrentQuantity" caption="Cantidad Disp." :width="100"></DxColumn>
                  <DxColumn v-if="showunitcostinpos && showUnitCost" data-field="UnitCost" caption="Cost./U" :width="100"></DxColumn>
                  <DxColumn data-field="ItemMeasureUnit" caption="Unit. Medida" :width="100"></DxColumn>
                  <DxColumn caption="Lista de Precio" data-field="PriceListName" :width="120"></DxColumn>

                  <template #Item-name="{data}">
                    <div>
                      <div style="display: flex; align-items: center; gap: 6px;">
                        <textarea
                          :style="{
                            width: posrestaurant ? '85%' : '100%',
                            textAlign: 'justify',
                            height: 'auto',
                            minHeight: '8px',
                            resize: 'none',
                            border: 'none',
                            padding: '3px',
                            lineHeight: '1.2',
                            fieldSizing: 'content'
                          }"
                          v-model="data.data.ItemName"
                          :readonly="allowQtyEditWhenForceBlocking"
                          @input="onCellValueChanged(data.data)"
                          v-show="!comprobateFormAirplaneTicket(data.data)"
                        ></textarea>
                        <template v-if="comprobateFormAirplaneTicket(data.data)">
                          {{ data.data.ItemName }}
                        </template>
                        <a
                          v-if="posrestaurant"
                          :class="{ 'grid-action-disabled': allowQtyEditWhenForceBlocking }"
                          @click="if (!allowQtyEditWhenForceBlocking) { showItemComments = true; commentsObject = data.data; }"
                        ><v-icon>mdi-pencil-plus</v-icon></a>
                      </div>
                      <div v-if="posrestaurant">
                        <p style="color: red !important;" v-if="data.data.ItemComments != null && data.data.ItemComments != ''">
                          <br/>Observaciones: {{ data.data.ItemComments }}
                        </p>
                      </div>
                    </div>
                  </template>

                  <template #itemPrice="{ data }">
                    <div v-if="$store.getters['rolesUser/getCustomRole'](8)">
                      <div v-if="(data.data.nontaxable || data.data.nonsuj || data.data.nogravada) && !restivaposexentonosuj">
                        <input
                          :readonly="
                            !$store.getters['rolesUser/getCustomRole'](8) || allowQtyEditWhenForceBlocking
                          "
                          type="number"
                          style="width: 100% !important; text-align: center"
                          v-model="data.data.ItemNewPrice"
                          @input="calculateItemNewPrice(data.data)"
                          @blur="calculateItemNewPrice5(data.data)"
                          @keyup.enter="calculateItemNewPrice5(data.data)"
                        />
                        <!-- {{ (data.data.ItemNewPrice / 1.13).toFixed(8) }} -->
                      </div>
                      <div v-else>
                        <input
                          :readonly="
                            !$store.getters['rolesUser/getCustomRole'](8) || allowQtyEditWhenForceBlocking
                          "
                          type="number"
                          style="width: 100% !important; text-align: center"
                          v-if="
                            form.invoicetype == 'CCF' ||
                            form.invoicetype == 'DNC' ||
                            form.invoicetype == 'DND' || 
                            ((data.data.nontaxable || data.data.nonsuj || data.data.nogravada) && restivaposexentonosuj)
                          "
                          v-model="data.data.TmpItemNewPrice"
                          @input="calculateItemNewPrice2(data.data)"
                          @blur="calculateItemNewPrice3(data.data, true)"
                          @keyup.enter="calculateItemNewPrice3(data.data)"
                        />
                        <input
                          :readonly="
                            !$store.getters['rolesUser/getCustomRole'](8) || allowQtyEditWhenForceBlocking
                          "
                          type="number"
                          style="width: 100% !important; text-align: center"
                          v-if="form.invoicetype != 'CCF' && form.invoicetype != 'DNC' && form.invoicetype != 'DND' && !data.data.nontaxable && !data.data.nonsuj && !data.data.nogravada"
                          v-model="data.data.ItemNewPrice"
                          @input="calculateItemNewPrice(data.data)"
                          @blur="calculateItemNewPrice4(data.data)"
                          @keyup.enter="calculateItemNewPrice4(data.data)"
                        />
                        <!--{{ form.invoicetype == 'CCF' ? (data.data.ItemNewPrice / 1.13).toFixed(8) : "" }}
                        {{ form.invoicetype != 'CCF' ? data.data.ItemNewPrice.toFixed(8) : "" }} -->
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="(data.data.nontaxable || data.data.nonsuj || data.data.nogravada) && !restivaposexentonosuj">
                        {{ (data.data.ItemNewPrice).toFixed(8) }}
                      </div>
                      <div v-else>
                        {{
                          form.invoicetype == "CCF" ||
                          form.invoicetype == "DNC" ||
                          form.invoicetype == "DND" || 
                          ((data.data.nontaxable || data.data.nonsuj || data.data.nogravada) && restivaposexentonosuj)
                            ? (data.data.ItemNewPrice / 1.13).toFixed(8)
                            : ""
                        }}
                        {{
                          form.invoicetype != "CCF" &&
                          form.invoicetype != "DNC" &&
                          form.invoicetype != "DND" && 
                          !data.data.nontaxable && !data.data.nonsuj && !data.data.nogravada
                            ? data.data.ItemNewPrice.toFixed(8)
                            : ""
                        }}
                      </div>
                    </div>
                  </template>

                  <template #totalItemPrice="{ data }">
                    <div v-if="(data.data.nontaxable || data.data.nonsuj || data.data.nogravada) && !restivaposexentonosuj">
                      {{
                        data.data.TmpCounter > 0
                          ? calculateCellValue(data.data)
                          : calculateCellValue(data.data)
                      }}
                    </div>
                    <div v-else>
                      {{
                        (form.invoicetype == "CCF" ||
                          form.invoicetype == "DNC" ||
                          form.invoicetype == "DND" || 
                          ((data.data.nontaxable || data.data.nonsuj || data.data.nogravada) && restivaposexentonosuj)
                        ) &&
                        data.data.TmpCounter == 0
                          ? ( 
                              noaddivainpos 
                              ? (calculateCellValue(data.data) * 1.13).toFixed(8) 
                              : (
                                  (ishosting && addimpturismo && data.data.TurismoPorAlojamiento)
                                    ? (calculateCellValue(data.data) / 1.18).toFixed(8) 
                                    : (calculateCellValue(data.data) / 1.13).toFixed(8) 
                                )
                            ) 
                          : ""
                            
                      }}
                      {{
                        (form.invoicetype == "CCF" ||
                          form.invoicetype == "DNC" ||
                          form.invoicetype == "DND" || 
                          ((data.data.nontaxable || data.data.nonsuj || data.data.nogravada) && restivaposexentonosuj)
                        ) &&
                        data.data.TmpCounter > 0
                          ? ( 
                              noaddivainpos 
                              ? (calculateCellValue(data.data) * 1.13).toFixed(8) 
                              : (
                                  (ishosting && addimpturismo && data.data.TurismoPorAlojamiento)
                                    ? (calculateCellValue(data.data) / 1.18).toFixed(8) 
                                    : (calculateCellValue(data.data) / 1.13).toFixed(8) 
                                )
                            ) 
                          : ""
                      }}
                      {{
                        form.invoicetype != "CCF" &&
                        form.invoicetype != "DNC" &&
                        form.invoicetype != "DND" && 
                        !data.data.nontaxable && !data.data.nonsuj && !data.data.nogravada
                          ? calculateCellValue(data.data)
                          : ""
                      }}
                    </div>
                  </template>

                  <template #show-template="{ data }">
                    <div>
                      <a
                        href="#"
                        class="mx-1"
                        :class="{ 'grid-action-disabled': allowQtyEditWhenForceBlocking }"
                        @click.prevent.stop="
                          if (!allowQtyEditWhenForceBlocking) {
                            confirmDelete = data;
                            showAlert(
                              'question',
                              'Eliminar',
                              '¿Está seguro que desea eliminar este producto?',
                              'deleteoneproduct'
                            );
                          }
                        "
                      >
                        <v-icon color="error">mdi-delete</v-icon>
                      </a>
                      <a v-if="data.data?.ErrorRow == true"
                        href="#"
                        class="mx-1"
                        title="La cantidad del producto contiene un valor negativo o excede al stock actual"
                        >
                        <v-icon color="error">mdi-alert-circle</v-icon>
                      </a>
                    </div>
                  </template>
                  <template #NonTaxable="{ data }">
                    <div>
                      <input
                        v-if="
                          (data.data.IsExempt == 1 ||
                            form.legalisexempt ||
                            data.data.nontaxable2) &&
                          form.invoicetype != 'FEX'
                        "
                        type="checkbox"
                        v-model="data.data.nontaxable"
                        checked
                        @change="
                          data.data.nontaxable2 = false;
                          data.data.nonsuj = false;
                          data.data.nogravada = false;
                          onCellValueChanged(data.data);
                        "
                        :disabled="form.invoicetype == 'FEX' || allowQtyEditWhenForceBlocking"
                      />

                      <input
                        v-else
                        type="checkbox"
                        v-model="data.data.nontaxable"
                        @click="data.data.nonsuj = false; data.data.nogravada = false"
                        :disabled="form.invoicetype == 'FEX' || allowQtyEditWhenForceBlocking"
                        @change="onCellValueChanged(data.data)"
                      />
                    </div>
                  </template>
                  <template #NonSuj="{ data }">
                    <div>
                      <input
                        v-if="
                          (form.legalisnontaxable == 1 || data.data.nonsuj2) &&
                          form.invoicetype != 'FEX'
                        "
                        type="checkbox"
                        v-model="data.data.nonsuj"
                        checked
                        @change="
                          data.data.nonsuj2 = false;
                          data.data.nontaxable = false;
                          data.data.nogravada = false;
                          onCellValueChanged(data.data);
                        "
                        :disabled="form.invoicetype == 'FEX' || allowQtyEditWhenForceBlocking"
                      />
                      <input
                        v-else
                        type="checkbox"
                        v-model="data.data.nonsuj"
                        @click="data.data.nontaxable = false; data.data.nogravada = false;"
                        :disabled="form.invoicetype == 'FEX' || allowQtyEditWhenForceBlocking"
                        @change="onCellValueChanged(data.data)"
                      />
                    </div>
                  </template>
                  <template #NoGravadas="{ data }"> 
                    <div>
                      <input
                        v-if="
                          (form.legalisnontaxable == 1 || data.data.nogravada2) &&
                          form.invoicetype != 'FEX'
                        "
                        type="checkbox"
                        v-model="data.data.nogravada"
                        checked
                        @change="
                          data.data.nogravada2 = false;
                          data.data.nontaxable = false;
                          data.data.nonsuj = false;
                          onCellValueChanged(data.data);
                        "
                        :disabled="allowQtyEditWhenForceBlocking || data.data.type != 'service' || ['DNC', 'DND', 'DNR', 'CDD', 'FNS'].includes(form.invoicetype)"
                      />
                      <input
                        v-else
                        type="checkbox"
                        v-model="data.data.nogravada"
                        @click="data.data.nontaxable = false; data.data.nonsuj = false"
                        :disabled="allowQtyEditWhenForceBlocking || data.data.type != 'service' || ['DNC', 'DND', 'DNR', 'CDD', 'FNS'].includes(form.invoicetype)"
                        @change="onCellValueChanged(data.data)"
                      />
                    </div>
                  </template>
                  <template #IsHidrocarburo="{ data }">
                    <div>
                      <input
                        type="checkbox"
                        v-model="data.data.IsHidrocarburo"
                        disabled
                      />
                    </div>
                  </template>
                  <template #TurismoPorAlojamiento="{ data }">
                    <div>
                      <input
                        type="checkbox"
                        v-model="data.data.TurismoPorAlojamiento"
                        disabled
                      />
                    </div>
                  </template>
                  <template #Discount="{ data }">
                    <button
                      type="checkbox"
                      :disabled="allowQtyEditWhenForceBlocking"
                      @click="
                        showDiscount = true;
                        discountObject = data.data;
                        objectToApplyDiscount = { ...data.data };
                        loadPriceListData(data.data.ID_Item);
                        showPrices = false;
                      "
                    >
                      <v-icon
                        :color="
                          data.data.ItemPriceDiscountAmount > 0
                            ? 'warning'
                            : 'primary'
                        "
                        >mdi-eye</v-icon
                      >
                    </button>
                  </template>
                </DxDataGrid>
              </v-col>
              <!-- <GeneralFilter :search="{}" :filterEndpoint="filterPromise" @emptyFilter="clearFilter" @filtered="filterHandler"> -->
              <!-- </GeneralFilter> -->
            </v-row>
            <!-- <v-divider></v-divider> -->
          </div>
        </v-col>
      </v-row>

      <v-dialog v-model="searchCustomerDialog" scrollable max-width="1000">
        <search @customerSelected="customerSelected"></search>
      </v-dialog>

      <SearchTable @customerSelected="customerSelected" v-model="showSearchCustomerTableDialog"></SearchTable>

      <v-dialog v-model="searchSellerDialog" scrollable>
        <SearchDialog
          :entityLabel="'Vendedor'"
          :filterEndpoint="$API.sellers.getAllSellersFiltered"
          :defaultEndpoint="$API.sellers.getAllSellers"
          :gridKeyExp="'ID_Seller'"
          :recordsetBody="[
            {
              caption: 'ID',
              dataField: 'ID_Seller',
            },
            {
              caption: 'Nombre',
              dataField: 'FirstName',
            },
            {
              caption: 'Apellido',
              dataField: 'LastName',
            },
            {
              caption: 'Correo Electrónico',
              dataField: 'Email',
            },
            {
              caption: 'Teléfono Celular',
              dataField: 'Mobile',
            },
          ]"
          @select="sellerSelectedFromDialog"
          max-width="1000"
        />
      </v-dialog>
      <v-dialog v-model="searchTechnicalDialog" scrollable>
        <SearchDialog
          :entityLabel="'Técnico'"
          :filterEndpoint="$API.sellers.getAllTechnicalFiltered"
          :defaultEndpoint="$API.sellers.getAllTechnical"
          :gridKeyExp="'ID_Seller'"
          :recordsetBody="[
            {
              caption: 'ID',
              dataField: 'ID_Seller',
            },
            {
              caption: 'Nombre',
              dataField: 'FirstName',
            },
            {
              caption: 'Apellido',
              dataField: 'LastName',
            },
            {
              caption: 'Correo Electrónico',
              dataField: 'Email',
            },
            {
              caption: 'Teléfono Celular',
              dataField: 'Mobile',
            },
          ]"
          @select="technicalSelectedFromDialog"
          max-width="1000"
        />
      </v-dialog>
      <!-- Null Invoice -->
      <v-dialog v-model="nullInvoice" max-width="400">
        <null-invoice
          :invoiceId="createdInvoiceId"
          @hideNullInvoiceDialog="nullInvoice = false"
        ></null-invoice>
      </v-dialog>
      <!-- Discount global modal -->
      <v-dialog v-model="showDiscountGlobal" max-width="350">
        <v-card>
          <v-card-title class="text-h5"> Aplicar Descuento </v-card-title>
          <v-card-text>
            <form>
              <v-text-field
                outlined
                dense
                disabled
                :value="getGlobalDiscountBaseTotal().toFixed(2)"
                label="Precio total"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                disabled
                v-model="globalDiscount.TotalNewTotal"
                label="Total con descuento"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                type="number"
                step="0.0001"
                min="0"
                inputmode="decimal"
                v-model="globalDiscount.TotalPriceDiscountPercent"
                label="Porcentaje de descuento"
                @input="onGlobalDiscountPercentInput"
                :disabled="
                  !$store.getters['rolesUser/getArrayCustomRole']([253])
                "
              ></v-text-field>
              <v-text-field
                outlined
                dense
                type="number"
                step="0.0001"
                min="0"
                inputmode="decimal"
                v-model="globalDiscount.TotalNewPrice"
                label="Monto descuento a aplicar"
                @input="onGlobalDiscountAmountInput"
                :disabled="
                  !$store.getters['rolesUser/getArrayCustomRole']([253])
                "
              ></v-text-field>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="hasAppliedGlobalDiscount()"
              class='btnclean'
              text
              @click="removeGlobalDiscount()"
              :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
            >
              Cancelar descuento
            </v-btn>
            <v-btn
              class="btn-save"
              text
              @click="applyGlobalDiscount()"
              :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
            >
              Aplicar
            </v-btn>
            <v-btn class="btndelete" text @click="showDiscountGlobal = false">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Discount Modal -->
      <v-dialog
        v-model="showDiscount"
        :max-width="showPrices ? 800 : (ferretlabenddata ? 800 : 300)"
        scrollable
      >
        <v-card>
          <v-card-title class="text-h5">
            {{ $t("vwinvoices_capplydiscount") }}
          </v-card-title>
          <v-card-text>
            <v-row class="mt-1">
              <v-col
                cols="12"
                :lg="showPrices ? 3 : (ferretlabenddata ? 3 : 12 )"
                class="mt-3 text-center"
              >
                <form v-if="discountObject">
                  <v-text-field
                    outlined
                    dense
                    disabled
                    v-model="discountObject.ItemOriginalPrice"
                    label="Precio original"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    dense
                    disabled
                    v-model="discountObject.ItemNewPrice"
                    label="Precio con descuento"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    dense
                    v-model="discountObject.ItemPriceDiscountPercent"
                    :label="$t('vwinvoices_cdiscountporcentage')"
                    @input="onInputDiscountObjs('ItemPriceDiscountPercent')"
                    @focus="onItemPriceDiscountPercentFocusBlur"
                    @blur="onItemPriceDiscountPercentFocusBlur"
                    :disabled="
                      !$store.getters['rolesUser/getArrayCustomRole']([253])
                    "
                  ></v-text-field>
                  <v-text-field
                    outlined
                    dense
                    v-model="discountObject.ItemPriceDiscountAmount"
                    :label="$t('vwinvoices_cdiscountfixed')"
                    @input="onInputDiscountObjs('ItemPriceAmountPercent')"
                    @focus="onItemPriceDiscountAmountFocusBlur"
                    @blur="onItemPriceDiscountAmountFocusBlur"
                    :disabled="
                      !$store.getters['rolesUser/getArrayCustomRole']([253])
                    "
                  ></v-text-field>
                </form>
                <v-btn v-if="ferretlabenddata == 0" @click="showPrices = !showPrices" color="comment" dark>{{
                  showPrices ? "Ocultar precios" : "Mostrar precios"
                }}</v-btn>
              </v-col>
              <v-col cols="12" lg="9" v-if="showPrices || ferretlabenddata == 1">
                <div class="text-h6 mb-3 black--text">Precios</div>
                <v-data-table
                  :headers="headers"
                  :items="prices"
                  :height="200"
                  :items-per-page="-1"
                  @click:row="selectedPrice"
                  fixed-header
                  disable-pagination
                  hide-default-footer
                  dense
                >
                  <template #item.ItemPriceDiscountAmount="{ item }">
                    {{ item.ItemPriceDiscountAmount.toFixed(6) }}
                  </template>
                  <template #item.ItemNewPrice="{ item }">
                    {{ item.ItemNewPrice.toFixed(6) }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click.prevent="
                invoiceAutoSave ? updateTempDetails(discountObject.uuid) : '';
                showDiscount = false;
                discountObject = null; 
              "
              :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
            >
              Aplicar
            </v-btn>
            <v-btn color="error darken-1" text @click.prevent="cancelDiscount">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog 
        v-model="showFormAirplaneTicket"
        :max-width="600"
        scrollable
      >
        <v-card>
          <v-card-title class="text-h5">
            Formulario de boleto aereo
          </v-card-title>
          <v-card-text>
            <v-row class="mt-1" v-if="airplaneTicketObject">
              <v-col cols="12"> 
                <v-text-field 
                  dense
                  outlined
                  v-model="airplaneTicketObject.LineaAerea"
                  label="Linea Aerea"
                  maxlength="250"
                ></v-text-field>
              </v-col>
              <v-col cols="12"> 
                <v-text-field 
                  dense
                  outlined
                  v-model="airplaneTicketObject.Boleto"
                  label="N. Boleto"
                  maxlength="250"
                ></v-text-field>
              </v-col>
              <v-col cols="12"> 
                <v-text-field 
                  dense
                  outlined
                  v-model="airplaneTicketObject.Pasajero"
                  label="Pasajeros"
                  maxlength="250"
                ></v-text-field>
              </v-col>
              <v-col cols="12"> 
                <v-text-field 
                  dense
                  outlined
                  v-model="airplaneTicketObject.Ruta"
                  label="Rutas"
                  maxlength="250"
                ></v-text-field>
              </v-col>
            </v-row> 
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click.prevent="applyAirplaneTicket"
            >
              Aplicar
            </v-btn>
            <v-btn 
              color="error darken-1" 
              text 
              @click.prevent="cancelAirplaneTicket"
            >
              Limpiar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- Datos de factura -->
    <div ref="summary" class="mt-3">
      <FixedPanel @panel-mounted="(setParentRef) => setParentRef($refs.container)">
        <v-row cols="12" class="justify-center align-center">
          <!-- ROW CONTROLS -->
          <v-col cols="12" xl="8" class="py-3">
            <v-row cols="12" class="justify-center">
              <!-- Gravadas -->
              <v-col cols="6" md="3" lg="2">
                <FixedPanelField
                  :disabled="true" 
                  :label="form.invoicetype != 'FEX' ? 'Gravadas' : 'Afectas'" 
                  v-model="sumObject.subTotal" 
                />
              </v-col>
              <v-col
                v-if="parseFloat(sumObject.globalDiscount || 0) > 0"
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true"
                  label="Desc. global"
                  v-model="sumObject.globalDiscount"
                />
              </v-col>
              <!-- IVA 13% -->
              <v-col
                 v-if="
                    form.invoicetype != 'FCF' &&
                    form.invoicetype != 'TCKS' &&
                    form.invoicetype != 'DNR'
                  " 
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true" 
                  label="IVA 13%" 
                  v-model="sumObject.iva" 
                />
              </v-col>
              <!-- Exentas -->
              <v-col 
                v-if="form.invoicetype != 'FEX'"
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true"
                  label="Exentas" 
                  v-model="sumObject.nontaxable" 
                />
              </v-col>
              <!-- No Sujetas -->
              <v-col 
                v-if="form.invoicetype != 'FEX'"
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true" 
                  label="No Sujetas" 
                  v-model="sumObject.nonsuj" 
                />
              </v-col>
              <!-- No Gravadas -->
              <v-col 
                v-if="sumObject.nogravada > 0"
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true" 
                  label="No Gravadas" 
                  v-model="sumObject.nogravada" 
                />
              </v-col>
              <!-- Propinas -->
              <v-col 
                v-if="(form.invoicetype == 'FCF' || form.invoicetype == 'CCF' || form.invoicetype == 'DNC' || form.invoicetype == 'DND') && activarPropinas"
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true" 
                  label="Propina" 
                  v-model="sumObject.propina" 
                />
              </v-col>
              <!-- IVA Rete -->
              <v-col 
                v-if="form.invoicetype != 'FEX' && sumObject.ivaret > 0"
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true" 
                  label="IVA Rete" 
                  v-model="sumObject.ivaret" 
                />
              </v-col>
              <!-- IVA Perce -->
              <v-col 
                v-if="form.invoicetype != 'FEX'  && sumObject.ivaperce > 0"
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true" 
                  label="IVA perce" 
                  v-model="sumObject.ivaperce" 
                />
              </v-col>
              <!-- Ret renta -->
              <v-col cols="6" md="3" lg="2"
                v-if="sumObject.reterenta > 0"
              >
                <FixedPanelField
                  :disabled="true" 
                  label="Ret Renta" 
                  v-model="sumObject.reterenta" 
                />
              </v-col>
              <!-- Fovial -->
              <v-col
                v-if="
                  sumObject.fovial > 0 &&
                  (form.invoicetype == 'FCF' ||
                    form.invoicetype == 'CCF' ||
                    form.invoicetype == 'DNR')
                " 
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true" 
                  label="Fovial" 
                  v-model="sumObject.fovial" 
                />
              </v-col>
              <!-- Cotrans -->
              <v-col
                v-if="
                  sumObject.cotrans > 0 &&
                  (form.invoicetype == 'FCF' ||
                    form.invoicetype == 'CCF' ||
                    form.invoicetype == 'DNR')
                "
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true" 
                  label="Cotrans" 
                  v-model="sumObject.cotrans" 
                />
              </v-col>
              <!-- Impuesto turismo -->
              <v-col 
                v-if="sumObject.turismoPorAlojamiento > 0"
                cols="6" md="3" lg="2"
              >
                <FixedPanelField
                  :disabled="true" 
                  label="Imp. turismo" 
                  v-model="sumObject.turismoPorAlojamiento" 
                />
              </v-col>
              <!-- Total -->
              <v-col
                cols="6" md="3" lg="2"
              >
                <FixedPanelField 
                  disabled
                  label="Total" 
                  v-model="sumObject.total" 
                  color="total"
                />
              </v-col>
              <v-col
                v-if="showTimesExecute == true"
                cols="6" md="3" lg="2"
              >
                <FixedPanelField 
                  type="number"
                  label="Cantidad a procesar" 
                  v-model="form.timesexecute" 
                />
              </v-col>
  
            </v-row>
          </v-col>
          <!-- ROW BUTTONS -->
          <v-col cols="12" xl="4" class="d-flex justify-center align-center flex-wrap py-3">
             <!-- BTN: Limpiar formulario -->
            <v-btn class="mx-1 my-1 text-uppercase btnclean" @click.prevent="clearForm">
              <v-icon>mdi-broom</v-icon>
            </v-btn>
            <!-- BTN: Guardar Plantilla -->
            <v-btn 
              v-if="$store.getters['rolesUser/getCustomRole'](7) && invalid == null && ndornc == null && form.isquote == 0"
              :disabled="loading"
              title="Guardar plantilla"
              class="mx-1 my-1 text-uppercase btn-save"
              @click.prevent="
                pospayments
                  ? ((showReturnedAndPaymentModal = true),
                    (form.istemplate = 1),
                    (isReadyToBill = false))
                  : (showDialogTemplate = true)
              "
            >
              <v-icon>mdi-book-plus-multiple</v-icon>
            </v-btn>
            <!-- BTN: Guardar Factura-->
            <v-btn 
              v-if="$store.getters['rolesUser/getCustomRole'](6) && invalid == null && ndornc == null && form.isquote == 0 && forceBlocking == null"
              :disabled="loading"
              title="Guardar factura"
              class="mx-1 my-1 text-uppercase btn-save"
              @click.prevent="saveBill()"
            >
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
            <v-btn 
              v-if="$store.getters['rolesUser/getCustomRole'](6) && invalid == null && ndornc == null && form.isquote == 0 && posrestaurant"
              :disabled="loading"
              title="Crear comanda"
              class="mx-1 my-1 text-uppercase btn-save"
              @click.prevent="createComanda()"
            >
              Crear comanda
            </v-btn>
            <!-- BTN: Financiamiento Factura-->
            <!--v-btn 
              v-if="$store.getters['rolesUser/getCustomRole'](6) && invalid == null && ndornc == null && form.isquote == 0"
              :disabled="loading"
              title="Guardar factura"
              class="mx-1 my-1 text-uppercase btn-save"
              @click.prevent="
                pospayments
                  ? ((showReturnedAndPaymentModal = true),
                    (isReadyToBill = false),
                    (form.istemplate = 0), 
                    (form.isfinance = 1))
                  : ((form.isfinance = 1),
                    sendBill(0))
              "
            >
              <v-icon>mdi-content-save</v-icon> tmp
            </v-btn-->
            <!-- BTN: Facturar -->
            <v-btn 
              v-if="$store.getters['rolesUser/getCustomRole'](5) && form.isquote == 0"
              :disabled="(creditBillingBlock && form.invoicestatusdescription == 'Crédito') || loading || invoiceSubmissionInProgress"
              class="mx-1 my-1 text-uppercase btn-add"
              @click.prevent="createBill()"
            >
              <v-icon>mdi-printer-pos</v-icon>
              &nbsp;Facturar 
            </v-btn>
            <v-btn
              :title="statusAutoSave"
              v-if="form.isquote == 0 && invoiceAutoSave && tempId.startsWith('AUT')"
              :class="statusAutoSave === 'Guardada' ? 'mx-1 my-1 text-uppercase btn-save' : 'mx-1 my-1 text-uppercase btndelete'"
            >
              <v-icon v-if="statusAutoSave === 'Guardada'">mdi-cloud-check-variant</v-icon>
              <v-icon v-else-if="statusAutoSave === 'Verificando...'">mdi-cloud-arrow-down</v-icon>
              <v-icon v-else class="mdi-flip-h">mdi-cloud-arrow-up</v-icon>
            </v-btn>
            <!-- BTN: Facturar con ticket -->
            <!--v-btn 
              v-if="$store.getters['rolesUser/getCustomRole'](5) && form.isquote == 0 && showTicket"
              :disabled="creditBillingBlock || loading"
              class="mx-1 my-1 text-uppercase btn-save"
              @click.prevent="
                pospayments &&
                form.invoicetype != 'DND' &&
                form.invoicetype != 'DNC'
                  ? (
                    (PrintTicket = true)
                    (showReturnedAndPaymentModal = true),
                    (isReadyToBill = false),
                    (form.istemplate = 0)
                  )
                  : (
                    (PrintTicket = true),
                    sendBill(1)
                  )
              "
            >
              <v-icon>mdi-printer-pos</v-icon>
              &nbsp;Ticket
            </v-btn-->
            <!-- BTN: Crear cotizacion -->
            <v-btn 
              v-if="$store.getters['rolesUser/getCustomRole'](72) && form.isquote == 1 && quote != 'edit'"
              :disabled="loading"
              class="mx-1 my-1 text-uppercase btn-save"
              @click.prevent="alertContinueWithDifferentDateThanToday(0)"
            >
              <v-icon>mdi-printer-pos</v-icon>
               &nbsp;CREAR COTIZACIÓN
            </v-btn>
            <v-btn 
              v-if="$store.getters['rolesUser/getCustomRole'](72) && form.isquote == 1 && quote == 'edit'"
              :disabled="loading"
              class="mx-1 my-1 text-uppercase btn-save"
              @click.prevent="alertContinueWithDifferentDateThanToday(0)"
            >
              <v-icon>mdi-content-save</v-icon>
               &nbsp;EDITAR COTIZACIÓN
            </v-btn>
            <div v-if="showTimesExecute == true">
              <FixedPanelField 
                label="Cantidad a procesar" 
                v-model="form.timesexecute" 
              />
            </div>
          </v-col>
        </v-row>
      </FixedPanel>
    </div>

    <alerts
      style="z-index: 20000 !important"
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    >
    </alerts>
    <v-dialog v-model="showDetailsMessages" width="60%">
      <v-card>
        <v-card-title
          class="text-h5"
          style="
            margin-top: 0.3rem;
            margin-bottom: 0.3rem;
            display: flex;
            justify-content: space-between;
          "
        >
          <div>Detalles de factura</div>
          <div>
            <v-btn
              small
              class="btndelete"
              @click.prevent="showDetailsMessages = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <div>
            <v-btn @click="copyText()" class="btn-save"> copiar texto </v-btn>
          </div>
          <p
            style="color: black !important; font-size: 16px"
            v-html="currenterrordata"
          ></p>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <print-pos-tk :dataProps="print2"></print-pos-tk>

    <!--print-pos-tk-fcf :dataProps="print3"></print-pos-tk-fcf-->
    
    <template v-if="isFCF">
      <print-pos-factura :dataRegular="print" :dataTicket="print3" :hideQr="posrestaurant === 1 && orderAndPrint === true" v-if="!IsIsss && orderAndPrint === false"></print-pos-factura>
      <PrintPosFaMed v-if="IsIsss" :hideQr="hideQr" :dataProps="print"></PrintPosFaMed>
    </template>
    <template v-else>
      <PrintPosFaMed v-if="keyMaster === 'e05f325e05113060116d3d03ea7de431' || IsIsss" :hideQr="hideQr" :dataProps="print"></PrintPosFaMed>
      <PrintPosFacturaSolAmbiental v-else-if="keyMaster === '7accd5a9b298117d5fd9b94c54d8f97f'" :hideQr="hideQr" :dataProps="print"></PrintPosFacturaSolAmbiental>
      <print-pos-coco-teams v-else-if="keyMaster === 'c050f33ac72b1e37cdbe728fa5b50d29'" :hideQr="hideQr" :dataProps="print"></print-pos-coco-teams>
      <print-pos-fa-ciade v-else-if="keyMaster === '3f3355bdc105555f5c6fe11bfd1e5021'" :hideQr="hideQr" :dataProps="print"></print-pos-fa-ciade>

      <print-pos-fa v-else-if="!IsIsss" :dataProps="print"></print-pos-fa>
    </template>

    <PrintPosDteLetter :hideQr="hideQr" :dataProps="printLetter"></PrintPosDteLetter>

    <v-dialog v-model="showDialogTemplate" max-width="1000">
      <v-card>
        <v-card-title class="text-h5"
          >Creación de plantilla de facturación</v-card-title
        >
        <v-card-text>
          <v-text-field
            v-model="form.templatename"
            label="Nombre de plantilla"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-left">
            <v-btn @click="showDialogTemplate = false" class="btndelete">
              Cancelar
            </v-btn>
          </v-col>
          <v-col class="text-right">
            <v-btn
              :disabled="loading"
              @click="
                form.istemplate = 1;
                alertContinueWithDifferentDateThanToday(0);
              "
              class="btn-save"
            >
              Guardar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <InvoiceProductsClasificationSelector v-if="productsToBillForSelector.length > 0 && servicesToBillForSelector.length > 0" v-model="showClasificationSelector" :products="productsToBillForSelector" :services="servicesToBillForSelector" @addElement="addElementFromSelector"></InvoiceProductsClasificationSelector> -->
    <InvoiceProductsClasificationSelector
      v-model="showClasificationSelector"
      :products="productsToBillForSelector"
      :services="servicesToBillForSelector"
      @addElement="addElementFromSelector"
    ></InvoiceProductsClasificationSelector>
    <v-dialog v-model="showReturnedAndPaymentModal" scrollable max-width="1000">
      <v-card height="inherit" style="overflow: auto">
        <v-card-title class="text-h5"> Método de pago </v-card-title>
        <v-card-text>
          <v-row class="mt-2">
            <v-col class="text-right">
              <v-btn @click="addPaymentType" class="btn-save" :disabled="isCreditPaymentRestricted">
                <v-icon>mdi-plus</v-icon>&nbsp;Agregar tipo de pago
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <DxDataGrid :data-source="paymentsData" :show-borders="true">
              <DxEditing
                :allow-updating="true"
                :select-text-on-edit-start="true"
                start-edit-action="click"
                mode="cell"
              />
              <DxColumn width="40" cell-template="select-type-payments" caption="" header-cell-template="headerSelect"/>
                <template #headerSelect="{}">
                  <v-icon style="cursor: pointer;" v-if="paymentTypeSelect" @click="resetSeleted" color="primary">mdi-refresh</v-icon>
                </template>
              <template #select-type-payments="{ data }">
                <div style="padding-top: 6px;">
                    <input :value="data.rowIndex"  type="radio" name="selectedPayment" v-model="selectedPayment" id="selectedPayment" @change="(e) => selectPayment(data, e)" />
                </div>
              </template>
              <DxColumn cell-template="type-payments" caption="Tipo de pago" />
              <template #type-payments="{ data }">
                <div>
                  <div style="width: 100%">
                    <select
                      style="width: calc(100% - 30px); padding: 5px"
                      v-model="data.data.typePaymentAlt"
                      @change="handleTypePaymentChange(data)"
                      :disabled="isCreditPaymentRestricted"
                    >
                      <option
                        v-for="(paymentType, index) in visiblePaymentTypes"
                        :key="index"
                        :value="paymentType.Codigo_Alt"
                      >
                        {{ (paymentType.Codigo_Alt == codCompuestoAnt) ? data.data.descriptionPayment : paymentType.Valores }}
                      </option>
                    </select>
                    <v-icon>mdi-arrow-down</v-icon>
                  </div>
                </div>
              </template>
              <DxColumn cell-template="total-payment" caption="Total" />
              <template #total-payment="{ data }">
                <div>
                  <v-text-field
                    class="mt-0 centered-input"
                    type="number"
                    v-model="data.data.totalPayment"
                    @blur="showPaymentWithDecimal(data.data)"
                    @input="handleRowChangedPayments()"
                    @keydown.enter.prevent.stop="handlePaymentEnter($event, data.data)"
                    @focus="onTextFieldFocus"
                    :autofocus="data.rowIndex === 0"
                    hide-details
                    dense
                    :disabled="paymentTypeSelect || isCreditPaymentRestricted"
                  />
                </div>
              </template>
              <DxColumn
                cell-template="reference-editing"
                caption="N. Referencia"
              />
              <template #reference-editing="{ data }">
                <template>
                  <input
                    v-model="data.data.reference"
                    style="width: 100% !important; text-align: center"
                    :disabled="data.data.typePayment == '01'"
                  />
                </template>
              </template>

              <DxColumn :width="50" cell-template="delete-payment" caption="" />
              <template #delete-payment="{ data }">
                    <a href="#" class="mx-1" @click="deletePayment(data.data)" v-if="!isCreditPaymentRestricted">
                  <v-icon color="error"> mdi-delete </v-icon>
                </a>
              </template>
            </DxDataGrid>
          </v-row>
          <v-row class="mb-2">
            <v-col class="mt-5">
              <v-row class="d-flex justify-center">
                <span style="color: black">Total a pagar</span>
              </v-row>
              <v-row class="d-flex justify-center">
                <input type="text" class="form-control" :value="sumPayments" />
              </v-row>
            </v-col>
            <v-col class="mt-5">
              <v-row class="d-flex justify-center">
                <span style="color: black">Total a cancelar</span>
              </v-row>
              <v-row class="d-flex justify-center">
                <input
                  type="text"
                  class="totalDesign form-control"
                  :value="sumObject.total"
                />
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-col class="text-left">
            <v-btn
              @click="sendCancel"
              class="btndelete"
            >
              Cancelar
            </v-btn>
          </v-col>
          <v-col v-if="form.isquote" class="text-right">
            <v-btn
              :disabled="loading"
              @click="
                showReturnedAndPaymentModal = false;
                alertContinueWithDifferentDateThanToday(0);
              "
              class="btn-save"
            >
              <v-icon>mdi-content-save</v-icon>&nbsp;Guardar Cotización
            </v-btn>
          </v-col>
          <v-col v-if="form.istemplate" class="text-right">
            <v-btn
              :disabled="loading"
              @click="
                showReturnedAndPaymentModal = false;
                showDialogTemplate = true;
              "
              class="btn-save"
            >
              <v-icon>mdi-content-save</v-icon>&nbsp;Guardar Plantilla
            </v-btn>
          </v-col>
          <v-col v-if="isReadyToBill" class="text-right">
            <v-btn
              :disabled="loading"
              @click="
                showReturnedAndPaymentModal = false;
                alertContinueWithDifferentDateThanToday(0);
              "
              class="btn-save"
            >
              <v-icon>mdi-content-save</v-icon>&nbsp;Guardar Factura
            </v-btn>
          </v-col>
          <v-col
            v-if="!isReadyToBill && form.istemplate == 0 && form.isquote == 0"
            class="text-right"
          >
            <v-btn
              :disabled="loading || invoiceSubmissionInProgress"
              @click.prevent="requestBillSubmission(1)"
              class="btn-add"
              v-if="$store.getters['rolesUser/getCustomRole'](5)"
            >
              <v-icon>mdi-printer-pos</v-icon>&nbsp;Facturar 
            </v-btn>
          </v-col>
          <!--v-col
            v-if="!isReadyToBill && form.istemplate == 0 && form.isquote == 0 && PrintTicket"
            class="text-right"
          >
            <v-btn
              :disabled="loading"
              @click="
                showReturnedAndPaymentModal = false;
                sendBill(1);
              "
              class="btn-save"
              v-if="$store.getters['rolesUser/getCustomRole'](5)"
            >
              <v-icon>mdi-printer-pos</v-icon>&nbsp;Ticket
            </v-btn>
          </v-col-->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogSaleThirdParty" scrollable max-width="1000">
      <v-card height="inherit" style="overflow: auto">
        <v-card-title class="text-h5"> Venta por cuenta de terceros </v-card-title>
        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12" md="12">
              <div 
                class="form-group"
              >
                <CustomAutoComplete
                  style="display: inline-block; vertical-align: top; width: 100%"
                  key="CustomerVtercero"
                  v-if="vTerceroList.length > 0"
                  :label="'Buscar y seleccionar cliente para venta a tercero'"
                  v-model="form.ventaterceroid"
                  :search="{ ...search, filteredFrom: 2 }"
                  :min-search-length="3"
                  :limit="50"
                  :items="vTerceroList"
                  :item-text="'itemText'"
                  :filter-endpoint="$API.customers.findCustomerOnlyThirdParty"
                  :item-value="'ID_Customer'"
                  @select="
                    (e) => {
                      form.ventaterceroid = ''
                      vTerceroSelectOnChange(e);
                    }
                  "
                  @updateItems="updateVterceroList"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field 
                v-model="form.ventaterceronit"
                outlined 
                dense 
                label="NIT por cuenta de Terceros"
                @keyup="getNITMaskVentaTercero"
                autocomplete="name"
                />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field 
                v-model="form.ventaterceronombre"
                outlined 
                dense 
                label="Nombre, denominación o razón social del Tercero" 
                autocomplete="name"
                />
            </v-col>

            <v-col class="mt-4 mb-4 text-right" cols="12" md="12">
              <v-btn
                color="btndisable"
                dark
                @click="showDialogSaleThirdParty = !showDialogSaleThirdParty">
                Continuar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogAdvancePayments" scrollable max-width="1000">
      <v-card height="inherit" style="overflow: auto">
        <v-card-title class="text-h5"> Anticipos del cliente </v-card-title>
        <v-card-text>
          <v-row class="mt-2">
            <v-simple-table dense style="width: 100%">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-left">ID</th>
                    <th class="text-left">Fecha</th>
                    <!--th class="text-left">Tipo de pago</th-->
                    <!--th class="text-left">Referencia</th-->
                    <th class="text-left">Cantidad</th>
                    <th class="text-left">Descripción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="advancePayment in advancePayments" :key="advancePayment">
                    <td>
                      <v-checkbox @click.prevent="checkAdvancePaymentChanged(advancePayment)"> </v-checkbox>
                    </td>
                    <td>{{ advancePayment.ID_AdvancePayment }}</td>
                    <td>{{ formatDate(advancePayment.DatePayment) }}</td>
                    <td>$ {{ advancePayment.Payment.toFixed(2) }}</td>
                    <td>{{ advancePayment.Comment }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-col class="mt-4 mb-4" cols=12 md=6>
              <v-btn
                color="primary"
                dark
                @click.prevent="addAdvancePayments" :disabled="isCreditPaymentRestricted">
                Guardar selección de anticipos en el pago de factura
              </v-btn>
            </v-col>

            <v-col class="mt-4 mb-4 text-right" cols="12" md="6">
              <v-btn
                color="btndisable"
                dark
                @click="showDialogAdvancePayments = !showDialogAdvancePayments">
                Continuar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <alert
      v-model="alertFactura.show"
      :title="alertFactura.title"
      :color="alertFactura.color"
      :altColor="alertFactura.colorBtn"
      :titleColor="alertFactura.colorTitle"
    >
      <div :class="`mb-3 ${['RECHAZADO', 'CONTINGENCIA'].includes(alertFactura.estado) ? 'black--text' : 'white--text'}`">{{alertFactura.message}}</div>
      <template v-if="!!alertFactura.total">
        <div class="mb-1"><span :class="`'mb-1 text-h5' ${['RECHAZADO', 'CONTINGENCIA'].includes(alertFactura.estado) ? 'black--text' : 'primary--text'}`">Total facturado:</span> ${{alertFactura.total}}</div>
        <div class="text-h5"><span :class="`'text-h5' ${['RECHAZADO', 'CONTINGENCIA'].includes(alertFactura.estado) ? 'black--text' : 'primary--text'}`">Total pagado:</span> ${{alertFactura.pagoCon}}</div>
        <div class="mt-1 text-h5"><span :class="`'text-h5' ${['RECHAZADO', 'CONTINGENCIA'].includes(alertFactura.estado) ? 'black--text' : 'primary--text'}`">Cambio:</span> ${{alertFactura.cambio}}</div>
      </template>
      <div class="mt-3"><span :class="`${['RECHAZADO', 'CONTINGENCIA'].includes(alertFactura.estado) ? 'black--text' : 'primary--text'}`">Estado: </span>{{alertFactura.estado}}</div>
      <div :class="`${['RECHAZADO', 'CONTINGENCIA'].includes(alertFactura.estado) ? 'black--text' : 'primary--text'}`">Mensaje del Ministerio de Hacienda:</div><span>{{alertFactura.description}}</span>
      <div>
        <span :class="`${['RECHAZADO', 'CONTINGENCIA'].includes(alertFactura.estado) ? 'black--text' : 'primary--text'}`">Observaciones DTE:</span>
        <template v-if="!!alertFactura.observaciones.length">
          <div :key="index" v-for="(observacion, index) in alertFactura.observaciones">- {{observacion}}</div>
        </template>
        <div v-else>- Ninguna observación</div>   
      </div>
    </alert>

    <v-dialog v-model="showItemComments" scrollable max-width="300"> 
      <v-card height="inherit" style="overflow: auto">
        <v-card-title class="text-h5"> Observaciones adicionales </v-card-title>
        <v-card-text>
          <br/>
          <v-textarea 
            label="Ingrese detalles del producto/servicio" 
            outlined
            v-model="commentsObject.ItemComments" 
            @input="onCellValueChangedComments(commentsObject)">
          </v-textarea>

          <v-btn
            color="btndisable"
            dark
            @click="showItemComments = !showItemComments">
            Continuar
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div v-if="printAccountStatement && printAccountStatement.show && printAccountStatement.data">
      <print-withholding :dataProps="printAccountStatement" :key="printAccountStatement.ID"/>
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxAsyncRule,
  DxRequiredRule,
  DxFormat,
  DxPatternRule,
  DxScrolling,
  DxLookup,
} from "devextreme-vue/data-grid";
import InvoiceProductsClasificationSelector from "../InvoiceProductsClasificationSelector.vue";
import Vue from "vue";
import PrintPosFa from "@/components/ReportsAndPrintings/PrintPosFa";
import PrintPosTk from "@/components/ReportsAndPrintings/PrintPosTk";
import { multipleCriteriaFilter } from "@/helpers/object";
import Search from "./Search";
import SearchTable from "./SearchTable";
import NewCustomerScreen from "./NewCustomerScreen.vue";
import DatePicker from "../../../components/DatePicker";
import NullInvoice from "./NullInvoice";
import Alerts from "@/components/Alerts";
import { Observable } from "rxjs";
import { mapState } from "vuex";
import { quillConfig } from "../../../helpers/quillconfig";
import { mapGetters } from "vuex";
import { numberToText } from "../../../helpers/conveterNumberText";
import Block from "@/components/Block";
import GeneralFilter from "../../../components/GeneralFilter.vue";
import CustomAutoComplete from "../../../components/CustomAutoComplete.vue";
import SearchDialog from "@/components/SearchDialog.vue";
import { numberWithCommas } from "../../../helpers/money";
import QuantityDialog from "../../../components/POS/QuantityDialog.vue";
import { generateUUID } from "../../../helpers/misc";
import PrintPosFactura from "../../../components/ReportsAndPrintings/PrintPosFactura.vue";
import PrintPosFacturaSolAmbiental from "../../../components/ReportsAndPrintings/PrintPosFacturaSolAmbiental";
import PrintPosCocoTeams from "../../../components/ReportsAndPrintings/PrintPosCocoTeams";
import PrintPosFaCiade from "../../../components/ReportsAndPrintings/PrintPosFaCiade";
import PrintPosDteLetter from "../../../components/ReportsAndPrintings/PrintPosDteLetter.vue";
import moment from "moment";
import PrintPosFaMed from "../../../components/ReportsAndPrintings/PrintPosFaMed";
import FixedPanel from "@/components/FixedPanel/FixedPanel.vue";
import FixedPanelField from "@/components/FixedPanel/FixedPanelField.vue";
import financing from '@/helpers/financing.js'

import {
  dui as duiMask,
  nrc as nrcMask,
  applyDUIMaskOutOfInput,
  // applyNITMaskOutOfInput,
  nitMaskHandlingHomologation,
  applyNitMaskHandlingHomologationOutOfInput,
} from "@/helpers/masks";

import { validateNITHomologation } from "@/helpers/object";
import { onlyDigitsAndAPoint } from "../../../helpers/masks";
//import PrintPosTkFcf from "@/components/ReportsAndPrintings/PrintPosTkFcf.vue";
import {
  //VUE_APP_ENV,
  VUE_APP_CARSEM_ID_KEYMASTER1,
  VUE_APP_CARSEM_ID_KEYMASTER2,
  VUE_APP_CARSEM_ID_KEYMASTER3,
} from "../../../config";

import { getCookie } from "../../../helpers/misc";
import { imprimirFactura } from "../../../utils/printInvoice";
import { resolveBranchConfiguredDteTemplate } from "@/helpers/dteTemplateSettings";
import PrintWithholding from '@/components/ReportsAndPrintings/PrintWithholding.vue';
import CustomAutoCompleteObject from "../../../components/CustomAutoCompleteObject.vue";

const EL_SALVADOR = "El Salvador";
const ENTITY_LABELS_FOR_EL_SALVADOR = new Set([
  "PERSONA NATURAL",
  "PERSONA JURIDICA",
]);

function normalizeEntityLabel(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();
}

function filterEntityOptionsByCountry(options, country) {
  if (country !== EL_SALVADOR) {
    return options;
  }

  return options.filter((option) =>
    ENTITY_LABELS_FOR_EL_SALVADOR.has(normalizeEntityLabel(option))
  );
}

const printPosFaConstructor = Vue.extend(PrintPosFa);

export default {
  name: "Create",
  components: {
    InvoiceProductsClasificationSelector,
    SearchDialog,
    NullInvoice,
    DatePicker,
    Search,
    SearchTable,
    NewCustomerScreen,
    DxDataGrid,
    DxEditing,
    DxAsyncRule,
    DxRequiredRule,
    DxFormat,
    DxPatternRule,
    DxColumn,
    DxScrolling,
    DxLookup,
    Alerts,
    Block,
    PrintPosFa,
    PrintPosTk,
    //PrintPosTkFcf,
    GeneralFilter,
    CustomAutoComplete,
    QuantityDialog,
    PrintPosFactura,
    PrintPosFacturaSolAmbiental,
    PrintPosCocoTeams,
    PrintPosFaCiade,
    PrintPosDteLetter,
    PrintPosFaMed,
    FixedPanel,
    FixedPanelField,
    'print-withholding': PrintWithholding,
    CustomAutoCompleteObject
  },
  props: ["win", "hasActiveCashOpening"],
  data() {
    return {
      invoiceAttemptKey: null,
      invoiceAttemptUncertain: false,
      invoiceRequestInFlight: false,
      tempId: '',
      tempDetails: [],
      extendedViewTable: false,
      paymentTypeSelect: false,
      orderAndPrint: false,
      selectedPayment: '',
      TipoPlan: JSON.parse(localStorage.getItem('user')).TipoPlan,
      alertFactura:{
        show:false,
        title:"",
        message:"",
        color:"comment",
        total:"",
        pagoCon:"",
        cambio:"",
        estado:"",
        description:"",
        observaciones:[],
        colorBtn:"primary",
        colorTitle: "",
      },
      showPrices: false,
      headers: [
        {
          text: "Lista de precios",
          align: "start",
          sortable: false,
          value: "PriceListName",
        },
        {
          text: "Precio original",
          align: "end",
          sortable: false,
          value: "ItemOriginalPrice",
        },
        {
          text: "Monto descuento",
          align: "end",
          sortable: false,
          value: "ItemPriceDiscountAmount",
        },
        {
          text: "Porcentaje descuento",
          align: "end",
          sortable: false,
          value: "ItemPriceDiscountPercent",
        },
        {
          text: "Precio con descuento",
          align: "end",
          sortable: false,
          value: "ItemNewPrice",
        },
        {
          text: "Rango inicial",
          align: "end",
          sortable: false,
          value: "InitialRange",
        },
        {
          text: "Rango final",
          align: "end",
          sortable: false,
          value: "FinalRange",
        },
      ],
      prices: [],
      invoiceAutoSave: 0,
      togglehide: false,
      togglehideSeller: "display: none !important",
      showClasificationSelector: false,
      sellersList: [],
      technicalList: [],
      dteUsers: [],
      datatoprint: {
        branch: JSON.parse(localStorage.getItem("branch")),
        user: JSON.parse(localStorage.getItem("user")),
        header: null,
        body: null,
        dteJson: null,
      },
      print: {
        show: false,
        data: {},
      },
      print2: {
        show: false,
        data: {},
      },
      print3: {
        show: false,
        data: {},
      },
      printLetter: {
        show: false,
        data: {},
      },
      allowEditName: false,
      customersList: [],
      vTerceroList: [],
      itemQtyPattern: /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/i,
      loading: false,
      workingIn: "",
      displayInvoice: "products",
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      currenterrordata: null,
      role: null,
      branch: null,
      business: null,
      search: {},
      form: {
        invoicedate: null,
        invoicetype: null,
        rulestoshowcomments: 0,
        idinvoice: "",
        legalidinvoice: "",
        legalisnontaxable: 0,
        legalisnonsuj: 0,
        istemplate: 0,
        isquote: 0,
        timesexecute: 0,
        flete: 0,
        seguro: 0,
        invoicecreditday: "",
        invoicestatusdescription: "",
        isfinance: 0,
        codasociado: null,
        docasociado: "",
        detalleasociado: "",
        extensionnombentrega: "",
        extensiondocuentrega: "",
        extensiontelefonoentrega: "",
        extensionnombrecibe: "",
        extensiondocurecibe: "",
        extensiontelefonorecibe: "",
        showresponsabilitiesininvoice: 0,
        apendice: null,
      },
      showBgcolorNotes: "tabs",
      confirmDelete: null,
      quillOptions: quillConfig,
      showNotes: false,
      showFilter: false,
      filterProducts: {
        filter: "",
        family: null,
        category: null,
        subcategory: null,
      },
      filterServices: {
        filter: "",
        family: null,
        category: null,
        subcategory: null,
      },
      newCostumer: false,
      priceList: [
        {
          PriceListName: "TODOS",
        },
      ],
      types: ["TODOS", "PRODUCTO"],
      warehouse: [
        {
          ID_Warehouse: "TODOS",
          Warehouse: "TODOS",
        },
      ],
      provider: [
        {
          ID_Provider: "TODOS",
          ProviderName: "TODOS",
        },
      ],
      productsToBillDefault: [],
      productsToBill: {},
      productsToBillForSelector: [],
      productToBillPrev: {},
      servicesToBill: [],
      servicesToBillForSelector: [],

      //??????? no se
      nullInvoice: false,

      productsToShow: [],
      taxpayersize: [
        { key: "MEDIANO", value: "MEDIANO" },
        { key: "PEQUEÑO", value: "PEQUEÑO" },
        { key: "GRANDE", value: "GRANDE" },
      ],
      businessSize: ["PEQUEÑO", "MEDIANO", "GRANDE"],
      businessEntity: [
        "PERSONA NATURAL",
        "PERSONA JURÍDICA",
        "SOCIEDAD ANÓNIMA",
        "CORPORACIÓN",
      ],
      searchCustomerDialog: false,
      showSearchCustomerTableDialog: false,
      searchSellerDialog: false,
      searchTechnicalDialog: false,
      warehouses: [],
      headerFirstRowDefaultElements: 3,
      headerFirstRowElementWidth: 4,
      headerFirstRowMdsManagement: {
        3: 2,
        4: 3,
        5: null,
        6: 2,
      },
      headerSecondRowDefaultElements: 1,
      headerSecondRowElementWidth: 12,
      headerSecondRowColsManagement: {
        1: 12,
        2: 6,
        3: 4,
      },
      productcode: null,
      productAutocompleteKey: 0,
      filterWarehouses: {},
      PriceListSelected: null,
      warehouseSelected: null,
      responsableDteUserId: null,
      priceListData: [],
      isCustomerSelected: false,
      createdInvoiceId: null,
      discountObject: null,
      objectToApplyDiscount: {},
      showDiscount: false,
      showDiscountGlobal: false,
      barcode: "",
      isCarsem: false,
      typeService: [
        {
          ID: "PLT",
          Name: "Examen de Laboratorio",
        },
        {
          ID: "OTR",
          Name: "Otro",
        },
      ],
      showComment: false,
      showInvoiceComments: false,
      showApendice: false,
      apendiceEnabled: false,
      apendiceAddOrderLabel: false,
      apendiceRows: [],
      apendiceCampoOptions: [
        { text: "OrdenCompra", value: "OrdenCompra" },
        { text: "Comentario", value: "Comentario" },
      ],
      apendiceFieldRules: {
        campo: [
          (v) => !!v || "Este campo es requerido",
          (v) => String(v || "").trim().length >= 2 || "Mínimo 2 caracteres",
          (v) => String(v || "").trim().length <= 25 || "Máximo 25 caracteres",
        ],
        etiqueta: [
          (v) => !!v || "Este campo es requerido",
          (v) => String(v || "").trim().length >= 3 || "Mínimo 3 caracteres",
          (v) => String(v || "").trim().length <= 50 || "Máximo 50 caracteres",
        ],
        valor: [
          (v) => !!v || "Este campo es requerido",
          (v) => String(v || "").trim().length >= 1 || "Mínimo 1 caracter",
          (v) => String(v || "").trim().length <= 150 || "Máximo 150 caracteres",
        ],
      },
      showCustomer: false,
      showProductsAndServices: false,
      globalDiscount: {
        TotalNewPrice: 0,
        TotalPriceDiscountPercent: 0,
        TotalNewTotal: 0,
      },
      appliedGlobalDiscount: {
        discountAmount: 0,
        discountPercent: 0,
        descu: 0,
        descuNoSuj: 0,
        descuExenta: 0,
        descuGravada: 0,
        ivaReduction: 0,
        totalEffect: 0,
      },
      invoiceStatus: 0,
      pricelistDetail: [],
      showDetailsMessages: false,
      showDialogTemplate: false,
      taxPayerSize: null,
      BusinessLegalAgentRetain: false,
      required: [(v) => !!v || "Este campo es requerido"],
      defaultPriceList: null,
      productsFiltered: false,
      productsToShowFiltered: [],
      showTimesExecute: false,
      cancelTimesExecute: false,
      barCodes: [],
      selectedBarCode: null,
      barCodeToFind: null,
      customerCreditInformation: {},
      creditBillingBlock: false,
      productsToBillSearchTab: [],
      servicesToBillSearchTab: [],
      ProductServList: [],
      assignedList: {
        prod: false,
        serv: false,
      },
      posrestaurant: JSON.parse(localStorage.getItem("user")).posrestaurant,
      Currency: JSON.parse(localStorage.getItem("branch")).Currency,
      showReturnedAndPaymentModal: false,
      isReadyToBill: false,
      invoiceSubmissionInProgress: false,
      copiedPaymentsInitialized: false,
      enableEnterBillFromPayments: JSON.parse(localStorage.getItem("user")).pospaymentsenterbill || 0,
      codCompuestoAnt: null,
      paymentsData: JSON.parse(localStorage.getItem("user")).keymaster == "47770e9a83f6f46af2a3d2b93fff710a" ? 
      [
        {
          typePayment: "01",
          descriptionPayment: "Billetes y monedas",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "02",
          descriptionPayment: "Tarjeta Débito",
          totalPayment: 0.0,
          reference: null,
        },
        {
           typePayment: "03",
           descriptionPayment: "Tarjeta Crédito",
           totalPayment: 0.0,
           reference: null,
        },
        {
          typePayment: "04",
          descriptionPayment: "Cheque",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "05",
          descriptionPayment: "Transferencia_ Depósito Bancario",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "13",
          descriptionPayment: "Cuentas por pagar del receptor",
          totalPayment: 0.0,
          reference: null,
        },
      ] : 
      [
        {
          typePayment: "01",
          descriptionPayment: "Billetes y monedas",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "02",
          descriptionPayment: "Tarjeta Débito",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "04",
          descriptionPayment: "Cheque",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "05",
          descriptionPayment: "Transferencia_ Depósito Bancario",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "13",
          descriptionPayment: "Cuentas por pagar del receptor",
          totalPayment: 0.0,
          reference: null,
        },
      ],
      sumPayments: 0,
      pospayments: JSON.parse(localStorage.getItem("user")).pospayments,
      codigosAsociados: [
        { id: 1, valor: "Emisor" },
        { id: 2, valor: "Receptor" },
      ],
      codigosAsociadosEx: [
        {
          id: 4,
          valor: "Transporte",
        },
        {
          id: 1,
          valor: "Emisor",
        },
        {
          id: 2,
          valor: "Receptor",
        },
      ],
      modoTransporte: [
        { id: 1, valor: "Terrestre" },
        { id: 2, valor: "Marítimo" },
        { id: 3, valor: "Aéreo" },
        { id: 4, valor: "Multimodal, Terrestre-marítimo" },
        { id: 5, valor: "Multimodal, Terrestre-aéreo" },
        { id: 6, valor: "Multimodal, Marítimo- aéreo" },
        { id: 7, valor: "Multimodal, Terrestre-Marítimo- aéreo" },
      ],
      zonasExportacion: [
        { id: 1, valor: "Exportaciones a Zonas Francas" },
        { id: 2, valor: "Exportaciones dentro del área centroamericana" },
        { id: 3, valor: "Exportaciones fuera del área centroamericana" },
        { id: 4, valor: "Exportaciones de servicios" },
      ],
      itemPriceDiscountPercentFocus: false,
      itemPriceDiscountAmountFocus: false,
      itemPriceDiscountPercentBeforeEdit: null,
      itemPriceDiscountAmountBeforeEdit: null,
      creditDays: [
        "1 días",
        "8 días",
        "15 días",
        "30 días",
        "45 días",
        "60 días",
        "90 días",
        "120 días",
        "180 días",
      ],
      stopIn: false,
      DynamicPriceLists: JSON.parse(localStorage.getItem("user"))
        .dynamicpricelists,
      POSRequiredIdSeller: JSON.parse(localStorage.getItem("user"))
        .posrequiredidseller,
      showQuantityDialog: false,
      currentItemToAdd: null,
      currentItemType: 0,
      POSProductsAlternativeBehavior: JSON.parse(localStorage.getItem("user"))
        .posproductsalternativebehavior,
      keyboardConfig: {
        F10: () => {
          if (this.form.idcustomer) {
            this.togglehide = true;
          }
          this.loadpriceProducts();
        },
        F12: () => {
          if (
            this.pospayments &&
            this.form.invoicetype != "DND" &&
            this.form.invoicetype != "DNC"
          ) {
            this.showReturnedAndPaymentModal = true;
            this.isReadyToBill = false;
            this.form.istemplate = 0;
          }
        },
        F1: () => {
          if (this.loading === false) {
            this.requestBillSubmission(1);
          }
        },
        F2: () => {
          if (this.loading === false) {
            this.alertContinueWithDifferentDateThanToday(0);
          }
        },
        F11: () => {
          let index =
            this.priceListData.findIndex(
              (current) => current.id === this.PriceListSelected
            ) + 1;
          if (index >= this.priceListData.length) {
            index = 0;
          }
          const { id } = this.priceListData[index];
          this.PriceListSelected = id;
          this.getPriceListSelected();
        },
      },
      posshowprincipalbarcode: JSON.parse(localStorage.getItem("user"))
        .posshowprincipalbarcode,
      bienTitulo: [
        { id: "01", value: "Depósito" },
        { id: "02", value: "Propiedad" },
        { id: "03", value: "Consignación" },
        { id: "04", value: "Traslado" },
        { id: "05", value: "Otros" },
      ],
      ZoneConfiguration: [],
      EnableZoneConfiguration: JSON.parse(localStorage.getItem("user"))
        .enablezoneconfiguration,
      allowRepetitionOfArticles: false,
      EnableNegativeItem: JSON.parse(localStorage.getItem("user")).enablenegativeitem,
      ShowBatchInfoPos: JSON.parse(localStorage.getItem("user")).showbatchinfopos,
      ferretlabenddata: JSON.parse(localStorage.getItem("user")).ferretlabenddata,
      showExtraInfoBatch: false,
      restivaposexentonosuj: JSON.parse(localStorage.getItem("user")).restivaposexentonosuj,
      keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
      ticketdirectprinting: JSON.parse(localStorage.getItem("user")).ticketdirectprinting || 0,
      ticketdirectnowinfcf: JSON.parse(localStorage.getItem("user")).ticketdirectnowinfcf || 0,
      ticketdirectnowinccf: JSON.parse(localStorage.getItem("user")).ticketdirectnowinccf || 0,
      showDialogAdvancePayments: false,
      advancePayments: [],
      advancePaymentsSelected: [],
      onlycreditpaymentmethod: JSON.parse(localStorage.getItem("user")).onlycreditpaymentmethod || 0,
      normalInvoicePaymentTypeBeforeCredit: null,
      normalPaymentsBeforeCredit: null,
      incoterms: [
        { id: "01", valor: "EXW-En fabrica" },
        { id: "02", valor: "FCA-Libre transportista" },
        { id: "03", valor: "CPT-Transporte pagado hasta" },
        { id: "04", valor: "CIP-Transporte y seguro pagado hasta" },
        { id: "05", valor: "DAP-Entrega en el lugar" },
        { id: "06", valor: "DPU-Entregado en el lugar descargado" },
        { id: "07", valor: "DDP-Entrega con impuestos pagados" },
        { id: "08", valor: "FAS-Libre al costado del buque" },
        { id: "09", valor: "FOB-Libre a bordo" },
        { id: "10", valor: "CFR-Costo y flete" },
        { id: "11", valor: "CIF- Costo seguro y flete" },
        { id: "12", valor: "DAT-Entregado en terminal" },
        { id: "13", valor: "DAF-Entregada en frontera" },
        { id: "14", valor: "DES-Entregada sobre duque" },
        { id: "15", valor: "DEQ-Entregada en muelle" },
        { id: "16", valor: "DDU- Entregada derechos no pagados" }
      ],
      noaddivainpos: JSON.parse(localStorage.getItem("user")).noaddivainpos || 0,
      addimpturismo: JSON.parse(localStorage.getItem("user")).keepturismtaxunitprice || 0,
      ishosting: JSON.parse(localStorage.getItem("user")).ishosting || 0,
      noCalculateAddimpturismo: false,
      ShowCorrelativeControl: JSON.parse(localStorage.getItem("user")).showcorrelativecontrol,
      //PrintTicket: false,
      UseNewEnpointToAllClient: true,
      IsIsss: false,
      UseNewSpNumControl: JSON.parse(localStorage.getItem("user")).usenewspnumcontrol,
      throttleTimeout: null,
      throttleDelay: 500,  // milliseconds to wait before sending
      statusAutoSave: "Verificando...",
      paymentTypes: [],
      billposwith1warehouse: JSON.parse(localStorage.getItem("user")).billposwith1warehouse || 0,
      addwarehouseofprodinbill: JSON.parse(localStorage.getItem("user")).addwarehouseofprodinbill || 0,
      AuthFeMode: JSON.parse(localStorage.getItem("branch"))?.AuthFeMode,
      showItemComments: false,
      commentsObject: {},
      showDialogSaleThirdParty: false,
      BccEmails: [],
      tmpResponseRechazado: {},
      InvoiceWithCredit:[],
      printAccountStatement: {
        show : false,
        header: {},
        data: []
      },
      customerSelectedData: {},
      activarPropinas: 0,
      porcentajePropinas: 10,
      servicioDeProPinas: {},
      propinasdefault: JSON.parse(localStorage.getItem("user"))?.propinasdefault,
      enablenegativeitem: JSON.parse(localStorage.getItem("user"))?.enablenegativeitem,
      showunitcostinpos: JSON.parse(localStorage.getItem("user"))?.showunitcostinpos,
      usetechnical: JSON.parse(localStorage.getItem('user'))?.usetechnical || 0,
      firstLoad: true,
      stopCounterDynamicList: 0,
      showFormAirplaneTicket: false,
      airplaneTicketObject: null,
      showformairlinetickets: JSON.parse(localStorage.getItem('user'))?.showformairlinetickets || 0,
      family: [],
      category: [],
      subcategory: [],
      minProductView: false,
      MarkAsBilledItems: {},
      hideQr: false,
    };
  },
  computed: {
    ...mapState(["changueWarehouse", "changuePriceList"]),
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
    sortedFamilies() {
      return [...(this.family || [])].sort((a, b) =>
        (a?.name || "").localeCompare(b?.name || "")
      );
    },
    filteredCategories() {
      if (!this.filterProducts.family) {
        return [];
      }

      return [...(this.category || [])]
        .filter((element) => element.parent_id === this.filterProducts.family)
        .sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
    },
    filteredSubcategories() {
      if (!this.filterProducts.category) {
        return [];
      }

      return [...(this.subcategory || [])]
        .filter((element) => element.parent_id === this.filterProducts.category)
        .sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
    },
    filteredServiceCategories() {
      if (!this.filterServices.family) {
        return [];
      }

      return [...(this.category || [])]
        .filter((element) => element.parent_id === this.filterServices.family)
        .sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
    },
    filteredServiceSubcategories() {
      if (!this.filterServices.category) {
        return [];
      }

      return [...(this.subcategory || [])]
        .filter((element) => element.parent_id === this.filterServices.category)
        .sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
    },
    shouldAutoSave () {
      return this.invoiceAutoSave && this.tempId.startsWith('AUT');
    },
    isFCF() {
      return (
        JSON.parse(localStorage.getItem("user")).ticketformatfcf &&
        JSON.parse(localStorage.getItem("user")).TipoPlan != "Ecoanual" &&
        (this.form.invoicetype == "FCF" || this.form.invoicetype == "CCF")
      );
    },
    showUnitCost() {
      return (["FCF", "CCF", "FEX", "CDD", "DNR", "TCKS"].includes(this.form.invoicetype))
    },
    allowQtyEditWhenForceBlocking() {
      return Boolean(
        this.header?.InventoryStatus &&
        this.forceBlocking &&
        this.ndornc == null &&
        !(
          ["RECHAZADO", "CONTINGENCIA"].includes(this.header?.FeMhEstado) &&
          !this.copy
        )
      );
    },
    isProductsGridDisabled() {
      return Boolean(
        this.BlockInvoice &&
          this.ndornc == null &&
          !this.allowQtyEditWhenForceBlocking
      );
    },
    BlockInvoice() {
      return Boolean(
        this.header?.InventoryStatus &&
          (
            this.forceBlocking ||
            (
              ["RECHAZADO", "CONTINGENCIA"].includes(this.header?.FeMhEstado) &&
              !this.copy
            )
          )
      );
    },
    /*showTicket() {
      return (
        JSON.parse(localStorage.getItem('user')).ticketformatfcf && 
        JSON.parse(localStorage.getItem('user')).TipoPlan != 'Emprendedor' &&
        JSON.parse(localStorage.getItem('user')).TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' &&
        (this.form.invoicetype == 'FCF' || this.form.invoicetype == 'CCF')
      )
    },*/
    isTablet() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    colClasses() {
      let classes = {
        "d-flex": true,
        "justify-center": true,
        responsiveTinyCol: true,
        "mt-8": !this.isMobile,
      };

      if (this.form.isquote === 1) {
        classes["mr-4"] = true;
      }
      return classes;
    },
    colGroupStyle() {
      if (this.isTablet) {
        return {
          width: "100%",
          display: "flex",
          "justify-content": "center",
          margin: "25px",
        };
      } else {
        return "";
      }
    },
    retornarDTEname() {
      if (this.form.invoicetype == "FCF") {
        return "FACTURA CONSUMIDOR FINAL";
      } else {
        if (this.form.invoicetype == "CCF") {
          return "COMPROBANTE CRÉDITO FISCAL";
        } else {
          if (this.form.invoicetype == "FNS") {
            return "FACTURA SUJETO EXCLUIDO";
          } else {
            if (this.form.invoicetype == "FEX") {
              return "FACTURA EXPORTACIÓN";
            } else {
              if (this.form.invoicetype == "CDD") {
                return "COMPROBANTE DE DONACION";
              } else {
                if (this.form.invoicetype == "DNC") {
                  return "NOTA DE CRÉDITO";
                } else {
                  if (this.form.invoicetype == "DND") {
                    return "NOTA DE DÉBITO";
                  } else {
                    if (this.form.invoicetype == "DNR") {
                      return "NOTA DE REMISIÓN";
                    } else {
                      return "Otro";
                    }
                  }
                }
              }
            }
          }
        }
      }
    },

    filterType() {
      const TicketLocal = (JSON.parse(localStorage.getItem('user'))?.ticketlocal ?? 0) == 1;
      const masterBusiness = JSON.parse(localStorage.getItem("user"))?.keymaster ?? '';
      const TicketLocalKeymaster = [
        '377be3042e446f9f8312a4ea699a4381', 
        '689510125c294fa0c2b02d6200cceb7f',
        '0a9e451bcfa7e7db984f3e7f27e1bd56',
        '6e87d287a283098a118f6ba5526233b9',
        '8ef25daf48ea91f34aeaabbe9eb5b0d2',
      ]
      if (
        ( JSON.parse(localStorage.getItem("branch")).ID_Business == "17" ||
          JSON.parse(localStorage.getItem("branch")).ID_Business == "41" || 
          TicketLocalKeymaster.includes(masterBusiness) || 
          TicketLocal ) &&
        this.form.invoicetype != "DNC" &&
        this.form.invoicetype != "DND" &&
        this.form.invoicetype != "COT"
      ) {
        return [
          {
            name: "CONSUMIDOR FINAL",
            key: "FCF",
          },
          {
            name: "CRÉDITO FISCAL",
            key: "CCF",
          },
          {
            name: "SUJETO EXCLUIDO",
            key: "FNS",
          },
          {
            name: "EXPORTACIÓN",
            key: "FEX",
          },
          {
            name: "COMPROBANTE DE DONACIÓN",
            key: "CDD",
          },
          {
            name: "TICKETS",
            key: "TCKS",
          },
          {
            name: "NOTA DE REMISIÓN",
            key: "DNR",
          },
          {
            name: "NOTA DE CRÉDITO",
            key: "DNC",
          },
          {
            name: "NOTA DE DÉBITO",
            key: "DND",
          },
        ];
      } else if (this.form.invoicetype == "DNC" && this.ndornc != null) {
        return [
          {
            name: "NOTA DE CRÉDITO",
            key: "DNC",
          },
        ];
      } else if (this.form.invoicetype == "DND" && this.ndornc != null) {
        return [
          {
            name: "NOTA DE DÉBITO",
            key: "DND",
          },
        ];
      } else if (this.form.invoicetype == "COT") {
        return [
          {
            name: "COTIZACIÓN",
            key: "COT",
          },
        ];
      } else {
        return [
          {
            name: "CONSUMIDOR FINAL",
            key: "FCF",
          },
          {
            name: "CRÉDITO FISCAL",
            key: "CCF",
          },
          {
            name: "SUJETO EXCLUIDO",
            key: "FNS",
          },
          {
            name: "EXPORTACIÓN",
            key: "FEX",
          },
          {
            name: "COMPROBANTE DE DONACIÓN",
            key: "CDD",
          },
          {
            name: "NOTA DE REMISIÓN",
            key: "DNR",
          },
          {
            name: "NOTA DE CRÉDITO",
            key: "DNC",
          },
          {
            name: "NOTA DE DÉBITO",
            key: "DND",
          },
        ];
      }
    },
    checkCountryInvoiceStatuses() {
      const country = JSON.parse(localStorage.getItem("branch")).Country;
      if (
        this.isCustomerSelected &&
        country === "El Salvador" &&
        (this.form.creditstatus == "BLOQUEADO" ||
          this.form.creditstatus == "INACTIVO" ||
          this.form.creditstatus == "SUSPENDIDO")
      ) {
        return ["Cancelada"];
      /*} else if (
        this.form.invoicetype == "DNC" ||
        this.form.invoicetype == "DND"
      ) {
        return ["Cancelada"];*/
      } else if (country === "El Salvador") {
        return ["Cancelada", "Crédito"];
      } else {
        return ["Cancelada", "Pendiente de pago", "Crédito"];
      }
    },
    businessEntityOptions() {
      const branchCountry = JSON.parse(localStorage.getItem("branch"))?.Country || "";
      return filterEntityOptionsByCountry(this.businessEntity, branchCountry);
    },
    checkWarehandPl() {
      if (!this.PriceListSelected || !this.warehouseSelected) return true;
      else return false;
    },
    correlative() {
      return this.form.idinvoice;
    },
    allproducts() {
      let values = [];
      if (this.productsToBillSearchTab.length > 0) {
        this.productsToBillSearchTab.forEach((element) => {
          values.push({
            ID: element.ID_Item,
            val: element.ID_Item,
            prod: { ...element, type: "product" },
          });
        });
      }
      if (this.servicesToBillSearchTab.length > 0) {
        this.servicesToBillSearchTab.forEach((element) => {
          values.push({
            ID: element.CodeService,
            val: element.CodeService,
            prod: { ...element, type: "service" },
          });
        });
      }
      return values;
    },
    allproductbyName() {
      let values = [];
      // const products = [];
      if (this.productsToBillSearchTab.length > 0) {
        if (this.warehouseSelected) {
          const filteredProducts = this.productsToBillSearchTab.filter(
            (element) => element.Warehouse === this.warehouseSelected
          ) ?? [];

          filteredProducts.forEach((element) => {
            values.push({
              ID:
                element.ItemName +
                (element.ItemComercialName
                  ? " | " + element.ItemComercialName
                  : ""),
              val: element.ID_Item,
              prod: { ...element, type: "product" },
            });
          });
        } else {
          this.productsToBillSearchTab.forEach((element) => {
            values.push({
              ID:
                element.ItemName +
                (element.ItemComercialName
                  ? " | " + element.ItemComercialName
                  : ""),
              val: element.ID_Item,
              prod: { ...element, type: "product" },
            });
          });
        }
      }
      if (this.servicesToBillSearchTab.length > 0) {
        this.servicesToBillSearchTab.forEach((element) => {
          values.push({
            ID:
              element.NameService + (element.Name ? " | " + element.Name : ""),
            val: element.CodeService,
            prod: { ...element, type: "service" },
          });
        });
      }

      return values;
    },
    sumObject() {
      return this.buildInvoiceSummary(true);
    },
    ...mapState("posData", {
      customer: (state) => state.customer,
      header: (state) => state.header,
      body: (state) => state.body,
      invalid: (state) => state.invalid,
      ndornc: (state) => state.ndornc,
      quote: (state) => state.quote,
      contingency: (state) => state.contingency,
      copy: (state) => state.copy,
      forceBlocking: (state) => state.forceBlocking,
    }),
    validateform() {
      if (this.form.invoicetype == "CCF") {
        let counter = 0;
        /*if (this.form.legalidinvoice == "" || this.form.legalidinvoice == null) {
          counter++;
        }*/
        if (this.form.legaladdress == "" || this.form.legaladdress == null) {
          counter++;
        }
        if (this.form.legalname == "" || this.form.legalname == null) {
          counter++;
        }
        if (this.form.legalnit == "" || this.form.legalnit == null) {
          counter++;
        }
        if (this.form.legalnrc == "" || this.form.legalnrc == null) {
          counter++;
        }
        /* if(this.form.legalsector == "" || this.form.legalsector == null) {
          counter++;
        } */
        if (
          this.form.legaltaxpayersize == "" ||
          this.form.legaltaxpayersize == null
        ) {
          counter++;
        }
        /*if (this.form.dui == "" || this.form.dui == null) {
          counter++;
        }*/
        if (this.form.codactividad == "" || this.form.codactividad == null) {
          counter++;
        }
        if (this.form.isa_business) {
          if (
            this.form.businesscontactemail == "" ||
            this.form.businesscontactemail == null
          ) {
            counter++;
          }
        } else {
          if (this.form.email == "" || this.form.email == null) {
            counter++;
          }
        }

        if (this.form.isa_business) {
          if (
            this.form.businesscontactphone == "" ||
            this.form.businesscontactphone == null
          ) {
            counter++;
          }
        } else {
          if (this.form.phonenumber == "" || this.form.phonenumber == null) {
            counter++;
          }
        }

        if (counter > 0) return true;
        else return false;
      } else if (this.form.invoicetype == "FCF") {
        let counter = 0;
        if (
          this.sumObject.total >= 25000.0 &&
          (this.form.dui == "" || this.form.dui == null)
        ) {
          counter++;
        }
        if (this.form.legalname == "" || this.form.legalname == null) {
          counter++;
        }
        if (counter > 0) return true;
        else return false;
      }

      return false;
    },
    responsibleDataRequired() {
      return Number(this.sumObject.total || 0) >= 25000;
    },
    ...mapGetters(["getCatalogMH", "activeWindowUuid"]),
    activities() {
      return this.getCatalogMH("ActividadEconomica");
    },
    showAccountStatement(){
      return (this.$store.getters['rolesUser/getCustomRole'](273))
            && this.customerSelectedData 
            && this.form.limitcredit > 0;
    },
    notQuantity(){
      return ["DNC", "FNS","DND", "COT"].includes(this.form.invoicetype) || this.form.isquote == 1;
    },
    isCreditPaymentRestricted() {
      return Number(this.onlycreditpaymentmethod) === 1 && this.form.invoicestatusdescription === "Crédito";
    },
    visiblePaymentTypes() {
      return this.isCreditPaymentRestricted
        ? this.paymentTypes.filter((paymentType) => String(paymentType.Codigo) === "13")
        : this.paymentTypes;
    }
    //paymentTypes() {
    //  return this.getCatalogMH("FormaPago");
    //},
  },
  async mounted() {
    try {
      this.verifyCarsem();
      /*GET BUSINESS ID AND BRANCH FOR INVOICES*/
      this.invoiceAutoSave = JSON.parse(localStorage.getItem("user")).invoiceAutoSave;
      this.branch = JSON.parse(localStorage.getItem("user")).branch;
      this.business = JSON.parse(localStorage.getItem("user")).businessid;
      //console.log(localStorage.getItem("user"));
      this.search.branch = this.branch;
      this.search.business = this.business;
      this.search.enablenegativeitem = this.enablenegativeitem;
      this.getInfoBranch();
      this.form.invoicetype = "FCF";
      this.form.idbusiness = this.business;
      this.form.idbranch = this.branch;
      this.codCompuestoAnt = '99-' + this.business + '-ANT'
      //Vista minima Prolab
      this.minProductView = (['93b34d33d4c8c8b5e14c182e936ff9fc'].includes(this.keyMaster ?? ''));     
      /*************************************/

      this.activarPropinas = ( this.propinasdefault && this.posrestaurant && ["FCF", "CCF"].includes(this.form.invoicetype) )

      this.allowEditName = this.$store.getters["rolesUser/getCustomRole"](225) ? true: false;
      this.getAllCostumersOnlyThirdParty();
      this.getAllCostumers();
      this.getAllSellers();
      this.getAllTechnical();
      await this.getDteUsers();

      /*identified user role*/
      this.role = localStorage.getItem("system_role");
      /******************** */

      this.filterProducts.business = this.business;
      this.filterProducts.branch = this.branch;
      //Siempre activo para Ferreteria La Bendicion ("8ef25daf48ea91f34aeaabbe9eb5b0d2")
      // {int}: 0 | 1
      this.filterProducts.showZeroQuantities = ["8ef25daf48ea91f34aeaabbe9eb5b0d2"].includes(this.keyMaster) ? 1 : 0;

      this.filterServices.business = this.business;
      this.filterServices.branch = this.branch;

      this.filterProducts2 = {
        filter: "pricelist",
        business: this.business,
        branch: this.branch,
      };
      await this.getAllPriceList();
      

      if (this.customer) {
        this.preloadCustomer();
        if( this.form?.codactividad ){
          this.changueValueactivity();
        }
      }

      const priceListResponse = await this.$API.products.priceList()
      priceListResponse.map((item, index) => {
        Vue.set(this.priceList, index + 1, item)
      })

      const warehouseResponse = await this.$API.warehouse.getWarehouses({...this.search, notShowReserve: 1 })
      warehouseResponse.map((item, index) => {
        Vue.set(this.warehouse, index + 1, item);
      })

      const providersResponse = await this.$API.providers.getProviders()
      providersResponse.map((item, index) => {
        Vue.set(this.provider, index + 1, item);
      })

      if(!this.header || !this.body){
        await this.getProducts();
        await this.getServices();
        await this.getWarehouse();
      }
      await this.getPaymentTypesValues();

      await this.getZoneConfiguration();
      this.tempId = '';

      if (this.header && !this.header.ID_Invoice.startsWith('AUT') && this.body) {
        /*SEGMENT EDIT INVOICE*/
        //console.log('//////////')
        //console.log('EDIT INVOICE')
        this.noCalculateAddimpturismo = true
        await this.loadInvoiceHeader();
        await this.getProducts();
        await this.getServices();
        await this.loadInvoiceItems();
        await this.getWarehouse();
      } else if (this.quote) {
        //console.log('/////// IS QUOTE')
        await this.loadQuoteBill();
      } else if (this.invoiceAutoSave) {
        //console.log('GET TEMP INVOICE')
        await this.getOrCreateTempInvoice();
      }
      /**** */

      this.reactiveMainProductsFilter();

      //if (VUE_APP_ENV === "1") {
        document.addEventListener("keydown", (e) => {
          if (this.keyboardConfig[e.code]) {
            this.keyboardConfig[e.code]();
          }
        });
      //}

      let userseller = JSON.parse(localStorage.getItem('user')).idseller
      if (userseller != null && userseller != "") {
        if(!this.isCarsem) {
          this.form.ID_Seller = userseller;
        }
      }

      const [families, categories, subcategories] = await Promise.all([
        this.$API.itemtypes.getFamilies(),
        this.$API.itemtypes.getCategories(),
        this.$API.itemtypes.getSubs()
      ])

      this.families = families.map((fam) => ({name: fam.name, value: fam.id}));
      this.categories = categories.map((cat) => ({name: cat.name, value: cat.id, parent_id: cat.id_family}));
      this.subcategories = subcategories.map((sub) => ({name: sub.name, value: sub.id, parent_id: sub.id_cat}));
      this.family = this.families;
      this.category = this.categories;
      this.subcategory = this.subcategories;
      
    } catch (error) {
      console.log(error);
    }
  },
  destroyed() {
    document.removeEventListener("keydown", (e) => {
      console.log(e);
    });
  },
  watch: {
    'alertFactura.show'(value){
      if(!value){
        this.closeAlert()
      }
    },
    //warehouses() {
    //  this.warehouses = this.warehouses.filter((item) => item.ID_Warehouse !== 'WHS0000000000')
    //},
    warehouseSelected(newValue) {
      if (newValue != null && newValue != "") {
        if (this.stopIn == true) {
          this.filterProducts.warehouse = newValue;
          this.getProducts();
        }
        this.search.warehouse = newValue;
      }
    },
    showProductsAndServices(val) {
      if (!val) {
        this.showExtraInfoBatch = false
        this.filterProducts.filter = ""
        this.filterProducts.family = null
        this.filterProducts.category = null
        this.filterProducts.subcategory = null
        this.filterServices.filter = ""
        this.filterServices.family = null
        this.filterServices.category = null
        this.filterServices.subcategory = null
        this.getProductsOnFilter();
        this.getServicesOnFilter();
      }
    },
    headerFirstRowDefaultElements(val) {
      this.headerFirstRowElementWidth = this.headerFirstRowMdsManagement[val];
    },
    headerSecondRowDefaultElements(val) {
      this.headerSecondRowElementWidth =
        this.headerSecondRowColsManagement[val];
    },
    "form.legalidinvoice"(val, oldVal) {
      if (val != "No hay correlativo") {
        this.headerSecondRowDefaultElements++;
      } else if (oldVal === "No hay correlativo") {
        this.headerSecondRowDefaultElements--;
      }
    },
    "form.invoicestatusdescription"(val, oldVal) {
      if (val === "Crédito") {
        this.headerSecondRowDefaultElements++;
        if (Number(this.onlycreditpaymentmethod) === 1) {
          this.activateRestrictedCreditPayment();
        }
      } else if (oldVal === "Crédito") {
        this.headerSecondRowDefaultElements--;
        if (Number(this.onlycreditpaymentmethod) === 1) {
          this.restoreNormalPaymentFlow();
        }
      }
    },
    "form.codasociado"(val) {
      if (this.form.invoicetype === "FEX") {
        this.getReceptorDocument(val);
      }
    },
    customerSelectedData() {
      if (this.form.invoicetype === "FEX" && this.form.codasociado == 2) {
        this.$nextTick(() => {
          this.getReceptorDocument(2);
        });
      }
    },
    "form.invoicepaymenttype"(val, oldVal) {
      if (
        val != "Billetes y monedas" &&
        (oldVal === undefined || oldVal === "Billetes y monedas")
      ) {
        this.headerFirstRowDefaultElements++;
      } else if (
        val === "Billetes y monedas" &&
        oldVal != undefined &&
        oldVal != "Billetes y monedas"
      ) {
        this.headerFirstRowDefaultElements--;
      }
    },
    /* //Se quita la busque incremental, por llamar demasiadas veces el endpoint
    filterProducts: {
      deep: false,
      handler: "getProducts",
    },*/
    "form.invoicetype"() {
      if (this.productsToShow.length > 0 && this.form.invoicetype == "FEX") {
        for (let i = 0; i < this.productsToShow.length; i++) {
          this.productsToShow[i].nonsuj = 0;
          this.productsToShow[i].nonsuj2 = 0;
          this.productsToShow[i].nontaxable = 0;
          this.productsToShow[i].nontaxable2 = 0;
          //this.productsToShow[i].nogravada = 0;
          //this.productsToShow[i].nogravada2 = 0;
        }
      }

      if (this.productsToShow.length > 0 && ['DNC', 'DND', 'DNR', 'CDD', 'FNS'].includes(this.form.invoicetype)) {
        for (let i = 0; i < this.productsToShow.length; i++) {
          this.productsToShow[i].nogravada = 0;
          this.productsToShow[i].nogravada2 = 0;
        }
      }

      this.activarPropinas = ( this.propinasdefault && this.posrestaurant && ["FCF", "CCF"].includes(this.form.invoicetype) )
    },
    "discountObject.ItemPriceDiscountPercent"() {
      if (this.discountObject) {
        if (!this.itemPriceDiscountAmountFocus) {
          this.discountObject.ItemPriceDiscountAmount = parseFloat(
            (
              this.discountObject.ItemOriginalPrice *
              (this.discountObject.ItemPriceDiscountPercent / 100)
            ).toFixed(8)
          );
        }
        this.discountObject.discountFixed =
          this.discountObject.ItemPriceDiscountAmount;

        if (this.discountObject.ItemPriceDiscountAmount > 0) {
          if (
            this.form.invoicetype != "CCF" &&
            this.form.invoicetype != "DNC" &&
            this.form.invoicetype != "DND"
          ) {
            if (this.noaddivainpos) {
              this.discountObject.TmpItemNewPrice = parseFloat(
                parseFloat(
                  (this.discountObject.ItemOriginalPrice -
                    this.discountObject.ItemPriceDiscountAmount)
                ).toFixed(8)
              );
            }
            else {
              if (this.ishosting && this.addimpturismo && this.discountObject.TurismoPorAlojamiento) {
                this.discountObject.TmpItemNewPrice = parseFloat(
                  parseFloat(
                    (this.discountObject.ItemOriginalPrice -
                      this.discountObject.ItemPriceDiscountAmount) /
                      1.18
                  ).toFixed(8)
                );
              }
              else {
                this.discountObject.TmpItemNewPrice = parseFloat(
                  parseFloat(
                    (this.discountObject.ItemOriginalPrice -
                      this.discountObject.ItemPriceDiscountAmount) /
                      1.13
                  ).toFixed(8)
                );
              }
            }
            
            this.discountObject.ItemNewPrice = parseFloat(
              parseFloat(
                this.discountObject.ItemOriginalPrice -
                  this.discountObject.ItemPriceDiscountAmount
              ).toFixed(8)
            );
          } else {
            if (this.noaddivainpos) {
              this.discountObject.TmpItemNewPrice = parseFloat(
                parseFloat(
                  (this.discountObject.ItemOriginalPrice -
                    this.discountObject.ItemPriceDiscountAmount)
                ).toFixed(8)
              );
            }
            else {
              if (this.ishosting && this.addimpturismo && this.discountObject.TurismoPorAlojamiento) {
                this.discountObject.TmpItemNewPrice = parseFloat(
                  parseFloat(
                    (this.discountObject.ItemOriginalPrice -
                      this.discountObject.ItemPriceDiscountAmount) /
                      1.18
                  ).toFixed(8)
                );
              }
              else {
                this.discountObject.TmpItemNewPrice = parseFloat(
                  parseFloat(
                    (this.discountObject.ItemOriginalPrice -
                      this.discountObject.ItemPriceDiscountAmount) /
                      1.13
                  ).toFixed(8)
                );
              }
            }
            
            this.discountObject.ItemNewPrice = parseFloat(
              parseFloat(
                this.discountObject.ItemOriginalPrice -
                  this.discountObject.ItemPriceDiscountAmount
              ).toFixed(8)
            );
          }
        }

        this.calculateCellValue(this.discountObject);
      }
    },
    "discountObject.ItemPriceDiscountAmount"() {
      if (this.discountObject) {
        if (!this.itemPriceDiscountPercentFocus) {
          this.discountObject.ItemPriceDiscountPercent = (
            (this.discountObject.ItemPriceDiscountAmount /
              this.discountObject.ItemOriginalPrice) *
            100
          ).toFixed(8);
        }
        this.discountObject.discountFixed =
          this.discountObject.ItemPriceDiscountAmount;

        if (this.discountObject.ItemPriceDiscountAmount > 0) {
          if (
            this.form.invoicetype != "CCF" &&
            this.form.invoicetype != "DNC" &&
            this.form.invoicetype != "DND"
          ) {
            if (this.noaddivainpos) {
              this.discountObject.TmpItemNewPrice = parseFloat(
                parseFloat(
                  (this.discountObject.ItemOriginalPrice -
                    this.discountObject.ItemPriceDiscountAmount)
                ).toFixed(8)
              );
            }
            else {
              if (this.ishosting && this.addimpturismo && this.discountObject.TurismoPorAlojamiento) {
                this.discountObject.TmpItemNewPrice = parseFloat(
                  parseFloat(
                    (this.discountObject.ItemOriginalPrice -
                      this.discountObject.ItemPriceDiscountAmount) /
                      1.18
                  ).toFixed(8)
                );
              }
              else {
                this.discountObject.TmpItemNewPrice = parseFloat(
                  parseFloat(
                    (this.discountObject.ItemOriginalPrice -
                      this.discountObject.ItemPriceDiscountAmount) /
                      1.13
                  ).toFixed(8)
                );
              }
            }
            
            this.discountObject.ItemNewPrice = parseFloat(
              parseFloat(
                this.discountObject.ItemOriginalPrice -
                  this.discountObject.ItemPriceDiscountAmount
              ).toFixed(8)
            );
          } else {
            if (this.noaddivainpos) {
              this.discountObject.TmpItemNewPrice = parseFloat(
                parseFloat(
                  (this.discountObject.ItemOriginalPrice -
                    this.discountObject.ItemPriceDiscountAmount)
                ).toFixed(8)
              );
            }
            else {
              if (this.ishosting && this.addimpturismo && this.discountObject.TurismoPorAlojamiento) {
                this.discountObject.TmpItemNewPrice = parseFloat(
                  parseFloat(
                    (this.discountObject.ItemOriginalPrice -
                      this.discountObject.ItemPriceDiscountAmount) /
                      1.18
                  ).toFixed(8)
                );
              }
              else {
                this.discountObject.TmpItemNewPrice = parseFloat(
                  parseFloat(
                    (this.discountObject.ItemOriginalPrice -
                      this.discountObject.ItemPriceDiscountAmount) /
                      1.13
                  ).toFixed(8)
                );
              }
            }
            
            this.discountObject.ItemNewPrice = parseFloat(
              parseFloat(
                this.discountObject.ItemOriginalPrice -
                  this.discountObject.ItemPriceDiscountAmount
              ).toFixed(8)
            );
          }
        }

        this.calculateCellValue(this.discountObject);
      }
    },
    changueWarehouse() {
      if (this.changueWarehouse === true) {
        this.getWarehouse();
      }
    },
    changuePriceList() {
      if (this.changuePriceList === true) {
        this.getAllPriceList();
      }
    },
    productsToShow: {
      handler: function (oldValue, newValue) {
        if (newValue.nontaxable2 || oldValue.nontaxable2) {
          this.sumObject;
        }

        if (newValue.nonsuj2 || oldValue.nonsuj2) {
          this.sumObject;
        }

        if (newValue.nogravada2 || oldValue.nogravada2) {
          this.sumObject;
        }
      },
      deep: true,
    },
    "form.codincoterms"() {
      if (this.form.codincoterms) {
        const incotermsselected = this.incoterms.find(item => item.id === this.form.codincoterms)
        if (incotermsselected) {
          const value = incotermsselected.valor
          this.form.descincoterms = value
        }
      }
    },
    addimpturismo(newValue) {
      if (newValue && !this.noCalculateAddimpturismo && this.ishosting) {
        for (let i = 0; i < this.productsToShow.length; i++) {
          if (this.form.invoicetype == 'FCF' && this.productsToShow[i].TurismoPorAlojamiento 
          && !this.productsToShow[i].nonsuj && !this.productsToShow[i].nonsuj2 
          && !this.productsToShow[i].nontaxable && !this.productsToShow[i].nontaxable2) {
            let precioSinImpuestos = parseFloat(parseFloat(this.productsToShow[i].ItemNewPrice) / 1.18)
            let calculoIva = parseFloat(precioSinImpuestos * 0.13)
            let precioFinal = parseFloat(precioSinImpuestos + calculoIva)

            this.productsToShow[i].ItemNewPrice = parseFloat(precioFinal)
            this.productsToShow[i].ItemOriginalPrice = parseFloat(precioFinal)
            this.productsToShow[i].TmpItemNewPrice = parseFloat(precioFinal)
          }

          if ((this.form.invoicetype == 'CCF' || this.form.invoicetype == 'DNC' || this.form.invoicetype == 'DND') && this.productsToShow[i].TurismoPorAlojamiento 
          && !this.productsToShow[i].nonsuj && !this.productsToShow[i].nonsuj2 
          && !this.productsToShow[i].nontaxable && !this.productsToShow[i].nontaxable2) {
            let precioSinImpuestos = parseFloat(parseFloat(this.productsToShow[i].ItemNewPrice) / 1.18)
            this.productsToShow[i].TmpItemNewPrice = parseFloat(precioSinImpuestos)
          }
        }
      }
      else {
        this.noCalculateAddimpturismo = false
      }
    },
    activarPropinas(val) {
      if (val) {
        this.servicioDeProPinas = {
          ID_Item: "SERVPROPINAS",
          ID_Branch: this.branch,
          ID_Business: this.business,
          ItemName: "Propina",
          ItemName2: "Propina",
        }
      }
      else {
        this.servicioDePropinas = {}
      }
    },
  },
  methods: {
    formatExpirationDate(date) {
        if (!date) return "";

        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
    },
    getReceptorDocument(codasociado = this.form.codasociado) {
      if (codasociado == 2) {
        const customer = this.customerSelectedData?.ID_Customer
          ? this.customerSelectedData
          : this.form;
        const nit = customer?.LegalNIT || customer?.legalnit;
        const dui = customer?.dui;
        if (customer && (dui || nit)) {
          let doc = this.getDoc(nit);
          if (!doc) {
            doc = this.getDoc(dui);
          }
          if (!this.header || !this.header.DocAsociado) {
            Vue.set(this.form, "docasociado", doc || "");
          }

          if (!this.header || !this.header.DetalleAsociado) {
            Vue.set(this.form, "detalleasociado", this.getDocName(doc));
          }
        }
      } else {
        if (!this.header || !this.header.DocAsociado) {
          Vue.set(this.form, "docasociado", "");
        }

        if (!this.header || !this.header.DetalleAsociado) {
          Vue.set(this.form, "detalleasociado", "");
        }
      }
    },
    getDoc(v) {
      if (!v) return null;
      return v?.replace('-', '')
    },
    getDocName(v) {
      if (!v) return '';
      const val = v?.trim()?.replace('-', '')?.length ?? 0;
      return val == 14 ? 'NIT' : (val == 9 ? 'DUI' : 'OTROS DOCUMENTOS');
    },
    getCatalogTaxFlags(data, itemType = "product") {
      const toBool = (value) => value === true || value === 1 || value === "1";
      const isExempt = toBool(data.IsExempt) || toBool(data.IsExento) || toBool(data.isexempt) || toBool(data.isexento);
      const isNoSujeto = toBool(data.IsNoSujeto) || toBool(data.isnosujeto);
      const isNoAfecto = toBool(data.IsNoAfecto) || toBool(data.isnoafecto) || toBool(data.ItemNoGravada) || toBool(data.itemnogravada);

      if (isExempt || isNoSujeto || isNoAfecto) {
        return {
          nontaxable: isExempt ? 1 : 0,
          nonsuj: isNoSujeto ? 1 : 0,
          nogravada: isNoAfecto ? 1 : 0,
        };
      }

      if (itemType === "service") {
        return {
          nontaxable: this.form.legalisexempt && this.form.invoicetype != "FEX" ? 1 : 0,
          nonsuj: this.form.invoicetype != "FEX" ? this.form.legalisnontaxable : 0,
          nogravada: 0,
        };
      }

      return {
        nontaxable: this.form.legalisexempt && this.form.invoicetype != "FEX"
          ? 1
          : (this.form.invoicetype != "FEX" ? (toBool(data.IsExempt) || toBool(data.IsExento) || toBool(data.isexempt) ? 1 : 0) : 0),
        nonsuj: (toBool(data.IsExempt) || toBool(data.IsExento) || toBool(data.isexempt) || this.form.invoicetype == "FEX")
          ? 0
          : this.form.legalisnontaxable,
        nogravada: 0,
      };
    },
    hasBlockedTipItem(data) {
      const hasFlag = (value) => value === true || value === 1 || value === "1" || value === "true";
      return (
        hasFlag(data?.BloquearPropinas) ||
        hasFlag(data?.bloquearpropinas) ||
        hasFlag(data?.prod?.BloquearPropinas) ||
        hasFlag(data?.prod?.bloquearpropinas)
      );
    },
    hasProductsClassificationFilters() {
      return !!(
        this.filterProducts.family ||
        this.filterProducts.category ||
        this.filterProducts.subcategory
      );
    },
    hasServicesClassificationFilters() {
      return !!(
        this.filterServices.family ||
        this.filterServices.category ||
        this.filterServices.subcategory
      );
    },
    async applyProductsClassificationFilter() {
      this.loading = true

      const params = {
        ...this.filterProducts,
        showAllRecords: false
      }

      this.$API.products.getProductsToBillForInvoiceFiltered(params).then(response => {
        if (response.length > 0) {
          this.productsToBill = response;
          this.productToBillPrev = response;
          this.loadpriceProductsOnFilter();
        }
        else {
          this.loadDefaultProductsOnFilter()
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => this.loading = false)
    },
    handleFamilyChange() {
      this.filterProducts.category = null;
      this.filterProducts.subcategory = null;
      if (this.hasProductsClassificationFilters()) {
        this.applyProductsClassificationFilter();
        return;
      }

      this.loadDefaultProductsOnFilter();
    },
    handleCategoryChange() {
      this.filterProducts.subcategory = null;
      if (this.hasProductsClassificationFilters()) {
        this.applyProductsClassificationFilter();
        return;
      }

      this.loadDefaultProductsOnFilter();
    },
    async applyServicesClassificationFilter() {
      this.loading = true

      const params = {
        ...this.filterServices,
        showAllRecords: false
      }

      this.$API.services.getAllServicesWithPriceListFiltered(params).then(response => {
        this.servicesToBill = response;
      }).catch(error => {
        console.log(error)
      }).finally(() => this.loading = false)
    },
    handleServiceFamilyChange() {
      this.filterServices.category = null;
      this.filterServices.subcategory = null;
      if (this.hasServicesClassificationFilters()) {
        this.applyServicesClassificationFilter();
        return;
      }

      this.loadDefaultServicesOnFilter();
    },
    handleServiceCategoryChange() {
      this.filterServices.subcategory = null;
      if (this.hasServicesClassificationFilters()) {
        this.applyServicesClassificationFilter();
        return;
      }

      this.loadDefaultServicesOnFilter();
    },
    comprobateFormAirplaneTicket(data) {
      return (
        (data?.LineaAerea && data?.LineaAerea.length > 0) || 
        (data?.Boleto && data?.Boleto.length > 0) || 
        (data?.Pasajero && data?.Pasajero.length > 0) || 
        (data?.Ruta && data?.Ruta.length > 0)
      ) 
    },
    setEnableQuantitiesVal(){
      const status = this.notQuantity ? 1 : this.enablenegativeitem;
      //console.log({status});
      
      this.search.enablenegativeitem = status;
      this.filterProducts.showZeroQuantities = status;
      
      //Default Ferreteria La Bendicion
      if (["8ef25daf48ea91f34aeaabbe9eb5b0d2"].includes(this.keyMaster)) {
        this.filterProducts.showZeroQuantities = 1;
      }
    },
    async getReportAccountStatement(){
      this.loading = true;
      try {
        let search = {
            ID_Customer: this.form.idcustomer,
            typeData: this.AuthFeMode,
            isCancel: false
        }
        this.InvoiceWithCredit = await this.$API.customers.getAcountsReceivableDetailedByCustomer(search);
        if(this.InvoiceWithCredit.length > 0 && this.customerSelectedData){
          this.printAccountStatement = {
              show : false,
              header: {},
              data: []
          }
          this.printAccountStatement.header = {
              title: 'Estado de Cuenta',
              subTitle: '',
              busniessName: JSON.parse(localStorage.getItem('user')).business,
              date:  this.findOldDate(this.InvoiceWithCredit),
              customer: this.customerSelectedData, 
              currentDate: moment().format('DD/MM/YYYY')
          }
          const Tansactions = [];
          const ValuesToMap = this.InvoiceWithCredit;
          //Ordenamiento por fecha de vencimiento (PaymentDate)
          const parseDate = (d) => {
              const [day, month, year] = d.split('/');
              return new Date(`${year}-${month}-${day}`);
          };
          ValuesToMap.sort((a, b) => parseDate(a.PaymentDate) - parseDate(b.PaymentDate));

          ValuesToMap.forEach((item)=>{
              item.Note = 'Cargo por nuevo credito a factura ' +  this.calculateDueDate(item.InvoiceDate, item.InvoiceCreditDay)
              Tansactions.push({ ...item, Cred: item.InvoiceTotalPagar  });
          });
          this.printAccountStatement.data.body = Tansactions.map((item, index)=>{
              item.index = index + 1;
              return item
          });
          this.printAccountStatement.show = true;
          this.printAccountStatement.footer = {
              TotalPaymentShow: Tansactions.reduce( (accum, current) => accum + current.PendingToPay, 0 ),
          }
          this.printAccountStatement.ID = `${this.customerSelectedData.ID_Customer}__${Date.now()}`;
        }else this.showAlert("success", "Estado de cuenta", "No se encontraron cuentas pendientes por pagar de este cliente.")
        
      } catch (error) {
        console.warn({generar_estado_cuenta: error});
        
      } finally{
        this.loading = false;
      }
      
    },
    findOldDate(data = []) {
      const oldest = data
        .map(i => i.InvoiceDate)
        .filter(Boolean)
        .map(d => {
          const [day, month, year] = d.split('/');
          return new Date(year, month - 1, day);
        })
        .filter(d => !isNaN(d))
        .sort((a, b) => a - b)[0];

      return oldest
        ? oldest.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
        : null;
    },
    calculateDueDate(originDate, intervalDay) {
      const [d, m, y] = originDate.split('/').map(Number);
      const days = Number(intervalDay.replace(/\D/g, '')) || 0;

      const date = new Date(y, m - 1, d);
      date.setDate(date.getDate() + days);

      return [
        date.getDate().toString().padStart(2, '0'),
        (date.getMonth() + 1).toString().padStart(2, '0'),
        date.getFullYear()
      ].join('/');
    },
    isValidEmails(value) {
      if (!value) return true;
      
      const reg = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      return reg.test(value) || 'Correo electrónico inválido';
    },
    validateEmails() {
      this.BccEmails = this.BccEmails.filter((email) =>
        this.isValidEmails(email)
      );
    },
    saveBill() {
      this.orderAndPrint = false; 
      if (this.pospayments &&
      this.form.invoicetype != 'DND' &&
      this.form.invoicetype != 'DNC') {
        this.showReturnedAndPaymentModal = true
        this.isReadyToBill = true
        this.form.istemplate = 0
      } else {
        this.alertContinueWithDifferentDateThanToday(0)
      }
    },
    createComanda() {
      this.orderAndPrint = true; 
      this.requestBillSubmission(1)
    },
    createBill() {
      this.orderAndPrint = false; 
      if (this.pospayments &&
      this.form.invoicetype != 'DND' &&
      this.form.invoicetype != 'DNC') {
        this.showReturnedAndPaymentModal = true
        this.isReadyToBill = false
        this.form.istemplate = 0
      } else {
        this.requestBillSubmission(1)
      }
    },
    getInitials(text) {
      if(!text) return '';
      return text
        .split(" ")
        .filter(w => w.length > 0)
        .map(w => w[0])
        .join("")
        .toUpperCase()
    },
    async getInvoiceProductItems() {
      let products = []

      try {
        const invoiceProducts = await this.$API.invoices.getInvoiceProductItemsWithStock(this.tempId || this.form.idinvoice )
        if (invoiceProducts.length) {
         products = [...invoiceProducts];
        } 
      } catch (err) {
        console.log("Error", err);
      }

      return products;
    },
    async getInvoiceServiceItems() {
      let services = []

      try {
        const invoiceServices = await this.$API.invoices.getInvoiceServiceItems(this.tempId || this.form.idinvoice )
        if (invoiceServices.length) {
         services = [...invoiceServices];
        } 
      } catch (err) {
        console.log("Error", err);
      }

      return services;
    },
    async loadBody() {
      this.productsToShow = [];

      const [products, services] = await Promise.all([
        this.getInvoiceProductItems(),
        this.getInvoiceServiceItems(),
      ]);

      this.$store.commit("posData/setBody", [...products, ...services]);
    },
    async getOrCreateTempInvoice () {
      if (!this.invoiceAutoSave) {
        return;
      }
      this.statusAutoSave = "Verificando...";
      try {
        let header = {}; 
        let form = { ...this.form };
        for (var i in form) {
          let key = i.replace("legal", "invoice");
          header[key] = this.form[i];
        }

        const { data: tempInvoice } = await this.$API.invoices.getOrCreateTempInvoice({
          header,
          ID_Invoice: this.header ? this.header.ID_Invoice : null
        });

        //console.log(tempInvoice)

        if (tempInvoice) {
          this.tempId = tempInvoice.ID_Invoice;
          //this.form.oldIdInvoice = tempInvoice.ID_Invoice; 
          this.$store.commit('posData/setHeader', tempInvoice);
          
          await this.loadInvoiceHeader();
          await this.loadBody();
          
          if (this.header && this.body) {
            await this.getProducts();
            await this.getServices();
          }
          
          await this.loadInvoiceItems();
        }
      } catch (err) {
        console.log(err)
      }
      this.statusAutoSave = "Guardada";
    },
    async updateTempInvoiceField () {
      //console.log(this.tempId)
      if (!this.invoiceAutoSave || !this.tempId.startsWith('AUT')) {
        //console.log('NOT TEMP INVOICE')
        return;
      }

      // Clear existing timer if any
      if (this.throttleTimeout) clearTimeout(this.throttleTimeout);

      // Throttle the API call: delay sending updateData
      this.throttleTimeout = setTimeout(async () => {
        this.statusAutoSave = "Guardando...";
        try {
          let header = {}; 
          let form = { ...this.form };
          for (var i in form) {
            let key = i.replace("legal", "invoice");
            header[key] = this.form[i];
          }

          await this.$API.invoices.saveHeaderInvoice({ header })

          this.statusAutoSave = "Guardada";
        } catch (err) {
          console.log(err)
        }
      }, this.throttleDelay);
    },
    onCellValueChanged(e) {
      // e.data - the whole row object
      // e.dataField - the column field that changed
      // e.value - the new value
      // e.oldValue - the previous value

      this.updateTempDetails(e.uuid);
    },
    onCellValueChangedComments(e) {
      const item = this.productsToShow.find(obj => obj.uuid == e.uuid)
      if (item) {
        item.ItemComments = e.ItemComments
      }
    },
    async saveDetailsItem(data) {
      try {
        data.ID_Business = this.business;
        data.ID_Branch = this.branch;

        const requestData = {
          item: data, 
          ID_Invoice: this.tempId,
          InvoiceType: this.form.invoicetype,
          options: {
            noaddivainpos: this.noaddivainpos,
            addimpturismo: this.addimpturismo,
            restivaposexentonosuj: this.restivaposexentonosuj,
          }
        };

        let responseSaveDetails = await this.$API.invoices.saveDetailsInvoice(requestData);

        if (responseSaveDetails.success) {
          const index = this.productsToShow.findIndex(i => i.uuid === data.uuid)
          if (responseSaveDetails.data.proccess === "created") {
            if (index !== -1) {
              this.productsToShow[index].Pk_billing_invoices_details = responseSaveDetails.data.dataValues.Pk_billing_invoices_details
            }
          }
          
          if (index !== -1 && responseSaveDetails.data.ItemCurrentQuantity) {
            this.productsToShow[index].ItemCurrentQuantity = responseSaveDetails.data.ItemCurrentQuantity
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    async updateTempDetails (itemUUID, throttleCall = true) {
      if (!this.invoiceAutoSave || !this.tempId.startsWith('AUT')) {
        //console.log('NOT TEMP INVOICE')
        return;
      }
      
      if (!throttleCall) {
        //console.log('/////// NO THROTLE CALL')
        this.statusAutoSave = "Guardando...";

        const item = this.productsToShow.find(i => i.uuid === itemUUID);

        if (item) {
          await this.saveDetailsItem(item)
        }

        this.statusAutoSave = "Guardada";
        return;
      }

      const foundTempItem = this.tempDetails.find(i => i.uuid === itemUUID);

      if (foundTempItem) {
        return;
      }

      this.tempDetails.push(itemUUID);

      // Clear existing timer if any
      if (this.detailsThrottleTimeout) clearTimeout(this.detailsThrottleTimeout);

      // Throttle the API call: delay sending updateData
      this.detailsThrottleTimeout = setTimeout(async () => {
        //console.log('/////// THROTLE CALL')
        this.statusAutoSave = "Guardando...";
        try {
          const itemsData = this.productsToShow.filter(i => {
            const found = this.tempDetails.find(td => td === i.uuid);  
            return !!found;
          });

          if (itemsData.length > 0) {
            for (const item of itemsData) {
              this.saveDetailsItem(item)
            }
          }

          this.tempDetails = [];

          this.statusAutoSave = "Guardada";
        } catch (err) {
          console.log(err)
        }
      }, this.throttleDelay);
    },
    async getPaymentTypesValues() {
      let formaPagoCatalogo = await this.getCatalogMH("FormaPago");
      if (this.keyMaster === "47770e9a83f6f46af2a3d2b93fff710a") {
        formaPagoCatalogo = formaPagoCatalogo.map(x => x.Codigo === '02'
          ? { ...x, Valores: "POS DAVIVIENDA" } 
          : (x.Codigo === '03' ? { ...x, Valores: "POS CREDOMATIC" } : x )
        );
      }else if(this.keyMaster === '2c451b9885da7d373da24547ba01c29a'){
        // Mostrar solo Forma de pagos: o1 Billetes y monedad, 02 Tarjetas, 05 QR. (Coffe Bike)
        formaPagoCatalogo = formaPagoCatalogo
                            .filter(x => x.Codigo === '01' || x.Codigo === '02' || x.Codigo === '05' || x.Codigo === '03')
                            .map(x => x.Codigo === '03'? { ...x, Valores: "QR" }: x); 
      }
      
      this.paymentTypes = formaPagoCatalogo

      this.paymentsData = []
      if (this.isCreditPaymentRestricted) {
        this.activateRestrictedCreditPayment();
      } else if (!this.header || !this.header?.payments || this.header?.payments.length == 0 || this.forceBlocking) {
        for (let i = 0; i < 5; i++) {
          let item = this.paymentTypes[i]
          if(!item) continue;
          this.paymentsData.push(
            {
              typePayment: item.Codigo,
              typePaymentAlt: item.Codigo_Alt,
              descriptionPayment: item.Valores,
              totalPayment: 0.0,
              reference: null,
            }
          )
        }
      }
    },
    getCreditPaymentType() {
      return this.paymentTypes.find((paymentType) => String(paymentType.Codigo) === "13") || null;
    },
    activateRestrictedCreditPayment() {
      const creditPaymentType = this.getCreditPaymentType();
      if (!creditPaymentType) return false;

      if (this.normalInvoicePaymentTypeBeforeCredit === null) {
        this.normalInvoicePaymentTypeBeforeCredit = this.form.invoicepaymenttype;
        this.normalPaymentsBeforeCredit = this.paymentsData.map((payment) => ({ ...payment }));
      }

      this.advancePaymentsSelected.forEach((advancePayment) => {
        advancePayment.IsSelected = false;
      });
      this.advancePaymentsSelected = [];
      this.showDialogAdvancePayments = false;
      this.paymentsData = [{
        typePayment: creditPaymentType.Codigo,
        typePaymentAlt: creditPaymentType.Codigo_Alt,
        descriptionPayment: creditPaymentType.Valores,
        totalPayment: this.normalizePaymentAmount(this.sumObject?.total),
        reference: null,
      }];
      this.form.invoicepaymenttype = creditPaymentType.Valores;
      this.handleRowChangedPayments();
      return true;
    },
    async restoreNormalPaymentFlow() {
      const normalPayments = this.normalPaymentsBeforeCredit;
      const normalInvoicePaymentType = this.normalInvoicePaymentTypeBeforeCredit;
      this.normalInvoicePaymentTypeBeforeCredit = null;
      this.normalPaymentsBeforeCredit = null;
      this.paymentTypeSelect = false;
      this.selectedPayment = "";
      this.form.invoicepaymenttype = "";

      if (normalPayments && normalPayments.length > 0) {
        this.paymentsData = normalPayments;
      } else {
        this.paymentsData = [];
      }

      await this.getPaymentTypesValues();
      if (normalPayments && normalPayments.length > 0) {
        this.paymentsData = normalPayments;
      } else if (this.paymentsData.length === 0) {
        this.paymentTypes.slice(0, 5).forEach((paymentType) => {
          this.paymentsData.push({
            typePayment: paymentType.Codigo,
            typePaymentAlt: paymentType.Codigo_Alt,
            descriptionPayment: paymentType.Valores,
            totalPayment: 0.0,
            reference: null,
          });
        });
      }
      this.form.invoicepaymenttype = normalInvoicePaymentType || this.paymentTypes[0]?.Valores || "";
      this.handleRowChangedPayments();
    },
    syncRestrictedCreditPayment(total) {
      if (!this.isCreditPaymentRestricted) return;
      const creditPaymentType = this.getCreditPaymentType();
      if (!creditPaymentType) return;
      this.paymentsData = [{
        ...(this.paymentsData[0] || {}),
        typePayment: creditPaymentType.Codigo,
        typePaymentAlt: creditPaymentType.Codigo_Alt,
        descriptionPayment: creditPaymentType.Valores,
        totalPayment: this.normalizePaymentAmount(total),
        reference: null,
      }];
    },
    sendCancel() {
      this.showReturnedAndPaymentModal = false; 
      this.paymentTypeSelect =false; 
      this.selectedPayment = ''
    },
    releaseInvoiceSubmissionLock() {
      this.invoiceSubmissionInProgress = false;
    },
    normalizePaymentAmount(value) {
      const numericValue = Number(value);

      if (!Number.isFinite(numericValue) || numericValue <= 0) {
        return 0;
      }

      return parseFloat(financing.roundMoneyIEEE754(numericValue, 2));
    },
    isValidPaymentAmount(value) {
      const numericValue = Number(value);

      return Number.isFinite(numericValue) && numericValue > 0;
    },
    getValidPaymentsForSubmission() {
      return this.paymentsData
        .map((payment) => ({
          ...payment,
          totalPayment: this.normalizePaymentAmount(payment.totalPayment),
        }))
        .filter((payment) => this.isValidPaymentAmount(payment.totalPayment));
    },
    canSubmitBillFromPaymentsModal() {
      return (
        this.showReturnedAndPaymentModal === true &&
        this.isReadyToBill === false &&
        this.form.istemplate == 0 &&
        this.form.isquote == 0 &&
        this.pospayments &&
        this.enableEnterBillFromPayments &&
        this.$store.getters['rolesUser/getCustomRole'](5) &&
        !this.invoiceSubmissionInProgress &&
        !this.loading
      );
    },
    isValidInvoicePaymentState() {
      if (this.isCreditPaymentRestricted) {
        this.handleRowChangedPayments();
        const restrictedPayments = this.getValidPaymentsForSubmission();
        const totalAmount = this.normalizePaymentAmount(this.sumObject?.total);
        const creditPayment = restrictedPayments.length === 1 ? restrictedPayments[0] : null;

        if (
          !creditPayment ||
          String(creditPayment.typePayment) !== "13" ||
          Number(creditPayment.totalPayment) !== totalAmount
        ) {
          this.showAlert(
            "warning",
            "Advertencia",
            'Las ventas a crédito de este negocio únicamente permiten la forma de pago "Cuentas por pagar del receptor".'
          );
          return false;
        }
        return true;
      }

      if (!this.pospayments) {
        return true;
      }

      if (this.form.invoicetype == "DNC" || this.form.invoicetype == "DND") {
        return true;
      }

      this.handleRowChangedPayments();

      const validPayments = this.getValidPaymentsForSubmission();
      const totalAmount = Number(this.sumObject?.total);
      const sumAmount = Number(this.sumPayments);

      if (
        !Number.isFinite(totalAmount) ||
        totalAmount <= 0 ||
        !Number.isFinite(sumAmount) ||
        sumAmount <= 0 ||
        validPayments.length === 0
      ) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Debe ingresar un monto de pago válido mayor que cero antes de facturar."
        );
        return false;
      }

      return true;
    },
    handlePaymentEnter(event, payment) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (payment) {
        this.showPaymentWithDecimal(payment);
      }

      this.handleRowChangedPayments();

      if (!this.canSubmitBillFromPaymentsModal()) {
        return;
      }

      this.requestBillSubmission(1);
    },
    requestBillSubmission(status = 0) {
      if (status === 1) {
        if (this.invoiceSubmissionInProgress || this.loading) {
          return;
        }

        if (!this.isValidInvoicePaymentState()) {
          return;
        }

        this.invoiceSubmissionInProgress = true;
        this.showReturnedAndPaymentModal = false;
      }

      this.alertContinueWithDifferentDateThanToday(status);
    },
    resetSeleted() {
      this.paymentTypeSelect =false; 
      this.selectedPayment = ''
    },
    selectPayment(data) {
      // console.log('this.paymentsData', this.paymentsData);
      this.paymentsData.forEach((payment) => {
        payment.totalPayment = 0;
      });
      data.data.totalPayment = this.sumObject.total;
      this.showPaymentWithDecimal(data.data);
      this.handleRowChangedPayments();
      this.paymentTypeSelect = true;
    },
    readOnlyCreditDays() {
      if (this.keyMaster === "d6d47d6edfc3812b5c68c16a07d51d8b" || this.keyMaster === "f33722a12f5e692b30374bbcf86011db") {
        return !(this.form.creditperiod == 0 && this.form.creditstatus == 'DISPONIBLE')
      }
      else {
        return !(this.form.creditstatus == 'DISPONIBLE')
      }
    },
    onTextFieldFocus(event) {
      event.target.select()
    },
    addAdvancePayments() {
      if (this.isCreditPaymentRestricted) {
        return;
      }
      for (const item of this.advancePaymentsSelected) {
        if (item.IsSelected) {

          const alreadyAdded = this.paymentsData.some(
            (selectedItem) => selectedItem.ID_AdvancePayment === item.ID_AdvancePayment
          );

          if (!alreadyAdded) {
            const dataToPush = {
              typePayment: '99',
              typePaymentAlt: this.codCompuestoAnt,
              descriptionPayment: 'Otros (anticipos)',
              totalPayment: this.normalizePaymentAmount(item.Payment),
              reference: item.Reference,
              ID_AdvancePayment: item.ID_AdvancePayment,
              ID_Customer: item.ID_Customer
            }

            this.paymentsData.push(dataToPush)
          }

          const alreadyAdded2 = this.paymentTypes.some(
            (row) => row.Codigo_Alt === this.codCompuestoAnt
          )

          if (!alreadyAdded2) {
            const dataToPush = {
              Codigo: '99',
              Codigo_Alt: this.codCompuestoAnt,
              Valores: 'Otros (anticipos)',
              ID_Business: this.businessid
            }

            this.paymentTypes.push(dataToPush)
          }
        }
        else {
          const index = this.paymentsData.findIndex(
            (selectedItem) => selectedItem?.ID_AdvancePayment === item.ID_AdvancePayment
          );

          if (index > -1) {
            this.paymentsData.splice(index, 1);
          }
        }
      }

      if (this.pospayments) {
        this.handleRowChangedPayments()
      }

      this.showDialogAdvancePayments = !this.showDialogAdvancePayments
      this.showAlert("success", "Exito", "Los anticipos seleccionados han sido agregados a la factura.")
    },
    checkAdvancePaymentChanged(item) {
      const index = this.advancePaymentsSelected.findIndex(
        (selectedItem) => selectedItem.ID_AdvancePayment === item.ID_AdvancePayment
      );

      if (index > -1) {
        this.advancePaymentsSelected[index].IsSelected = !this.advancePaymentsSelected[index].IsSelected;
      } else {
        item.IsSelected = true;
        this.advancePaymentsSelected.push(item);
      }
    },
    searchSeveralCustomer() {
      const foundCustomer = this.customersList.find(
        (current) => current.IsSeveralCustomer === 1
      );
      if (foundCustomer) {
        this.customerSelected(
          this.customersList.find((current) => current.IsSeveralCustomer === 1)
        );

        this.form.invoicestatusdescription = "Cancelada"

      }
      else {
        this.showAlert("warning", "Información", "No hay clientes varios por defecto")
      }
    },
    async loadPriceListData(ID_Item) {
      this.loading = true;
      try {
        this.prices = await this.$API.priceList.getInfoPriceByProduct({
          ID_Item,
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    selectedPrice(item) {
      this.discountObject.PriceListName = item.PriceListName
      this.discountObject.ItemOriginalPrice = item.ItemOriginalPrice.toFixed(8)
      this.discountObject.ItemNewPrice = item.ItemNewPrice.toFixed(8)
      this.discountObject.ItemPriceDiscountAmount = item.ItemPriceDiscountAmount.toFixed(8)
    },
    verifyCarsem() {
      const keyMastersArray = JSON.parse(getCookie("ID_KeyMaster"));
      const specialKeyMasters =
        keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER1) ||
        keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER2) ||
        keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER3);
      if (specialKeyMasters) {
        this.isCarsem = true;
        this.key++;
      } else {
        this.isCarsem = false;
      }
    },
    handleSpace(product) {
      this.triggerAddItemEvent(product, 1);
      this.$nextTick(() => {
        this.$refs.plusIcon.focus(); // Reenfocar después de la acción
      });
    },
    handleSpaceService(product) {
      this.triggerAddItemEvent(product, 2);
      this.$nextTick(() => {
        this.$refs.plusIconService.focus(); // Reenfocar después de la acción
      });
    },

    handleKeyDown(event) {
      if (event.key === "ArrowDown") {
        this.selectFirstRowInGrid();
        event.preventDefault(); // Evita más acciones del evento
      }
    },
    selectFirstRowInGrid() {
      this.$nextTick(() => {
        if (this.$refs.dxDataGridInstance) {
          // Asumiendo que 'instance' es el objeto de grid expuesto por DevExtreme
          const gridInstance = this.$refs.dxDataGridInstance.instance;

          // Activar la primera fila o celda
          if (gridInstance) {
            gridInstance.focus(gridInstance.getCellElement(0, 0)); // Enfoca la primera celda
          }
        }
      });
    },
    handleEnterKey() {
      if (this.showProductsAndServices) {
        this.$nextTick(() => {
          this.$refs.generalFilter.focusInput(); // Llama al método de GeneralFilter
        });
      }
    },

    handleTypePaymentChange(data) {
      if (this.isCreditPaymentRestricted) {
        this.activateRestrictedCreditPayment();
        return;
      }
      const selectedTypePayment = data.data.typePaymentAlt;
      const obj = this.paymentTypes.find(
        (row) => row.Codigo_Alt == selectedTypePayment
      );

      data.data.descriptionPayment = obj.Valores;
      data.data.typePayment = obj.Codigo

    },
    async onInputDiscountObjs(label) {
      this.discountObject[label] &&
        (this.discountObject[label] = await onlyDigitsAndAPoint(
          this,
          this.discountObject[label]
        ));
    },
    isDiscountLimitExceeded(currentValue, limitValue) {
      const maxDiscount = parseFloat(limitValue);

      if (!Number.isFinite(maxDiscount) || maxDiscount <= 0) {
        return false;
      }

      const numericCurrentValue = parseFloat(String(currentValue ?? ""));

      return (
        Number.isFinite(numericCurrentValue) &&
        numericCurrentValue > maxDiscount
      );
    },
    onItemPriceDiscountPercentFocusBlur() {
      const currentValue = String(
        this.discountObject?.ItemPriceDiscountPercent ?? ""
      );

      if (!this.itemPriceDiscountPercentFocus) {
        this.itemPriceDiscountPercentBeforeEdit =
          this.discountObject.ItemPriceDiscountPercent;

        if (currentValue.length === 0) {
          this.discountObject.ItemPriceDiscountPercent = "0.00";
        } else if (currentValue === "0.00") {
          this.discountObject.ItemPriceDiscountPercent = "";
        }

        this.itemPriceDiscountPercentFocus = true;
        return;
      }

      if (
        this.isDiscountLimitExceeded(
          currentValue,
          this.discountObject?.MaxDiscountPercentage
        )
      ) {
        this.discountObject.ItemPriceDiscountPercent =
          this.itemPriceDiscountPercentBeforeEdit ?? "";
        this.showAlert(
          "warning",
          "Información",
          `No puede aplicar un descuento mayor al límite permitido de ${this.discountObject?.MaxDiscountPercentage}%.`
        );
        this.itemPriceDiscountPercentFocus = false;
        return;
      }

      if (currentValue.length === 0) {
        this.discountObject.ItemPriceDiscountPercent = "0.00";
      } else if (currentValue === "0.00") {
        this.discountObject.ItemPriceDiscountPercent = "";
      }

      this.itemPriceDiscountPercentFocus = false;
    },
    onItemPriceDiscountAmountFocusBlur() {
      const currentValue = String(
        this.discountObject?.ItemPriceDiscountAmount ?? ""
      );

      if (!this.itemPriceDiscountAmountFocus) {
        this.itemPriceDiscountAmountBeforeEdit =
          this.discountObject.ItemPriceDiscountAmount;

        if (currentValue.length === 0) {
          this.discountObject.ItemPriceDiscountAmount = "0.00";
        } else if (currentValue === "0.00") {
          this.discountObject.ItemPriceDiscountAmount = "";
        }

        this.itemPriceDiscountAmountFocus = true;
        return;
      }

      if (
        this.isDiscountLimitExceeded(
          currentValue,
          this.discountObject?.MaxDiscountDecimal
        )
      ) {
        this.discountObject.ItemPriceDiscountAmount =
          this.itemPriceDiscountAmountBeforeEdit ?? "";
        this.showAlert(
          "warning",
          "Información",
          `No puede aplicar un descuento mayor al límite permitido de ${this.discountObject?.MaxDiscountDecimal}.`
        );
        this.itemPriceDiscountAmountFocus = false;
        return;
      }

      if (currentValue.length === 0) {
        this.discountObject.ItemPriceDiscountAmount = "0.00";
      } else if (currentValue === "0.00") {
        this.discountObject.ItemPriceDiscountAmount = "";
      }

      this.itemPriceDiscountAmountFocus = false;
    },
    //Nueva funcionalidad Descuentos
    buildInvoiceSummary(applyGlobalDiscount = true) {
      let sum = this.productsToShow.reduce(
        (prev_value, next_value) => {
          let price = parseFloat(this.calculateCellValue(next_value));
          let sumInSubTotal = 0.0;
          let sumPropina = 0.0;

          if (
            next_value.nontaxable != true &&
            next_value.nontaxable2 != true &&
            next_value.nonsuj != true &&
            next_value.nonsuj2 != true &&
            next_value.nogravada != true &&
            next_value.nogravada2 != true
          ) {
            sumInSubTotal = price;

            if (
              this.activarPropinas &&
              !this.hasBlockedTipItem(next_value) &&
              (this.form.invoicetype == "FCF" ||
                this.form.invoicetype == "CCF" ||
                this.form.invoicetype == "DNC" ||
                this.form.invoicetype == "DND")
            ) {
              sumPropina = parseFloat(
                (price / 1.13) * (this.porcentajePropinas / 100)
              );
            } else {
              sumPropina = 0.0;
            }
          }

          return {
            subTotal: +prev_value.subTotal + sumInSubTotal,
            nontaxable:
              prev_value.nontaxable +
              (next_value.nontaxable
                ? price
                : next_value.nontaxable2
                ? price
                : 0),
            nonsuj:
              prev_value.nonsuj +
              (next_value.nonsuj ? price : next_value.nonsuj2 ? price : 0),
            nogravada:
              prev_value.nogravada +
              (next_value.nogravada ? price : next_value.nogravada2 ? price : 0),
            propina: +prev_value.propina + sumPropina,
          };
        },
        { subTotal: 0, nontaxable: 0, nonsuj: 0, nogravada: 0, propina: 0 }
      );

      if (this.form.invoicetype == "FCF") {
        sum.subTotal = parseFloat(sum.subTotal).toFixed(2);
        if (this.restivaposexentonosuj) {
          sum.nontaxable = parseFloat(sum.nontaxable / 1.13).toFixed(2);
          sum.nonsuj = parseFloat(sum.nonsuj / 1.13).toFixed(2);
          sum.nogravada = parseFloat(sum.nogravada / 1.13).toFixed(2);
        } else {
          sum.nontaxable = parseFloat(sum.nontaxable).toFixed(2);
          sum.nonsuj = parseFloat(sum.nonsuj).toFixed(2);
          sum.nogravada = parseFloat(sum.nogravada).toFixed(2);
        }

        sum.iva = 0.0;
        sum.fovial = 0.0;
        sum.cotrans = 0.0;
        sum.reterenta = 0.0;
        sum.turismoPorAlojamiento = 0.0;

        let sumtmp =
          parseFloat(sum.subTotal) +
          parseFloat(sum.nontaxable) +
          parseFloat(sum.nonsuj);

        if (!this.BusinessLegalAgentRetain && this.form.legalagentretain) {
          if (sumtmp >= 113) {
            let subTotalLessIva = parseFloat(sum.subTotal / 1.13).toFixed(2);
            sum.ivaret = parseFloat(parseFloat(subTotalLessIva) * 0.01).toFixed(
              2
            );
          } else if (this.form.removerestrictionpublicentity) {
            let subTotalLessIva = parseFloat(sum.subTotal / 1.13).toFixed(2);
            sum.ivaret = parseFloat(parseFloat(subTotalLessIva) * 0.01).toFixed(
              2
            );
          } else {
            sum.ivaret = 0.0;
          }
        } else {
          sum.ivaret = 0.0;
        }

        let fovial = 0;
        let cotrans = 0;
        let turismoPorAlojamiento = 0;
        for (let m = 0; m < this.productsToShow.length; m++) {
          if (
            this.productsToShow[m].type != "service" &&
            this.productsToShow[m].IsHidrocarburo
          ) {
            fovial += parseFloat(parseFloat(this.productsToShow[m].qty) * 0.2);
            cotrans += parseFloat(parseFloat(this.productsToShow[m].qty) * 0.1);
          }

          if (
            this.ishosting &&
            this.productsToShow[m].TurismoPorAlojamiento &&
            !this.productsToShow[m].nontaxable &&
            !this.productsToShow[m].nontaxable2 &&
            !this.productsToShow[m].nonsuj &&
            !this.productsToShow[m].nonsuj2
          ) {
            turismoPorAlojamiento += parseFloat(
              parseFloat(this.productsToShow[m].ItemNewNewPrice / 1.13) * 0.05
            );
          }
        }

        sum.fovial = parseFloat(fovial).toFixed(2);
        sum.cotrans = parseFloat(cotrans).toFixed(2);
        sum.turismoPorAlojamiento = parseFloat(turismoPorAlojamiento).toFixed(2);

        if (this.form.legalreterenta) {
          let reterenta = 0;
          for (let m = 0; m < this.productsToShow.length; m++) {
            if (this.productsToShow[m].type == "service") {
              reterenta += parseFloat(
                parseFloat(this.productsToShow[m].ItemNewNewPrice / 1.13) * 0.1
              );
            }
          }

          sum.reterenta = parseFloat(reterenta).toFixed(2);
        }

        sum.propina = parseFloat(sum.propina).toFixed(2);
        sum.total = parseFloat(
          parseFloat(sum.subTotal) +
            parseFloat(sum.nontaxable) +
            parseFloat(sum.nonsuj) +
            parseFloat(sum.fovial) +
            parseFloat(sum.cotrans) -
            parseFloat(sum.ivaret) -
            parseFloat(sum.reterenta) +
            parseFloat(sum.turismoPorAlojamiento) +
            parseFloat(sum.propina) +
            parseFloat(sum.nogravada)
        ).toFixed(2);
      } else if (
        this.form.invoicetype == "CCF" ||
        this.form.invoicetype == "DND" ||
        this.form.invoicetype == "DNC"
      ) {
        if (this.noaddivainpos) {
          sum.iva = parseFloat(sum.subTotal * 0.13).toFixed(2);
          sum.subTotal = parseFloat(parseFloat(sum.subTotal)).toFixed(2);
        } else if (this.addimpturismo && this.ishosting) {
          let calculoDeSubTotal = this.productsToShow.reduce(
            (prev_value, next_value) => {
              let price = parseFloat(this.calculateCellValue(next_value));
              let sumInSubTotal = 0.0;
              let sumInIva = 0.0;

              if (
                next_value.nontaxable != true &&
                next_value.nontaxable2 != true &&
                next_value.nonsuj != true &&
                next_value.nonsuj2 != true &&
                next_value.nogravada != true &&
                next_value.nogravada2 != true
              ) {
                if (next_value.TurismoPorAlojamiento) {
                  sumInSubTotal = parseFloat(price / 1.18);
                } else {
                  sumInSubTotal = parseFloat(price / 1.13);
                }

                sumInIva = parseFloat(sumInSubTotal * 0.13);
              }

              return {
                subTotal: +prev_value.subTotal + sumInSubTotal,
                iva: +prev_value.iva + sumInIva,
              };
            },
            { subTotal: 0, iva: 0 }
          );

          let subtotalSinImpuestos = parseFloat(
            calculoDeSubTotal.subTotal
          ).toFixed(2);
          sum.iva = parseFloat(calculoDeSubTotal.iva).toFixed(2);
          sum.subTotal = parseFloat(parseFloat(subtotalSinImpuestos)).toFixed(2);
        } else {
          sum.iva = parseFloat(sum.subTotal - sum.subTotal / 1.13).toFixed(2);
          sum.subTotal = parseFloat(
            parseFloat(sum.subTotal) - parseFloat(sum.iva)
          ).toFixed(2);
        }

        if (this.restivaposexentonosuj) {
          sum.nontaxable = parseFloat(sum.nontaxable / 1.13).toFixed(2);
          sum.nonsuj = parseFloat(sum.nonsuj / 1.13).toFixed(2);
          sum.nogravada = parseFloat(sum.nogravada / 1.13).toFixed(2);
        } else {
          sum.nontaxable = parseFloat(sum.nontaxable).toFixed(2);
          sum.nonsuj = parseFloat(sum.nonsuj).toFixed(2);
          sum.nogravada = parseFloat(sum.nogravada).toFixed(2);
        }

        sum.fovial = 0.0;
        sum.cotrans = 0.0;
        sum.reterenta = 0.0;
        sum.turismoPorAlojamiento = 0.0;

        let sumtmp = parseFloat(sum.subTotal);
        if (this.BusinessLegalAgentRetain && !this.form.legalagentretain) {
          if (sumtmp >= 100) {
            sum.ivaperce = parseFloat(sum.subTotal * 0.01).toFixed(2);
          } else {
            sum.ivaperce = 0;
          }

          sum.ivaret = 0;
        } else {
          sum.ivaperce = 0;
        }

        if (!this.BusinessLegalAgentRetain && this.form.legalagentretain) {
          if (sumtmp >= 100 && this.form.invoicetype == "CCF") {
            sum.ivaret = parseFloat(sum.subTotal * 0.01).toFixed(2);
          } else if (
            (this.form.invoicetype == "DNC" || this.form.invoicetype == "DND") &&
            (this.ndornc?.ApplyRete1 || sumtmp >= 100)
          ) {
            sum.ivaret = parseFloat(sum.subTotal * 0.01).toFixed(2);
          } else {
            sum.ivaret = 0;
          }

          sum.ivaperce = 0;
        } else {
          sum.ivaret = 0;
        }

        let fovial = 0;
        let cotrans = 0;
        let turismoPorAlojamiento = 0;
        for (let m = 0; m < this.productsToShow.length; m++) {
          if (
            this.productsToShow[m].type != "service" &&
            this.productsToShow[m].IsHidrocarburo
          ) {
            fovial += parseFloat(parseFloat(this.productsToShow[m].qty) * 0.2);
            cotrans += parseFloat(parseFloat(this.productsToShow[m].qty) * 0.1);

            if (parseFloat(sum.ivaperce) > 0) {
              sum.ivaperce = parseFloat(
                parseFloat(sum.ivaperce) -
                  parseFloat(this.productsToShow[m].ItemNewNewPrice / 1.13) * 0.01
              ).toFixed(2);
            }
          }

          if (
            this.ishosting &&
            this.productsToShow[m].TurismoPorAlojamiento &&
            !this.productsToShow[m].nontaxable &&
            !this.productsToShow[m].nontaxable2 &&
            !this.productsToShow[m].nonsuj &&
            !this.productsToShow[m].nonsuj2
          ) {
            if (this.noaddivainpos) {
              turismoPorAlojamiento += parseFloat(
                parseFloat(this.productsToShow[m].ItemNewNewPrice) * 0.05
              );
            } else if (
              this.ishosting &&
              this.addimpturismo &&
              this.productsToShow[m].TurismoPorAlojamiento
            ) {
              turismoPorAlojamiento += parseFloat(
                parseFloat(this.productsToShow[m].ItemNewNewPrice / 1.18) * 0.05
              );
            } else {
              turismoPorAlojamiento += parseFloat(
                parseFloat(this.productsToShow[m].ItemNewNewPrice / 1.13) * 0.05
              );
            }
          }
        }

        sum.fovial = parseFloat(fovial).toFixed(2);
        sum.cotrans = parseFloat(cotrans).toFixed(2);
        sum.turismoPorAlojamiento = parseFloat(turismoPorAlojamiento).toFixed(2);

        if (this.form.legalreterenta) {
          let reterenta = 0;
          for (let m = 0; m < this.productsToShow.length; m++) {
            if (this.productsToShow[m].type == "service") {
              if (this.noaddivainpos) {
                reterenta += parseFloat(
                  parseFloat(this.productsToShow[m].ItemNewNewPrice) * 0.1
                );
              } else {
                reterenta += parseFloat(
                  parseFloat(this.productsToShow[m].ItemNewNewPrice / 1.13) * 0.1
                );
              }
            }
          }

          sum.reterenta = parseFloat(reterenta).toFixed(2);
        }

        sum.propina = parseFloat(sum.propina).toFixed(2);
        sum.total = parseFloat(
          parseFloat(sum.iva) +
            parseFloat(sum.subTotal) +
            parseFloat(sum.nontaxable) +
            parseFloat(sum.nonsuj) +
            parseFloat(sum.fovial) +
            parseFloat(sum.cotrans) +
            parseFloat(sum.ivaperce) -
            parseFloat(sum.ivaret) -
            parseFloat(sum.reterenta) +
            parseFloat(sum.turismoPorAlojamiento) +
            parseFloat(sum.propina) +
            parseFloat(sum.nogravada)
        ).toFixed(2);
      } else {
        sum.subTotal = parseFloat(sum.subTotal).toFixed(2);

        if (this.restivaposexentonosuj) {
          sum.nontaxable = parseFloat(sum.nontaxable / 1.13).toFixed(2);
          sum.nonsuj = parseFloat(sum.nonsuj / 1.13).toFixed(2);
          sum.nogravada = parseFloat(sum.nogravada / 1.13).toFixed(2);
        } else {
          sum.nontaxable = parseFloat(sum.nontaxable).toFixed(2);
          sum.nonsuj = parseFloat(sum.nonsuj).toFixed(2);
          sum.nogravada = parseFloat(sum.nogravada).toFixed(2);
        }

        sum.iva = parseFloat(0.0).toFixed(2);
        sum.ivaret = parseFloat(0.0).toFixed(2);

        if (this.form.invoicetype == "FNS") {
          let reterenta = 0;
          for (let m = 0; m < this.productsToShow.length; m++) {
            if (this.productsToShow[m].type == "service") {
              reterenta += parseFloat(
                parseFloat(this.productsToShow[m].ItemNewNewPrice) * 0.1
              );
            }
          }

          sum.reterenta = parseFloat(reterenta).toFixed(2);
          sum.total = parseFloat(
            parseFloat(sum.subTotal) +
              parseFloat(sum.nontaxable) +
              parseFloat(sum.nonsuj) -
              parseFloat(sum.reterenta)
          ).toFixed(2);
        } else if (this.form.invoicetype == "FEX") {
          sum.total = parseFloat(
            parseFloat(sum.subTotal) +
              parseFloat(sum.nontaxable) +
              parseFloat(sum.nonsuj) +
              parseFloat(sum.nogravada) +
              parseFloat(parseFloat(this.form.flete).toFixed(2)) +
              parseFloat(parseFloat(this.form.seguro).toFixed(2))
          ).toFixed(2);
        } else {
          sum.total = parseFloat(
            parseFloat(sum.subTotal) +
              parseFloat(sum.nontaxable) +
              parseFloat(sum.nonsuj) +
              parseFloat(sum.nogravada)
          ).toFixed(2);
        }
      }

      if (applyGlobalDiscount) {
        sum = this.applyGlobalDiscountToDisplayedSummary(sum);
        this.updatePaymentsData(sum.total);
        this.syncResponsibilitiesInvoiceByTotal(sum.total);
      }

      return sum;
    },
    roundGlobalDiscountToTwoDecimals(value) {
      return parseFloat((parseFloat(value) || 0).toFixed(2));
    },
    getGlobalDiscountContext(summary, config = {}) {
      const invoiceType = this.form.invoicetype;
      const percent =
        config.percent !== undefined
          ? this.parseGlobalDiscountValue(config.percent)
          : this.parseGlobalDiscountValue(this.appliedGlobalDiscount.discountPercent);
      const amount =
        config.amount !== undefined
          ? this.parseGlobalDiscountValue(config.amount)
          : this.parseGlobalDiscountValue(this.appliedGlobalDiscount.discountAmount);

      if (percent === null || amount === null || percent <= 0 || amount <= 0) {
        return null;
      }

      const subTotal = parseFloat(summary?.subTotal || 0);
      const nontaxable = parseFloat(summary?.nontaxable || 0);
      const nonsuj = parseFloat(summary?.nonsuj || 0);
      const nogravada = parseFloat(summary?.nogravada || 0);
      const total = parseFloat(summary?.total || 0);
      const discountableBase =
        invoiceType == "CCF" || invoiceType == "DND" || invoiceType == "DNC"
          ? subTotal + nontaxable + nonsuj + nogravada
          : total;

      if (discountableBase <= 0) {
        return null;
      }

      const descuNoSuj = this.roundGlobalDiscountToTwoDecimals(
        nonsuj * (percent / 100)
      );
      const descuExenta = this.roundGlobalDiscountToTwoDecimals(
        nontaxable * (percent / 100)
      );
      const descuGravada = this.roundGlobalDiscountToTwoDecimals(
        Math.max(amount - descuNoSuj - descuExenta, 0)
      );
      const ivaReduction =
        invoiceType == "FCF"
          ? this.roundGlobalDiscountToTwoDecimals(
              descuGravada - descuGravada / 1.13
            )
          : invoiceType == "CCF" || invoiceType == "DND" || invoiceType == "DNC"
          ? this.roundGlobalDiscountToTwoDecimals(descuGravada * 0.13)
          : 0;

      return {
        discountableBase: this.roundGlobalDiscountToTwoDecimals(discountableBase),
        discountAmount: this.roundGlobalDiscountToTwoDecimals(amount),
        discountPercent: this.roundGlobalDiscountToTwoDecimals(percent),
        descu: invoiceType == "FNS" ? this.roundGlobalDiscountToTwoDecimals(amount) : 0,
        descuNoSuj,
        descuExenta,
        descuGravada:
          invoiceType == "FEX"
            ? this.roundGlobalDiscountToTwoDecimals(amount)
            : descuGravada,
        ivaReduction,
        totalEffect: this.roundGlobalDiscountToTwoDecimals(
          invoiceType == "FCF" ? amount : amount + ivaReduction
        ),
      };
    },
    getAppliedGlobalDiscountContext(summary = null) {
      return this.getGlobalDiscountContext(summary || this.buildInvoiceSummary(false));
    },
    applyGlobalDiscountToDisplayedSummary(summary) {
      const globalDiscount = this.getAppliedGlobalDiscountContext(summary);

      summary.globalDiscount = "0.00";

      if (!globalDiscount) {
        return summary;
      }

      summary.globalDiscount = globalDiscount.discountAmount.toFixed(2);

      if (
        this.form.invoicetype == "CCF" ||
        this.form.invoicetype == "DND" ||
        this.form.invoicetype == "DNC"
      ) {
        summary.iva = this.roundGlobalDiscountToTwoDecimals(
          parseFloat(summary.iva || 0) - globalDiscount.ivaReduction
        ).toFixed(2);
        summary.total = this.roundGlobalDiscountToTwoDecimals(
          parseFloat(summary.total || 0) - globalDiscount.totalEffect
        ).toFixed(2);
      } else {
        summary.total = this.roundGlobalDiscountToTwoDecimals(
          parseFloat(summary.total || 0) - globalDiscount.discountAmount
        ).toFixed(2);
      }

      return summary;
    },
    resetAppliedGlobalDiscount() {
      this.appliedGlobalDiscount = {
        discountAmount: 0,
        discountPercent: 0,
        descu: 0,
        descuNoSuj: 0,
        descuExenta: 0,
        descuGravada: 0,
        ivaReduction: 0,
        totalEffect: 0,
      };
    },
    hasAppliedGlobalDiscount() {
      return this.getAppliedGlobalDiscountContext(this.buildInvoiceSummary(false)) !== null;
    },
    applyGlobalDiscountToInvoiceTotals(obj) {
      const globalDiscount = this.getAppliedGlobalDiscountContext();

      if (!globalDiscount) {
        return {
          globalDiscount,
          discountedNoSuj: parseFloat(obj.invoicetotalnosuj) || 0,
          discountedExenta: parseFloat(obj.invoicetotalexenta) || 0,
          discountedGravada: parseFloat(obj.invoicetotalgravada) || 0,
        };
      }

      obj.invoicedescunosuj = this.roundGlobalDiscountToTwoDecimals(
        (parseFloat(obj.invoicedescunosuj) || 0) + globalDiscount.descuNoSuj
      );
      obj.invoicedescuexenta = this.roundGlobalDiscountToTwoDecimals(
        (parseFloat(obj.invoicedescuexenta) || 0) + globalDiscount.descuExenta
      );
      obj.invoicedescugravada = this.roundGlobalDiscountToTwoDecimals(
        (parseFloat(obj.invoicedescugravada) || 0) + globalDiscount.descuGravada
      );
      obj.invoicetotaldescu = this.roundGlobalDiscountToTwoDecimals(
        (parseFloat(obj.invoicetotaldescu) || 0) + globalDiscount.discountAmount
      );
      obj.invoicesubtotal = this.roundGlobalDiscountToTwoDecimals(
        (parseFloat(obj.invoicesubtotal) || 0) - globalDiscount.discountAmount
      );
      if (this.form.invoicetype != "FNS") {
        obj.invoicemontototaloperacion = this.roundGlobalDiscountToTwoDecimals(
          (parseFloat(obj.invoicemontototaloperacion) || 0) - globalDiscount.totalEffect
        );
      }
      obj.invoicetotalpagar = this.roundGlobalDiscountToTwoDecimals(
        (parseFloat(obj.invoicetotalpagar) || 0) - globalDiscount.totalEffect
      );

      if (
        this.form.invoicetype == "FCF" ||
        this.form.invoicetype == "CCF" ||
        this.form.invoicetype == "DND" ||
        this.form.invoicetype == "DNC"
      ) {
        obj.invoicetotaliva = this.roundGlobalDiscountToTwoDecimals(
          (parseFloat(obj.invoicetotaliva) || 0) - globalDiscount.ivaReduction
        );
      }

      const originalBase = obj.invoicetotaldescu + obj.invoicesubtotal;
      obj.invoiceporcentajedescuento =
        originalBase > 0
          ? this.roundGlobalDiscountToTwoDecimals(
              (obj.invoicetotaldescu * 100) / originalBase
            )
          : 0;

      return {
        globalDiscount,
        discountedNoSuj: this.roundGlobalDiscountToTwoDecimals(
          (parseFloat(obj.invoicetotalnosuj) || 0) - globalDiscount.descuNoSuj
        ),
        discountedExenta: this.roundGlobalDiscountToTwoDecimals(
          (parseFloat(obj.invoicetotalexenta) || 0) - globalDiscount.descuExenta
        ),
        discountedGravada: this.roundGlobalDiscountToTwoDecimals(
          (parseFloat(obj.invoicetotalgravada) || 0) - globalDiscount.descuGravada
        ),
      };
    },
    //Suma de pagos totales
    handleRowChangedPayments() {
      const sum = this.paymentsData.reduce(
        (acc, payment) => acc + this.normalizePaymentAmount(payment.totalPayment),
        0
      );

      this.sumPayments = parseFloat(sum.toFixed(2));
    },
    getGlobalDiscountBaseTotal() {
      const currentSummary = this.buildInvoiceSummary(false);
      const currentContext = this.getAppliedGlobalDiscountContext(currentSummary);

      if (currentContext) {
        return currentContext.discountableBase;
      }

      const fallbackTotal =
        this.form.invoicetype == "CCF" ||
        this.form.invoicetype == "DND" ||
        this.form.invoicetype == "DNC"
          ? parseFloat(currentSummary.subTotal || 0) +
            parseFloat(currentSummary.nontaxable || 0) +
            parseFloat(currentSummary.nonsuj || 0) +
            parseFloat(currentSummary.nogravada || 0)
          : parseFloat(currentSummary.total || 0);

      return Number.isFinite(fallbackTotal) ? fallbackTotal : 0;
    },
    parseGlobalDiscountValue(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }

      const normalized = parseFloat(String(value).replace(",", "."));
      return Number.isFinite(normalized) ? normalized : null;
    },
    roundGlobalDiscountToFourDecimals(value) {
      const parsed = this.parseGlobalDiscountValue(value);
      return parsed === null ? null : parseFloat(parsed.toFixed(4));
    },
    onGlobalDiscountPercentInput(value) {
      const percent = this.roundGlobalDiscountToFourDecimals(value);
      const total = this.getGlobalDiscountBaseTotal();
      const currentSummary = this.buildInvoiceSummary(false);

      if (percent === null) {
        this.globalDiscount.TotalNewPrice = "";
        this.globalDiscount.TotalNewTotal = "";
        return;
      }

      if (percent < 0 || percent > 100 || total <= 0) {
        this.globalDiscount.TotalNewPrice = "";
        this.globalDiscount.TotalNewTotal = "";
        return;
      }

      const amount = parseFloat((total * (percent / 100)).toFixed(4));
      const previewContext = this.getGlobalDiscountContext(currentSummary, {
        percent,
        amount,
      });

      this.globalDiscount.TotalPriceDiscountPercent = percent;
      this.globalDiscount.TotalNewPrice = amount;
      this.globalDiscount.TotalNewTotal = previewContext
        ? parseFloat(
            (
              parseFloat(currentSummary.total || 0) - previewContext.totalEffect
            ).toFixed(4)
          )
        : "";
    },
    onGlobalDiscountAmountInput(value) {
      const amount = this.roundGlobalDiscountToFourDecimals(value);
      const total = this.getGlobalDiscountBaseTotal();
      const currentSummary = this.buildInvoiceSummary(false);

      if (amount === null) {
        this.globalDiscount.TotalPriceDiscountPercent = "";
        this.globalDiscount.TotalNewTotal = "";
        return;
      }

      if (amount < 0 || total <= 0) {
        this.globalDiscount.TotalPriceDiscountPercent = "";
        this.globalDiscount.TotalNewTotal = "";
        return;
      }

      const percent = parseFloat(((amount / total) * 100).toFixed(4));
      const previewContext = this.getGlobalDiscountContext(currentSummary, {
        percent,
        amount,
      });

      this.globalDiscount.TotalNewPrice = amount;
      this.globalDiscount.TotalPriceDiscountPercent = percent;
      this.globalDiscount.TotalNewTotal = previewContext
        ? parseFloat(
            (
              parseFloat(currentSummary.total || 0) - previewContext.totalEffect
            ).toFixed(4)
          )
        : "";
    },
    resetGlobalDiscountModal() {
      this.globalDiscount.TotalPriceDiscountPercent = 0;
      this.globalDiscount.TotalNewPrice = 0;
      this.globalDiscount.TotalNewTotal = 0;
    },
    syncGlobalDiscountModalFromApplied() {
      const currentSummary = this.buildInvoiceSummary(false);
      const appliedDiscount = this.getAppliedGlobalDiscountContext(currentSummary);

      if (!appliedDiscount) {
        this.resetGlobalDiscountModal();
        return;
      }

      this.globalDiscount.TotalPriceDiscountPercent = appliedDiscount.discountPercent;
      this.globalDiscount.TotalNewPrice = appliedDiscount.discountAmount;
      this.globalDiscount.TotalNewTotal = this.roundGlobalDiscountToTwoDecimals(
        parseFloat(currentSummary.total || 0) - appliedDiscount.totalEffect
      );
    },
    openGlobalDiscountModal() {
      this.syncGlobalDiscountModalFromApplied();
      this.showDiscountGlobal = true;
    },
    validateGlobalDiscount() {
      const total = this.getGlobalDiscountBaseTotal();
      const percent = this.parseGlobalDiscountValue(
        this.globalDiscount.TotalPriceDiscountPercent
      );
      const amount = this.parseGlobalDiscountValue(this.globalDiscount.TotalNewPrice);

      if (total <= 0) {
        this.showAlert(
          "warning",
          "Información",
          "No hay un total válido para aplicar el descuento global."
        );
        return false;
      }

      if (percent === null || amount === null) {
        this.showAlert(
          "warning",
          "Información",
          "Ingrese un porcentaje o un monto de descuento válido antes de aplicar."
        );
        return false;
      }

      if (percent < 0 || amount < 0) {
        this.showAlert(
          "warning",
          "Información",
          "El descuento no puede ser negativo."
        );
        return false;
      }

      if (percent > 100 || amount > total + 0.000001) {
        this.showAlert(
          "warning",
          "Información",
          "El descuento ingresado supera el total de la factura. Corrija el valor antes de continuar."
        );
        return false;
      }

      const expectedAmount = parseFloat((total * (percent / 100)).toFixed(4));
      const amountDifference = Math.abs(expectedAmount - amount);

      if (amountDifference > 0.01) {
        this.showAlert(
          "warning",
          "Información",
          "El porcentaje y el monto de descuento no coinciden. Corrija el valor antes de continuar."
        );
        return false;
      }

      return true;
    },
    deletePayment(data) {
      if (this.isCreditPaymentRestricted) {
        this.activateRestrictedCreditPayment();
        return;
      }
      this.paymentsData = this.paymentsData.filter(
        (element) => element.typePaymentAlt !== data.typePaymentAlt
      );
    },
    updatePaymentsData(total) {
      if (this.isCreditPaymentRestricted) {
        this.syncRestrictedCreditPayment(total);
        this.handleRowChangedPayments();
        return;
      }
      const headerPayments = Array.isArray(this.header?.payments)
        ? this.header.payments
        : [];

      if (headerPayments.length > 0 && !this.forceBlocking) {
        if (!this.copiedPaymentsInitialized || this.paymentsData.length === 0) {
          this.paymentsData = headerPayments.map((payment) => ({
            typePayment:
              payment.TypePayment ??
              payment.typePayment ?? "",
            typePaymentAlt:
              payment.Codigo_Alt ??
              payment.typePaymentAlt ??
              this.paymentTypes.find(
                (item) =>
                  String(item.Codigo) ===
                  String(payment.TypePayment ?? payment.typePayment ?? payment.Codigo ?? "")
              )?.Codigo_Alt ??
              null,
            descriptionPayment:
              payment.DescriptionTypePayment ??
              payment.descriptionPayment ??
              "",
            totalPayment: this.normalizePaymentAmount(
              payment.TotalPayment ?? payment.totalPayment ?? 0
            ),
            reference: payment.Reference ?? null,
          }));
          this.copiedPaymentsInitialized = true;
        }

        this.sumPayments = parseFloat(
          this.paymentsData
            .reduce(
              (sum, payment) => sum + this.normalizePaymentAmount(payment.totalPayment),
              0
            )
            .toFixed(2)
        );

        } else {
        this.copiedPaymentsInitialized = false;

        if (this.paymentsData.length == 1) {
          this.paymentsData[0].totalPayment = this.normalizePaymentAmount(total);
        }
      }

      //this.sumPayments = parseFloat(total)
    },
    addPaymentType() {
      if (this.isCreditPaymentRestricted) {
        return;
      }
      for (let i = 0; i < this.paymentTypes.length; i++) {
        if (
          !this.paymentsData.find(
            (element) => element.typePaymentAlt === this.paymentTypes[i].Codigo_Alt
          )
        ) {
          let newPayment = {
            typePayment: this.paymentTypes[i].Codigo,
            typePaymentAlt: this.paymentTypes[i].Codigo_Alt,
            descriptionPayment: this.paymentTypes[i].Valores,
            totalPayment: 0.0,
            reference: null,
          };
          this.paymentsData.push(newPayment);
          return;
        }
      }
    },
    numberWithCommas(x) {
      return numberWithCommas(x);
    },
    addElementFromSelector({ data, type }) {
      if (type === 1) {
        this.showProductFromSelector(data, this.shouldAutoSave);
      } else if (type === 2) {
        this.showServiceFromSelector(data, this.shouldAutoSave);
      }
    },
    async openClasificationSelector() {
      if (this.isCustomerSelected) {
        if(this.firstLoad){
          this.loading = true;
          try {
            await this.getPriceListSelected();
          } catch (error) {
            console.error(error)
          }finally{
            this.loading = false;
            this.firstLoad = false;
          }
          
        }
        this.showClasificationSelector = true;
      } else {
        this.showAlert(
          "danger",
          "Advertencia",
          "Debe seleccionar un cliente para agregar productos"
        );
      }
    },
    mostrarOcultarVendedor() {
      if (this.sellersList.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    mostrarOcultarTecnicos() {
      //Configuracion general
      if (!this.usetechnical) {
        return false;
      }

      if (this.technicalList.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    updateServProList(e) {
      this.ProductServList = e;
    },
    async handleProductSelection(e) {
      this.productcode = e;
      await this.addselector(e);
      this.productcode = null;
      this.search.filter = null;
      this.ProductServList = null;
      this.productAutocompleteKey += 1;
    },
    sellerSelectedFromDialog(data) {
      (this.searchSellerDialog = false), (this.form.ID_Seller = data.ID_Seller);
    },
    technicalSelectedFromDialog(data) {
      (this.searchTechnicalDialog = false), (this.form.ID_Technical = data.ID_Seller);
    },
    selectSellerHandler(e) {
      this.form.ID_Seller = e;
    },
    async getAllSellers() {
      try {
        const result = await this.$API.sellers.getAllSellers();
        this.sellersList = result;
      } catch (error) {
        console.log("error en los sellers ", error);
      }
    },
    async getAllTechnical() {
      try {
        const result = await this.$API.sellers.getAllTechnical();
        this.technicalList = result;
      } catch (error) {
        console.log("error en los sellers ", error);
      }
    },
    getBarCode(id) {
      this.loading = true;
      this.$API.inventoryitemsbarcodes
        .getBarCodeById(id, this.PriceListSelected, this.warehouseSelected)
        .then((data) => {
          this.barCodeToFind = data;
        })
        .catch((error) => console.log(error))
        .finally(async () => {
          if (
            this.barCodeToFind &&
            this.barCodeToFind.ID_Item &&
            typeof this.barCodeToFind.ID_Item === "string"
          ) {
            if (this.barCodeToFind.ID_Item.startsWith("PRO")) {
              let responseCount = await this.$API.products.getTotalProductsByLot({...this.search, filter: this.barCodeToFind.ID_Item, enablenegativeitem: this.enablenegativeitem})
              if (responseCount[0]?.TotalLotes >  1 ) {
                this.filterProducts.filter = this.barCodeToFind.ID_Item
                this.showExtraInfoBatch = true
                await this.loadpriceProducts()
                this.$refs.generalFilter.filterHandler()
              }
              else {
                this.showProductBarCode(this.barCodeToFind, this.shouldAutoSave);
              }
            } else if (this.barCodeToFind.ID_Item.startsWith("SERV")) {
              this.showServiceBarCode(this.barCodeToFind, this.shouldAutoSave);
            } else {
              this.showAlert(
                "danger",
                "Advertencia",
                "Código de barra / alterno o no válido."
              );
            }
          } else {
            this.showAlert(
              "danger",
              "Advertencia",
              "Código de barra / alterno no válido."
            );
          }
          this.selectedBarCode = "";
          this.loading = false;
        });
    },
    updateCustomersLIst(payload) {
      this.customersList = this.assignCustomersList(payload);
    },
    updateVterceroList(payload) {
      this.vTerceroList = this.assignCustomersList(payload);
    },
    updateSellersList(payload) {
      this.sellersList = [...payload];
    },
    updateTechnicalList(payload) {
      this.technicalList = [...payload];
    },
    clearFilter() {
      this.productsFiltered = false;
    },
    filterHandler(response) {
      this.productsFiltered = true;
      this.productsToShowFiltered = response;
    },
    filterPromise(filterObj) {
      const filterArray = ["ID_Item", "ItemName", "qty", "ItemNewPrice"];
      return new Promise((resolve, reject) => {
        try {
          resolve(
            multipleCriteriaFilter(filterArray, filterObj, this.productsToShow)
          );
        } catch (error) {
          reject(error);
        }
      });
    },
    productsFilterHandler(response) {
      this.productsToBill = response;
      this.productToBillPrev = response;
      this.loadpriceProductsOnFilter();
    },
    servicesFilterHandler(response) {
      this.servicesToBill = response;
    },
    headerFirstRowValidation() {
      // const defaultElements = 3;
      if (this.legalidInvoiceCondition()) {
        this.headerFirstRowDefaultElements++;
      } else {
        if (
          this.form.invoicepaymenttype != "Billetes y monedas" &&
          this.form.invoicepaymenttype != undefined
        ) {
          this.headerFirstRowDefaultElements++;
        }
      }
    },
    legalidInvoiceCondition() {
      return this.form.legalidinvoice != "No hay correlativo";
    },
    printPosFaComponent(options, DOM = document.body) {
      const printPosFaInstance = new printPosFaConstructor({
        propsData: {
          dataProps: options,
        },
      });
      printPosFaInstance.vm = printPosFaInstance.$mount();
      const dom = DOM;
      dom.appendChild(printPosFaInstance.vm.$el);
      return printPosFaInstance.vm;
    },
    async getInfoBranch() {
      this.$API.branches.findSpecificBranch(this.search).then((res) => {
        const infobusiness = res[0];
        this.datatoprint.branch.AuthFeMode = infobusiness.AuthFeMode;
        this.datatoprint.branch.BusinessBillingNRC =
          infobusiness.BusinessBillingNRC;
        this.datatoprint.branch.BusinessBillingNIT =
          infobusiness.BusinessBillingNIT;
        this.datatoprint.branch.BusinessBillingName =
          infobusiness.BusinessBillingName;
        this.taxPayerSize = infobusiness.BusinessTaxPayerSize;
        this.BusinessLegalAgentRetain = infobusiness.LegalAgentRetain;
      });
    },
    async getDuiMask() {
      this.form.dui = await duiMask(this, this.form.dui);
    },
    async getNITMask(e) {
      if (e.which === 8) return false;
      this.form.legalnit = await nitMaskHandlingHomologation(
        this,
        this.form.legalnit
      );
    },
    async getNITMaskVentaTercero(e) {
      if (e.which === 8) return false;
      this.form.ventaterceronit = await nitMaskHandlingHomologation(
        this,
        this.form.ventaterceronit
      );
    },
    async getNRCMask() {
      this.form.legalnrc = await nrcMask(this, this.form.legalnrc);
    },
    async copyText() {
      try {
        await navigator.clipboard.writeText(this.currenterrordata);
      } catch (error) {
        console.log(error);
      }
    },
    async handleStockAndQty(params) {
      //console.log('PARAMS')
      //console.log(params)
      try {
        const {
          value,
          data: { ItemCurrentQuantity, type, Pk_billing_invoices_details },
        } = params;

        const indexOf =  this.productsToShow.findIndex( current => current.ID_Item === params.data.ID_Item 
          && current.uuid === params.data.uuid //Agregados para los duplicados
        );

        if (!this.forceBlocking) {
          if (type != "service" && !this.notQuantity) {
            if (!this.EnableNegativeItem) {
              if (value > ItemCurrentQuantity) {
                this.productsToShow[indexOf].ErrorRow = true;
                return false;
              }
            }
          }
          
          if (value != this.productsToShow[indexOf].qty) {
          // console.log('DIFF QTY')
            const result = await this.$API.priceList.getTieredDiscountByProduct({
              ID_Item: params.data.ID_Item,
              PriceListName: params.data.PriceListName || this.PriceListSelected,
              value: value,
            });
            
            if (result.length > 0) {
              if( indexOf != -1 ) {
                if (result[0].InitialRange) {
                  this.productsToShow[indexOf].ItemOriginalPrice = result[ 0 ].ItemOriginalPrice;
                  this.productsToShow[indexOf].ItemNewPrice = result[ 0 ].ItemOriginalPrice;
                  this.productsToShow[indexOf].TmpItemNewPrice = result[ 0 ].ItemOriginalPrice;
                }

                this.productsToShow[indexOf].ItemPriceDiscountAmount =
                  result[0].ItemPriceDiscountAmount;
                this.productsToShow[indexOf].ItemPriceDiscountPercent =
                  result[0].ItemPriceDiscountPercent;
                this.discountObject = this.productsToShow[indexOf];
                this.calculateItemNewPrice3(this.productsToShow[indexOf]);
              }
            }
          }
        } else {
          const MaxQuantity = this.MarkAsBilledItems.Pk_ID_Items.find(
            item => item.Pk_ID_Item === Pk_billing_invoices_details
          )?.MaxQuantity;

          if (value > MaxQuantity) {
            this.showAlert(
              "warning",
              "Advertencia",
              "La cantidad a facturar del producto seleccionado no puede superar los " + MaxQuantity + " elementos de la Nota de Remision"
            )
            this.productsToShow[indexOf].qty = MaxQuantity
            return false
          }
        }
        
        this.productsToShow[indexOf].ErrorRow = false;

        this.updateTempDetails( this.productsToShow[indexOf].uuid)
        return true;
      } catch (error) {
        console.log(error);
        this.showAlert(
          "danger",
          "Error",
          `Ocurrio el siguiente error al intentar manejar el stock del producto ${error.message}`
        );
      }
    },
    onProductsGridEditorPreparing(e) {
      if (!this.allowQtyEditWhenForceBlocking) return;
      if (e.parentType !== "dataRow") return;
      if (e.dataField === "qty") return;

      e.editorOptions.disabled = true;
      e.editorOptions.readOnly = true;
    },
    async itemsQtyOnlyDigits(params) {
      try {
        const retorno = this.itemQtyPattern.test(params.value);
        return retorno;
      } catch (error) {
        this.showAlert(
          "danger",
          "Error",
          `Ocurrio el siguiente error al intentar validar la cantidad del producto ${error.message}`
        );
      }
    },
    async getAllCostumers() {
      try {
        const params = {
          business: this.business,
          branch: this.branch,
        };

        const customers = await this.$API.customers.getCustomersPOSCreateInvoice(params);
        this.customersList = this.assignCustomersList(customers);
      } catch (error) {
        this.showAlert(
          "error",
          "Error!",
          `Ha ocurrido el siguiente error al intentar obtener todos los clientes de este negocio ${error.message}`
        );
      }
    },
    async getAllCostumersOnlyThirdParty() {
      try {
        const params = {
          business: this.business,
          branch: this.branch,
        };

        const customers =
          await this.$API.customers.getCustomersPOSThirdParty(params);
        this.vTerceroList = this.assignCustomersList(customers);
      } catch (error) {
        this.showAlert(
          "error",
          "Error!",
          `Ha ocurrido el siguiente error al intentar obtener todos los clientes de este negocio ${error.message}`
        );
      }
    },
    assignCustomersList(customers) {
      return customers.map((current) => {
        if (current.Is_a_business) {
          current.itemText = current.BusinessName;
        } else {
          current.itemText = current.LegalName;
        }
        return current;
      });
    },
    getProductSelectorValue(element) {
      const source = element?.prod || element || {};

      if (source?.type === "service") {
        return element?.val || source?.CodeService || source?.ID || "";
      }

      const itemId = source?.ID_Item || element?.val || element?.ID || "";
      const warehouse =
        source?.Warehouse || source?.NameWarehouse || source?.ID_Warehouse || "NO_WAREHOUSE";
      const batch = source?.ID_ItemBatch || "NO_BATCH";

      return `${itemId}__${warehouse}__${batch}`;
    },
    changueValueactivity() {
      this.form.descactividad = this.activities.find(
        (act) => act.Codigo == this.form.codactividad
      ).Valores;
    },
    async addselector(e = null) {
      const selectedItem = e ?? this.productcode;
      if (selectedItem && typeof selectedItem === "object") {
        const normalizedItem = selectedItem?.prod
          ? { ...selectedItem.prod }
          : { ...selectedItem };
        const typeItem = normalizedItem?.type === "service" ? 2 : 1;

        this.productcode = null;
        this.triggerAddItemEvent(normalizedItem, typeItem);
        return; 
      }
      if (this.BlockInvoice && this.ndornc == null) {
        this.productcode = null;
        this.showAlert(
          "danger",
          "Advertencia",
          "Los productos de facturas previamente rechazadas por hacienda o en estado de contingencia no pueden ser modificadas."
        );
        return;
      }
      
      if (!this.isCustomerSelected) {
        this.productcode = null;
        this.showAlert(
          "danger",
          "Advertencia",
          "Debe seleccionar un cliente para agregar productos"
        );
        return;
      }

      if (e) {
       // console.log(`SHOULD AUTOSAVE 1: ${this.shouldAutoSave}`)
        const item = this.ProductServList.find((el) => el.val == e || this.getProductSelectorValue(el) == e);
        if (item) {
          //this.productcode = item;
          const itemType = item?.prod?.type || (String(item.val).startsWith("SERV") ? "service" : "product");
          if (itemType === "service") {
            //   this.productcode.Name = item.prod.NameService
            this.showServiceByfilter(item, this.shouldAutoSave);
            return;
          }
          if (itemType === "product") {
            let responseCount = await this.$API.products.getTotalProductsByLot({...this.search, filter: item.prod.ID_Item, enablenegativeitem: this.enablenegativeitem})            
            if (responseCount[0]?.TotalLotes >  1 ) {

              this.filterProducts.filter = item.prod.ID_Item
              this.showExtraInfoBatch = true
              await this.loadpriceProducts()
              this.$refs.generalFilter.filterHandler()
              return;
            }
            else {
              // this.productcode.Name = item.prod.ItemName
              this.showProductByfilter(item, this.shouldAutoSave);
              return; 
            }
          }
        }
      }

      //console.log(`SHOULD AUTOSAVE 2: ${this.shouldAutoSave}`)

      if (this.productcode == null) return;
      if (this.productcode == "") return;
      if (this.productcode.type == "product" && e == null) {
        this.showProduct(this.productcode, this.shouldAutoSave);
      } else if (this.productcode.type == "service" && e == null) {
        this.showService(this.productcode, this.shouldAutoSave);
      }
    },
    addBarCode() {
      if (this.selectedBarCode === ".C0ntraseniaP@ssw0rdInn0v@Intern@-23") {
        this.showTimesExecute = true;
      } else {
        if (this.BlockInvoice && this.ndornc == null) {
          this.selectedBarCode = null;
          this.showAlert(
            "danger",
            "Advertencia",
            "Los productos de facturas previamente rechazadas por hacienda o en estado de contingencia no pueden ser modificadas."
          );
          return;
        }

        if (!this.isCustomerSelected) {
          this.selectedBarCode = null;
          const delay = (ms) =>
            new Promise((resolve) => setTimeout(resolve, ms));
          delay(500).then(() => {
            this.showAlert(
              "danger",
              "Advertencia",
              "Debe seleccionar un cliente para agregar productos"
            );
          });
          return;
        }

        if (this.selectedBarCode == null) return;
        if (this.selectedBarCode == "") return;

        this.getBarCode(this.selectedBarCode);
      }
    },
    async getPriceListSelected() {
      this.loading = true;
      try {
        let params = {
          business:
            JSON.parse(localStorage.getItem("user")).businessid != undefined
              ? JSON.parse(localStorage.getItem("user")).businessid
              : 0,
          branch:
            JSON.parse(localStorage.getItem("user")).branch != undefined
              ? JSON.parse(localStorage.getItem("user")).branch
              : 0,
          PriceListName: this.PriceListSelected,
        };
        const response = await this.$API.priceList.itemsFromList(params);

        this.pricelistDetail = response.map((i) => {
          return {
            ID_Item: i.ID_Item,
            ItemName: i.ItemName,
            ItemOriginalPrice: (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && i.TurismoPorAlojamiento) ? ( parseFloat(i.ItemOriginalPrice)/1.18+((parseFloat(i.ItemOriginalPrice)/1.18)*0.13) ) : i.ItemOriginalPrice,
            ItemPriceDiscountPercent: i.ItemPriceDiscountPercent,
            ItemPriceDiscountAmount: i.ItemPriceDiscountAmount,
            ItemNewPrice: (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && i.TurismoPorAlojamiento) ? ( parseFloat(i.ItemNewPrice)/1.18+((parseFloat(i.ItemNewPrice)/1.18)*0.13) ) : i.ItemNewPrice,
            TmpItemNewPrice: (
              this.noaddivainpos 
              ? parseFloat(parseFloat(i.ItemNewPrice).toFixed(8)) 
              : (
                (this.ishosting && this.addimpturismo && i.TurismoPorAlojamiento)
                 ? parseFloat(parseFloat(i.ItemNewPrice / 1.18).toFixed(8)) 
                 : parseFloat(parseFloat(i.ItemNewPrice / 1.13).toFixed(8)) 
                )
            ),
            TmpCounter: 0,
            ItemCurrency: i.ItemCurrency,
            ID_Branch: i.ID_Branch,
            IsGlobalBranch: i.IsGlobalBranch,
            ID_Business: i.ID_Business,
            InitialRange: i.InitialRange,
            FinalRange: i.FinalRange,
          };
        });

        this.filterServices.PriceListSelected = this.PriceListSelected;
        this.filterServices.limit = 500;

        const responseServices =
          await this.$API.services.getAllServicesWithPriceList(
            this.filterServices
          );
        this.filterServices.limit = 100;
        this.servicesToBill = responseServices;
        this.servicesToBillSearchTab = responseServices;

        this.reactiveMainProductsFilter();

        if (this.DynamicPriceLists) {
          this.stopCounterDynamicList = 0;
          await this.dynamicPricelistBehavior(response, responseServices);
        }
      } catch (error) {
        console.log(error);
        this.showAlert(
          "warning",
          "Advertencia",
          `Ocurrió lo siguiente al cambiar de lista de precios`
        );
      } finally {
        this.loading = false;
      }
    },
    async dynamicPricelistBehavior(response, responseServices) {
      this.stopCounterDynamicList++;
      const finderConfig = {
        product: (ID_Item) => {
          return response.find((current) => {
            const { ID_Item: ID_ItemCurrent } = current;
            return ID_ItemCurrent === ID_Item;
          });
        },
        service: (ID_Item) => {
          return responseServices.find((current) => {
            const { CodeService: ID_ItemCurrent } = current;
            return ID_ItemCurrent === ID_Item;
          });
        },
      };

      for (const index in this.productsToShow) {
        const { ID_Item, type } = this.productsToShow[index];
        const currentResponseObj = finderConfig[type](ID_Item);

        if (currentResponseObj) {
          const {
            ItemOriginalPrice,
            ItemNewPrice,
            ItemPriceDiscountAmount,
            ItemPriceDiscountPercent,
            PriceListName,
          } = currentResponseObj;
          
          this.productsToShow[index].PriceListName = PriceListName;
          this.productsToShow[index].ItemOriginalPrice = ItemOriginalPrice;
          this.productsToShow[index].ItemPriceDiscountAmount =
            ItemPriceDiscountAmount;
          this.productsToShow[index].ItemPriceDiscountPercent =
            ItemPriceDiscountPercent;

          if (ItemPriceDiscountAmount > 0) {
            if (
              this.form.invoicetype != "CCF" &&
              this.form.invoicetype != "DNC" &&
              this.form.invoicetype != "DND"
            ) {
              if (this.noaddivainpos) {
                this.productsToShow[index].TmpItemNewPrice = parseFloat(
                  parseFloat(
                    (ItemOriginalPrice - ItemPriceDiscountAmount)
                  ).toFixed(8)
                );
              }
              else {
                if (this.ishosting && this.addimpturismo && this.productsToShow[index].TurismoPorAlojamiento) {
                  this.productsToShow[index].TmpItemNewPrice = parseFloat(
                    parseFloat(
                      (ItemOriginalPrice - ItemPriceDiscountAmount) / 1.18
                    ).toFixed(8)
                  );
                }
                else {
                  this.productsToShow[index].TmpItemNewPrice = parseFloat(
                    parseFloat(
                      (ItemOriginalPrice - ItemPriceDiscountAmount) / 1.13
                    ).toFixed(8)
                  );
                }
              }
              
              this.productsToShow[index].ItemNewPrice = parseFloat(
                parseFloat(ItemOriginalPrice - ItemPriceDiscountAmount).toFixed(
                  4
                )
              );
            } else {
              if (this.noaddivainpos) {
                this.productsToShow[index].TmpItemNewPrice = parseFloat(
                  parseFloat(
                    (ItemOriginalPrice - ItemPriceDiscountAmount)
                  ).toFixed(8)
                );
              }
              else {
                if (this.ishosting && this.addimpturismo && this.productsToShow[index].TurismoPorAlojamiento) {
                  this.productsToShow[index].TmpItemNewPrice = parseFloat(
                    parseFloat(
                      (ItemOriginalPrice - ItemPriceDiscountAmount) / 1.18
                    ).toFixed(8)
                  );
                }
                else {
                  this.productsToShow[index].TmpItemNewPrice = parseFloat(
                    parseFloat(
                      (ItemOriginalPrice - ItemPriceDiscountAmount) / 1.13
                    ).toFixed(8)
                  );
                }
              }
              
              this.productsToShow[index].ItemNewPrice = parseFloat(
                parseFloat(ItemOriginalPrice - ItemPriceDiscountAmount).toFixed(
                  4
                )
              );
            }
          } else {
            this.productsToShow[index].ItemNewPrice = ItemNewPrice;

            if (this.noaddivainpos) {
              this.productsToShow[index].TmpItemNewPrice = parseFloat(
                parseFloat(ItemOriginalPrice).toFixed(8)
              );
            }
            else {
              if (this.ishosting && this.addimpturismo && this.productsToShow[index].TurismoPorAlojamiento) {
                this.productsToShow[index].TmpItemNewPrice = parseFloat(
                  parseFloat(ItemOriginalPrice / 1.18).toFixed(8)
                );
              }
              else {
                this.productsToShow[index].TmpItemNewPrice = parseFloat(
                  parseFloat(ItemOriginalPrice / 1.13).toFixed(8)
                );
              }
              
            }
          }

          this.productsToShow[index].TmpCounter = 0;
        } else {
          if (this.stopCounterDynamicList < 3) {
            let params = {
              business:
                JSON.parse(localStorage.getItem("user")).businessid != undefined
                  ? JSON.parse(localStorage.getItem("user")).businessid
                  : 0,
              branch:
                JSON.parse(localStorage.getItem("user")).branch != undefined
                  ? JSON.parse(localStorage.getItem("user")).branch
                  : 0,
              PriceListName: this.priceListData.find( current => current.Active === 1 ).id,
            };
            const newResponseProducts = await this.$API.priceList.itemsFromList(params);
            const newResponseServices = await this.$API.services.getAllServicesWithPriceList( { ...this.filterServices, PriceListSelected: this.priceListData.find( current => current.Active === 1 ).id } );
            await this.dynamicPricelistBehavior( newResponseProducts, newResponseServices );
          }
        }
      }
    },
    async getAllPriceList() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const userPriceList = JSON.parse(localStorage.getItem("user")).userpricelist
        let response = [];
        if (this.$store.getters['rolesUser/getCustomRole']('admin')){
          response = await this.$API.priceList.priceListNoData()
        }else{
          response = await this.$API.priceList.priceListNotAdmin()
        }
        this.priceListData = response;
        let found = this.priceListData.find(
          (pl) =>
            pl.Active == true &&
            pl.ID_Branch == user?.branch
        );

        let foundBranchPriceList = this.priceListData.find(
          pl => 
            pl.id === JSON.parse(localStorage.getItem("branch")).BranchPrincipalPriceList
        );

        if (userPriceList != null && userPriceList != "") {
          this.PriceListSelected = userPriceList;
          this.defaultPriceList = this.PriceListSelected;
        }
        else if( foundBranchPriceList ) {
          this.PriceListSelected = foundBranchPriceList.id;
          this.defaultPriceList = this.PriceListSelected;
        } else {
          if (found) {
            this.PriceListSelected = found.id;
            this.defaultPriceList = this.PriceListSelected;
          } else {
            this.PriceListSelected = this.priceListData.find(
              (pl) => pl.id == "Precios por defecto"
            ).id;
            this.defaultPriceList = this.PriceListSelected;
          }
        }

        this.$store.commit("setChanguePriceList", false);
      } catch (error) {
        console.warn('getAllPriceList',error)
      }
    },
    getWarehouse() {
      let idbusiness =
        JSON.parse(localStorage.getItem("user")).businessid || "";
      let idbranch = JSON.parse(localStorage.getItem("user")).branch || "";
      this.filterWarehouses.branch = idbranch;
      this.filterWarehouses.business = idbusiness;
      
      this.$API.warehouse
        .getWarehouses({...this.filterWarehouses, notShowReserve: 1 })
        .then((response) => {
          this.warehouses = response;
          const found = this.warehouses.find(
            (wh) => wh.Active == true && wh.ID_Branch == idbranch
          );
          if (found) {
            if(this.billposwith1warehouse == 1 && this.productsToShow.length > 0)
            {
              //this.warehouseSelected = this.productsToShow[0]?.Warehouse;
              this.warehouseSelected =  this.productsToShow.find(i => i.Warehouse && i.Warehouse !== '')?.Warehouse;
              //console.log('// found', this.productsToShow);
              
            }
              else{
              this.warehouseSelected = found.ID_Warehouse;
            }
          } else {
            if(this.billposwith1warehouse == 1 && this.productsToShow.length > 0)
            {
              //this.warehouseSelected = this.productsToShow[0]?.Warehouse;
              this.warehouseSelected =  this.productsToShow.find(i => i.Warehouse && i.Warehouse !== '')?.Warehouse;
              
            }
            else
              this.warehouseSelected = this.warehouses[0].ID_Warehouse;
          }
          this.$store.commit("setChangueWarehouse", false);
        })
        .catch((error) => console.log(error));
    },
    acceptAlert() {
      this.alert.show = false;
      const alertOptions = this.alert.options;

      if( typeof alertOptions === 'string' && alertOptions.includes( 'sendbillAfterDateValidation' ) ) {
        this.alert.options = null;
        const [ , secondPart ] = alertOptions.split( '_' );

        const sendBillStatus = parseInt( secondPart );

        this.sendBill( sendBillStatus );
      }

      if (this.alert.options == "deleteoneproduct") {
        this.removeRow(this.confirmDelete);
      }
      if (this.alert.options == "showErrorDetails") {
        this.showDetailsMessages = true;
      }
    },
    async preloadCustomer() {
      await Object.keys(this.customer).map((el) => {
        Vue.set(
          this.form,
          el.replace("_", "").toLowerCase(),
          this.customer[el]
        );
      });

      this.isCustomerSelected = true;
      this.syncCustomerResponsible(this.customer);
    },
    getCurrentUserData() {
      try {
        return JSON.parse(localStorage.getItem("user")) || {};
      } catch (error) {
        console.log(error);
        return {};
      }
    },
    getUserOptionId(user = {}) {
      return user.ID_User || user.id || null;
    },
    getUserPlainName(user = {}) {
      const firstName = user.FirstName || user.firstname || "";
      const lastName = user.LastName || user.lastname || "";
      return `${firstName} ${lastName}`.trim();
    },
    getUserOptionName(user = {}) {
      const fullName = this.getUserPlainName(user);
      //const userName = user.UserName || user.username || user.userName || "";

      if (fullName) {
        return `${fullName}`;
      }

      return fullName || "";
    },
    getUserOptionDocument(user = {}) {
      return user.Dui || user.dui || user.DUI || "";
    },
    getUserOptionPhone(user = {}) {
      return (
        user.PhoneNumber ||
        user.phoneNumber ||
        user.phonenumber ||
        user.MobileNumber ||
        user.mobileNumber ||
        user.mobilenumber ||
        ""
      );
    },
    createDteResponsibleValue(source, id) {
      if (!id) {
        return null;
      }
      return `${source}:${id}`;
    },
    normalizeDteUserOption(user = {}) {
      const value = this.getUserOptionId(user);
      const label = this.getUserOptionName(user);
      const fullName = this.getUserPlainName(user) || (user.UserName || user.username || user.userName || "");

      return {
        ...user,
        value: this.createDteResponsibleValue("user", value),
        label: label || String(value || ""),
        fullName,
        document: this.getUserOptionDocument(user),
        phone: this.getUserOptionPhone(user),
      };
    },
    normalizeDteSellerOption(seller = {}) {
      const sellerId = seller.ID_Seller || seller.id || null;
      const firstName = seller.FirstName || seller.firstname || "";
      const lastName = seller.LastName || seller.lastname || "";
      const fullName =
        seller.FullName ||
        `${firstName} ${lastName}`.trim() ||
        sellerId ||
        "";

      return {
        ...seller,
        value: this.createDteResponsibleValue("seller", sellerId),
        label: fullName ? `${fullName} (Vendedor)` : `Vendedor ${sellerId || ""}`.trim(),
        fullName,
        document: seller.Dui || seller.dui || "",
        phone: seller.Mobile || seller.mobile || seller.EmergencyContactPhone || "",
      };
    },
    async getDteUsers() {
      const currentUser = this.getCurrentUserData();
      let users = [];
      let sellers = [];

      try {
        const [usersResponse, sellersResponse] = await Promise.all([
          this.$API.users.getUsersByBranch(),
          this.$API.sellers.getAllSellers(),
        ]);
        users = Array.isArray(usersResponse) ? usersResponse : [];
        sellers = Array.isArray(sellersResponse) ? sellersResponse : [];
      } catch (error) {
        console.log(error);
      }

      const normalizedUsers = users
        .map((user) => this.normalizeDteUserOption(user))
        .filter((user) => user.value);
      const normalizedSellers = sellers
        .map((seller) => this.normalizeDteSellerOption(seller))
        .filter((seller) => seller.value);

      const currentUserOption = this.normalizeDteUserOption(currentUser);

      if (
        currentUserOption.value &&
        !normalizedUsers.find((user) => user.value === currentUserOption.value)
      ) {
        normalizedUsers.unshift(currentUserOption);
      }

      this.dteUsers = [...normalizedUsers, ...normalizedSellers];

      const hasResponsibleSelectedFromForm =
        this.syncResponsibleDteUserSelectionFromForm();

      if (!hasResponsibleSelectedFromForm) {
        this.syncLoggedUserAsDteResponsible();
      }
    },
    syncResponsibleDteUserSelectionFromForm() {
      const extensionDoc = (this.form.extensiondocuentrega || "").trim();
      const extensionName = (this.form.extensionnombentrega || "").trim();

      const selectedUser = this.dteUsers.find((user) => {
        const userDocument = (user.document || "").trim();
        const userName = (user.fullName || "").trim();
        const userLabel = (user.label || "").trim();

        if (extensionDoc && userDocument && userDocument === extensionDoc) {
          return true;
        }

        if (extensionName && userName && userName === extensionName) {
          return true;
        }

        if (extensionName && userLabel && userLabel === extensionName) {
          return true;
        }

        return false;
      });

      this.responsableDteUserId = selectedUser?.value || null;
      return !!selectedUser;
    },
    syncLoggedUserAsDteResponsible() {
      const currentUser = this.getCurrentUserData();
      const currentUserId = this.getUserOptionId(currentUser);

      if (!currentUserId) {
        return;
      }

      const selectedUser =
        this.dteUsers.find(
          (user) => user.value === this.createDteResponsibleValue("user", currentUserId)
        ) ||
        this.normalizeDteUserOption(currentUser);

      this.responsableDteUserId = selectedUser.value;
      if (!this.form.extensionnombentrega) {
        this.form.extensionnombentrega = selectedUser.fullName || "";
      }
      if (!this.form.extensiondocuentrega) {
        this.form.extensiondocuentrega = selectedUser.document || "";
      }
      if (!this.form.extensiontelefonoentrega) {
        this.form.extensiontelefonoentrega = selectedUser.phone || "";
      }
    },
    handleDteResponsibleChange(userId) {
      const selectedUser = this.dteUsers.find((user) => user.value === userId);

      if (!selectedUser) {
        return;
      }

      this.form.extensionnombentrega = selectedUser.fullName || "";
      this.form.extensiondocuentrega = selectedUser.document || "";
      this.form.extensiontelefonoentrega = selectedUser.phone || "";
    },
    syncCustomerResponsible(customer = null, overwrite = true) {
      const customerData = customer || this.customerSelectedData || {};
      const businessName =
        customerData.BusinessName || customerData.businessname || "";
      const legalName =
        this.form.legalname || customerData.LegalName || customerData.legalname || "";
      const firstName = customerData.FirstName || customerData.firstname || "";
      const lastName = customerData.LastName || customerData.lastname || "";
      const fullName = `${firstName} ${lastName}`.trim();
      const receptorName = legalName || businessName || fullName || "";
      const receptorDocument =
        this.form.dui ||
        this.form.legalnit ||
        customerData.dui ||
        customerData.Dui ||
        customerData.LegalNIT ||
        customerData.legalnit ||
        "";
      const receptorPhone =
        this.form.phonenumber ||
        this.form.businesscontactphone ||
        this.form.businesscontactmobile ||
        this.form.businessphone ||
        this.form.mobilenumber ||
        customerData.PhoneNumber ||
        customerData.phoneNumber ||
        customerData.phonenumber ||
        customerData.BusinessContactPhone ||
        customerData.businesscontactphone ||
        customerData.BusinessContactMobile ||
        customerData.businesscontactmobile ||
        customerData.BusinessPhone ||
        customerData.businessphone ||
        customerData.MobileNumber ||
        customerData.mobileNumber ||
        customerData.mobilenumber ||
        "";

      if (overwrite || !this.form.extensionnombrecibe) {
        this.form.extensionnombrecibe = receptorName;
      }
      if (overwrite || !this.form.extensiondocurecibe) {
        this.form.extensiondocurecibe = receptorDocument;
      }
      if (overwrite || !this.form.extensiontelefonorecibe) {
        this.form.extensiontelefonorecibe = receptorPhone;
      }
    },
    resetInvoiceExtensionData() {
      this.form.extensionnombentrega = "";
      this.form.extensiondocuentrega = "";
      this.form.extensiontelefonoentrega = "";
      this.form.extensionnombrecibe = "";
      this.form.extensiondocurecibe = "";
      this.form.extensiontelefonorecibe = "";
      this.syncLoggedUserAsDteResponsible();
    },

    resetInvoiceApendiceData() {
      this.showApendice = false;
      this.apendiceEnabled = false;
      this.apendiceAddOrderLabel = false;
      this.apendiceRows = [];
      this.form.apendice = null;
      if (this.$refs.apendiceForm) {
        this.$refs.apendiceForm.resetValidation();
      }
    },

    createApendiceRow(data = {}) {
      return {
        _rowId: generateUUID(),
        campo: data.campo || "",
        etiqueta: data.etiqueta || "",
        valor: data.valor || "",
      };
    },

    normalizeApendiceSource(apendice = null) {
      if (!apendice) {
        return [];
      }

      let source = apendice;
      if (typeof source === "string") {
        try {
          source = JSON.parse(source);
        } catch (error) {
          return [];
        }
      }

      const rows = Array.isArray(source)
        ? source
        : Array.isArray(source?.items)
        ? source.items
        : [];

      return rows.slice(0, 10).map((row) => this.createApendiceRow(row));
    },

    syncApendiceStateFromForm(apendice = null) {
      const normalizedRows = this.normalizeApendiceSource(apendice);
      this.apendiceRows = normalizedRows;
      this.syncApendiceFormValue();
    },

    syncApendiceFormValue() {
      if (!this.apendiceRows.length) {
        this.form.apendice = null;
        if (this.invoiceAutoSave) {
          this.updateTempInvoiceField();
        }
        return;
      }

      this.form.apendice = this.apendiceRows.map((row) => ({
        campo: row.campo,
        etiqueta: row.etiqueta,
        valor: row.valor,
      }));

      if (this.invoiceAutoSave) {
        this.updateTempInvoiceField();
      }
    },

    openApendiceDialog() {
      if (!this.apendiceRows.length && this.form.apendice) {
        this.syncApendiceStateFromForm(this.form.apendice);
      }

      this.showApendice = true;
    },

    closeApendiceDialog() {
      this.syncApendiceFormValue();
      this.showApendice = false;
    },

    ensureApendiceMinimumRow() {
      if (this.apendiceRows.length === 0) {
        this.apendiceRows.push(this.createApendiceRow());
      }
    },

    applyApendiceOrderLabelToFirstRow() {
      if (!this.apendiceRows.length) {
        return;
      }

      const firstRow = this.apendiceRows[0];
      firstRow.campo = "OrdenCompra";
      firstRow.etiqueta = "Numero de orden de compra";
    },

    handleApendiceEnabledChange(value) {
      this.apendiceEnabled = Boolean(value);

      if (this.apendiceEnabled) {
        this.ensureApendiceMinimumRow();
        if (this.apendiceAddOrderLabel) {
          this.applyApendiceOrderLabelToFirstRow();
        }
      } else {
        this.apendiceAddOrderLabel = false;
      }

      this.syncApendiceFormValue();
      if (this.$refs.apendiceForm) {
        this.$refs.apendiceForm.resetValidation();
      }
    },

    handleApendiceOrderLabelChange(value) {
      this.apendiceAddOrderLabel = Boolean(value);

      if (this.apendiceAddOrderLabel) {
        this.ensureApendiceMinimumRow();
        this.applyApendiceOrderLabelToFirstRow();
      }

      this.syncApendiceFormValue();
    },

    addApendiceRow() {
      if (this.apendiceRows.length >= 10) {
        return;
      }

      this.apendiceRows.push(this.createApendiceRow());
      this.syncApendiceFormValue();
    },

    removeApendiceRow(row) {
      const rowIndex = this.apendiceRows.indexOf(row);
      if (rowIndex === -1) {
        return;
      }

      this.apendiceRows.splice(rowIndex, 1);

      this.syncApendiceFormValue();
    },

    onApendiceCampoChange(row, value) {
      const campo = typeof value === "object" && value !== null
        ? value.value || value.text || row?.campo
        : value || row?.campo;

      if (campo === "OrdenCompra") {
        row.etiqueta = "Numero de orden de compra";
      }

      this.syncApendiceFormValue();
    },

    validateApendiceData() {
      if (!this.apendiceRows.length) {
        this.form.apendice = null;
        return true;
      }

      this.syncApendiceFormValue();

      if (!Array.isArray(this.form.apendice) || this.form.apendice.length < 1) {
        this.showAlert(
          "warning",
          "Advertencia",
          "El apéndice debe contener al menos un registro."
        );
        return false;
      }

      if (this.form.apendice.length > 10) {
        this.showAlert(
          "warning",
          "Advertencia",
          "El apéndice no puede contener más de 10 registros."
        );
        return false;
      }

      const hasInvalidRow = this.form.apendice.some((row) => {
        const campo = String(row?.campo || "").trim();
        const etiqueta = String(row?.etiqueta || "").trim();
        const valor = String(row?.valor || "").trim();

        return (
          campo.length < 2 ||
          campo.length > 25 ||
          etiqueta.length < 3 ||
          etiqueta.length > 50 ||
          valor.length < 1 ||
          valor.length > 150
        );
      });

      if (hasInvalidRow) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Revise el apéndice. Cada registro debe cumplir con las longitudes mínimas y máximas."
        );
        return false;
      }

      if (this.$refs.apendiceForm && !this.$refs.apendiceForm.validate()) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Revise los campos del apéndice antes de continuar."
        );
        return false;
      }

      return true;
    },

    async shouldUseNativeDteTemplateForCurrentBranch() {
      const branchData = this.datatoprint && this.datatoprint.branch
        ? this.datatoprint.branch
        : JSON.parse(localStorage.getItem("branch")) || {};
      const resolved = await resolveBranchConfiguredDteTemplate(this.$API, branchData);
      return Boolean(resolved.eligible);
    },

    async imprimirFacturaDirecta(){
      // imprimirFactura(this.invoice.ID_Invoice);

      this.loading = true;
      try {
        await imprimirFactura(this.datatoprint.header.ID_Invoice, this);
      } catch (error) {
        console.error('Error al imprimir factura:', error);
        this.showAlert(
          "danger",
          "Error",
          "Ha ocurrido un error al imprimir la factura"
        );
      } finally {
        this.loading = false;
      }
      
    },
    isEnabledFlag(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    isTicketDirectPrintingEnabled(invoiceType) {
      return this.isEnabledFlag(this.ticketdirectprinting) && (invoiceType == 'FCF' || invoiceType == 'CCF' || invoiceType == 'TCKS');
    },
    shouldSkipExtraPrintWindowAfterDirectTicket(invoiceType) {
      if (invoiceType === "FCF") {
        return this.isEnabledFlag(this.ticketdirectnowinfcf);
      }

      if (invoiceType === "CCF") {
        return this.isEnabledFlag(this.ticketdirectnowinccf);
      }

      return true;
    },
    canUseFcfCcfTicketFormat(invoiceType) {
      const user = JSON.parse(localStorage.getItem("user"));
      return (
        user.ticketformatfcf &&
        user.TipoPlan != "Ecoanual" &&
        (invoiceType === "FCF" || invoiceType === "CCF")
      );
    },
    async openCreatedInvoicePrintComponent(invoiceType) {
      const printData = {
        ...this.datatoprint,
        invoicePayments: Array.isArray(this.datatoprint.invoicePayments)
          ? this.datatoprint.invoicePayments.map((payment) => ({ ...payment }))
          : [],
      };
      const shouldUseNativeDteTemplate =
        invoiceType != "TCKS" &&
        await this.shouldUseNativeDteTemplateForCurrentBranch();

      if (shouldUseNativeDteTemplate) {
        this.printLetter = {
          show: true,
          data: printData,
        };
        return;
      }

      if (this.canUseFcfCcfTicketFormat(invoiceType)) {
        this.print3 = {
          show: true,
          data: printData,
        };
        this.print = {
          show: true,
          data: printData,
        };
        return;
      }

      if (invoiceType === "TCKS") {
        this.print2 = {
          show: true,
          data: printData,
        };
        return;
      }

      this.print = {
        show: true,
        data: printData,
      };
    },

    async closeAlert() {
      this.alert.show = false;

      if (this.alert.options == "deleteoneproduct") {
        this.confirmDelete = null;
      }

      if (this.alert.options == "update") {
        this.clearForm();
        this.$store.commit("posData/changeView", "tab-3");
        this.$store.commit("posData/setReloaders", "reloadBill");
        this.$store.commit("posData/setReloaders", "reloadHistory");
        this.$store.commit("posData/setReloaders", "reloadTemplateBill");
        this.$store.commit("posData/setReloaders", "reloadQuotesBill");
        this.$store.commit("posData/setReloaders", "reloadFinanceBill");
      }

      if (this.alert.options == "updateTemplate") {
        this.clearForm();
        this.$store.commit("posData/changeView", "tab-4");
        this.$store.commit("posData/setReloaders", "reloadBill");
        this.$store.commit("posData/setReloaders", "reloadHistory");
        this.$store.commit("posData/setReloaders", "reloadTemplateBill");
        this.$store.commit("posData/setReloaders", "reloadQuotesBill");
        this.$store.commit("posData/setReloaders", "reloadFinanceBill");
      }

      if (this.alert.options == "updateQuote") {
        this.clearForm();
        this.$store.commit("posData/changeView", "tab-5");
        this.$store.commit("posData/setReloaders", "reloadBill");
        this.$store.commit("posData/setReloaders", "reloadHistory");
        this.$store.commit("posData/setReloaders", "reloadTemplateBill");
        this.$store.commit("posData/setReloaders", "reloadQuotesBill");
        this.$store.commit("posData/setReloaders", "reloadFinanceBill");
      }

      if (this.alert.options == "updateFinance") {
        this.clearForm();
        this.$store.commit("posData/changeView", "tab-7");
        this.$store.commit("posData/setReloaders", "reloadBill");
        this.$store.commit("posData/setReloaders", "reloadHistory");
        this.$store.commit("posData/setReloaders", "reloadTemplateBill");
        this.$store.commit("posData/setReloaders", "reloadQuotesBill");
        this.$store.commit("posData/setReloaders", "reloadFinanceBill");
      }

      if (this.alert.options == "updateFinish") {
        this.clearForm();
        this.$store.commit("posData/changeView", "tab-2");
        this.$store.commit("posData/setReloaders", "reloadBill");
        this.$store.commit("posData/setReloaders", "reloadHistory");
        this.$store.commit("posData/setReloaders", "reloadTemplateBill");
        this.$store.commit("posData/setReloaders", "reloadQuotesBill");
        this.$store.commit("posData/setReloaders", "reloadFinanceBill");
      }
      if (this.datatoprint.header) {
        this.datatoprint.header.customerInfo = this.customerSelectedData;
      }
      if (this.alert.options == "updateFinishAndPrintInvoice") {
        const invoiceType = this.form.invoicetype;
        this.datatoprint.invoicePayments = this.pospayments ? this.paymentsData : [];

        try {
          if (this.isTicketDirectPrintingEnabled(invoiceType)) {
            if (!this.shouldSkipExtraPrintWindowAfterDirectTicket(invoiceType)) {
              await this.openCreatedInvoicePrintComponent(invoiceType);
              await this.$nextTick();
            }
            await this.imprimirFacturaDirecta();
          } else {
            await this.openCreatedInvoicePrintComponent(invoiceType);
          }
        } catch (error) {
          console.error("La factura fue procesada, pero no se pudo abrir la impresión:", error);
          this.showAlert(
            "warning",
            "Factura procesada",
            "La factura fue procesada correctamente, pero no se pudo abrir la impresión. No vuelva a facturarla; puede imprimirla desde el historial."
          );
        } finally {
          try {
            await this.clearFormForPrinting();
          } catch (clearError) {
            console.error("No se pudo limpiar el formulario después de procesar la factura:", clearError);
          } finally {
            this.releaseInvoiceSubmissionLock();
          }
        }

        return;
      }

      if (this.alert.options == "showErrorDetails") {
        this.clearForm();
        this.$store.commit("posData/setReloaders", "reloadBill");
        this.$store.commit("posData/setReloaders", "reloadHistory");
        this.$store.commit("posData/setReloaders", "reloadTemplateBill");
        this.$store.commit("posData/setReloaders", "reloadQuotesBill");
        this.$store.commit("posData/setReloaders", "reloadFinanceBill");
      }

      if (this.alert.options == "cancelTimesExecute") {
        this.cancelTimesExecute = true;
      }

      if (this.alert.options == "refreshDteRechazado") {

        if (this.tmpResponseRechazado.ID_Invoice && (this.tmpResponseRechazado.estado == "RECHAZADO" || this.tmpResponseRechazado.estado == "FIRMADOR")) {
          this.loading = true
          let tmpInvoice = await this.$API.invoices.getInvoice(this.tmpResponseRechazado.ID_Invoice)
          let tmpItems = await this.$API.invoices.getAllInvoiceItems(this.tmpResponseRechazado.ID_Invoice)
          this.$store.commit("posData/setHeader", tmpInvoice);
          this.$store.commit("posData/setBody", tmpItems);
          this.$store.commit("posData/setCopy", null)
          this.$store.commit("posData/setContingency", {
            CodigoGeneracion: null,
            NumeroControl: null,
          });
          this.$store.commit("posData/setInvalid", null);
          this.$store.commit("posData/setQuote", null);

          if( this.ndornc) {
            this.$store.commit("posData/setNDorNC", this.ndornc );
          } else {
            this.$store.commit("posData/setNDorNC", null);
          }

          this.$store.commit("posData/setForceBlocking", null);

          this.$store.commit("posData/setReloaders", "reloadCreate");
        }
      }

      this.releaseInvoiceSubmissionLock();
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    getInvoiceId() {
      let sptype = "GETCORRELATIVE";

      return new Observable((observer) => {
        this.$API.invoices
          .getInvoiceID({
            sptype: sptype,
            invoicetype: this.form.invoicetype,
            business: this.business,
            branch: this.branch,
          })
          .then((data) => {
            this.form.legalidinvoice = data.id;
            this.form.idinvoice = data.ID_Invoice;
            observer.next(data.id);
            observer.complete();
          })
          .catch((data) => {
            this.form.legalidinvoice = "No hay correlativo";
            this.form.idinvoice = data.ID_Invoice;
          });
      });
    },
    clearForm() {
      this.invoiceAttemptKey = null;
      this.invoiceAttemptUncertain = false;
      this.$store.commit("posData/setHeader", null);
      this.$store.commit("posData/setBody", null);
      this.$store.commit("posData/setCustomer", null);
      this.$store.commit("posData/setInvalid", null);
      this.$store.commit("posData/setNDorNC", null);
      this.$store.commit("posData/setQuote", null);
      this.$store.commit("posData/setContingency", null);
      this.$store.commit("posData/setCopy", null);
      this.$store.commit("posData/setForceBlocking", null);
      this.$store.commit("posData/setReloaders", "reloadCreate");
      this.resetAppliedGlobalDiscount();
      this.resetGlobalDiscountModal();
      this.copiedPaymentsInitialized = false;
      this.resetInvoiceExtensionData();
      this.resetInvoiceApendiceData();
      this.getOrCreateTempInvoice();
    },
    async clearFormForPrinting() {
      this.$store.commit("posData/setHeader", null);
      this.$store.commit("posData/setBody", null);
      this.$store.commit("posData/setCustomer", null);
      this.$store.commit("posData/setInvalid", null);
      this.$store.commit("posData/setNDorNC", null);
      this.$store.commit("posData/setQuote", null);
      this.$store.commit("posData/setContingency", null);
      this.$store.commit("posData/setCopy", null);
      this.$store.commit("posData/setForceBlocking", null);

      this.workingIn = "";
      this.resetAppliedGlobalDiscount();
      this.resetGlobalDiscountModal();
      this.copiedPaymentsInitialized = false;
      this.resetInvoiceApendiceData();
      
      /*await this.$API.customerAdvancePayment.findAdvancePaymentByCustomerForPos({ ID_Customer: this.form.idcustomer })
        .then((response) => {
          this.advancePayments = response.data
      })*/

      this.tempId = ''
      
      const newForm = {
        invoicedate: this.form.invoicedate,
        invoicetype: this.form.invoicetype,
        rulestoshowcomments: 0,
        idinvoice: "",
        legalidinvoice: "No hay correlativo",
        legalisnontaxable: 0,
        legalisnonsuj: 0,
        istemplate: 0,
        isquote: 0,
        timesexecute: 0,
        idbusiness: JSON.parse(localStorage.getItem("user")).branch,
        idbranch: JSON.parse(localStorage.getItem("user")).businessid,
        flete: 0,
        seguro: 0,
        invoiceinternalnote: "",
        isfinance: 0,
        codasociado: null,
        docasociado: "",
        detalleasociado: "",
        extensionnombentrega: "",
        extensiondocuentrega: "",
        extensiontelefonoentrega: "",
        extensionnombrecibe: "",
        extensiondocurecibe: "",
        extensiontelefonorecibe: "",
        showresponsabilitiesininvoice: 0,
        apendice: null,
      };

      this.productsToShow = [];
      this.BccEmails = [];

      await this.getPaymentTypesValues()

      this.sumPayments = 0.0;

      this.branch = JSON.parse(localStorage.getItem("user")).branch;
      this.business = JSON.parse(localStorage.getItem("user")).businessid;
      this.search.branch = this.branch;
      this.search.business = this.business;
      this.getInfoBranch();
      newForm.idbusiness = this.business;
      newForm.idbranch = this.branch;
      //this.$refs.posForm.$children[1].reset();
      //this.$refs.posForm.$children[2].reset();

      this.form = { ...newForm };
      this.resetInvoiceExtensionData();
      this.resetInvoiceApendiceData();

      //this.getInvoiceId().subscribe();

      //this.form.invoicetype = "FCF";

      this.productcode = "";

      delete this.form.invoicepaymenttype;
      delete this.form.invoicestatusdescription;
      this.isCustomerSelected = false;

      this.getOrCreateTempInvoice();
    },
    async getProducts(limit = 100) {
      let idsArray = null;
      let idsWarehouse = null;
      let idsBatch = null;
      let isBatchNull = false;
      //Fetereria La bendicion
      const keymaster = JSON.parse(localStorage.getItem("user")).keymaster;
      if(["8ef25daf48ea91f34aeaabbe9eb5b0d2"].includes(keymaster)){
        this.filterProducts.pricelist = this.PriceListSelected
      }
      this.filterProducts.limit = limit;
      if (this.header && this.body && this.stopIn == false) {
        this.filterProducts.pricelist = this.PriceListSelected
        this.filterProducts.id_invoice = this.header.ID_Invoice
        let i = 0;
        for (let item of this.body) {
          if (i == 0) {
            idsArray = `'${item.ID_Item}'`;
            idsWarehouse = `'${item.Warehouse}'`;

            if (item.ID_ItemBatch == "" || item.ID_ItemBatch == null) {
              isBatchNull = true;
            } else {
              idsBatch = `'${item.ID_ItemBatch}'`;
            }
          } else {
            idsArray = idsArray + `,'${item.ID_Item}'`;
            idsWarehouse = idsWarehouse + `,'${item.Warehouse}'`;

            if (item.ID_ItemBatch == "" || item.ID_ItemBatch == null) {
              isBatchNull = true;
            } else {
              idsBatch = idsBatch + `,'${item.ID_ItemBatch}'`;
            }
          }

          i++;
        }
      }
      this.filterProducts.idsArray = idsArray;
      this.filterProducts.idsWarehouse = idsWarehouse;
      this.filterProducts.idsBatch = idsBatch;
      this.filterProducts.isBatchNull = isBatchNull;
      const response = await this.$API.products.getProductsToBillForInvoice(
        this.filterProducts
      );
      this.productsToBillSearchTab = response;
      if (this.warehouseSelected) {
        const filteredProducts = this.productsToBillSearchTab.filter(
          (element) => element.Warehouse === this.warehouseSelected
        ) ?? [];
        this.ProductServList = [];
        filteredProducts.forEach((element) => {
          this.ProductServList.push({
            ID: `${element.ItemName}${
              element.ItemComercialName ? " | " + element.ItemComercialName : ""
            }`,
            val: element.ID_Item,
            prod: { ...element, type: "product" },
          });
        });
        this.assignedList.prod = true;
      } else {
        this.ProductServList = []
        this.productsToBillSearchTab.forEach((element) => {
          this.ProductServList.push({
            ID: `${element.ItemName}${
              element.ItemComercialName ? " | " + element.ItemComercialName : ""
            }`,
            val: element.ID_Item,
            prod: { ...element, type: "product" },
          });
        });
        this.assignedList.prod = true;
      }

      this.productsToBillDefault = response;
      this.productsToBill = response;
      this.productsToBillForSelector = response;
      this.productToBillPrev = response;
      //this.reactiveMainProductsFilter();
    },
    getProductsOnFilter() {
      if (this.hasProductsClassificationFilters()) {
        this.applyProductsClassificationFilter();
        return;
      }

      this.loadDefaultProductsOnFilter();
    },
    loadDefaultProductsOnFilter() {
      this.$API.products
        .getProductsToBillForInvoice(this.filterProducts)
        .then((response) => {
          this.productsToBillDefault = [...response];
          this.productsToBill = response;
          this.productToBillPrev = response;
          this.loadpriceProductsOnFilter();
        });
    },
    getServicesOnFilter() {
      if (this.hasServicesClassificationFilters()) {
        this.applyServicesClassificationFilter();
        return;
      }

      this.loadDefaultServicesOnFilter();
    },
    loadDefaultServicesOnFilter() {
      this.$API.services
        .getAllServicesWithPriceList(this.filterServices)
        .then((response) => {
          this.servicesToBill = response;
        });
    },
    async getServices(limit = 100) {
      try {
        let idsArray = null;
        if (this.header && this.body && this.stopIn == false) {
          let i = 0;
          for (let item of this.body) {
            if (i == 0) {
              idsArray = `'${item.ID_Item}'`;
            } else {
              idsArray = idsArray + `,'${item.ID_Item}'`;
            }

            i++;
          }
        }

        this.filterServices.idsArray = idsArray;
        //Fetereria La bendicion
        const keymaster = JSON.parse(localStorage.getItem("user")).keymaster;
        if(["8ef25daf48ea91f34aeaabbe9eb5b0d2"].includes(keymaster)){
          this.filterProducts.pricelist = this.PriceListSelected
        }
        this.filterServices.limit = limit;
        const response = await this.$API.services.getAllServicesWithPriceList(
          this.filterServices
        );
        this.servicesToBill = response;
        this.servicesToBillForSelector = response;
        this.servicesToBillSearchTab = response;
        if (this.servicesToBillSearchTab.length > 0) {
          this.servicesToBillSearchTab.forEach((element) => {
            this.ProductServList.push({
              ID:
                element.NameService +
                (element.Name ? " | " + element.Name : ""),
              val: element.CodeService,
              prod: { ...element, type: "service" },
            });
          });
          this.assignedList.serv = true;
        }
      } catch (error) {
        this.assignedList.serv = true;
      }
    },

    onEditorChange(e) {
      this.form.invoiceinternalnote = e.html;
      if (this.form.invoiceinternalnote != "") {
        this.showBgcolorNotes = "tabsContent";
      } else if (
        this.form.invoiceinternalnote == "" ||
        this.form.invoiceinternalnote == "<p><br></p>"
      ) {
        this.showBgcolorNotes = "tabs";
      } else {
        this.showBgcolorNotes = "tabs";
      }

      if (this.invoiceAutoSave) {
        this.updateTempInvoiceField()
      }
    },
    async showProduct(data, updateTempData = false, addByException = false) {
      let productData = null;

      if (this.BlockInvoice && !addByException && this.ndornc == null) {
        this.showProductsAndServices = !this.showProductsAndServices;
        this.showAlert(
          "danger",
          "Advertencia",
          "Los productos de facturas previamente rechazadas por hacienda o en estado de contingencia no pueden ser modificadas."
        );
        return;
      }

      if (this.isCustomerSelected) {
        if (
          !this.productsToShow.find(
            (i) =>
              i.ID_Item == data.ID_Item &&
              this.allowRepetitionOfArticles == false
          )
        ) {
          const qtyToAdd =
            this.POSProductsAlternativeBehavior && data?.qty && data?.qty > 0
              ? parseFloat(data.qty)
              : 1;
          if (data.ItemCurrentQuantity > 0 || this.EnableNegativeItem == 1  || this.notQuantity) {
            const uuid = generateUUID();

            let CustomName = data.ItemComercialName || data.ItemName

            if (this.addwarehouseofprodinbill) {
              let initialsWarehoue = this.getInitials(data.NameWarehouse)
              CustomName += " (" + initialsWarehoue + ")"
            }
            
            if (this.ShowBatchInfoPos) {
              let expiration = data.ExpirationDate || ""
              if (data.ID_ItemBatch) {
                CustomName +=" - Lote: " + data.ID_ItemBatch
              }
              if (expiration) {
                CustomName +=" - Fecha de expiración: " + expiration
              }
            }

            let unitCost = 0
            if (this.showunitcostinpos) {
              unitCost = await this.getItemCostByIdProduct(data.ID_Item)
            }

            productData = {
              ...data,
              ItemName: CustomName,
              qty: qtyToAdd,
              type: "product",
              ...this.getCatalogTaxFlags(data, "product"),
              TmpItemNewPrice: (
                this.noaddivainpos 
                  ? parseFloat(parseFloat(data.ItemOriginalPrice).toFixed(8)) 
                  : (
                    (this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento)
                    ? parseFloat(parseFloat(data.ItemOriginalPrice / 1.18).toFixed(8)) 
                    : parseFloat(parseFloat(data.ItemOriginalPrice / 1.13).toFixed(8)) 
                  )
              ),
              TmpCounter: 0,
              uuid: uuid,
              Pk_billing_invoices_details: data.Pk_billing_invoices_details,
              ItemCurrentQuantity: data.ItemCurrentQuantity,
              ItemComments: '',
              UnitCost: unitCost || 0
            }

            this.productsToShow.push(productData);
            
            var foundProduct = null

            if (this.body) {
              foundProduct = this.body.find(
                item => item.Pk_billing_invoices_details === data.Pk_billing_invoices_details
              )
            }
            
            if (!foundProduct) {
              const result = await this.$API.priceList.getTieredDiscountByProduct({
                ID_Item: data.ID_Item,
                PriceListName: data.PriceListName || this.PriceListSelected,
                value: qtyToAdd,
              });

              const indexOf =  this.productsToShow.findIndex( current => current.uuid === uuid );
              
              if (result.length > 0) {
                if( indexOf != -1 ) {
                  this.productsToShow[indexOf].ItemOriginalPrice = result[ 0 ].ItemOriginalPrice;
                  this.productsToShow[indexOf].ItemNewPrice = result[ 0 ].ItemOriginalPrice;
                  this.productsToShow[indexOf].TmpItemNewPrice = result[ 0 ].ItemOriginalPrice;
                  this.productsToShow[indexOf].ItemPriceDiscountAmount =
                    result[0].ItemPriceDiscountAmount;
                  this.productsToShow[indexOf].ItemPriceDiscountPercent =
                    result[0].ItemPriceDiscountPercent;
                  this.discountObject = this.productsToShow[indexOf];
                  this.calculateItemNewPrice3(this.productsToShow[indexOf]);
                }
              }
            }

          } else {
            if (this.showProductsAndServices) {
              this.showProductsAndServices = !this.showProductsAndServices;
            }
            if (this.form.invoicetype == "DNC" || this.form.invoicetype == "FNS" || this.header?.StockProductsInReserve || addByException) {
              const uuid = generateUUID();
              
              let CustomName = data.ItemComercialName || data.ItemName

              if (this.addwarehouseofprodinbill) {
                let initialsWarehoue = this.getInitials(data.NameWarehouse)
                CustomName += " (" + initialsWarehoue + ")"
              }

              if (this.ShowBatchInfoPos) {
                let expiration = data.ExpirationDate || ""
                if (data.ID_ItemBatch) {
                  CustomName +=" - Lote: " + data.ID_ItemBatch
                }
                if (expiration) {
                  CustomName +=" - Fecha de expiración: " + expiration
                }
              }

              let unitCost = 0
              if (this.showunitcostinpos) {
                unitCost = await this.getItemCostByIdProduct(data.ID_Item)
              }

              productData = {
                ...data,
                ItemName: CustomName,
                qty: qtyToAdd,
                type: "product",
                ...this.getCatalogTaxFlags(data, "product"),
                TmpItemNewPrice: (
                  this.noaddivainpos 
                  ? parseFloat(parseFloat(data.ItemOriginalPrice).toFixed(8)) 
                  : (
                    (this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento)
                    ? parseFloat(parseFloat(data.ItemOriginalPrice / 1.18).toFixed(8)) 
                    : parseFloat(parseFloat(data.ItemOriginalPrice / 1.13).toFixed(8)) 
                  )
                ),
                TmpCounter: 0,
                uuid: uuid,
                Pk_billing_invoices_details: data.Pk_billing_invoices_details,
                ItemCurrentQuantity: data.ItemCurrentQuantity,
                ErrorRow: addByException,
                ItemComments: '',
                UnitCost: unitCost || 0
              };

              this.productsToShow.push(productData);
            } else {
              //alert(JSON.stringify(data))
              this.showAlert(
                "danger",
                "Advertencia",
                "No hay unidades disponibles de este producto"
              );
            }
          }
        }
      } else {
        this.showProductsAndServices = !this.showProductsAndServices;
        this.showAlert(
          "danger",
          "Advertencia",
          "Debe seleccionar un cliente para agregar productos"
        );
      }
      if (updateTempData && productData) {
        this.updateTempDetails(productData.uuid, false);
      }
    },
    async showProductFromSelector(data, updateTempData = false) {
      let productData = null;

      if (this.isCustomerSelected) {
        if (
          !this.productsToShow.find(
            (i) =>
              i.ID_Item == data.ID_Item &&
              this.allowRepetitionOfArticles == false
          )
        ) {
          if (data.ItemCurrentQuantity > 0 || this.EnableNegativeItem == 1 || this.notQuantity) {
            const uuid = generateUUID();

            let CustomName = data.ItemComercialName || data.ItemName

            if (this.addwarehouseofprodinbill) {
              let initialsWarehoue = this.getInitials(data.NameWarehouse)
              CustomName += " (" + initialsWarehoue + ")"
            }

            if (this.ShowBatchInfoPos) {
              let expiration = data.ExpirationDate || ""
              if (data.ID_ItemBatch) {
                CustomName +=" - Lote: " + data.ID_ItemBatch
              }
              if (expiration) {
                CustomName +=" - Fecha de expiración: " + expiration
              }
            }

            let unitCost = 0
            if (this.showunitcostinpos) {
              unitCost = await this.getItemCostByIdProduct(data.ID_Item)
            }

            productData = {
              ...data,
              ItemName: CustomName,
              type: "product",
              ...this.getCatalogTaxFlags(data, "product"),
              TmpItemNewPrice: (
                this.noaddivainpos 
                ? parseFloat(parseFloat(data.ItemOriginalPrice).toFixed(8)) 
                : (
                  (this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento)
                  ? parseFloat(parseFloat(data.ItemOriginalPrice / 1.18).toFixed(8)) 
                  : parseFloat(parseFloat(data.ItemOriginalPrice / 1.13).toFixed(8)) 
                )
              ),
              TmpCounter: 0,
              uuid: uuid,
              Pk_billing_invoices_details: data.Pk_billing_invoices_details,
              ItemCurrentQuantity: data.ItemCurrentQuantity,
              ItemComments: '',
              UnitCost: unitCost || 0
            };

            this.productsToShow.push(productData);
          } else {
            if (this.showProductsAndServices) {
              this.showProductsAndServices = !this.showProductsAndServices;
            }

            this.showAlert(
              "danger",
              "Advertencia",
              "No hay unidades disponibles de este producto"
            );
          }
        }
      } else {
        this.showProductsAndServices = !this.showProductsAndServices;
        this.showAlert(
          "danger",
          "Advertencia",
          "Debe seleccionar un cliente para agregar productos"
        );
      }

      if (updateTempData && productData) {
        this.updateTempDetails(productData.uuid, false);
      }
    },
    async showProductBarCode(data, updateTempData = false) {
      const { PrincipalBarCodeValue } = data;

      let productData = null;

      if (this.isCustomerSelected) {
        if (
          !this.productsToShow.find((i) => {
            return (
              i.ID_Item == data.ID_Item &&
              this.allowRepetitionOfArticles == false
            );
          })
        ) {
          if (data.ItemCurrentQuantity > 0 || this.EnableNegativeItem == 1 || this.notQuantity) {
            const uuid = generateUUID();
            
            let CustomName = data.ItemComercialName || data.ItemName

            if (this.addwarehouseofprodinbill) {
              let initialsWarehoue = this.getInitials(data.NameWarehouse)
              CustomName += " (" + initialsWarehoue + ")"
            }

            if (this.ShowBatchInfoPos) {
              let expiration = data.ExpirationDate || ""
              if (data.ID_ItemBatch) {
                CustomName +=" - Lote: " + data.ID_ItemBatch
              }
              if (expiration) {
                CustomName +=" - Fecha de expiración: " + expiration
              }
            }

            let unitCost = 0
            if (this.showunitcostinpos) {
              unitCost = await this.getItemCostByIdProduct(data.ID_Item)
            }

            productData ={
              ...data,
              BarCode:
                PrincipalBarCodeValue || PrincipalBarCodeValue?.length > 0
                  ? PrincipalBarCodeValue
                  : null,
              ItemName: CustomName,
              qty: 1,
              type: "product",
              ...this.getCatalogTaxFlags(data, "product"),
              TmpItemNewPrice: (
                this.noaddivainpos 
                ? parseFloat(parseFloat(data.ItemOriginalPrice).toFixed(8)) 
                : (
                  (this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento)
                  ? parseFloat(parseFloat(data.ItemOriginalPrice / 1.18).toFixed(8)) 
                  : parseFloat(parseFloat(data.ItemOriginalPrice / 1.13).toFixed(8)) 
                )
              ),
              TmpCounter: 0,
              uuid: uuid,
              Pk_billing_invoices_details: data.Pk_billing_invoices_details,
              ItemCurrentQuantity: data.ItemCurrentQuantity,
              ItemComments: '',
              UnitCost: unitCost || 0,
            }

            this.productsToShow.push(productData);
          } else {
            if (this.showProductsAndServices) {
              this.showProductsAndServices = !this.showProductsAndServices;
            }

            this.showAlert(
              "danger",
              "Advertencia",
              "No hay unidades disponibles de este producto"
            );
          }
        } else {
          for (const indexOf in this.productsToShow) {
            const { ID_Item } = this.productsToShow[indexOf];

            if (ID_Item == data.ID_Item) {
              this.productsToShow[indexOf].qty++;

              const result = await this.$API.priceList.getTieredDiscountByProduct({
                ID_Item: data.ID_Item,
                PriceListName: data.PriceListName || this.PriceListSelected,
                value: this.productsToShow[indexOf].qty,
              });

              if (result.length > 0) {
                if( indexOf != -1 ) {
                  this.productsToShow[indexOf].ItemOriginalPrice = result[ 0 ].ItemOriginalPrice;
                  this.productsToShow[indexOf].ItemNewPrice = result[ 0 ].ItemOriginalPrice;
                  this.productsToShow[indexOf].TmpItemNewPrice = result[ 0 ].ItemOriginalPrice;
                  this.productsToShow[indexOf].ItemPriceDiscountAmount =
                    result[0].ItemPriceDiscountAmount;
                  this.productsToShow[indexOf].ItemPriceDiscountPercent =
                    result[0].ItemPriceDiscountPercent;
                  this.discountObject = this.productsToShow[indexOf];
                  this.calculateItemNewPrice3(this.productsToShow[indexOf]);
                }
              }

              break;
            }
          }
        }
      } else {
        this.showProductsAndServices = !this.showProductsAndServices;
        this.showAlert(
          "danger",
          "Advertencia",
          "Debe seleccionar un cliente para agregar productos"
        );
      }

      if (updateTempData && productData) {
        this.updateTempDetails(productData.uuid, false);
      }
    },
    quantityInput(data, type) {
      this.currentItemToAdd = { ...data };
      this.currentItemType = type;
      this.showQuantityDialog = true;
    },
    triggerAddItemEvent(data, type) {
      if (this.POSProductsAlternativeBehavior) {
        this.quantityInput(data, type);
      } else {
        if (type == 2) {
          this.showService(data, this.shouldAutoSave);
        } else {
          this.showProduct(data, this.shouldAutoSave);
        }
      }
    },
    submitQuantityInput(data) {
      if (this.currentItemType === 1) {
        this.showProduct(data, this.shouldAutoSave);
      } else if (this.currentItemType === 2) {
        this.showService(data, this.shouldAutoSave);
      }
      this.clearQuantityInputValues();
      this.showProductsAndServices = false;
    },
    clearQuantityInputValues() {
      this.currentItemToAdd = null;
      this.currentItemType = 0;
      this.showQuantityDialog = true;
    },
    showService(data, updateTempData = false, addByException = false) {
      let serviceData = null;

      if (this.BlockInvoice && !addByException && this.ndornc == null) {
        this.showProductsAndServices = !this.showProductsAndServices;
        this.showAlert(
          "danger",
          "Advertencia",
          "Los productos de facturas previamente rechazadas por hacienda o en estado de contingencia no pueden ser modificadas."
        );
        return;
      }
      if (this.isCustomerSelected) {
        if (!this.productsToShow.find((i) => i.ID_Item == data.CodeService && this.allowRepetitionOfArticles == false)) {
          const uuid = generateUUID();
          const qtyToAdd =
            this.POSProductsAlternativeBehavior && data?.qty && data?.qty > 0
              ? parseFloat(data.qty)
              : 1;

          serviceData = {
            ID_Branch: data.ID_Branch,
            ID_Business: data.ID_Business,
            ID_Item: data.CodeService,
            ItemName: data.Name || data.NameService,
            ItemName2: data.NameService || data.Name,
            discountFixed: 0,
            ItemNewPrice: (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) ? ( parseFloat(data.ItemNewPrice)/1.18+((parseFloat(data.ItemNewPrice)/1.18)*0.13) ) : parseFloat(data.ItemNewPrice),
            TmpItemNewPrice: (
              this.noaddivainpos 
              ? parseFloat(parseFloat(data.ItemOriginalPrice).toFixed(8)) 
              : (
                (this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento)
                ? parseFloat(parseFloat(data.ItemOriginalPrice / 1.18).toFixed(8)) 
                : parseFloat(parseFloat(data.ItemOriginalPrice / 1.13).toFixed(8)) 
              )
            ),
            TmpCounter: 0,
            ItemOriginalPrice: (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) ? ( parseFloat(data.ItemOriginalPrice)/1.18+((parseFloat(data.ItemOriginalPrice)/1.18)*0.13) ) : parseFloat(data.ItemOriginalPrice),
            qty: qtyToAdd,
            type: "service",
            ItemType: "SERVICIO",
            serviceType: data.TypeService || "",
            idServiceType: data.ID_TypeService || "",
            ItemCurrency: "$",
            ItemMeasureUnit: "",
            BloquearPropinas: data.BloquearPropinas || data.bloquearpropinas || 0,
            ...this.getCatalogTaxFlags(data, "service"),
            PriceListName: data.PriceListName,
            ItemPriceDiscountAmount: data.ItemPriceDiscountAmount,
            ItemPriceDiscountPercent: data.ItemPriceDiscountPercent,
            TurismoPorAlojamiento: data.TurismoPorAlojamiento,
            uuid: uuid,
            Pk_billing_invoices_details: data.Pk_billing_invoices_details,
            ItemCurrentQuantity: data.ItemCurrentQuantity,
            ItemComments: '',
            UnitCost: 0,
          };

          this.productsToShow.push(serviceData);
        }
      } else {
        this.showProductsAndServices = !this.showProductsAndServices;
        this.showAlert(
          "warning",
          "Advertencia",
          "Por favor seleccione un cliente para facturar el servicio"
        );
      }

      if (updateTempData && serviceData) {
        this.updateTempDetails(serviceData.uuid, false);
      }
    },
    showServiceFromSelector(data, updateTempData = false) {
      let serviceData = null;

      if (this.isCustomerSelected) {
        if (!this.productsToShow.find((i) => i.ID_Item == data.CodeService && this.allowRepetitionOfArticles == false)) {
          const uuid = generateUUID();

          serviceData = {
            ID_Branch: data.ID_Branch,
            ID_Business: data.ID_Business,
            ID_Item: data.CodeService,
            ItemName: data.Name || data.NameService,
            ItemName2: data.NameService || data.Name,
            discountFixed: 0,
            ItemNewPrice: (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) ? ( parseFloat(data.ItemNewPrice)/1.18+((parseFloat(data.ItemNewPrice)/1.18)*0.13) ) : parseFloat(data.ItemNewPrice),
            TmpItemNewPrice: (
              this.noaddivainpos 
              ? parseFloat(parseFloat(data.ItemOriginalPrice).toFixed(8)) 
              : (
                (this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento)
                ? parseFloat(parseFloat(data.ItemOriginalPrice / 1.18).toFixed(8)) 
                : parseFloat(parseFloat(data.ItemOriginalPrice / 1.13).toFixed(8)) 
              )
            ),
            TmpCounter: 0,
            ItemOriginalPrice: (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) ? ( parseFloat(data.ItemOriginalPrice)/1.18+((parseFloat(data.ItemOriginalPrice)/1.18)*0.13) ) : parseFloat(data.ItemNewPrice),
            qty: data.qty,
            type: "service",
            ItemType: "SERVICIO",
            serviceType: data.TypeService || "",
            idServiceType: data.ID_TypeService || "",
            ItemCurrency: "$",
            ItemMeasureUnit: "",
            BloquearPropinas: data.BloquearPropinas || data.bloquearpropinas || 0,
            ...this.getCatalogTaxFlags(data, "service"),
            PriceListName: data.PriceListName,
            ItemPriceDiscountAmount: data.ItemPriceDiscountAmount,
            ItemPriceDiscountPercent: data.ItemPriceDiscountPercent,
            TurismoPorAlojamiento: data.TurismoPorAlojamiento,
            uuid: uuid,
            Pk_billing_invoices_details: data.Pk_billing_invoices_details,
            ItemCurrentQuantity: data.ItemCurrentQuantity,
            ItemComments: '',
            UnitCost: 0
          };

          this.productsToShow.push(serviceData);
        }
      } else {
        this.showProductsAndServices = !this.showProductsAndServices;
        this.showAlert(
          "warning",
          "Advertencia",
          "Por favor seleccione un cliente para facturar el servicio"
        );
      }

      if (updateTempData && serviceData) {
        this.updateTempDetails(serviceData.uuid, false);
      }
    },
    async showProductByfilter(val, updateTempData = false) {
      const data = val.prod;

      let productData = null;

      if (this.isCustomerSelected) {
        if (
          !this.productsToShow.find(
            (i) =>
              i.ID_Item == data.ID_Item &&
              this.allowRepetitionOfArticles == false
          )
        ) {
          if (data.ItemCurrentQuantity > 0 || this.EnableNegativeItem == 1 || this.notQuantity) {
            const uuid = generateUUID();

            let CustomName = data.ItemComercialName || data.ItemName

            if (this.addwarehouseofprodinbill) {
              let initialsWarehoue = this.getInitials(data.NameWarehouse)
              CustomName += " (" + initialsWarehoue + ")"
            }

            if (this.ShowBatchInfoPos) {
              let expiration = data.ExpirationDate || ""
              if (data.ID_ItemBatch) {
                CustomName +=" - Lote: " + data.ID_ItemBatch
              }
              if (expiration) {
                CustomName +=" - Fecha de expiración: " + expiration
              }
            }

            let unitCost = 0
            if (this.showunitcostinpos) {
              unitCost = await this.getItemCostByIdProduct(data.ID_Item)
            }

            productData = {
              ...data,
              ItemName: CustomName,
              qty: 1,
              type: "product",
              ...this.getCatalogTaxFlags(data, "product"),
              TmpItemNewPrice: (
                this.noaddivainpos 
                ? parseFloat(parseFloat(data.ItemOriginalPrice).toFixed(8)) 
                : (
                  (this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento)
                  ? parseFloat(parseFloat(data.ItemOriginalPrice / 1.18).toFixed(8)) 
                  : parseFloat(parseFloat(data.ItemOriginalPrice / 1.13).toFixed(8)) 
                )
              ),
              TmpCounter: 0,
              uuid: uuid,
              Pk_billing_invoices_details: data.Pk_billing_invoices_details,
              ItemCurrentQuantity: data.ItemCurrentQuantity,
              ItemComments: '',
              UnitCost: unitCost || 0
            };

            this.productsToShow.push(productData);
          } else {
            if (this.showProductsAndServices) {
              this.showProductsAndServices = !this.showProductsAndServices;
            }

            this.showAlert(
              "danger",
              "Advertencia",
              "No hay unidades disponibles de este producto"
            );
          }

          if (updateTempData && productData) {
            this.updateTempDetails(productData.uuid, false);
          }
        }
      } else {
        this.showProductsAndServices = !this.showProductsAndServices;
        this.showAlert(
          "danger",
          "Advertencia",
          "Debe seleccionar un cliente para agregar productos"
        );
      }
    },
    showServiceByfilter(val, updateTempData = false) {
      const data = val.prod;

      let serviceData = null;

      if (this.isCustomerSelected) {
        if (!this.productsToShow.find((i) => i.ID_Item == data.CodeService && this.allowRepetitionOfArticles == false)) {
          const uuid = generateUUID();

          serviceData = {
            ID_Branch: data.ID_Branch,
            ID_Business: data.ID_Business,
            ID_Item: data.CodeService,
            ItemName: data.Name || data.NameService,
            ItemName2: data.NameService || data.Name,
            discountFixed: 0,
            ItemNewPrice: (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) ? ( parseFloat(data.ItemNewPrice)/1.18+((parseFloat(data.ItemNewPrice)/1.18)*0.13) ) : parseFloat(data.ItemNewPrice),
            TmpItemNewPrice: (
              this.noaddivainpos 
              ? parseFloat(parseFloat(data.ItemOriginalPrice).toFixed(8)) 
              : (
                (this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento)
                ? parseFloat(parseFloat(data.ItemOriginalPrice / 1.18).toFixed(8))  
                : parseFloat(parseFloat(data.ItemOriginalPrice / 1.13).toFixed(8)) 
              )
            ),
            TmpCounter: 0,
            ItemOriginalPrice: (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) ? ( parseFloat(data.ItemOriginalPrice)/1.18+((parseFloat(data.ItemOriginalPrice)/1.18)*0.13) ) : parseFloat(data.ItemOriginalPrice),
            qty: 1,
            type: "service",
            ItemType: "SERVICIO",
            serviceType: data.TypeService || "",
            idServiceType: data.ID_TypeService || "",
            ItemCurrency: "$",
            ItemMeasureUnit: "",
            BloquearPropinas: data.BloquearPropinas || data.bloquearpropinas || 0,
            ...this.getCatalogTaxFlags(data, "service"),
            PriceListName: data.PriceListName,
            ItemPriceDiscountAmount: data.ItemPriceDiscountAmount,
            ItemPriceDiscountPercent: data.ItemPriceDiscountPercent,
            TurismoPorAlojamiento: data.TurismoPorAlojamiento,
            uuid: uuid,
            Pk_billing_invoices_details: data.Pk_billing_invoices_details,
            ItemCurrentQuantity: data.ItemCurrentQuantity,
            ItemComments: '',
            UnitCost: 0,
          };

          this.productsToShow.push(serviceData);
        }
        this.productcode = null;
      } else if (this.newCostumer == true) {
        this.productcode = null;
      } else {
        this.showProductsAndServices = !this.showProductsAndServices;
        this.showAlert(
          "warning",
          "Advertencia",
          "Por favor seleccione un cliente para facturar el servicio"
        );
      }

      if (updateTempData && serviceData) {
        this.updateTempDetails(serviceData.uuid, false);
      }
    },
    showServiceBarCode(data, updateTempData = false) {
      const { PrincipalBarCodeValue } = data;

      let serviceData = null;

      if (this.isCustomerSelected) {
        if (!this.productsToShow.find((i) => i.ID_Item == data.CodeService && this.allowRepetitionOfArticles == false)) {
          const uuid = generateUUID();
          
          serviceData = {
            ID_Branch: data.ID_Branch,
            ID_Business: data.ID_Business,
            ID_Item: data.CodeService,
            ItemName: data.Name || data.NameService,
            ItemName2: data.NameService || data.Name,
            discountFixed: 0,
            ItemNewPrice: (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) ? ( parseFloat(data.ItemNewPrice)/1.18+((parseFloat(data.ItemNewPrice)/1.18)*0.13) ) : parseFloat(data.ItemNewPrice),
            TmpItemNewPrice: (
              this.noaddivainpos 
              ? parseFloat(parseFloat(data.ItemOriginalPrice).toFixed(8)) 
              : (
                (this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento)
                ? parseFloat(parseFloat(data.ItemOriginalPrice / 1.18).toFixed(8)) 
                : parseFloat(parseFloat(data.ItemOriginalPrice / 1.13).toFixed(8)) 
              )
            ),
            TmpCounter: 0,
            ItemOriginalPrice: (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) ? ( parseFloat(data.ItemOriginalPrice)/1.18+((parseFloat(data.ItemOriginalPrice)/1.18)*0.13) ) : parseFloat(data.ItemOriginalPrice),
            qty: 1,
            type: "service",
            ItemType: "SERVICIO",
            serviceType: data.TypeService || "",
            idServiceType: data.ID_TypeService || "",
            ItemCurrency: "$",
            ItemMeasureUnit: "",
            BloquearPropinas: data.BloquearPropinas || data.bloquearpropinas || 0,
            ...this.getCatalogTaxFlags(data, "service"),
            PriceListName: data.PriceListName,
            ItemPriceDiscountAmount: data.ItemPriceDiscountAmount,
            ItemPriceDiscountPercent: data.ItemPriceDiscountPercent,
            BarCode:
              PrincipalBarCodeValue || PrincipalBarCodeValue?.length > 0
                ? PrincipalBarCodeValue
                : null,
            TurismoPorAlojamiento: data.TurismoPorAlojamiento,
            uuid: uuid,
            Pk_billing_invoices_details: data.Pk_billing_invoices_details,
            ItemCurrentQuantity: data.ItemCurrentQuantity,
            ItemComments: '',
            UnitCost: 0,
          };

          this.productsToShow.push(serviceData);
        } else {
          for (const index in this.productsToShow) {
            const { ID_Item } = this.productsToShow[index];

            if (ID_Item == data.CodeService) {
              this.productsToShow[index].qty++;
              break;
            }
          }
        }
      } else {
        this.showProductsAndServices = !this.showProductsAndServices;
        this.showAlert(
          "warning",
          "Advertencia",
          "Por favor seleccione un cliente para facturar el servicio"
        );
      }

      if (updateTempData && serviceData) {
        this.updateTempDetails(serviceData.uuid, false);
      }
    },
    async addNewCustomer(payloadOverride = null) {
      if (payloadOverride) {
        try {
          this.loading = true
          const response = await this.$API.customers.addCustomerFromInvoice({customerData: payloadOverride});
          await this.getAllCostumers();
          this.newCostumer = false;
          this.isCustomerSelected = true;
          
          const customerExists = this.customersList.find(
            (current) => `${current.ID_Customer}` === `${response.data.customer}`
          );
          
          if (!customerExists) {
            const customersById =
              await this.$API.customers.getCustomersPOSCreateInvoiceByCustomer({
                ID_Customer: response.data.customer,
                business: this.business,
                branch: this.branch,
              });
            const selectedCustomer = customersById?.[0];
            const mappedCustomer = this.assignCustomersList([selectedCustomer])[0];
            this.customersList.push(mappedCustomer);
            this.customerSelectOnchange(mappedCustomer.ID_Customer);
          } else {
            this.customerSelectOnchange(customerExists.ID_Customer);
          }
          
          this.showAlert(
            "success",
            "Cliente agregado",
            "El cliente se ha agregado correctamente"
          );
        } catch (error) {
          this.showAlert(
            "danger",
            "Error al agregar cliente",
            "Hubo un problema al agregar el cliente"
          );
        }
        finally {
          this.loading = false
        }
        return;
      }

      if (this.form.legalnit) {
        if (
          !validateNITHomologation(
            "form",
            this,
            "legalnit",
            "Número de NIT del Cliente"
          )
        ) {
          return;
        }
      }

      const newForm = {
        legalname: this.form.legalname,
        legaladdress: this.form.legaladdress,
        legalnrc: this.form.legalnrc
          ? this.form.legalnrc.replaceAll("-", "")
          : "",
        legalnit: this.form.legalnit
          ? this.form.legalnit.replaceAll("-", "")
          : "",
        dui: this.form.dui ? this.form.dui.replaceAll("-", "") : "",
        legalentity: this.form.legalentity,
        information: this.form.information,
        legalisnontaxable: this.form.legalisnontaxable,
        // legalsector: this.form.legalsector,
        legaltaxpayersize: this.form.legaltaxpayersize,
        status: 1,
        idbusiness: JSON.parse(localStorage.getItem("user")).businessid || "",
        idbranch: JSON.parse(localStorage.getItem("user")).branch || "",
        codactividad: this.form.codactividad,
        descactividad: this.form.descactividad,
        phonenumber: this.form.phonenumber,
        email: this.form.email,
        //islegal: true
      };

      try {
        this.loading = true
        const response = await this.$API.customers.addCustomerFromInvoice({customerData: newForm});
        await this.getAllCostumers();
        this.newCostumer = false;
        this.isCustomerSelected = true;
        
        const customerExists = this.customersList.find(
          (current) => `${current.ID_Customer}` === `${response.data.customer}`
        );
        
        if (!customerExists) {
          const customersById =
            await this.$API.customers.getCustomersPOSCreateInvoiceByCustomer({
              ID_Customer: response.data.customer,
              business: this.business,
              branch: this.branch,
            });
          const selectedCustomer = customersById?.[0];
          const mappedCustomer = this.assignCustomersList([selectedCustomer])[0];
          this.customersList.push(mappedCustomer);
          this.customerSelectOnchange(mappedCustomer.ID_Customer);
        } else {
          this.customerSelectOnchange(customerExists.ID_Customer);
        }
        
        this.showAlert(
          "success",
          "Cliente agregado",
          "El cliente se ha agregado correctamente"
        );
      } catch (error) {
        this.showAlert(
          "danger",
          "Error al agregar cliente",
          "Hubo un problema al agregar el cliente"
        );
      }
      finally {
        this.loading = false
      }
    },
    async handleNewCustomerSubmit({ customerData }) {
      await this.addNewCustomer(customerData);
      if (this.isCustomerSelected) {
        this.showCustomer = false;
      }
    },
    async removeRow(data) {
      if(this.invoiceAutoSave) {
        let responseDeleteDetails = await this.$API.invoices.deleteDestailsInvoice({ item: data.data, items2: this.tempDetails, ID_Invoice: this.tempId })

        if (responseDeleteDetails.success) {
          const indexToSplice = this.productsToShow.findIndex( current => current.uuid === data.data.uuid );

          this.productsToShow.splice(indexToSplice, 1);
          this.body.splice(indexToSplice, 1);
          this.discountObject.splice(indexToSplice, 1);  
        }
        else {
          this.showAlert("warning", "Advertencia", "Ocurrio un problema al eliminar el producto/servicio")
        }
      }
      else {
        const indexToSplice = this.productsToShow.findIndex( current => current.uuid === data.data.uuid );

        this.productsToShow.splice(indexToSplice, 1);
        this.body.splice(indexToSplice, 1);
        this.discountObject.splice(indexToSplice, 1);
      }
    },
    calculateCellValue(data) {
      data.ItemNewNewPrice = parseFloat(
        data.qty * data.ItemOriginalPrice -
        data.qty * data.ItemPriceDiscountAmount
      ).toFixed(8);
      return parseFloat(
        data.qty * data.ItemOriginalPrice -
          data.qty * data.ItemPriceDiscountAmount
      ).toFixed(8);
    },
    calculateCellValueSinIva(data) {
      let preciosiniva = parseFloat((data.ItemOriginalPrice / 1.13).toFixed(2));
      return parseFloat(
        data.qty * preciosiniva - data.qty * data.ItemPriceDiscountAmount
      ).toFixed(2);
    },
    calculateItemNewPrice(data) {
      //console.log('CALCULATE NEW PRICE')
      data.TmpCounter++;
      data.ItemOriginalPrice = data.ItemNewPrice;

      if (this.noaddivainpos) {
        data.TmpItemNewPrice = parseFloat((data.ItemNewPrice).toFixed(8));
      }
      else {
        if (this.addimpturismo && this.ishosting && data.TurismoPorAlojamiento) {
          data.TmpItemNewPrice = parseFloat((data.ItemNewPrice / 1.18).toFixed(8));
        }
        else {
          data.TmpItemNewPrice = parseFloat((data.ItemNewPrice / 1.13).toFixed(8));
        }
      }

      if (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) {
        let precioSinImpuestos = parseFloat(data.ItemNewPrice / 1.18)
        let calculoIva = parseFloat(precioSinImpuestos * 0.13)

        data.TmpItemNewPrice = parseFloat(parseFloat(precioSinImpuestos + calculoIva).toFixed(8))
      }

      if (data.TmpCounter > 0) {
        data.ItemPriceDiscountAmount = 0;
        data.ItemPriceDiscountPercent = 0;
        this.discountObject = data;
      }

      this.updateTempDetails(data.uuid);
    },
    calculateItemNewPrice2(data) {
      //console.log('CALCULATE NEW PRICE 2')
      data.TmpCounter++;
      data.ItemNewPrice = data.TmpItemNewPrice;
      data.ItemOriginalPrice = data.TmpItemNewPrice;
      if (data.TmpCounter > 0) {
        data.ItemPriceDiscountAmount = 0;
        data.ItemPriceDiscountPercent = 0;
        this.discountObject = data;
      }
      this.updateTempDetails(data.uuid);
    },
    calculateItemNewPrice3(data, updateTempData = false) {
      //console.log('CALCULATE NEW PRICE 3')

      let maxSale = data.MaxSaleDecimal > 0 ? (parseFloat(data.ItemPrice) + parseFloat(data.MaxSaleDecimal)) : 0
      let maxDiscount = data.MaxDiscountDecimal > 0 ? (parseFloat(data.ItemPrice) - parseFloat(data.MaxDiscountDecimal)) : 0

      if ((maxDiscount !== 0 && data.ItemNewPrice < maxDiscount) || (maxSale !== 0 && data.ItemNewPrice > maxSale)) {
        this.showAlert(
          "warning", 
          "Advertencia", 
          "El valor de venta no puede ser menor a $" + maxDiscount + " ni mayor a $" + maxSale
        )
        data.ItemNewPrice = parseFloat(data.ItemPrice)
        data.TmpItemNewPrice = parseFloat(data.ItemNewPrice)
        this.calculateItemNewPrice2(data)
      }
      else if (this.showunitcostinpos && data.ItemNewPrice <= data.UnitCost) {
        this.showAlert(
          "warning", 
          "Advertencia", 
          "El valor de venta no puede ser menor o igual al costo de compra."
        )

        data.ItemNewPrice = parseFloat(data.ItemPrice)
        data.TmpItemNewPrice = parseFloat(data.ItemNewPrice)
        this.calculateItemNewPrice2(data)
      }
      else {
        if (this.noaddivainpos) {
          data.TmpItemNewPrice = parseFloat(parseFloat(data.ItemNewPrice).toFixed(8))
        }
        else {
          if (this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) {
            data.TmpItemNewPrice = parseFloat((data.ItemNewPrice / 1.18).toFixed(8));
          }
          else {
            data.TmpItemNewPrice = parseFloat((data.ItemNewPrice / 1.13).toFixed(8));
          }
        }

        if (updateTempData) {
          this.updateTempDetails(data.uuid);
        }
      }
    },
    calculateItemNewPrice4(data) {
      //console.log('CALCULATE NEW PRICE 4')

      let maxSale = data.MaxSaleDecimal > 0 ? (parseFloat(data.ItemPrice) + parseFloat(data.MaxSaleDecimal)) : 0
      let maxDiscount = data.MaxDiscountDecimal > 0 ? (parseFloat(data.ItemPrice) - parseFloat(data.MaxDiscountDecimal)) : 0

      if ((maxDiscount !== 0 && data.ItemNewPrice < maxDiscount) || (maxSale !== 0 && data.ItemNewPrice > maxSale)) {
        this.showAlert(
          "warning", 
          "Advertencia", 
          "El valor de venta no puede ser menor a $" + maxDiscount + " ni mayor a $" + maxSale
        )
        data.ItemNewPrice = parseFloat(data.ItemPrice)
        this.calculateItemNewPrice(data)
      }
      else if (this.showunitcostinpos && data.ItemNewPrice <= data.UnitCost) {
        this.showAlert(
          "warning", 
          "Advertencia", 
          "El valor de venta no puede ser menor o igual al costo de compra."
        )
        
        data.ItemNewPrice = parseFloat(data.ItemPrice)
        this.calculateItemNewPrice(data)
      }
      else {
        if (this.form.invoicetype == 'FCF' && this.ishosting && this.addimpturismo && data.TurismoPorAlojamiento) {
          data.ItemNewPrice = data.TmpItemNewPrice
          data.ItemOriginalPrice = data.TmpItemNewPrice
        }
        this.updateTempDetails(data.uuid);
      }
    },
    calculateItemNewPrice5(data) {
      let maxSale = data.MaxSaleDecimal > 0 ? (parseFloat(data.ItemPrice) + parseFloat(data.MaxSaleDecimal)) : 0
      let maxDiscount = data.MaxDiscountDecimal > 0 ? (parseFloat(data.ItemPrice) - parseFloat(data.MaxDiscountDecimal)) : 0

      if ((maxDiscount !== 0 && data.ItemNewPrice < maxDiscount) || (maxSale !== 0 && data.ItemNewPrice > maxSale)) {
        this.showAlert(
          "warning", 
          "Advertencia", 
          "El valor de venta no puede ser menor a $" + maxDiscount + " ni mayor a $" + maxSale
        )
        data.ItemNewPrice = parseFloat(data.ItemPrice)
        this.calculateItemNewPrice(data)
      }
    },
    async customerSelectOnchange(event) {
      try {
        const foundCustomer = this.customersList.find(
          (current) => current.ID_Customer === event
        );
        if (foundCustomer) {
          this.customerSelected(
            this.customersList.find((current) => current.ID_Customer === event)
          );
        }
      } catch (error) {
        console.log(error);
        this.showAlert(
          "error",
          "Error",
          `Ocurrió el siguiente error al intentar seleccionar un usuario ${error.message}`
        );
      }
    },
    async vTerceroSelectOnChange(event) {
      try {
        const foundCustomer = this.vTerceroList.find(
          (current) => current.ID_Customer === event
        );
        
        this.form.ventaterceronit = foundCustomer?.LegalNIT || ""
        this.form.ventaterceronombre = foundCustomer?.LegalName || ""
      } catch (error) {
        console.log(error);
        this.showAlert(
          "error",
          "Error",
          `Ocurrió el siguiente error al intentar seleccionar un usuario ${error.message}`
        );
      }
    },
    async customerSelected(data, preserveExtensionData = false) {
      this.isCustomerSelected = true;
      this.searchCustomerDialog = false;
      this.newCostumer = false;
      this.customerSelectedData = data;
      this.form.docasociado = null;
      this.form.detalleasociado = null;
      this.form.codasociado = null;
      if (
        !this.customersList.find(
          (current) => current.ID_Customer === data.ID_Customer
        )
      ) {
        if (data.Is_a_business) {
          data.itemText = data.BusinessName;
        } else {
          data.itemText = data.LegalName;
        }
        this.customersList.push(data);
      }
      Object.keys(data).map((el) => {
        Vue.set(this.form, el.replace("_", "").toLowerCase(), data[el]);
      });

      if (data.Is_a_Table) {
        this.form.legalname = "CLIENTES VARIOS"
      }

      if (data?.BccEmailsCustomer) {
        const bccmail = data?.BccEmailsCustomer || '';
        this.BccEmails = bccmail
                      .split(',')
                      .map(e => e.trim())
                      .filter(Boolean);
        
      }
      this.form.idbranch = this.branch;

      this.form.dui && (this.form.dui = applyDUIMaskOutOfInput(this.form.dui));
      this.form.legalnrc &&
        (this.form.legalnrc = applyDUIMaskOutOfInput(this.form.legalnrc));
      this.form.legalnit &&
        (this.form.legalnit = applyNitMaskHandlingHomologationOutOfInput(
          this.form.legalnit
        ));
      
      if (!this.header && !this.body) {  
        if (data.StatusInvoice != null && data.StatusInvoice != "") {
          this.form.invoicestatusdescription = data.StatusInvoice
        }

        if (data.TypeInvoice != null && data.TypeInvoice != "") {
          this.form.invoicetype = data.TypeInvoice
        }

        if (data.PaymentType != null && data.PaymentType != "") {
          if (this.pospayments == 0) {
            //this.form.invoicepaymenttype = data.PaymentType
            const exist = this.paymentTypes.some(item => item.Valores.trim() === data.PaymentType.trim());

            if (exist) {
              this.form.invoicepaymenttype = data.PaymentType
            }
          }
        }

        if (data.ID_Seller != null && data.ID_Seller != "") {
          this.form.ID_Seller = data.ID_Seller
        }
      }
      //Validacion de buscadores segun el cliente seleccionado 
      this.setEnableQuantitiesVal();

      if (data.PriceListName != null && data.PriceListName != "" && data.PriceListName != 0) {
        this.PriceListSelected = data.PriceListName;
        this.reactiveMainProductsFilter();
      } else {
        //this.PriceListSelected = this.PriceListSelected
        this.PriceListSelected = this.defaultPriceList;
        this.reactiveMainProductsFilter();
      }
      //Consultar solo cuando tiene credito habilitado
      if (data.CreditStatus !== 'BLOQUEADO' || this.form.limitcredit > 0) {
        this.customerCreditInformation =
        await this.$API.customers.getAcountReceivableByCustomer({
          ID_Customer: data.ID_Customer, typeData: this.AuthFeMode
        }); 
      }
     

      if (this.form.limitcredit > 0 && !["DNC", "DND", "FNS"].includes(this.form.invoicetype)) {
        if (this.customerCreditInformation.TotalDebt >= this.form.limitcredit && ["FCF", "CCF", "FEX"].includes(this.form.invoicetype)) {
          this.creditBillingBlock = true;
          this.showAlert(
            "dangerHtml",
            "Advertencia",
            `El cliente seleccionado ah llegado al límite de crédito permitido, por lo tanto no es posible facturarle.<br><br>
          Saldo pendiente del cliente $${parseFloat(
            this.customerCreditInformation.TotalDebt
          ).toFixed(2)}`
          );
        } else if (this.customerCreditInformation.TotalDebt > 0) {
          this.creditBillingBlock = false;
          let actualCredit =
            this.form.limitcredit - this.customerCreditInformation.TotalDebt;

          this.showAlert(
            "successHtml",
            "<span class='primary--text'>Advertencia</span>",
            `<span class="primary--text"> El cliente seleccionado tiene facturas con </span> crédito pendiente <span class="primary--text">a cancelar por un monto total de</span>
          $ ${parseFloat(this.customerCreditInformation.TotalDebt).toFixed(
            2
          )}<br><br>
          <span class="primary--text">Límite inicial de crédito del cliente</span> $ ${parseFloat(
            this.form.limitcredit
          ).toFixed(2)}<br><br>
          <span class="primary--text">Límite actual de crédito del cliente</span> $ ${parseFloat(
            actualCredit
          ).toFixed(2)}`
          );
        } else {
          this.creditBillingBlock = false;
        }
      } else {
        this.creditBillingBlock = false;
      }

      if (
        this.form.creditstatus == "BLOQUEADO" ||
        this.form.creditstatus == "SUSPENDIDO" ||
        this.form.creditstatus == "INACTIVO"
      ) {
        this.form.invoicestatusdescription = "Cancelada";
      }

      if (this.form.creditperiod != 0) {
        this.creditDays.push(this.form.creditperiod + " días");
        this.form.invoicecreditday = this.form.creditperiod + " días";
      }

      await this.$API.customerAdvancePayment.findAdvancePaymentByCustomerForPos({ ID_Customer: data.ID_Customer })
        .then((response) => {
          this.advancePayments = response.data
        })

      this.IsIsss = this.form.isisss ? true : false
      this.syncCustomerResponsible(data, !preserveExtensionData);
    },
    addNewClient() {
      this.$API.customers
        .addCustomer({ customerData: {...this.form, islegal: true} })
        .then((response) => {
          this.showAlert(
            "success",
            "Cliente agregado",
            "El cliente se ha agregado correctamente"
          );
          this.form = {};
          this.customerSelected(response.data);
        });
    },
    cancelDiscount() {
      let index = this.productsToShow.findIndex(
        (el) =>
          el.ID_Item == this.discountObject.ID_Item &&
          el.PriceListName == this.discountObject.PriceListName
      );
      Vue.set(this.productsToShow, index, { ...this.objectToApplyDiscount });
      this.showDiscount = false;
      this.discountObject = null;
    },
    cancelAirplaneTicket() {
      this.airplaneTicketObject.LineaAerea = ""
      this.airplaneTicketObject.Boleto = ""
      this.airplaneTicketObject.Pasajero = ""
      this.airplaneTicketObject.Ruta = ""

      if (this.airplaneTicketObject.CopyOriginalItemName) {
        this.airplaneTicketObject.ItemName = this.airplaneTicketObject.CopyOriginalItemName
      }

      this.showFormAirplaneTicket = false
      this.airplaneTicketObject = null
      this.$nextTick();
    },
    applyAirplaneTicket() {
      if (
        !this.airplaneTicketObject.LineaAerea &&
        !this.airplaneTicketObject.Boleto &&
        !this.airplaneTicketObject.Pasajero &&
        !this.airplaneTicketObject.Ruta
      ) {
        if (this.airplaneTicketObject.CopyOriginalItemName) {
          this.airplaneTicketObject.ItemName = this.airplaneTicketObject.CopyOriginalItemName
        }
      } else {
        let concatText = this.airplaneTicketObject.LineaAerea ? this.airplaneTicketObject.LineaAerea + " " : ""
        concatText += this.airplaneTicketObject.Boleto ? this.airplaneTicketObject.Boleto + " " : ""
        concatText += this.airplaneTicketObject.Pasajero ? this.airplaneTicketObject.Pasajero + " " : ""
        concatText += this.airplaneTicketObject.Ruta ? this.airplaneTicketObject.Ruta + " " : ""
        if (!this.airplaneTicketObject.CopyOriginalItemName) {
          this.airplaneTicketObject.CopyOriginalItemName = this.airplaneTicketObject.ItemName
        }
        this.airplaneTicketObject.ItemName = concatText
      }

      this.showFormAirplaneTicket = false
      this.airplaneTicketObject = null
      this.$nextTick();
    },
    checkValidDui() {
      const identificacion = this.form.legalnit ?? this.form.dui ?? null;
      return (identificacion, identificacion && identificacion.length > 8);
    },
    checkBusinessFields() {
      if (
        !this.form.legalnrc ||
        this.form.legalnrc === "" ||
        !this.form.legalnit ||
        this.form.legalnit === "" ||
        !this.form.codactividad ||
        this.form.codactividad === ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    async saveAfterFinishInvoice() {
      const requestData = {
        items: this.productsToShow, 
        ID_Invoice: this.tempId,
        InvoiceType: this.form.invoicetype,
        options: {
          noaddivainpos: this.noaddivainpos,
          addimpturismo: this.addimpturismo,
          restivaposexentonosuj: this.restivaposexentonosuj,
        }
      }

      this.$API.invoices.saveAllDetailsInvoice(requestData)

    },
    alertContinueWithDifferentDateThanToday( status = 0) {
      if( this.form.invoicedate != this.formatDate( new Date() ) && !this.continueDiffDate )  {
        this.showAlert(
          'question2',
          'Fecha difiere de la actual',
          'La fecha asignada a la factura difiere de la fecha actual ¿Desea continuar de todas formas?',
          `sendbillAfterDateValidation_${ status }`
        );
      } else {
        this.sendBill( status );
      }
    },
    async sendBill(status = 0) {
      if (this.invoiceRequestInFlight) return;
      let completedInvoiceAttempt = false;
      if (this.invoiceAttemptUncertain) {
        this.invoiceRequestInFlight = true;
        try {
          const attempt = await this.$API.invoices.getInvoiceAttemptStatus(this.invoiceAttemptKey);
          if (attempt?.data?.state !== 'COMPLETED') {
            this.showAlert('warning', 'Factura pendiente', 'No se pudo confirmar si el DTE fue procesado debido a una desconexión de internet. Se recomienda guardar el DTE y revisar el historial de facturas antes de intentar nuevamente para evitar duplicidad de DTEs');
            return;
          }
          completedInvoiceAttempt = true;
        } catch (error) {
          const notFound = error?.response?.status === 404 && error?.response?.data?.message === 'Intento no encontrado.';
          if (!notFound) {
            this.showAlert('warning', 'Factura pendiente', 'No se pudo confirmar si el DTE fue procesado debido a una desconexión de internet. Se recomienda guardar el DTE y revisar el historial de facturas antes de intentar nuevamente para evitar duplicidad de DTEs');
            return;
          }
        } finally {
          this.invoiceRequestInFlight = false;
          this.releaseInvoiceSubmissionLock();
        }
        this.invoiceAttemptUncertain = false;
        sessionStorage.removeItem('lastUncertainInvoiceAttempt');
      }
      if (status === 1 && !this.invoiceSubmissionInProgress) {
        this.invoiceSubmissionInProgress = true;
      }

      if (this.invoiceAutoSave) {
        let countActualItems = this.productsToShow.length
        let responseItemsDetails = await this.$API.invoices.countItemsDetailsInvoice({ ID_Invoice: this.tempId })
        
        if (responseItemsDetails.success) {
          let countItemsRefresh = responseItemsDetails.data.TotalItemsSave
          if (this.invoiceAutoSave && countItemsRefresh > countActualItems) {
            await this.saveAfterFinishInvoice()
            await this.getOrCreateTempInvoice()
            this.showAlert(
              'warning',
              'Advertencia',
              'Otra persona esta realizando cambios en este comprobante, Verifique los productos e información del cliente e intente de nuevo.'
            );
            return;
          }
        }
        else {
          this.showAlert(
              'warning',
              'Advertencia',
              'Se detecto un problema de red, espere un momento e intente de nuevo.'
            );

          return;
        }
      }
      
      if (status === 0 || status === 1) {
        const isValid = this.$refs.posForm.validate();
        if (!isValid) {
          this.showAlert(
            "warning", 
            "Advertencia",
            "Hay campos obligatorios sin completar."
          )

          return;
        }
      }
      
      this.loading = true;
      this.resetSeleted();

      //VALIDACIONES CUANDO ES TEMPLATE
      if (this.form.istemplate == 1) {
        this.showDialogTemplate = false;
        if (this.form.templatename == "" || this.form.templatename == null) {
          this.showAlert(
            "warning",
            "Advertencia",
            "El nombre de la plantilla de facturación es requerido"
          );
          this.form.templatename = "";
          this.form.istemplate = 0;
          this.loading = false
          return;
        }
      }

      //VALIDACIONES GENERALES
      /*if (this.sumObject.total <= 0 || !this.sumObject.total) {
        this.showAlert(
          "warning",
          "Advertencia",
          "No se puede facturar si el monto total de la factura es igual a $0"
        );
        this.loading = false
        return;
      }*/
      if (!this.form.isa_business) {
        if (
          this.sumObject.total >= 25000.0 &&
          this.form.invoicetype === "FCF" &&
          !this.checkValidDui()
        ) {
          // if(1095.01 > 1095.00 && this.form.invoicetype === 'FCF' && !this.checkValidDui()) {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para facturas con monto mayor o igual a USD 25,000.00, es obligatorio que el cliente tenga registrado DUI o NIT."
          );
          this.loading = false
          return;
        }
      } else {
        if (
          this.sumObject.total >= 25000.0 &&
          this.form.invoicetype === "FCF" &&
          !this.checkBusinessFields()
        ) {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para facturas con monto mayor o igual a USD 25,000.00, es obligatorio que el cliente tenga registrado NRC o NIT."
          );
          this.loading = false
          return;
        }
      }
      let errors = 0;

      if (!this.pospayments) {
        this.form.invoicepaymenttype || this.form.isquote == 1
          ? ""
          : (errors += 1);
      }

      this.form.invoicestatusdescription || this.form.isquote == 1
        ? ""
        : (errors += 1);

      if (!this.validateApendiceData()) {
        this.loading = false;
        return;
      }

      if (
        this.responsibleDataRequired &&
        (
          !this.form.extensionnombentrega ||
          !this.form.extensiondocuentrega ||
          !this.form.extensiontelefonoentrega ||
          !this.form.extensionnombrecibe ||
          !this.form.extensiondocurecibe ||
          !this.form.extensiontelefonorecibe
        )
      ) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Para facturas con monto mayor o igual a USD 25,000.00, es obligatorio completar los datos del responsable del emisor y del receptor."
        );
        this.loading = false;
        return;
      }

      if (this.POSRequiredIdSeller) {
        this.form.ID_Seller || this.form.isquote == 1 ? "" : (errors += 1);
      }

      if (this.form.invoicestatusdescription == "Crédito") {
        if (
          this.form.invoicecreditday == "" ||
          this.form.invoicecreditday == null
        )
          errors += 1;
      } else {
        this.form.invoicecreditday = null;
      }

      //VALIDACIONES CUANDO SE VA A FACTURAR
      var moneyReturn = 0; //Para devolución de dinero
      var cash = 0; //Cuanto pagaron en efectivo
      var sumOtherPay = 0; //Cuanto pagaron con otro método de pago

      if (status == 1) {
        if (this.header && this.body && this.copy === null) {
          const responseIsNotBillet = await this.$API.invoices.getInvoiceIsNotBilled({
            ID_Branch: this.branch,
            ID_Business: this.business,
            ID_Invoice: this.form.oldIdInvoice
          });

          if (!responseIsNotBillet.value) {
            this.showAlert(
              'warning', 
              'Advertencia',
              'La factura seleccionada ya se encuentra procesada.'
            );

            this.loading = false
            return; 
          } 
        }
        
        if (!completedInvoiceAttempt && this.EnableNegativeItem == false && !this.notQuantity) {
          const onlyProductsArray = this.productsToShow.filter( current => current.type != 'service' )
          const productsToSendForValidation = onlyProductsArray.map( ( { ID_Item, Warehouse, ID_ItemBatch, qty } ) => {
            return {
              ID_Item,
              Warehouse,
              ID_ItemBatch,
              requestedQuantity: qty,
              StockProductsInReserve: this.header?.StockProductsInReserve || 0
            }
          } );

          // COMPROBACION DE EXISTENCIAS ANTES DE FACTURAR
          const resultFromValidation = await this.$API.products.getInvoiceProductsQuantity( { StockProductsInReserve: this.header?.StockProductsInReserve ? 1 : 0 , items: productsToSendForValidation } );

          const { success, data } = resultFromValidation

          if( !success ) {
            const { msg } = resultFromValidation

            const alertArray = data.map( current => {
              const { ID_Item, Warehouse, ID_ItemBatch, found } = current;

              if( found ) {
                const { notEnoughStock } = current;

                if( notEnoughStock ) {
                  const { ItemCurrentQuantity } = current;
                  return `- ID PROD.: ${ ID_Item } | ID ALM. ${ Warehouse } | Lote. ${ ID_ItemBatch }: La cantidad solicitada excede las existencias disponibles de producto. Disponible: ${ ItemCurrentQuantity }`;
                }
              } else {
                return `- ID PROD.: ${ ID_Item } | ID ALM. ${ Warehouse } | Lote. ${ ID_ItemBatch }: El producto no fue encontrado mediante el criterio proporcionado`;
              }
            } )

            let alertBody = `${ msg }<br />${ alertArray.join( '<br />' ) }`;

            this.showAlert(
              "dangerHtml",
              "Advertencia",
              alertBody
            );
            this.loading = false
            return;
          }
        }

        //validaciones del módulo multipagos
        if (
          status == 1 &&
          !this.isReadyToBill &&
          this.form.istemplate == 0 &&
          this.form.isquote == 0 &&
          !this.orderAndPrint &&
          this.pospayments &&
          this.form.invoicetype != "DNC" &&
          this.form.invoicetype != "DND"
        ) {
          const paymentsForSubmission = this.getValidPaymentsForSubmission();

          if (!paymentsForSubmission.length) {
            this.showAlert(
              "warning",
              "Advertencia",
              "Debe ingresar un monto de pago válido mayor que cero antes de facturar."
            );
            this.loading = false;
            this.releaseInvoiceSubmissionLock();
            return;
          }

          const cashPayment = paymentsForSubmission.find((element) => element.typePayment == "01");
          cash = cashPayment ? this.normalizePaymentAmount(cashPayment.totalPayment) : 0;

          sumOtherPay = parseFloat(paymentsForSubmission.reduce((sum, element) => {
            if (element.typePayment != "01") {
              return sum + this.normalizePaymentAmount(element.totalPayment);
            }

            return sum;
          }, 0).toFixed(2));

          if (sumOtherPay > this.sumObject.total && cash >= 0) {
            this.showAlert(
              "dangerHtml",
              "Advertencia",
              `No es posible dar cambio en la operación actual pagos en Billetes y Monedas
            insuficientes.<br/><br/>
            Total a pagar en efectivo insuficiente: $${cash.toFixed(2)} <br><br>
            Total a pagar (otro tipo de pago): $${sumOtherPay.toFixed(
              2
            )} <br><br>
            Total DTE: $${this.sumObject.total}`
            );
            this.loading = false
            return;
          }

          if (this.sumPayments < this.sumObject.total && this.orderAndPrint === false) {
            this.showAlert(
              "dangerHtml",
              "Advertencia",
              `El total a pagar difiere con el total del DTE.<br><br>
            Total a pagar en efectivo: $${cash.toFixed(2)} <br><br>
            Total a pagar (otro tipo de pago): $${sumOtherPay.toFixed(
              2
            )} <br><br>
            Total DTE: $${this.sumObject.total}`
            );
            this.loading = false
            return;
          }

          if (this.sumPayments > this.sumObject.total) {
            moneyReturn = this.normalizePaymentAmount(
              this.sumPayments - this.sumObject.total
            );
          }
        }
        /*if(this.sumPayments < this.sumObject.total) {
          this.showAlert("dangerHtml", "Advertencia", `El total a pagar difiere con el total a cancelar.<br><br>
          Total a pagar: ${this.sumPayments} <br><br>
          Total a cancelar: ${this.sumObject.total}`)
          return
        }
        else {
          if(this.sumPayments > this.sumObject.total) {
            moneyReturn = parseFloat((this.sumPayments - this.sumObject.total).toFixed(2))
          }
        }*/

        if (this.form.limitcredit > 0) {
          let maxCredit =
            this.form.limitcredit - this.customerCreditInformation.TotalDebt;
          if (
            this.sumObject.total > maxCredit &&
            this.form.invoicestatusdescription == "Crédito"
          ) {
            this.showAlert(
              "dangerHtml",
              "Advertencia",
              `El límite de crédito para este cliente excede el permitido.<br><br>
            Límite inicial de crédito del cliente $${parseFloat(
              this.form.limitcredit
            ).toFixed(2)}<br><br>
            Saldo pendiente del cliente $${parseFloat(
              this.customerCreditInformation.TotalDebt
            ).toFixed(2)}<br><br>
            Límite actual de crédito del cliente $${maxCredit}`
            );
            this.loading = false
            return;
          }
        }

        if (this.form.invoicestatusdescription == "Pendiente de pago")
          errors += 1;

        if (this.form.invoicetype == "CCF" && this.form.descactividad == "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para facturas de crédito fiscal, es requerida la descripción de actividad del cliente"
          );
          this.loading = false
          return;
        }

        if (this.form.invoicetype == "CCF" && this.form.codactividad == "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para facturas de crédito fiscal, es requerido el código de actividad del cliente"
          );
          this.loading = false
          return;
        }

        if (this.form.invoicetype == "CCF" && this.form.legalnit == "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para facturas de crédito fiscal, es requerido el nit del cliente"
          );
          this.loading = false
          return;
        }

        if (this.form.invoicetype == "CCF" && this.form.legalnrc == "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para facturas de crédito fiscal, es requerido el nrc del cliente"
          );
          this.loading = false
          return;
        }

        if (this.form.invoicetype == "CCF" && this.form.department == "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para facturas de crédito fiscal, es requerido el departamento del cliente"
          );
          this.loading = false
          return;
        }

        if (this.form.invoicetype == "CCF" && this.form.municipality == "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para facturas de crédito fiscal, es requerido el municipio del cliente"
          );
          this.loading = false
          return;
        }

        if (this.form.invoicetype == "CCF" && this.form.legaladdress == "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para facturas de crédito fiscal, es requerida la dirección del cliente"
          );
          this.loading = false
          return;
        }

        if (this.form.invoicetype == "CDD" && this.form.codasociado == "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para comprobantes de donación, es requerido el codigo de documento asociado"
          );
          this.loading = false
          return;
        }

        if (this.form.invoicetype == "CDD" && this.form.docasociado == "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para comprobantes de donación, es requerido el documento asociado"
          );
          this.loading = false
          return;
        }

        if (this.form.invoicetype == "CDD" && this.form.detalleasociado == "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para comprobantes de donación, es requerido el detalle del documento asociado"
          );
          this.loading = false
          return;
        }
      }
      if (errors > 0) {
        if (
          this.form.invoicestatusdescription == "Pendiente de pago" &&
          status == 1
        ) {
          this.showAlert(
            "warning",
            "Advertencia",
            "No se puede facturar si la factura se encuentra pendiente de pago."
          );
        } else {
          this.showAlert(
            "warning",
            "Advertencia",
            "Debe llenar todos los campos obligatorios"
          );
        }
        this.loading = false
        return;
      }

      if (
        this.form.legalidinvoice != "No hay correlativo" ||
        JSON.parse(localStorage.getItem("FaMh")).AuthFeActive == 1
      ) {
        if (this.isCustomerSelected) {
          //legalidinvoice
          let obj = {}; //{ ...this.sumObject };
          let form = { ...this.form };
          for (var i in form) {
            let key = i.replace("legal", "invoice");
            obj[key] = this.form[i];
          }

          obj.invoicestatus = status;
          if (this.posrestaurant === 1 && this.orderAndPrint === true) {
            // se pasa a 0 para guardar la factura y no procesarla de una vez
            obj.invoicestatus = 0;
            obj.posrestaurant = 1;
          }
          else {
            obj.posrestaurant = 0;
          }

          let items = [];
          let serviceToGenerate = [];

          /*descuentos*/
          obj.invoicedescunosuj = 0;
          obj.invoicedescuexenta = 0;
          obj.invoicedescugravada = 0;
          obj.invoiceporcentajedescuento = 0;
          obj.invoicetotaldescu = 0;

          /*subtotales*/
          obj.invoicesubtotalventas = 0;
          obj.invoicesubtotal = 0;

          /*totales*/
          obj.invoicemontototaloperacion = 0;
          obj.invoicetotalexenta = 0;
          obj.invoicetotalnosuj = 0;
          obj.invoicetotalnogravada = 0;
          obj.invoicetotalgravada = 0;
          obj.invoicetotalpagar = 0;
          obj.invoicetotaliva = 0;
          obj.invoiceivarete1 = 0;
          obj.invoiceivaperce1 = 0;
          obj.invoicetotalletras = "";
          obj.invoicedui = obj.dui;
          obj.invoicereterenta = 0;
          obj.fovial = 0;
          obj.cotrans = 0;
          obj.turismoporalojamiento = 0;
          obj.propina = 0;

          let restIvaPerce = 0;

          this.productsToShow.map((el) => {
            if (el.type == "service") {
              serviceToGenerate.push(el);
            }

            if (el.discountFixed == undefined) {
              el.discountFixed = 0;
            } else {
              el.discountFixed = parseFloat(el.discountFixed);
            }

            if (el.ItemPriceDiscountPercent == undefined)
              el.ItemPriceDiscountPercent = 0;

            //let descu = parseFloat(parseFloat((el.ItemOriginalPrice/1.13)*(el.ItemPriceDiscountPercent / 100)).toFixed(2))

            if (
              isNaN(el.Suggested_price) ||
              el.Suggested_price == undefined ||
              el.Suggested_price == null
            ) {
              el.Suggested_price = el.ItemOriginalPrice;
            }

            let total_price;
            let totaliva;
            let totalunitcost;
            let totalgravada;
            let totalnosuj;
            let totalnogravada;
            let totalexenta;
            let totaldescu;
            let totalpropina;

            if (
              this.form.invoicetype == "CCF" ||
              this.form.invoicetype == "DND" ||
              this.form.invoicetype == "DNC"
            ) {

              if (this.noaddivainpos) {
                total_price = parseFloat(
                  parseFloat(
                    (parseFloat(el.ItemNewPrice).toFixed(8) * el.qty).toFixed(8)
                  ).toFixed(8)
                );
              }
              else {
                if (this.ishosting && this.addimpturismo && el.TurismoPorAlojamiento) {
                  total_price = parseFloat(
                    parseFloat(
                      ((parseFloat(el.ItemNewPrice) / 1.18).toFixed(8) * el.qty).toFixed(8)
                    ).toFixed(8)
                  );
                }
                else {
                  total_price = parseFloat(
                    parseFloat(
                      ((parseFloat(el.ItemNewPrice) / 1.13).toFixed(8) * el.qty).toFixed(8)
                    ).toFixed(8)
                  );
                }
              }
              
              if (this.activarPropinas && !this.hasBlockedTipItem(el)) {
                totalpropina = parseFloat(
                  parseFloat(
                    total_price * (this.porcentajePropinas / 100)
                  ).toFixed(8)
                )
              }
              else {
                totalpropina = 0
              }
              
              if (this.noaddivainpos) {
                totaliva =
                  el.nonsuj || el.nontaxable || el.nogravada
                    ? 0
                    : parseFloat(
                        parseFloat(total_price * 0.13).toFixed(8)
                      );
              }
              else {
                if (this.ishosting && this.addimpturismo && el.TurismoPorAlojamiento) {
                  totaliva =
                    el.nonsuj || el.nontaxable || el.nogravada
                      ? 0
                      : parseFloat(
                          parseFloat(total_price * 0.13).toFixed(8)
                        );
                }
                else {
                  totaliva =
                    el.nonsuj || el.nontaxable || el.nogravada
                      ? 0
                      : parseFloat(
                          parseFloat(el.ItemNewNewPrice - total_price).toFixed(8)
                        );
                }
              }
              
              
              if (this.restivaposexentonosuj) {
                totalunitcost = 
                el.nonsuj || el.nontaxable || el.nogravada
                ? parseFloat(parseFloat(el.ItemOriginalPrice / 1.13).toFixed(8))
                : ( 
                  this.noaddivainpos 
                  ? parseFloat(parseFloat(el.ItemOriginalPrice).toFixed(8)) 
                  : (
                    (this.ishosting && this.addimpturismo && el.TurismoPorAlojamiento)
                    ? parseFloat(parseFloat(el.ItemOriginalPrice / 1.18).toFixed(8)) 
                    : parseFloat(parseFloat(el.ItemOriginalPrice / 1.13).toFixed(8)) 
                  )
                );
              }
              else {
                totalunitcost = 
                el.nonsuj || el.nontaxable || el.nogravada
                ? parseFloat(parseFloat(el.ItemOriginalPrice).toFixed(8))
                : ( 
                  this.noaddivainpos 
                  ? parseFloat(parseFloat(el.ItemOriginalPrice).toFixed(8)) 
                  : (
                    (this.ishosting && this.addimpturismo && el.TurismoPorAlojamiento)
                    ? parseFloat(parseFloat(el.ItemOriginalPrice / 1.18).toFixed(8)) 
                    : parseFloat(parseFloat(el.ItemOriginalPrice / 1.13).toFixed(8)) 
                  )
                );
              }
              
              totalgravada =
                el.nonsuj || el.nontaxable || el.nogravada
                  ? 0
                  : parseFloat(parseFloat(total_price).toFixed(8));

              if (this.restivaposexentonosuj) {
                totalnosuj = el.nonsuj
                  ? parseFloat(parseFloat(el.ItemNewNewPrice / 1.13).toFixed(8))
                  : 0;
                totalexenta = el.nontaxable
                  ? parseFloat(parseFloat(el.ItemNewNewPrice / 1.13).toFixed(8))
                  : 0;
                totalnogravada = el.nogravada
                  ? parseFloat(parseFloat(el.ItemNewNewPrice / 1.13).toFixed(8))
                  : 0;
              }
              else {
                totalnosuj = el.nonsuj
                  ? parseFloat(parseFloat(el.ItemNewNewPrice).toFixed(8))
                  : 0;
                totalexenta = el.nontaxable
                  ? parseFloat(parseFloat(el.ItemNewNewPrice).toFixed(8))
                  : 0;
                totalnogravada = el.nogravada
                  ? parseFloat(parseFloat(el.ItemNewNewPrice).toFixed(8))
                  : 0;
              }    
              
              if (this.noaddivainpos) {
                totaldescu = parseFloat(
                  parseFloat(
                    (el.ItemPriceDiscountAmount) * el.qty
                  ).toFixed(8)
                );
              }
              else if (!this.restivaposexentonosuj && (el.nonsuj || el.nontaxable || el.nogravada)) {
                totaldescu = parseFloat(
                  parseFloat(
                    (el.ItemPriceDiscountAmount) * el.qty
                  ).toFixed(8)
                );
              }
              else {
                if (this.ishosting && this.addimpturismo && el.TurismoPorAlojamiento) {
                  totaldescu = parseFloat(
                    parseFloat(
                      (el.ItemPriceDiscountAmount / 1.18) * el.qty
                    ).toFixed(8)
                  );
                }
                else {
                  totaldescu = parseFloat(
                    parseFloat(
                      (el.ItemPriceDiscountAmount / 1.13) * el.qty
                    ).toFixed(8)
                  );
                }
              }

              if (el.nontaxable2) el.nontaxable = el.nontaxable2;

              if (el.nonsuj2) el.nonsuj = el.nonsuj2;

              if (el.nogravada2) el.nogravada = el.nogravada2

              obj.invoicesubtotalventas +=
                totalgravada + totalnosuj + totalexenta;

              obj.invoicetotaldescu += totaldescu; //el.discountFixed //descu
              //obj.invoiceporcentajedescuento += parseFloat(el.ItemPriceDiscountPercent)
              obj.invoicesubtotal += totalgravada + totalnosuj + totalexenta; //total_price
              obj.invoicetotalnosuj += totalnosuj;
              obj.invoicetotalexenta += totalexenta;
              obj.invoicetotalnogravada += totalnogravada + totalpropina;
              obj.invoicetotalgravada += totalgravada;

              if (this.noaddivainpos) {
                obj.invoicemontototaloperacion +=
                  (totalgravada != 0 ? parseFloat(el.ItemNewNewPrice) + financing.roundMoneyIEEE754( totaliva, 8) : 0) +
                  totalnosuj +
                  totalexenta;
                  //parseFloat(el.ItemNewNewPrice)
                obj.invoicetotalpagar +=
                  (totalgravada != 0 ? parseFloat(el.ItemNewNewPrice) + financing.roundMoneyIEEE754( totaliva, 8) : 0) +
                  totalnosuj +
                  totalexenta +
                  totalnogravada + 
                  totalpropina; //parseFloat(el.ItemNewNewPrice)
              }
              else {
                obj.invoicemontototaloperacion +=
                  (totalgravada != 0 ? parseFloat(el.ItemNewNewPrice) : 0) +
                  totalnosuj +
                  totalexenta; 
                  //parseFloat(el.ItemNewNewPrice)
                obj.invoicetotalpagar +=
                  (totalgravada != 0 ? parseFloat(el.ItemNewNewPrice) : 0) +
                  totalnosuj +
                  totalexenta + 
                  totalnogravada +
                  totalpropina; //parseFloat(el.ItemNewNewPrice)
              }
              
              obj.invoicetotaliva += totaliva;

              if (this.form.legalreterenta) {
                if (el.type == "service") {
                  let reterenta = parseFloat(
                    parseFloat(parseFloat(total_price) * 0.1).toFixed(2)
                  );
                  obj.invoicereterenta += reterenta;
                  obj.invoicetotalpagar = obj.invoicetotalpagar - reterenta;
                } else {
                  let reterenta = 0;
                  obj.invoicereterenta += reterenta;
                }
              }

              if (
                this.form.invoicetype == "CCF" &&
                el.type == "product" &&
                el.IsHidrocarburo
              ) {
                let fovial = parseFloat(
                  parseFloat(parseFloat(el.qty) * 0.2).toFixed(2)
                );
                let cotrans = parseFloat(
                  parseFloat(parseFloat(el.qty) * 0.1).toFixed(2)
                );

                obj.fovial += fovial;
                obj.cotrans += cotrans;
                obj.invoicemontototaloperacion =
                  obj.invoicemontototaloperacion + fovial + cotrans;
                obj.invoicetotalpagar =
                  obj.invoicetotalpagar + fovial + cotrans;
                restIvaPerce = restIvaPerce + totalgravada * 0.01;
              }

              if (
                this.ishosting &&
                el.TurismoPorAlojamiento &&
                !el.nontaxable &&
                !el.nontaxable2 &&
                !el.nonsuj &&
                !el.nonsuj2
              ) {
                let turismoPorAlojamiento = 0
                if (this.noaddivainpos) {
                  turismoPorAlojamiento = parseFloat(
                    parseFloat( ( parseFloat(el.ItemNewNewPrice) ) * 0.05).toFixed(2)
                  )
                }
                else {
                  if (this.addimpturismo) {
                    turismoPorAlojamiento = parseFloat(
                      parseFloat( ( parseFloat(el.ItemNewNewPrice) / 1.18 ) * 0.05).toFixed(2)
                    )
                  }
                  else {
                    turismoPorAlojamiento = parseFloat(
                      parseFloat( ( parseFloat(el.ItemNewNewPrice) / 1.13 ) * 0.05).toFixed(2)
                    )
                  }
                }
                
                obj.turismoporalojamiento += turismoPorAlojamiento;
                
                if (!this.addimpturismo) {
                  obj.invoicemontototaloperacion = 
                    obj.invoicemontototaloperacion + turismoPorAlojamiento;
                  obj.invoicetotalpagar = 
                    obj.invoicetotalpagar + turismoPorAlojamiento;
                }
              }

              obj.propina += totalpropina
            } else {
              total_price = parseFloat(
                parseFloat(el.ItemNewNewPrice).toFixed(8)
              );
              totaliva =
                el.nonsuj || el.nontaxable || el.nogravada
                  ? 0
                  : parseFloat(
                      parseFloat(total_price - total_price / 1.13).toFixed(8)
                    );

              totalgravada =
                el.nonsuj || el.nontaxable || el.nogravada
                  ? 0
                  : parseFloat(parseFloat(total_price).toFixed(8));
              
              if (this.activarPropinas && this.form.invoicetype == 'FCF' && !this.hasBlockedTipItem(el)) {
                totalpropina = parseFloat(
                  parseFloat(
                    (total_price / 1.13) * (this.porcentajePropinas / 100)
                  ).toFixed(8)
                )
              }
              else {
                totalpropina = 0
              }

              if (this.restivaposexentonosuj) {
                totalnosuj = el.nonsuj
                  ? parseFloat(parseFloat(total_price / 1.13).toFixed(8))
                  : 0;
                totalexenta = el.nontaxable
                  ? parseFloat(parseFloat(total_price / 1.13).toFixed(8))
                  : 0;
                totalnogravada = el.nogravada
                  ? parseFloat(parseFloat(total_price / 1.13).toFixed(8))
                  : 0;
              }
              else {
                totalnosuj = el.nonsuj
                  ? parseFloat(parseFloat(total_price).toFixed(8))
                  : 0;
                totalexenta = el.nontaxable
                  ? parseFloat(parseFloat(total_price).toFixed(8))
                  : 0;
                totalnogravada = el.nogravada
                  ? parseFloat(parseFloat(total_price).toFixed(8))
                  : 0;
              }
              
              if (this.restivaposexentonosuj && (el.nonsuj || el.nontaxable || el.nogravada)) {
                totaldescu = parseFloat(
                  parseFloat(el.ItemPriceDiscountAmount * el.qty / 1.13).toFixed(8)
                );
              }
              else {
                totaldescu = parseFloat(
                  parseFloat(el.ItemPriceDiscountAmount * el.qty).toFixed(8)
                );
              }

              if (el.nonsuj) {
                if (this.restivaposexentonosuj) {
                  totalunitcost = parseFloat(
                    parseFloat(el.ItemOriginalPrice / 1.13).toFixed(8)
                  );
                }
                else {
                  totalunitcost = parseFloat(
                    parseFloat(el.ItemOriginalPrice).toFixed(8)
                  );
                }
              } else if (el.nontaxable) {
                if (this.restivaposexentonosuj) {
                  totalunitcost = parseFloat(
                    parseFloat(el.ItemOriginalPrice / 1.13).toFixed(8)
                  );
                }
                else {
                  totalunitcost = parseFloat(
                    parseFloat(el.ItemOriginalPrice).toFixed(8)
                  );
                }
              } else if (el.nogravada) {
                if (this.restivaposexentonosuj) {
                  totalunitcost = parseFloat(
                    parseFloat(el.ItemOriginalPrice / 1.13).toFixed(8)
                  );
                }
                else {
                  totalunitcost = parseFloat(
                    parseFloat(el.ItemOriginalPrice).toFixed(8)
                  )
                }
              } else {
                totalunitcost = parseFloat(
                  parseFloat(el.ItemOriginalPrice).toFixed(8)
                );
              }

              if (el.nontaxable2) el.nontaxable = el.nontaxable2;

              if (el.nonsuj2) el.nonsuj = el.nonsuj2;

              if (el.nogravada2) el.nogravada = el.nogravada2;

              obj.invoicesubtotalventas +=
                totalgravada + totalnosuj + totalexenta;

              obj.invoicetotaldescu += totaldescu; //descu
              //obj.invoiceporcentajedescuento += parseFloat(el.ItemPriceDiscountPercent)
              obj.invoicesubtotal += totalgravada + totalnosuj + totalexenta; //total_price
              obj.invoicetotalnosuj += totalnosuj;
              obj.invoicetotalexenta += totalexenta;
              obj.invoicetotalgravada += totalgravada;
              obj.invoicetotalnogravada += totalnogravada + totalpropina;
              obj.invoicemontototaloperacion +=
                totalgravada + totalnosuj + totalexenta; //total_price
              obj.invoicetotalpagar += totalgravada + totalnosuj + totalexenta + totalpropina + totalnogravada; //total_price
              obj.invoicetotaliva += totaliva;

              if (this.form.invoicetype == "FNS") {
                if (el.type == "service") {
                  let reterenta = parseFloat(
                    parseFloat(parseFloat(total_price) * 0.1).toFixed(2)
                  );
                  obj.invoicereterenta += reterenta;
                  obj.invoicetotalpagar = obj.invoicetotalpagar - reterenta;
                } else {
                  let reterenta = 0;
                  obj.invoicereterenta += reterenta;
                }
              }

              if (this.form.legalreterenta && this.form.invoicetype == "FCF") {
                if (el.type == "service") {
                  let reterenta = parseFloat(
                    parseFloat(parseFloat(total_price / 1.13) * 0.1).toFixed(2)
                  );
                  obj.invoicereterenta += reterenta;
                  obj.invoicetotalpagar = obj.invoicetotalpagar - reterenta;
                } else {
                  let reterenta = 0;
                  obj.invoicereterenta += reterenta;
                }
              }

              if (
                this.form.invoicetype == "FCF" &&
                el.type == "product" &&
                el.IsHidrocarburo
              ) {
                let fovial = parseFloat(
                  parseFloat(parseFloat(el.qty) * 0.2).toFixed(2)
                );
                let cotrans = parseFloat(
                  parseFloat(parseFloat(el.qty) * 0.1).toFixed(2)
                );

                obj.fovial += fovial;
                obj.cotrans += cotrans;
                obj.invoicemontototaloperacion =
                  obj.invoicemontototaloperacion + fovial + cotrans;
                obj.invoicetotalpagar =
                  obj.invoicetotalpagar + fovial + cotrans;
              }

              if (
                this.ishosting &&
                el.TurismoPorAlojamiento &&
                !el.nontaxable &&
                !el.nontaxable2 &&
                !el.nonsuj &&
                !el.nonsuj2
              ) {
                let turismoPorAlojamiento = parseFloat(
                  parseFloat( ( parseFloat(total_price) / 1.13 ) * 0.05).toFixed(2)
                )

                obj.turismoporalojamiento += turismoPorAlojamiento;
                obj.invoicemontototaloperacion = 
                  obj.invoicemontototaloperacion + turismoPorAlojamiento;
                obj.invoicetotalpagar = 
                  obj.invoicetotalpagar + turismoPorAlojamiento;
              }

              obj.propina += totalpropina
            }

            console.log("item to push ", {
              idbranch: this.branch,
              idbusiness: el.ID_Business,
              iditem: el.ID_Item,
              itemtype: el.type,
              itemquantity: el.qty,
              itemmeasureunit: el.ItemMeasureUnit,
              itemdescription: el.ItemName,
              itemunitcost: totalunitcost, //Precio unitario original sin aplicar el descuento y con el iva
              itemdiscount: totaldescu || 0, //el.discountFixed || 0, //descu || 0,
              itemdiscountpercent: parseFloat(el.ItemPriceDiscountPercent) || 0,
              itemnosuj: totalnosuj, //No debe de incluir el iva ni el descuento
              itemexenta: totalexenta, //No debe de incluir el iva ni el descuento
              itemnogravada: totalnogravada,
              itemgravada: totalgravada, //No debe de incluir el iva ni el descuento
              itempsv: parseFloat(el.Suggested_price),
              itemiva: totaliva,
              itemcurrency: el.ItemCurrency || "$",
              warehouse: el.Warehouse,
              itembatch: el.ID_ItemBatch || "",
              ishidrocarburo: el.IsHidrocarburo || 0,
              principalbarcode: el.BarCode || "",
              BloquearPropinas: el.BloquearPropinas || el.bloquearpropinas || 0,
              turismoporalojamiento: el.TurismoPorAlojamiento || 0,
              itemcomments: el.ItemComments || "",
              pricelistname: el.PriceListName || null,
              LineaAerea: el.LineaAerea || null,
              Boleto: el.Boleto || null,
              Pasajero: el.Pasajero || null,
              Ruta: el.Ruta || null,
            });

            items.push({
              idbranch: this.branch,
              idbusiness: el.ID_Business,
              iditem: el.ID_Item,
              itemtype: el.type,
              itemquantity: el.qty,
              itemmeasureunit: el.ItemMeasureUnit,
              itemdescription: el.ItemName,
              itemunitcost: totalunitcost, //Precio unitario original sin aplicar el descuento y con el iva
              itemdiscount: totaldescu || 0, //el.discountFixed || 0, //descu || 0,
              itemdiscountpercent: parseFloat(el.ItemPriceDiscountPercent) || 0,
              itemnosuj: totalnosuj, //No debe de incluir el iva ni el descuento
              itemexenta: totalexenta, //No debe de incluir el iva ni el descuento
              itemnogravada: totalnogravada,
              itemgravada: totalgravada, //No debe de incluir el iva ni el descuento
              itempsv: parseFloat(el.Suggested_price),
              itemiva: totaliva,
              itemcurrency: el.ItemCurrency || "$",
              warehouse: el.Warehouse,
              itembatch: el.ID_ItemBatch || "",
              ishidrocarburo: el.IsHidrocarburo || 0,
              principalbarcode: el.BarCode || "",
              turismoporalojamiento: el.TurismoPorAlojamiento || 0,
              itemcomments: el.ItemComments || "",
              pricelistname: el.PriceListName || null,
              LineaAerea: el.LineaAerea || null,
              Boleto: el.Boleto || null,
              Pasajero: el.Pasajero || null,
              Ruta: el.Ruta || null, 
              Pk_billing_invoices_details: el.Pk_billing_invoices_details || null,
            });
          });

          obj.invoicedescunosuj = financing.roundMoneyIEEE754(obj.invoicedescunosuj, 2);
          obj.invoicedescuexenta = financing.roundMoneyIEEE754(obj.invoicedescuexenta, 2);
          obj.invoicedescugravada = financing.roundMoneyIEEE754(obj.invoicedescugravada, 2);
          obj.invoicetotaldescu = financing.roundMoneyIEEE754(obj.invoicetotaldescu, 2);
          obj.invoicesubtotalventas = financing.roundMoneyIEEE754(obj.invoicesubtotalventas, 2);
          obj.invoicesubtotal = financing.roundMoneyIEEE754(obj.invoicesubtotal, 2);

          obj.invoicemontototaloperacion = financing.roundMoneyIEEE754(obj.invoicemontototaloperacion, 2);

          obj.invoicetotalexenta = financing.roundMoneyIEEE754(obj.invoicetotalexenta, 2);
          obj.invoicetotalnosuj = financing.roundMoneyIEEE754(obj.invoicetotalnosuj, 2);
          obj.invoicetotalnogravada = financing.roundMoneyIEEE754(obj.invoicetotalnogravada, 2);
          obj.invoicetotalgravada = financing.roundMoneyIEEE754(obj.invoicetotalgravada, 2);
          obj.invoicetotalpagar = financing.roundMoneyIEEE754(obj.invoicetotalpagar, 2);
          obj.invoicetotaliva = financing.roundMoneyIEEE754(obj.invoicetotaliva, 2);
          obj.invoicereterenta = financing.roundMoneyIEEE754(obj.invoicereterenta, 2);
          obj.fovial = parseFloat(parseFloat(obj.fovial).toFixed(2));
          obj.cotrans = parseFloat(parseFloat(obj.cotrans).toFixed(2));
          obj.turismoporalojamiento = parseFloat(parseFloat(obj.turismoporalojamiento).toFixed(2));
          obj.propina = parseFloat(parseFloat(obj.propina).toFixed(2));
          const globalDiscountTotals = this.applyGlobalDiscountToInvoiceTotals(obj);

          if (
            this.form.invoicetype == "FCF" ||
            this.form.invoicetype == "FNS" ||
            this.form.invoicetype == "CCF" ||
            this.form.invoicetype == "DND" ||
            this.form.invoicetype == "DNC"
          )
            if (
              !this.BusinessLegalAgentRetain
            ) {
              if (this.form.legalagentretain) {
                //if (!this.form.isa_publicentity) {
                  if (this.form.invoicetype == "FCF") {
                    let sumtmp =
                      parseFloat(globalDiscountTotals.discountedExenta) +
                      parseFloat(globalDiscountTotals.discountedNoSuj) +
                      parseFloat(
                        globalDiscountTotals.discountedGravada - obj.invoicetotaliva
                      );
                    if (sumtmp >= 100) {
                      obj.invoiceivarete1 = parseFloat(
                        parseFloat(
                          (
                            globalDiscountTotals.discountedGravada -
                            obj.invoicetotaliva
                          ) * 0.01
                        ).toFixed(2)
                      );
                      obj.invoicetotalpagar = parseFloat(
                        parseFloat(
                          obj.invoicetotalpagar - obj.invoiceivarete1
                        ).toFixed(2)
                      );
                    }
                  } else {
                    let sumtmp = parseFloat(globalDiscountTotals.discountedGravada);
                    if (sumtmp >= 100 && (this.form.invoicetype == 'CCF' || this.form.invoicetype == "FNS")) {
                      obj.invoiceivarete1 = parseFloat(
                        parseFloat(globalDiscountTotals.discountedGravada * 0.01).toFixed(2)
                      );
                      obj.invoicetotalpagar = parseFloat(
                        parseFloat(
                          obj.invoicetotalpagar - obj.invoiceivarete1
                        ).toFixed(2)
                      );
                    } else {
                      if ( (this.form.invoicetype == 'DNC' || this.form.invoicetype == 'DND') && (this.ndornc?.ApplyRete1 || sumtmp >= 100)) {
                        obj.invoiceivarete1 = parseFloat(
                          parseFloat(globalDiscountTotals.discountedGravada * 0.01).toFixed(2)
                        );
                        obj.invoicetotalpagar = parseFloat(
                          parseFloat(
                            obj.invoicetotalpagar - obj.invoiceivarete1
                          ).toFixed(2)
                        );
                      }
                    }
                  }
                //}
              }
            }

          if (
            this.form.invoicetype == "CCF" ||
            this.form.invoicetype == "DND" ||
            this.form.invoicetype == "DNC"
          ) {
            if (this.BusinessLegalAgentRetain) {
              if (
                !this.form.legalagentretain
              ) {
                let sumtmp =
                  parseFloat(globalDiscountTotals.discountedExenta) +
                  parseFloat(globalDiscountTotals.discountedNoSuj) +
                  parseFloat(globalDiscountTotals.discountedGravada);
                if (sumtmp >= 100) {
                  obj.invoiceivaperce1 = parseFloat(
                    parseFloat(
                      obj.invoicetotalgravada * 0.01 - restIvaPerce
                    ).toFixed(2)
                  );
                  //obj.invoicemontototaloperacion = parseFloat(parseFloat(obj.invoicemontototaloperacion - obj.invoiceivarete1).toFixed(2))
                  obj.invoicetotalpagar = parseFloat(
                    parseFloat(
                      obj.invoicetotalpagar + obj.invoiceivaperce1
                    ).toFixed(2)
                  );
                }
                /*else {
                  if (this.form.invoicetype == 'DNC' || this.form.invoicetype == 'DNC') {
                    obj.invoiceivaperce1 = parseFloat(
                      parseFloat(
                        obj.invoicetotalgravada * 0.01 - restIvaPerce
                      ).toFixed(2)
                    );
                    //obj.invoicemontototaloperacion = parseFloat(parseFloat(obj.invoicemontototaloperacion - obj.invoiceivarete1).toFixed(2))
                    obj.invoicetotalpagar = parseFloat(
                      parseFloat(
                        obj.invoicetotalpagar + obj.invoiceivaperce1
                      ).toFixed(2)
                    );
                  }
                }*/
              }
            }
          }

          if (this.form.invoicetype == "FEX") {
            obj.invoicemontototaloperacion = parseFloat(
              parseFloat(
                obj.invoicemontototaloperacion +
                  parseFloat(this.form.flete) +
                  parseFloat(this.form.seguro)
              ).toFixed(2)
            );
            obj.invoicetotalpagar = parseFloat(
              parseFloat(
                obj.invoicetotalpagar +
                  parseFloat(this.form.flete) +
                  parseFloat(this.form.seguro)
              ).toFixed(2)
            );
          }

          obj.invoicetotalletras = numberToText(obj.invoicetotalpagar);

          //Se agrega el punto de venta para pasarlo al ministerio de hacienda
          obj.codpointsale = localStorage.getItem("codPointSale");

          obj.pospayments = this.pospayments;

          if (this.pospayments) {
            let paymentsForSubmission = this.getValidPaymentsForSubmission();
            const isRealBillSubmission =
              status == 1 &&
              !this.isReadyToBill &&
              this.form.istemplate == 0 &&
              this.form.isquote == 0 &&
              !this.orderAndPrint &&
              this.form.invoicetype != "DNC" &&
              this.form.invoicetype != "DND";

            if (isRealBillSubmission && !paymentsForSubmission.length) {
              this.showAlert(
                "warning",
                "Advertencia",
                "Debe ingresar un monto de pago válido mayor que cero antes de facturar."
              );
              this.loading = false;
              this.releaseInvoiceSubmissionLock();
              return;
            }

            if (moneyReturn > 0) {
              paymentsForSubmission = paymentsForSubmission.map((element) => {
                if (element.typePayment == "01" && element.totalPayment > 0) {
                  return {
                    ...element,
                    totalPayment: this.normalizePaymentAmount(
                      element.totalPayment - moneyReturn
                    ),
                  };
                }

                return element;
              });
            }

            if (isRealBillSubmission) {
              paymentsForSubmission = paymentsForSubmission.filter((element) =>
                this.isValidPaymentAmount(element.totalPayment)
              );
            }

            const paymentsSnapshot = paymentsForSubmission.map((payment) => ({
              ...payment,
            }));

            obj.invoicepaymenttype = null;
            obj.payments = paymentsSnapshot;
            this.datatoprint.invoicePayments = paymentsSnapshot.map((payment) => ({
              ...payment,
            }));
          } else {
            const paymentsForSubmission = this.paymentsData.map((payment) => ({
              ...payment,
              totalPayment: this.normalizePaymentAmount(payment.totalPayment),
            }));

            if (
              this.form.invoicepaymenttype != "" &&
              this.form.invoicepaymenttype != null &&
              paymentsForSubmission.length
            ) {
              this.paymentsData = paymentsForSubmission;

              this.paymentsData[0].typePayment = this.paymentTypes.find(
                (element) => element.Valores === this.form.invoicepaymenttype
              )?.Codigo;
              this.paymentsData[0].descriptionPayment =
                this.form.invoicepaymenttype;
              if (
                this.form.invoicepaymenttype != "Billetes y monedas" &&
                form.invoicepaymenttype != undefined
              ) {
                this.paymentsData[0].reference = this.form.invoicereference;
              }

              //Comprobante de anticipo
              let totalAdvancePayment = 0
              if (this.advancePaymentsSelected.length > 0) {
                for (const advancePayment of this.advancePaymentsSelected) {
                  totalAdvancePayment += parseFloat(parseFloat(advancePayment.Payment).toFixed(2))
                }
              }

              this.paymentsData[0].totalPayment = this.normalizePaymentAmount(
                obj.invoicetotalpagar - totalAdvancePayment
              );

              obj.invoicepaymenttype = this.paymentsData[0].descriptionPayment;

              this.paymentsData = this.paymentsData.filter(
                (element) => this.isValidPaymentAmount(element.totalPayment)
              );
            } else {
              this.paymentsData = [];
            }

            const paymentsSnapshot = this.paymentsData.map((payment) => ({
              ...payment,
            }));

            obj.payments = paymentsSnapshot;
            this.datatoprint.invoicePayments = paymentsSnapshot.map((payment) => ({
              ...payment,
            }));
          }

          obj.MoneyReturn = moneyReturn;
          obj.Flete = this.form.flete;
          obj.Seguro = this.form.seguro;
          obj.CheckTurismoPorAlojamiento = this.addimpturismo;
          obj.CheckPriceWithoutIvaCCF = this.noaddivainpos;
          obj.BccEmailsCustomer = this.BccEmails.join(", ")
          obj.FexZona = this.form.fexzona
          obj.PropinaStatus = this.activarPropinas

          if (this.BlockInvoice) {
            obj.InventoryStatus = this.header.InventoryStatus
          }
          else {
            obj.InventoryStatus = 0
          }
        
          /*if (status == 1) {
            this.$API.invoices.addServiceToClient({
              ID_Customer: obj.idcustomer,
              dateinvoice: this.form.invoicedate,
              services: serviceToGenerate,
              businesstype: JSON.parse(localStorage.getItem("user")).businesstype,
            });
          }*/

          let invalidData = this.invalid != null ? this.invalid : null;
          let ndorncData = this.ndornc != null ? this.ndornc : null;

          if (ndorncData == null && (this.form.invoicetype == 'DNC' || this.form.invoicetype == 'DND') ) {
            ndorncData = {
              FechaEmisionRelacionado: this.form.ncfecharelacionado,
              NumeroDocumentoRelacionado: this.form.nccodigorelacionado,
              TipoDocumentoRelacionado: "03",
              TipoGeneracionRelacionado: 1,
              Type: "DNC",
            }
          }

          let contingencyData =
            this.contingency != null ? this.contingency : null;

          if (this.form.timesexecute > 1 && status == 1) {
            this.loading = true;
            let quantityProcessed = 0;
            let quantityRejected = 0;
            for (let i = 0; i < this.form.timesexecute; i++) {
              if (this.cancelTimesExecute == true) {
                this.alert.show = false;
                this.showAlert(
                  "progress",
                  "Ejecutando facturas",
                  "Cancelando proceso..."
                );
                break;
              }

              let response = await this.$API.invoices.addInvoice({
                header: obj,
                items: items,
                user: JSON.parse(localStorage.getItem("user")).id,
                invalid: invalidData,
                ndornc: ndorncData,
                contingency: contingencyData,
              });

              if (response.estado == "PROCESADO") {
                if (
                  JSON.parse(localStorage.getItem("user")).businesstype ==
                    "bloodtestlaboratory" ||
                  JSON.parse(localStorage.getItem("user")).businesstype ==
                    "medicalclinic"
                ) {
                  await this.$API.invoices.addServiceToClient({
                    ID_Customer: obj.idcustomer,
                    dateinvoice: this.form.invoicedate,
                    services: serviceToGenerate,
                    businesstype: JSON.parse(localStorage.getItem("user"))
                      .businesstype,
                  });
                }
                quantityProcessed++;
              } else {
                quantityRejected++;
              }

              this.alert.show = false;
              this.showAlert(
                "progress",
                "Ejecutando facturas",
                "Procesadas: " +
                  quantityProcessed +
                  "/" +
                  this.form.timesexecute +
                  " | Rechazadas: " +
                  quantityRejected +
                  "/" +
                  this.form.timesexecute,
                "cancelTimesExecute"
              );

              if (this.cancelTimesExecute == true) {
                this.alert.show = false;
                this.showAlert(
                  "progress",
                  "Ejecutando facturas",
                  "Cancelando proceso..."
                );
                break;
              }
            }

            this.alert.show = false;

            this.loading = false;
            this.showAlert(
              "success",
              "Resultado de la facturación",
              "Procesadas: " +
                quantityProcessed +
                "/" +
                this.form.timesexecute +
                " | Rechazadas: " +
                quantityRejected +
                "/" +
                this.form.timesexecute,
              "updateFinish"
            );
          } else {
            if (this.keyMaster === '3616a6f4114dde41c65059e3a943e7ef'
            || this.keyMaster === '0636d70779280489c228f2bd3aa0ff95' 
            || this.keyMaster === 'e2d01706cc0a82a8544d1d1aa1299d16' 
            || this.keyMaster === '8ef25daf48ea91f34aeaabbe9eb5b0d2' 
            || this.UseNewEnpointToAllClient) {
              let processedInvoiceId = null;
              const invoiceAttemptKey = this.invoiceAttemptKey || this.$API.invoices.newIdempotencyKey();
              this.invoiceAttemptKey = invoiceAttemptKey;
              this.invoiceRequestInFlight = true;
              let requestCompleted = false;
              this.$API.invoices
                .createInvoice({
                  header: obj,
                  items: items,
                  user: JSON.parse(localStorage.getItem("user")).id,
                  invalid: invalidData,
                  ndornc: ndorncData,
                  contingency: contingencyData,
                  UseReserveWarehouse: JSON.parse(localStorage.getItem("user")).usereservewarehouse || 0,
                  ShowCorrelativeControl: this.ShowCorrelativeControl || 0,
                  UseNewSpNumControl: this.UseNewSpNumControl || 0,
                  ServicioDeProPinas: this.servicioDeProPinas,
                  MarkAsBilledItems: this.MarkAsBilledItems,
                }, invoiceAttemptKey, true)
                .then(async (resp) => {
                  requestCompleted = true;
                  this.invoiceAttemptKey = null;
                  //Comprobando que sea una respuesta satisfactoria del servidor
                  if (resp?.success) {
                    let response = resp.data
                    this.datatoprint.dteJson = response.billingDteJsonHeader || null;

                    //Si se retorna sendBill=1 entonces el mensaje es de facturación electrónica
                    if(response.sendBill == 1) {
                      if (response.estado == "PROCESADO") {
                        processedInvoiceId = response.billingDteJsonHeader?.ID_Invoice || null;
                        if (
                          JSON.parse(localStorage.getItem("user")).businesstype ==
                            "bloodtestlaboratory" ||
                          JSON.parse(localStorage.getItem("user")).businesstype ==
                            "medicalclinic"
                        ) {
                          this.$API.invoices.addServiceToClient({
                            ID_Customer: obj.idcustomer,
                            dateinvoice: this.form.invoicedate,
                            services: serviceToGenerate,
                            businesstype: JSON.parse(localStorage.getItem("user"))
                              .businesstype,
                          });
                        }
                        this.alertFactura.color = "comment";
                        if (response?.estadoInvalidacion === "PROCESADO") {
                          this.alertFactura.message =
                            "Se ha procesado la nueva factura con los datos editados y se ha invalidado la factura anteriormente seleccionada.";
                        } else if (response?.estadoInvalidacion === "RECHAZADO") {
                          this.alertFactura.message = `Se ha realizado y procesado la factura. Pero la invalidacion no se ha ejecutado. Por favor, invalide la factura manualmente`;
                        } else {
                          this.alertFactura.message = "Se ha realizado y procesado la factura."
                          this.alertFactura.total = this.sumObject.total
                          this.alertFactura.pagoCon = this.sumPayments
                          this.alertFactura.cambio = moneyReturn;
                        }
                        this.alertFactura.estado = response.estado;
                        this.alertFactura.description = response.descripcionMsg;
                        this.alertFactura.observaciones = response.observaciones

                        this.datatoprint.header =
                          await this.$API.invoices.getInvoice(
                            response.billingDteJsonHeader.ID_Invoice
                          );
                        this.datatoprint.body =
                          await this.$API.invoices.getAllInvoiceItems(
                            response.billingDteJsonHeader.ID_Invoice
                          );

                        if (
                          this.form.invoicetype == "DNC" ||
                          this.form.invoicetype == "DND"
                        ) {
                          this.datatoprint.docRelated =
                            await this.$API.invoices.getDocRelatedByInvoice(
                              response.billingDteJsonHeader.ID_Invoice
                            );
                        }

                        if (
                          this.form.invoicetype == "DNC" ||
                          this.form.invoicetype == "DND"
                        ) {
                          this.datatoprint.docRelated =
                            await this.$API.invoices.getDocRelatedByInvoice(
                              response.billingDteJsonHeader.ID_Invoice
                            );
                        }

                        this.print.show = false;
                        this.print3.show = false;

                        this.loading = false;
                        this.alertFactura.title = "DTE GENERADA"
                        this.alertFactura.colorTitle = "primary--text font-weight-bold"
                        this.alertFactura.show = true
                        this.alertFactura.colorBtn = "primary";
                        this.alert.options = "updateFinishAndPrintInvoice"
                      } else if (response.estado == "CONTINGENCIA") {
                        this.alertFactura.color = "warning";
                        this.alertFactura.colorTitle = "black--text font-weight-bold"
                        this.alertFactura.colorBtn = "comment"
                        this.alertFactura.message = "El DTE se ha guardado en estado de contingencia."
                        this.alertFactura.total = this.sumObject.total
                        this.alertFactura.pagoCon = this.sumPayments
                        this.alertFactura.cambio = this.moneyReturn;
                        this.alertFactura.estado = response.estado;
                        this.alertFactura.description = `${response.status}, ${response.error}`;
                        this.datatoprint.header =
                          await this.$API.invoices.getInvoice(
                            response.billingDteJsonHeader.ID_Invoice
                          );
                        this.datatoprint.body =
                          await this.$API.invoices.getAllInvoiceItems(
                            response.billingDteJsonHeader.ID_Invoice
                          );

                        this.print.show = false;
                        this.print3.show = false;

                        this.loading = false;
                        this.alertFactura.title = "DTE EN CONTINGENCIA",
                        this.alertFactura.show = true;
                        this.alert.options = "updateFinishAndPrintInvoice"
                      } else if (response.estado == "FIRMADOR") {
                        this.alertFactura.title = "ERROR DE FIRMADOR"
                        this.alertFactura.colorTitle = "black--text font-weight-bold"
                        this.alertFactura.color = "error"
                        this.alertFactura.colorBtn = "comment"
                        this.alertFactura.message = "Se ha rechazado el DTE, tomar en cuenta las observaciones del firmador y realizarla de nuevo."
                        this.alertFactura.description = response.descripcionMsg;
                        this.alertFactura.observaciones = response.observaciones;
                        this.loading = false;
                        this.alertFactura.show = true;
                        this.alert.options = "refreshDteRechazado"
                        this.tmpResponseRechazado = response
                      } else {
                        this.alertFactura.title = "DTE RECHAZADO"
                        this.alertFactura.colorTitle = "black--text font-weight-bold"
                        this.alertFactura.color = "error"
                        this.alertFactura.colorBtn = "comment"
                        this.alertFactura.message =
                          "Se ha rechazado el DTE, tomar en cuenta las observaciones del Ministerio de Hacienda y realizarla de nuevo.";
                        this.alertFactura.estado = response.estado;
                        this.alertFactura.description = response.descripcionMsg;
                        this.alertFactura.observaciones = response.observaciones;
                        this.loading = false;
                        this.alertFactura.show = true;
                        this.alert.options = "refreshDteRechazado"  
                        this.tmpResponseRechazado = response
                      }
                    } else if (response.sendBill == 0) {
                      if (obj?.invoicetype == "TCKS") {
                        this.datatoprint.header =
                          await this.$API.invoices.getInvoice(response.ID_Invoice);
                        this.datatoprint.body =
                          await this.$API.invoices.getAllInvoiceItems(
                            response.ID_Invoice
                          );

                        this.print.show = false;
                        this.print3.show = false;

                        this.loading = false;

                        this.alertFactura.message = response.message
                        this.alertFactura.total = this.sumObject.total
                        this.alertFactura.pagoCon = this.sumPayments
                        this.alertFactura.cambio = moneyReturn;
                        this.alertFactura.estado = "PROCESADO"
                        this.alertFactura.description = "NO APLICA"
                        this.alertFactura.observaciones = ""
                        this.alertFactura.title = "TICKET GENERADO"
                        this.alertFactura.colorTitle = "primary--text font-weight-bold"
                        this.alertFactura.show = true
                        this.alertFactura.colorBtn = "primary";
                        this.alert.options = "updateFinishAndPrintInvoice"
                      } else if (obj?.istemplate == 1) {
                        this.loading = false;
                        this.showAlert(
                          "success",
                          "Plantilla de factura generada",
                          response.message,
                          "updateTemplate"
                        );
                        this.$store.dispatch("reloadData", "invoices");
                      } else if (obj?.isquote == 1) {
                        this.loading = false;
                        this.showAlert(
                          "success",
                          "Cotización generada",
                          response.message,
                          "updateQuote"
                        );
                        this.$store.dispatch("reloadData", "invoices");
                      } else if (obj?.isfinance == 1) {
                        this.loading = false;
                        this.showAlert(
                          "success",
                          "Financiamiento a cuotas generada",
                          response.message,
                          "updateFinance"
                        )
                      } else {
                        this.loading = false;
                        if (this.posrestaurant === 1 && this.orderAndPrint === true) {
                          const idInvoice = response?.createdInvoice?.ID_Invoice ?? this.form?.oldIdInvoice;
                          this.datatoprint.header = await this.$API.invoices.getInvoice(idInvoice);
                          this.datatoprint.body = await this.$API.invoices.getAllInvoiceItems(idInvoice);
                          this.datatoprint.dteJson = await this.$API.invoices.getDteJsonHeaderByInvoice(idInvoice);
                          this.showAlert(
                            "success",
                            "Factura generada",
                            response.message,
                            "updateFinishAndPrintInvoice",
                          );
                        } else {
                          this.showAlert(
                            "success",
                            "Factura generada",
                            response.message,
                            "update",
                          );
                        }
                        this.$store.dispatch("reloadData", "invoices");
                      }
                    } else {
                      this.loading = false
                      let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)";
                      this.showAlert("warning", "Advertencia", message);
                    }
                  }
                  else if (!resp?.success) {
                    let response = resp.data
                    this.loading = false

                    if (resp?.lockdata) {
                      let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
                      this.showAlert("warning", "Información", message);
                    }
                    else if (resp?.typeError == "InventoryError") {
                      let message = 'No se puede crear el comprobante, se encontraron los siguientes errores: <br/><br/> '
                      message += typeof response === 'string' ? response : response?.message ?? '';
                      this.showAlert("dangerHtml", "Advertencia", message)
                    }
                    else if (response?.typeError == "DteError") {
                      let message = `Ha ocurrido un problema al momento de generar el correlativo del número de control, el sistema ha procedido a hacer la corrección en este momento.
                        <br/><br/>
                        Favor hacer clic nuevamente en Facturar para enviar el documento tributario electrónico`
                      
                      this.showAlert("dangerHtml", "Advertencia", message)
                    }
                    else {
                      let message = response.message || "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
                      this.showAlert("warning", "Advertencia", message);
                    }
                  }
                })
                .catch(async (error) => {
                  this.loading = false;
                  if (!requestCompleted) {
                    this.invoiceAttemptUncertain = !!(error?.transportFailure || error?.status === 409 || error?.status === 503);
                    if (!this.invoiceAttemptUncertain) this.invoiceAttemptKey = null;
                  }
                  if (this.invoiceAttemptUncertain) {
                    sessionStorage.setItem('lastUncertainInvoiceAttempt', invoiceAttemptKey);
                    let detail = 'No se pudo confirmar si el DTE fue procesado debido a una desconexión de internet. Se recomienda guardar el DTE y revisar el historial de facturas antes de intentar nuevamente para evitar duplicidad de DTEs';
                    try {
                      const status = await this.$API.invoices.getInvoiceAttemptStatus(invoiceAttemptKey);
                      if (status?.data?.ID_Invoice) detail += ` ID de factura: ${status.data.ID_Invoice}.`;
                      if (status?.data?.state === 'COMPLETED') detail += ' El intento terminó; abra la factura desde el historial.';
                    } catch (statusError) {
                      // La consulta no reenvía la factura.
                    }
                    this.showAlert('warning', 'Resultado pendiente', detail);
                    return;
                  }
                  if (processedInvoiceId) {
                    try {
                      await this.clearFormForPrinting();
                    } catch (clearError) {
                      console.error("No se pudo limpiar el formulario después de procesar la factura:", clearError);
                    } finally {
                      this.releaseInvoiceSubmissionLock();
                    }
                    this.showAlert(
                      "warning",
                      "Factura procesada",
                      `La factura ${processedInvoiceId} fue procesada correctamente, pero no se pudo preparar la impresión. No vuelva a facturarla; puede imprimirla desde el historial.`
                    );
                    return;
                  }
                  let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
                  this.showAlert("warning", "Advertencia", message);
                }) 
                .finally(() => {
                  this.loading = false
                  this.invoiceRequestInFlight = false;
                })   
            }
            else {
              this.$API.invoices
                .addInvoice({
                  header: obj,
                  items: items,
                  user: JSON.parse(localStorage.getItem("user")).id,
                  invalid: invalidData,
                  ndornc: ndorncData,
                  contingency: contingencyData,
                  UseReserveWarehouse: JSON.parse(localStorage.getItem("user")).usereservewarehouse || 0,
                  ShowCorrelativeControl: this.ShowCorrelativeControl || 0,
                })
                .then(async (response) => {
                  //Si se retorna sendBill=2 entonces el mensaje es de facturación con correlativos

                  //Si se retorna sendBill=1 entonces el mensaje es de facturación electrónica
                  this.datatoprint.dteJson = response.billingDteJsonHeader || null;
                  if (response.sendBill == 1) {
                    if (response.estado == "PROCESADO") {
                      if (
                        JSON.parse(localStorage.getItem("user")).businesstype ==
                          "bloodtestlaboratory" ||
                        JSON.parse(localStorage.getItem("user")).businesstype ==
                          "medicalclinic"
                      ) {
                        this.$API.invoices.addServiceToClient({
                          ID_Customer: obj.idcustomer,
                          dateinvoice: this.form.invoicedate,
                          services: serviceToGenerate,
                          businesstype: JSON.parse(localStorage.getItem("user"))
                            .businesstype,
                        });
                      }
                      this.alertFactura.color = "comment";
                      if (response?.estadoInvalidacion === "PROCESADO") {
                        this.alertFactura.message =
                          "Se ha procesado la nueva factura con los datos editados y se ha invalidado la factura anteriormente seleccionada.";
                      } else if (response?.estadoInvalidacion === "RECHAZADO") {
                        this.alertFactura.message = `Se ha realizado y procesado la factura. Pero la invalidacion no se ha ejecutado. Por favor, invalide la factura manualmente`;
                      } else {
                        this.alertFactura.message = "Se ha realizado y procesado la factura."
                        this.alertFactura.total = this.sumObject.total
                        this.alertFactura.pagoCon = this.sumPayments
                        this.alertFactura.cambio = moneyReturn;
                      }
                      this.alertFactura.estado = response.estado;
                      this.alertFactura.description = response.descripcionMsg;
                      this.alertFactura.observaciones = response.observaciones

                      this.datatoprint.header =
                        await this.$API.invoices.getInvoice(
                          response.billingDteJsonHeader.ID_Invoice
                        );
                      this.datatoprint.body =
                        await this.$API.invoices.getAllInvoiceItems(
                          response.billingDteJsonHeader.ID_Invoice
                        );

                      if (
                        this.form.invoicetype == "DNC" ||
                        this.form.invoicetype == "DND"
                      ) {
                        this.datatoprint.docRelated =
                          await this.$API.invoices.getDocRelatedByInvoice(
                            response.billingDteJsonHeader.ID_Invoice
                          );
                      }

                      if (
                        this.form.invoicetype == "DNC" ||
                        this.form.invoicetype == "DND"
                      ) {
                        this.datatoprint.docRelated =
                          await this.$API.invoices.getDocRelatedByInvoice(
                            response.billingDteJsonHeader.ID_Invoice
                          );
                      }

                      this.loading = false;
                      this.alertFactura.title = "DTE GENERADA"
                      this.alertFactura.colorTitle = "primary--text font-weight-bold"
                      this.alertFactura.show = true
                      this.alertFactura.colorBtn = "primary";
                      this.alert.options = "updateFinishAndPrintInvoice"
                    } else if (response.estado == "CONTINGENCIA") {
                      this.alertFactura.color = "warning";
                      this.alertFactura.colorTitle = "black--text font-weight-bold"
                      this.alertFactura.colorBtn = "comment"
                      this.alertFactura.message = "El DTE se ha guardado en estado de contingencia."
                      this.alertFactura.total = this.sumObject.total
                      this.alertFactura.pagoCon = this.sumPayments
                      this.alertFactura.cambio = this.moneyReturn;
                      this.alertFactura.estado = response.estado;
                      this.alertFactura.description = `${response.status}, ${response.error}`;
                      this.datatoprint.header =
                        await this.$API.invoices.getInvoice(
                          response.billingDteJsonHeader.ID_Invoice
                        );
                      this.datatoprint.body =
                        await this.$API.invoices.getAllInvoiceItems(
                          response.billingDteJsonHeader.ID_Invoice
                        );

                      this.loading = false;
                      this.alertFactura.title = "DTE EN CONTINGENCIA",
                      this.alertFactura.show = true;
                      this.alert.options = "updateFinishAndPrintInvoice"
                    } else {
                      this.alertFactura.title = "DTE RECHAZADO"
                      this.alertFactura.colorTitle = "black--text font-weight-bold"
                      this.alertFactura.color = "error"
                      this.alertFactura.colorBtn = "comment"
                      this.alertFactura.message =
                        "Se ha rechazado el DTE, tomar en cuenta las observaciones del Ministerio de Hacienda y realizarla de nuevo.";
                      this.alertFactura.estado = response.estado;
                      this.alertFactura.description = response.descripcionMsg;
                      this.alertFactura.observaciones = response.observaciones;
                      this.loading = false;
                      this.alertFactura.show = true;
                    }
                  } else if (response.sendBill == 0) {
                    if (obj?.invoicetype == "TCKS") {
                      this.datatoprint.header =
                        await this.$API.invoices.getInvoice(response.ID_Invoice);
                      this.datatoprint.body =
                        await this.$API.invoices.getAllInvoiceItems(
                          response.ID_Invoice
                        );

                      this.loading = false;
                      this.showAlert(
                        "success",
                        "Ticket generado",
                        response.message,
                        "updateFinishAndPrintInvoice"
                      );
                    } else if (obj?.istemplate == 1) {
                      this.loading = false;
                      this.showAlert(
                        "success",
                        "Plantilla de factura generada",
                        response.message,
                        "updateTemplate"
                      );
                      this.$store.dispatch("reloadData", "invoices");
                    } else if (obj?.isquote == 1) {
                      this.loading = false;
                      this.showAlert(
                        "success",
                        "Cotización generada",
                        response.message,
                        "updateQuote"
                      );
                      this.$store.dispatch("reloadData", "invoices");
                    } else {
                      this.loading = false;
                      this.showAlert(
                        "success",
                        "Factura generada",
                        response.message,
                        "update"
                      );
                      this.$store.dispatch("reloadData", "invoices");
                    }
                  } else {
                    this.loading = false
                    if (response?.typeError == "DteError") {
                      let message = `Ha ocurrido un problema al momento de generar el correlativo del número de control, el sistema ha procedido a hacer la corrección en este momento.
                        <br/><br/>
                        Favor hacer clic nuevamente en Facturar para enviar el documento tributario electrónico`
                      
                      this.showAlert("dangerHtml", "Advertencia", message)
                    }
                  }
                })
                .catch(() => {
                  this.loading = false;
                  let message = "Ocurrio un problema al realizar la factura. ¡Por favor intentarlo nuevamente!";
                  this.showAlert("danger", "Advertencia", message);
                });
            }
          }
        } else {
          this.showAlert(
            "danger",
            "Advertencia",
            "Por favor seleccione un cliente para facturar."
          );
          this.loading = false
        }
      } else {
        if (
          this.form.legalidinvoice != "No hay correlativo" &&
          JSON.parse(localStorage.getItem("FaMh")).AuthFeActive == 0
        ) {
          this.showAlert(
            "danger",
            "Advertencia",
            "No se puede generar facturas sin correlativo."
          );
          this.loading = false
        } else if (JSON.parse(localStorage.getItem("FaMh")).AuthFeActive == 1) {
          this.showAlert(
            "danger",
            "Advertencia",
            "No se puede generar facturas si no se ha configurado las credenciales de facturación electrónica en la configuración del negocio o sucursal."
          );
          this.loading = false
        } else {
          this.showAlert(
            "danger",
            "Advertencia",
            "Ha ocurrido un problema, no se pudo generar la factura. Por favor contacte al administrador del sistema."
          );
          this.loading = false
        }
      }
    },
    async loadpriceProducts() {
      if (this.isCustomerSelected) {
        this.loading = true
        await this.getProducts()
        await this.getServices()

        this.productsToBill.forEach((element) => {
          this.pricelistDetail.forEach((item) => {
            if (element.ID_Item == item.ID_Item && item.InitialRange == null) {
              element.ItemNewPrice = item.ItemNewPrice;

              if (this.noaddivainpos) {
                element.TmpItemNewPrice = parseFloat(
                  parseFloat(item.ItemOriginalPrice).toFixed(8)
                );
              }
              else {
                if (this.ishosting && this.addimpturismo && item.TurismoPorAlojamiento) {
                  element.TmpItemNewPrice = parseFloat(
                    parseFloat(item.ItemOriginalPrice / 1.18).toFixed(8)
                  );
                }
                else {
                  element.TmpItemNewPrice = parseFloat(
                    parseFloat(item.ItemOriginalPrice / 1.13).toFixed(8)
                  );
                }
              }
              
              element.TmpCounter = 0;
            }
          });
        });
        this.showProductsAndServices = !this.showProductsAndServices;
        this.loading = false
      } else {
        this.showAlert(
          "danger",
          "Advertencia",
          "Debe seleccionar un cliente para agregar productos"
        );
      }
    },
    reactiveMainProductsFilter() {
      if (!Array.isArray(this.productToBillPrev)) {
        this.productToBillPrev = [];
      }
      try {
        this.productsToBill = [
          ...this.productToBillPrev.filter((el) => {
            /* MODIFICACIONES INTRODUCIDAS PARA MOSTRAR LOS PRODUCTOS DE DISTINTOS LOTES POR EMANUEL */
            if (this.PriceListSelected != null && this.PriceListSelected != 0) {
              return (
                el.Warehouse === this.warehouseSelected &&
                el.PriceListName === this.PriceListSelected
              );
            } else if (
              this.warehouseSelected != null &&
              this.warehouseSelected != 0
            ) {
              return el.Warehouse === this.warehouseSelected;
            } else {
              return el;
            }
            /* FIN MODIFICACIONES INTRODUCIDAS PARA MOSTRAR LOS PRODUCTOS DE DISTINTOS LOTES POR EMANUEL */
          }),
        ];
        this.search.warehouse = this.warehouseSelected;
        this.search.pricelist = this.PriceListSelected;

        this.productsToBillForSelector = [
          ...this.productToBillPrev.filter((el) => {
            return (
              el.Warehouse === this.warehouseSelected &&
              el.PriceListName === this.PriceListSelected
            );
          }),
        ];

        this.servicesToBillForSelector = [...this.servicesToBillSearchTab];
      } catch (error) {
        console.log(error);
      }

      for (const element of this.productToBillPrev) {
        const { ID_Item, Warehouse } = element;
        if (this.warehouseSelected === Warehouse) {
          const foundProduct = this.productsToBill.find(
            (current) =>
              current.ID_Item === ID_Item && current.Warehouse === Warehouse
          );
          if (!foundProduct) {
            this.productsToBill.push(element);
            this.productsToBillForSelector.push(element);
          }
        }
      }

      this.ProductServList = [
        ...this.productsToBill.map((element) => {
          return {
            ID: `${element.ItemName}${
              element.ItemComercialName ? " | " + element.ItemComercialName : ""
            }`,
            val: element.ID_Item,
            prod: { ...element, type: "product" },
          };
        }),
      ];

      this.ProductServList.push(
        ...this.servicesToBillSearchTab.map((element) => {
          return {
            ID:
              element.NameService + (element.Name ? " | " + element.Name : ""),
            val: element.CodeService,
            prod: { ...element, type: "service" },
          };
        })
      );
    },
    loadpriceProductsOnFilter() {
      this.reactiveMainProductsFilter();
      //ItemNewPrice
      //pricelistDetail
      this.productsToBill.forEach((element) => {
        this.pricelistDetail.forEach((item) => {
          if (element.ID_Item == item.ID_Item && item.InitialRange == null) {
            element.ItemNewPrice = item.ItemNewPrice;

            if (this.noaddivainpos) {
              element.TmpItemNewPrice = parseFloat(
                parseFloat(item.ItemOriginalPrice).toFixed(8)
              );
            }
            else {
              if (this.ishosting && this.addimpturismo && item.TurismoPorAlojamiento) {
                element.TmpItemNewPrice = parseFloat(
                  parseFloat(item.ItemOriginalPrice / 1.18).toFixed(8)
                );
              }
              else {
                element.TmpItemNewPrice = parseFloat(
                  parseFloat(item.ItemOriginalPrice / 1.13).toFixed(8)
                );
              }
            }
            
            element.TmpCounter = 0;
          }
        });
      });
    },
    addProductAndService() {
      if (this.barcode === ".C0ntraseniaP@ssw0rdInn0v@Intern@-23") {
        this.showTimesExecute = true;
      }

      if (this.isCustomerSelected) {
        if (
          !this.productsToShow.find(
            (i) => i.ID_Item == this.barcode || i.ItemBarCode == this.barcode
          )
        ) {
          if (
            this.productsToBill.find(
              (i) => i.ID_Item == this.barcode || i.ItemBarCode == this.barcode
            )
          ) {
            var data = this.productsToBill.find(
              (i) => i.ID_Item == this.barcode || i.ItemBarCode == this.barcode
            );
            this.productsToShow.push({ ...data, qty: 1, UnitCost: 0 });
          }
        }
      } else {
        this.showAlert(
          "danger",
          "Advertencia",
          "Debe seleccionar un cliente para agregar productos"
        );
      }

      this.barcode = "";
      document.getElementById("input_barcode").focus();
    },

    async applyGlobalDiscount() {
      if (!this.validateGlobalDiscount()) {
        return;
      }

      const discountPercent = this.parseGlobalDiscountValue(
        this.globalDiscount.TotalPriceDiscountPercent
      );
      const discountAmount = this.parseGlobalDiscountValue(
        this.globalDiscount.TotalNewPrice
      );
      const currentSummary = this.buildInvoiceSummary(false);

      if (discountPercent === null || discountAmount === null) {
        this.showAlert(
          "warning",
          "Información",
          "No se pudo determinar el descuento global a aplicar."
        );
        return;
      }

      const globalDiscount = this.getGlobalDiscountContext(currentSummary, {
        percent: discountPercent,
        amount: discountAmount,
      });

      if (!globalDiscount) {
        this.showAlert(
          "warning",
          "InformaciÃ³n",
          "No se pudo determinar el descuento global a aplicar."
        );
        return;
      }

      this.loading = true;
      this.appliedGlobalDiscount = { ...globalDiscount };

      this.showDiscountGlobal = false;
      this.resetGlobalDiscountModal();
      this.loading = false;
    },
    removeGlobalDiscount() {
      this.loading = true;
      this.resetAppliedGlobalDiscount();
      this.resetGlobalDiscountModal();
      this.showDiscountGlobal = false;
      this.loading = false;
    },

    //Edit ivoice
    async loadInvoiceHeader() {
      if (this.invalid != null) {
        this.workingIn =
          "AGREGANDO NUEVO DTE CON DATOS CORREGIDOS\nSE INVALIDARÁ EL DTE: " +
          this.header.ID_Invoice;
        this.invalid.oldIdInvoice = this.header.ID_Invoice;
        this.form.invoicetype = this.header.InvoiceType;
        //this.getInvoiceId().subscribe();
      } else if (this.ndornc != null) {
        if (this.ndornc.Type == "DND") {
          this.workingIn =
            "AGREGANDO NOTA DE DÉBITO\nDOCUMENTO RELACIONADO: " +
            this.header.ID_Invoice;
          this.form.invoicetype = "DND";
        }

        if (this.ndornc.Type == "DNC") {
          this.workingIn =
          "AGREGANDO NOTA DE CRÉDITO\nDOCUMENTO RELACIONADO: " +
          this.header.ID_Invoice;
          this.form.invoicetype = "DNC";
        }
        
        if (this.contingency != null) {
          this.form.oldIdInvoice = this.header.ID_Invoice;
          this.form.invoicetype = this.header.InvoiceType;
          this.form.invoicedate = this.header.InvoiceDate;
        }

        //this.getInvoiceId().subscribe();
      } else if (this.header?.IsTemplate == 1) {
        this.workingIn = `AGREGANDO NUEVO DTE\nUSANDO PLANTILLA: (${this.header.TemplateName})`;
        this.form.invoicetype = this.header.InvoiceType;
        //this.getInvoiceId().subscribe();
      } else if (this.contingency != null) {
        this.workingIn = `FACTURANDO FACTURA EN ESTADO: ${this.header.FeMhEstado}\nID FACTURA: ${this.header.ID_Invoice}`;
        this.form.oldIdInvoice = this.header.ID_Invoice;
        this.form.invoicetype = this.header.InvoiceType;
        //this.getInvoiceId().subscribe();
        this.form.invoicedate = this.header.InvoiceDate;
        this.EnableNegativeItem = 1
      } else if (this.copy != null) {
        this.form.invoicetype = this.header.InvoiceType;
        this.copiedPaymentsInitialized = false;
        
        if (this.form.invoicetype == "DNR") {
          this.MarkAsBilledItems = { ID_Invoice: this.header.ID_Invoice };
          this.MarkAsBilledItems.Pk_ID_Items = this.body.map(item => ({
              Pk_ID_Item: item.Pk_billing_invoices_details,
              MaxQuantity: item.ItemQuantity
            })
          );
          this.form.invoicetype = "FCF";
        }

        if (this.form.invoicetype == "COT") {
          this.form.invoicetype = "FCF";
        }

        //this.getInvoiceId().subscribe();
      } else if (this.quote != null) {
        this.workingIn = "EDITANDO COTIZACIÓN: " + this.header.ID_Invoice
        this.form.invoicetype = "COT";
        this.form.isquote = 1;
        this.form.oldIdInvoice = this.header.ID_Invoice;
      } 
      else {
        if (this.invoiceAutoSave && this.header.ID_Invoice.startsWith('AUT')) {
          this.tempId = this.header.ID_Invoice
          this.workingIn = "AGREGANDO NUEVO DTE: " + this.retornarDTEname
        }
        else {
          this.workingIn = "EDITANDO FACTURA SIN PROCESAR";
        }
        
        this.form.oldIdInvoice = this.header.ID_Invoice;
        this.form.invoicetype = this.header.InvoiceType;

        if (this.form.invoicetype == "COT") {
          this.form.invoicetype = "FCF";
        }

        //this.getInvoiceId().subscribe();
      }

      if (this.header && this.header.ID_Customer) {
        this.isCustomerSelected = true;
      }
      this.form.idcustomer = this.header.ID_Customer;
      this.form.invoiceinternalnote = this.header.InvoiceInternalNote;
      this.form.rulestoshowcomments = this.header.RulesToShowComments;

      if (!this.pospayments) {
        this.form.invoicepaymenttype = this.header.InvoicePaymentType;
      }

      this.form.seguro = this.header.Seguro || 0;
      this.form.flete = this.header.Flete || 0;
      this.form.fexzona =  this.header.FexZona || null
      this.form.portofdeparture = this.header.PortOfDeparture || null
      this.form.shipmentno = this.header.ShipmentNo || null
      this.form.containerno = this.header.ContainerNo || null
      this.form.blno = this.header.BlNo || null
      this.form.vesselvoyage = this.header.VesselVoyage || null
      this.form.usadfa = this.header.UsadFa || null
      this.form.termsofpayment = this.header.TermsOfPayment || null
      this.form.codincoterms = this.header.CodIncoterms || null
      this.form.stockproductsinreserve = this.header.StockProductsInReserve || 0
      this.form.ventaterceronit = this.header.VentaTerceroNit || null
      this.form.ventaterceronombre = this.header.VentaTerceroNombre || null
      this.form.legaladdress2 = this.header.InvoiceAddress2 || ""
      this.addimpturismo = this.header.CheckTurismoPorAlojamiento || 0
      this.noaddivainpos = this.header.CheckPriceWithoutIvaCCF || this.noaddivainpos
      this.form.ID_Technical = this.header.ID_Technical || ""
      this.form.extensionnombentrega = this.header.InvoiceExtNombEntrega || ""
      this.form.extensiondocuentrega = this.header.InvoiceExtDocuEntrega || ""
      this.form.extensiontelefonoentrega = this.header.InvoiceExtTelEntrega || ""
      this.form.extensionnombrecibe = this.header.InvoiceExtNombRecibe || ""
      this.form.extensiondocurecibe = this.header.InvoiceExtDocuRecibe || ""
      this.form.extensiontelefonorecibe = this.header.InvoiceExtTelRecibe || ""
      this.form.showresponsabilitiesininvoice = this.header.ShowResponsabilitiesInInvoice || 0
      this.syncResponsibleDteUserSelectionFromForm()
      const headerApendice =
        Array.isArray(this.header.apendice) && this.header.apendice.length > 0
          ? this.header.apendice
          : Array.isArray(this.header.Apendice) && this.header.Apendice.length > 0
            ? this.header.Apendice
            : null
      this.syncApendiceStateFromForm(headerApendice)

      const loadedPropina = parseFloat(this.header.InvoicePropinas) || 0
      if (["FCF", "CCF"].includes(this.form.invoicetype)) {
        this.activarPropinas = loadedPropina > 0 ? 1 : 0
      } else {
        this.activarPropinas = 0
      }

      if (this.ndornc != null) {
        this.form.invoicestatusdescription = "Cancelada";
      } else {
        this.form.invoicestatusdescription =
          this.header.InvoiceStatusDescription;
      }

      this.form.invoicecreditday = this.header.InvoiceCreditDay;
      this.form.ID_Seller = this.header.ID_Seller;
      
      if (this.header && this.header.ID_Customer) {
        if (this.form.invoicetype == "FNS" && this.form.idcustomer.includes("PROV")) {
          await this.$API.providers.getSpecifiedProvider(this.form.idcustomer)
            .then(response => {
              this.customerSelected(
                {
                  ID_Customer: response.ID_Provider,
                  FirstName: response.ProviderName,
                  LastName: null,
                  PhoneNumber: response.ProviderPhone,
                  MobileNumber: response.ProviderMobileNumber,
                  Email: null,
                  Gender: null,
                  Age: null,
                  DateofBirth: null,
                  Address: response.ProviderAddress,
                  City: response.ProviderCity,
                  State: response.ProviderState,
                  Country: response.ProviderCountry,
                  Notes: null,
                  Status: 1,
                  SendEmail: 0,
                  SendSMS: 0,
                  SendWhatsapp: 0,
                  SendPushUp: 0,
                  Is_a_Business: true,
                  BusinessName: response.ProviderName,
                  BusinessPhone: response.ProviderPhone,
                  BusinessMobileNumber: response.ProviderMobileNumber,
                  BusinessEmail: response.ProviderEmail,
                  BusinessContactName: response.ProviderContactName,
                  BusinessContactPhone: response.ProviderContactPhone,
                  BusinessContactMobile: response.ProviderContactMobile,
                  BusinessContactEmail: response.ProviderContactEmail,
                  BusinessWebsite: null,
                  SendEmail_BusinessEmail: 0,
                  SendSMS_BusinessMobile: 0,
                  SendWhatsapp_BusinessMobile: 0,
                  LegalName: response.ProviderLegalName,
                  LegalAddress: response.ProviderLegalAddress,
                  LegalNRC: response.ProviderLegalNRC,
                  LegalNIT: response.ProviderLegalNIT,
                  dui: null,
                  LegalSector: response.ProviderLegalSector,
                  LegalEntity: response.ProviderLegalEntity,
                  LegalTaxPayerSize: response.ProviderLegalTaxPayerSize,
                  LegalIsNonTaxable: response.ProviderLegalIsNonTaxable,
                  LegalIsExempt: 0,
                  LegalInfo: null,
                  ID_Business: response.ID_Business,
                  ID_Branch: response.ID_Branch,
                  ID_User_Insert: response.ID_User_Insert,
                  ID_User_Update: response.ID_User_Update,
                  Department: response.ProviderState,
                  Municipality: response.ProviderCity,
                  codActividad: null,
                  descActividad: null,
                  ID_DocumentType: 0,
                  Prefijo: null,
                  PriceListName: 0,
                  LimitCredit: 0,
                  OldID: null,
                  isGlobalBranch: response.IsGlobalBranch,
                  Is_a_PublicEntity: 0,
                  Is_a_Ong: 0,
                  RemoveRestrictionPublicEntity: 0,
                  CreditPeriod: 0,
                  CreditStatus: "DISPONIBLE",
                  CountryMH: null,
                  ZoneClient: null,
                  isDeleted: 0,
                  LegalReteRenta: 0,
                  IsSeveralCustomer: 0,
                  TypeInvoice: null,
                  StatusInvoice: null
                },
                true
              )
            })
        }
        else {
          await this.$API.customers
            .getOneCustomer(this.form.idcustomer)
            .then((response) => {
              this.customerSelected(response, true);
          });
        }
      }

      this.form.zoneclient = this.header.ZoneClient || "";
      this.form.legalname = this.header.InvoiceName;
      this.form.codasociado = this.header.CodAsociado || null
      this.form.docasociado = this.header.DocAsociado || ""
      this.form.detalleasociado = this.header.DetalleAsociado || ""
      this.form.modotransp = this.header.ModoTransp || null
      this.form.numconductor = this.header.NumConductor || null
      this.form.nombreconductor = this.header.NombreConductor || null
      this.form.placatrans = this.header.PlacaTrans || null
    },
    async loadInvoiceItems() {
      this.productsToShow = [];
      this.allowRepetitionOfArticles = true
      let noCheck = []
      //console.log('//// Load Invoice items')
      //console.log(this.body)
      for (let item of this.body) {
        if (item.ItemType != "service") {
          const listaDeProductos = this.productsToBill

          let batch = !item.ID_ItemBatch || item.ID_ItemBatch == "" ? null : item.ID_ItemBatch;
          
          let i = listaDeProductos.filter(
            (i) =>
              i.ID_Item === item.ID_Item &&
              i.Warehouse === item.Warehouse &&
              i.ID_ItemBatch === batch 
          )[0] || {}; //10/04/2024 Resolver porque a veces viene con lista de precio, cuando el producto no se relaizo con lista de precios.
          //19/02/2026 Al fin se resolvio.
          
          const itemData = {
            ...i,
            ID_Item: i?.ID_Item || item?.ID_Item,
            Pk_billing_invoices_details: item.Pk_billing_invoices_details,
            ItemCurrentQuantity: item.ItemCurrentQuantity,
            qty: item?.ItemQuantity,
            ItemNewPrice: item?.ItemUnitPrice,
          };

          await this.showProduct(itemData, false, true);
          const currentItemKey = item.Pk_billing_invoices_details || null;
          for (let j = 0; j < this.productsToShow.length; j++) {
            const matchesLoadedItem = currentItemKey
              ? this.productsToShow[j].Pk_billing_invoices_details == currentItemKey
              : this.productsToShow[j].ID_Item == item.ID_Item;

            if (matchesLoadedItem && !noCheck.includes(this.productsToShow[j].uuid)) {
              
              noCheck.push(this.productsToShow[j].uuid)
              this.productsToShow[j].ItemName = item.ItemDescription;
              
              if (
                this.form.invoicetype == "CCF" ||
                this.form.invoicetype == "DNC" ||
                this.form.invoicetype == "DND"
              ) {
                if (!this.restivaposexentonosuj && (item.ItemNoSuj > 0 || item.ItemExenta > 0 || item.ItemNoGravada > 0)) {
                  this.productsToShow[j].ItemOriginalPrice = item.ItemUnitPrice
                }
                else {
                  if (this.ishosting && this.addimpturismo && this.productsToShow[j].TurismoPorAlojamiento && !this.noaddivainpos) {
                    this.productsToShow[j].ItemOriginalPrice = parseFloat(
                      (item.ItemUnitPrice * 1.18).toFixed(8)
                    );  
                  }
                  else {
                    if (this.noaddivainpos) {
                      this.productsToShow[j].ItemOriginalPrice = item.ItemUnitPrice
                    }
                    else {
                      this.productsToShow[j].ItemOriginalPrice = parseFloat(
                        (item.ItemUnitPrice * 1.13).toFixed(8)
                      );
                    }
                  }
                }
                
                this.productsToShow[j].ItemNewPrice =
                  this.productsToShow[j].ItemOriginalPrice -
                  (this.productsToShow[j].ItemOriginalPrice *
                    item.ItemDiscountPercent) /
                    100;
                this.productsToShow[j].TmpItemNewPrice = item.ItemUnitPrice;
              } else {
                if (this.restivaposexentonosuj && (item.ItemNoSuj > 0 || item.ItemExenta > 0 || item.ItemNoGravada > 0)) {
                  this.productsToShow[j].ItemOriginalPrice = parseFloat(
                    (item.ItemUnitPrice * 1.13).toFixed(8)
                  );
                }
                else {
                  this.productsToShow[j].ItemOriginalPrice = item.ItemUnitPrice;
                }

                this.productsToShow[j].ItemNewPrice =
                  this.productsToShow[j].ItemOriginalPrice -
                  (this.productsToShow[j].ItemOriginalPrice *
                    item.ItemDiscountPercent) /
                    100;
                
                //this.productsToShow[j].ItemNewPrice = item.ItemUnitPrice;
                this.productsToShow[j].TmpItemNewPrice = item.ItemUnitPrice;
              }

              this.productsToShow[j].qty = item.ItemQuantity;
              item.ItemIncomeTax > 0
                ? (this.productsToShow[j].nontaxable2 = true)
                : "";

              if (item.ItemNoSuj > 0) {
                this.productsToShow[j].nonsuj = true;
                this.productsToShow[j].nonsuj2 = true;
              } else {
                this.productsToShow[j].nonsuj = false;
                this.productsToShow[j].nonsuj2 = false;
              }

              if (item.ItemExenta > 0) {
                this.productsToShow[j].nontaxable = true;
                this.productsToShow[j].nontaxable2 = true;
              } else {
                this.productsToShow[j].nontaxable = false;
                this.productsToShow[j].nontaxable2 = false;
              }

              if (item.ItemNogravada > 0) {
                this.productsToShow[j].nogravada = true;
                this.productsToShow[j].nogravada2 = true;
              }
              else {
                this.productsToShow[j].nogravada = false;
                this.productsToShow[j].nogravada2 = false;
              }

              if (item.ItemDiscountPercent > 0) {
                this.productsToShow[j].ItemPriceDiscountPercent =
                  item.ItemDiscountPercent;
                
                this.productsToShow[j].ItemPriceDiscountAmount =
                  (item.ItemDiscountPercent / 100) *
                  this.productsToShow[j].ItemOriginalPrice;

                this.discountObject = this.productsToShow[j];
              } else {
                // 10/04/2024 Parche temporal.
                this.productsToShow[j].ItemPriceDiscountPercent = 0;
                this.productsToShow[j].ItemPriceDiscountAmount = 0;

                this.discountObject = this.productsToShow[j];
              }

              this.productsToShow[j].LineaAerea = item?.LineaAerea || ""
              this.productsToShow[j].Boleto = item?.Boleto || ""
              this.productsToShow[j].Pasajero = item?.Pasajero || ""
              this.productsToShow[j].Ruta = item?.Ruta || ""
            }
          }
        } else {
          let i = this.servicesToBill.find(
            (i) => i.CodeService == item.ID_Item
          );
          const serviceData = {
            ...i,
            Pk_billing_invoices_details: item.Pk_billing_invoices_details,
            ItemCurrentQuantity: item.ItemCurrentQuantity,
            qty: item?.ItemQuantity,
            ItemNewPrice: item?.ItemUnitPrice,
          };

          if (item.ID_Item != "SERVPROPINAS" || ["DNC", "DND"].includes(this.form.invoicetype)) {
            await this.showService(serviceData, false, true);
          }
          const currentItemKey = item.Pk_billing_invoices_details || null;
          for (let j = 0; j < this.productsToShow.length; j++) {
            const matchesLoadedItem = currentItemKey
              ? this.productsToShow[j].Pk_billing_invoices_details == currentItemKey
              : this.productsToShow[j].ID_Item == item.ID_Item;

            if (matchesLoadedItem && !noCheck.includes(this.productsToShow[j].uuid) && ( item.ID_Item != "SERVPROPINAS" || ["DNC", "DND"].includes(this.form.invoicetype) ) ) {
              
              noCheck.push(this.productsToShow[j].uuid)
              this.productsToShow[j].ItemName = item.ItemDescription;

              if (
                this.form.invoicetype == "CCF" ||
                this.form.invoicetype == "DNC" ||
                this.form.invoicetype == "DND"
              ) {
                if (this.ishosting && this.addimpturismo && this.productsToShow[j].TurismoPorAlojamiento && !this.noaddivainpos) {
                  this.productsToShow[j].ItemOriginalPrice = parseFloat(
                    (item.ItemUnitPrice * 1.18).toFixed(8)
                  );
                }
                else {
                  if (this.noaddivainpos) {
                    this.productsToShow[j].ItemOriginalPrice = item.ItemUnitPrice
                  }
                  else {
                    this.productsToShow[j].ItemOriginalPrice = parseFloat(
                      (item.ItemUnitPrice * 1.13).toFixed(8)
                    );
                  }
                }
                
                this.productsToShow[j].ItemNewPrice =
                  this.productsToShow[j].ItemOriginalPrice -
                  (this.productsToShow[j].ItemOriginalPrice *
                    item.ItemDiscountPercent) /
                    100;
                this.productsToShow[j].TmpItemNewPrice = item.ItemUnitPrice;
              } else {
                if (this.restivaposexentonosuj && (item.ItemNoSuj > 0 || item.ItemExenta > 0)) {
                  this.productsToShow[j].ItemOriginalPrice = parseFloat(
                    (item.ItemUnitPrice * 1.13).toFixed(8)
                  );
                }
                else {
                  this.productsToShow[j].ItemOriginalPrice = item.ItemUnitPrice;
                }
                
                this.productsToShow[j].ItemNewPrice = item.ItemUnitPrice;
                this.productsToShow[j].TmpItemNewPrice = item.ItemUnitPrice;
              }

              this.productsToShow[j].qty = item.ItemQuantity;
              item.ItemIncomeTax > 0
                ? (this.productsToShow[j].nontaxable2 = true)
                : "";

              if (item.ItemNoSuj > 0) {
                this.productsToShow[j].nonsuj = true;
                this.productsToShow[j].nonsuj2 = true;
              } else {
                this.productsToShow[j].nonsuj = false;
                this.productsToShow[j].nonsuj2 = false;
              }

              if (item.ItemExenta > 0) {
                this.productsToShow[j].nontaxable = true;
                this.productsToShow[j].nontaxable2 = true;
              } else {
                this.productsToShow[j].nontaxable = false;
                this.productsToShow[j].nontaxable2 = false;
              }

              if (item.ItemNoGravada > 0) {
                this.productsToShow[j].nogravada = true;
                this.productsToShow[j].nogravada2 = true;
              }
              else {
                this.productsToShow[j].nogravada = false;
                this.productsToShow[j].nogravada2 = false;
              }

              if (item.ItemDiscountPercent > 0) {
                this.productsToShow[j].ItemPriceDiscountPercent =
                  item.ItemDiscountPercent;
                this.productsToShow[j].ItemPriceDiscountAmount =
                  this.productsToShow[j].ItemOriginalPrice -
                  this.productsToShow[j].ItemNewPrice;

                this.discountObject = this.productsToShow[j];
              }

              this.productsToShow[j].LineaAerea = item?.LineaAerea || ""
              this.productsToShow[j].Boleto = item?.Boleto || ""
              this.productsToShow[j].Pasajero = item?.Pasajero || ""
              this.productsToShow[j].Ruta = item?.Ruta || ""
            }
          }
        }
      }
      this.filterProducts.id_invoice = null
      this.stopIn = true;
      //await this.getProducts();
      //await this.getServices();
      this.sumObject;
      this.allowRepetitionOfArticles = false
    },
    loadQuoteBill() {
      this.workingIn = "CREANDO COTIZACIÓN";
      this.form.invoicetype = "COT";
      this.form.isquote = 1;
      this.form.invoiceinternalnote = JSON.parse(localStorage.getItem("user")).defaultquotecomments
      this.getInvoiceId().subscribe();
    },
    changedItemPrice(value, status) {
      if (status == 1) {
        return (value / 1.13).toFixed(8);
      } else {
        return value.toFixed(8);
      }
    },
    showPaymentWithDecimal(data) {
      if (data.totalPayment == "" || data.totalPayment == null) {
        data.totalPayment = 0.0;
        this.handleRowChangedPayments();
      }

      data.totalPayment = this.normalizePaymentAmount(data.totalPayment);
    },
    syncResponsibilitiesInvoiceByTotal(total) {
      const parsedTotal = parseFloat(total);

      if (!Number.isNaN(parsedTotal) && parsedTotal >= 25000) {
        this.form.showresponsabilitiesininvoice = 1;
      }
    },
    getZoneConfiguration() {
      this.$API.business.getZoneConfiguration().then((response) => {
        if (response.length > 0) {
          let data = response[0];

          if (data?.ZoneConfiguration) {
            let zones = data.ZoneConfiguration;
            this.ZoneConfiguration = zones
              .split(" | ")
              .map((item) => item.trim());
          }
        }
      });
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    async getItemCostByIdProduct(ID_Item) {
      let cost = 0;
      try {
        var dataCost = await this.$API.products.getItemCostByIdProduct({ ID_Item: ID_Item })
        
        if (dataCost.length > 0) {
          cost = parseFloat(parseFloat(dataCost[0].costo_unitario || 0).toFixed(2))
        }
      }
      catch(err) {
        console.log(err)
      }
      
      return cost
    }
  },
};
</script>

<style scoped>
::v-deep .propina-check {
  float: right;
}
::v-deep .propina-input input {
  text-align: right;
}
::v-deep .text-wrap {
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: anywhere;
  vertical-align: top;
}
.centered-input >>> input {
  text-align: center
}

.w-full {
  width: 100%;
}

.grid-action-disabled {
  opacity: 0.5;
  pointer-events: none;
}

.product-filter-inline-selects {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
}

::v-deep .product-filter-inline-selects .v-input {
  min-width: 190px;
  max-width: 220px;
}

::v-deep .product-filter-inline-selects--grid .row > [class*="col-"] .v-input {
  width: 100%;
  min-width: 0;
  max-width: none;
}

.totalDesign {
  background-color: #00a178 !important;
  font-weight: bold !important;
  color: white !important;
  font-size: 25px;
  max-width: 165px !important;
}

.input-group.mb-3 {
  text-align: center;
}

.input-group-prepend {
  text-align: left;
}

input.form-control {
  background: #d6eaf3;
  border: 1px solid #1976d2;
  text-align: center;
  max-width: 80px;
  height: 30px;
  border-radius: 20px;
}

.filter-btn {
  position: absolute;
  top: 60px;
  left: 30px;
  z-index: 9;
}

.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabsContent:hover {
  background-color: #ffb266;
  cursor: pointer;
}

.tabsContent {
  width: 100%;
  padding: 10px;
  background-color: #f29d35;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.basic-action {
  background: #f0f8ff;
  position: -webkit-sticky;
  position: sticky;
  border-radius: 5px;
  border: 1px solid #cccccc;
  margin-top: 20px;
  bottom: 0;
}

.box {
  border-style: solid !important;
  border-color: black !important;
  border-width: 1px !important;
  background-color: white;
  padding: 0.5rem;
  border-radius: 15px;
  margin: 0.1rem;
}

.wrapper {
  height: 500px;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0 15px;
}

.scroll-bar {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
}

/* width */
.scroll-bar::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.scroll-bar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
.scroll-bar::-webkit-scrollbar-thumb {
  background: #262626;
  border-radius: 10px;
}

.btn-add {
  background-color: #00a178 !important;
  color: white;
}

.btnsave {
  background-color: #3498db !important;
  color: white;
}

.btnclean {
  background-color: #f29d35 !important;
  color: white;
}

.btndelete {
  background-color: #e3191e !important;
  color: white;
}

.btndisable {
  background-color: #41464c !important;
  color: white;
}

.btndisable2 {
  background-color: #1976d2 !important;
  color: white;
}

.text-input-red .v-text-field__slot input {
  color: red !important;
}
.no-wrap {
  white-space: nowrap !important;
}
.v-application .mb-2 {
  margin-right: 10px !important;
}

.v-application .mb-3 {
  margin-right: 50px !important;
}

.responsiveSmallCol {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}

.responsiveSmallColFCF {
  flex: 0 0 4.629629629611111%;
  max-width: 4.629629629611111%;
}

.responsiveAverageColFCF {
  flex: 0 0 16.6666666668%;
  max-width: 16.6666666668%;
}

.responsiveTinyCol {
  flex: 0 0 15%;
  max-width: 15%;
  justify-content: center;
}
.responsiveTinyColQuote {
  flex: 0 0 15%;
  max-width: 15%;
}

.invoiceResponsiveSummary {
  display: none;
}

.responsiveAverageCol {
  flex: 0 0 22%;
  max-width: 22%;
}

.responsiveAverageColQuote {
  flex: 0 0 22%;
  max-width: 22%;
}

@media only screen and (max-width: 1174px) {
  .responsiveSmallCol {
    flex: 0 0 33%;
    max-width: 33%;
  }

  .responsiveSmallColFCF {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .responsiveAverageCol {
    flex: 0 0 27.5%;
    max-width: 27.5%;
    margin-top: 32px !important;
  }
  .responsiveAverageColQuote {
    flex: 0 0 27.5%;
    max-width: 27.5%;
    margin-top: 32px !important;
  }

  .smallScreenScrollYContainer {
    display: none !important;
  }

  .invoiceResponsiveSummary {
    background: #41464c;
    color: white;
    bottom: 0;
    left: 280px;
    display: block;
  }

  .smallScreenScrollYContent {
    min-height: 123.2px;
  }
}

@media only screen and (max-width: 824px) {
  .responsiveTinyColQuote {
    margin-right: 25px !important;
  }
  .responsiveAverageColQuote {
    margin-right: 5% !important;
  }
  .responsiveTinyCol {
    flex: 0 0 15%;
    max-width: 15%;
    justify-content: center;
  }
}
@media only screen and (max-width: 600px) {
  .responsiveAverageColQuote {
    flex-wrap: wrap;
    flex-direction: column;
    max-width: auto;
    flex: 0 0 28.5%;
    max-width: 60.5%;
    margin-top: 32px !important;
  }
}

.autocomplete-product-option {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 2px 0;
}

.autocomplete-product-option__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.autocomplete-product-option__title {
  font-size: 0.95rem;
  line-height: 1.2rem;
  color: #172033;
}

.autocomplete-product-option__type {
  flex-shrink: 0;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.autocomplete-product-option__meta {
  color: #5c6475;
  line-height: 1.1rem;
}

.autocomplete-product-option__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 2px;
}

</style>
